
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("bK3oZ", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $7aRa9 = parcelRequire("7aRa9");

/* eslint-disable confluence-feature-gating/no-preconditioning */ 



var $kSwu1 = parcelRequire("kSwu1");


var $9DHhW = parcelRequire("9DHhW");


var $l2exp = parcelRequire("l2exp");


var $irnO2 = parcelRequire("irnO2");

var $Ou0Zz = parcelRequire("Ou0Zz");





var $cbY7C = parcelRequire("cbY7C");


var $krYZG = parcelRequire("krYZG");


var $1KOhB = parcelRequire("1KOhB");


var $kCECX = parcelRequire("kCECX");


var $7Y8M5 = parcelRequire("7Y8M5");


var $g9ZnD = parcelRequire("g9ZnD");


var $iDrrr = parcelRequire("iDrrr");


var $ieeJu = parcelRequire("ieeJu");


var $aYC8J = parcelRequire("aYC8J");





var $89QZA = parcelRequire("89QZA");


var $iF7Yl = parcelRequire("iF7Yl");


var $5OXoi = parcelRequire("5OXoi");


var $5Tn11 = parcelRequire("5Tn11");


var $2BLI8 = parcelRequire("2BLI8");


var $gQrdE = parcelRequire("gQrdE");


var $85mU8 = parcelRequire("85mU8");





var $lzoay = parcelRequire("lzoay");


var $hwIq7 = parcelRequire("hwIq7");


var $dE5YE = parcelRequire("dE5YE");


var $d5NOj = parcelRequire("d5NOj");


var $1r5s7 = parcelRequire("1r5s7");


var $4nKqn = parcelRequire("4nKqn");

function $2eb6b59988ab18a7$export$bef1f36f5486a6a3(message, ...args) {
    try {
        if (window.top?.__aifcDebuggerEnabled__) // eslint-disable-next-line no-console
        console.log(`[editor-rovo-bridge]: ${message}`, ...args);
    } catch (e) {
    // Ignore cross origin frame access errors
    }
}


class $0b03e6df869fefe4$export$54019a4b43471d88 {
    updateProps(props) {
        this.props = props;
    }
    deregister() {
    // do nothing
    }
    /**
   * Creates a new command handler instance.
   *
   * @param props - Pass-through props containing callbacks and utilities
   *                    needed for command execution and streaming operations
   */ constructor(props){
        /**
     * Properties passed through from the command manager containing callbacks
     * and utility functions for interacting with the editor and streaming system.
     */ this.props = void 0;
        this.props = props;
    }
}


class $a8b95bbe20f101c9$export$3a9b6d9d6180d66 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute() {
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('handle rovo-stream-aborted-command');
        try {
            this.onAbort();
        } catch  {
        // TODO: EDITOR-123 - report this error
        }
    }
    constructor(props, onAbort){
        super(props), this.onAbort = onAbort;
    }
}



class $6f058edf70792236$export$7806cb7ced51ef0f extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute(payload) {
        this.updateCommandProcessor.setActionMetadata(payload.data);
    }
    constructor(props, updateCommandProcessor){
        super(props), this.updateCommandProcessor = updateCommandProcessor;
    }
}









const $abcc86a5daca4460$export$20f464321a86286c = ({ delayedAtMs: delayedAtMs, success: success, id: id })=>{
    return {
        action: 'timeoutWarning',
        actionSubject: 'editorRovoBridge',
        actionSubjectId: 'editorPluginAI',
        eventType: 'track',
        attributes: {
            success: // Whether it was a "warning" (ie. would have timed out) or it was successful but just delayed
            success,
            delayedAtMs: // Time the delay fires
            delayedAtMs,
            id: // In case we need to stitch delayed + warning together
            id
        }
    };
};



/** Timeout duration in milliseconds for streaming operations (10 seconds) */ const $5896f48a4d11c2fd$var$TIMEOUT_MS = 10000;
const $5896f48a4d11c2fd$var$WARNING_TIMEOUT_MS = 8000;
class $5896f48a4d11c2fd$export$1673b811578d4e4e extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    /**
   * Clears any existing inactivity timeout.
   * This stops the timeout from firing if it hasn't already,
   * preventing unwanted aborts of active streams.
   */ clearInactivityTimeout() {
        if (this.timeoutWarning !== null) {
            clearTimeout(this.timeoutWarning);
            this.timeoutWarning = null;
        }
        if (this.timeoutStartTime !== null) {
            const delayTime = performance.now() - this.timeoutStartTime;
            if (delayTime > $5896f48a4d11c2fd$var$TIMEOUT_MS) this.props.editorAPI.analytics?.actions.fireAnalyticsEvent((0, $abcc86a5daca4460$export$20f464321a86286c)({
                delayedAtMs: delayTime,
                success: 'delayed',
                id: this.timeoutId
            }));
        }
        this.timeoutStartTime = null;
        this.timeoutId = null;
        if (this.timeout !== null) {
            clearTimeout(this.timeout);
            this.timeout = null;
        }
    }
    /**
   * Starts or restarts the inactivity timeout for the current stream.
   * If no stream activity occurs within the timeout period (30 seconds),
   * the stream will be automatically aborted and cleaned up.
   *
   * This helps prevent hanging streams and resource leaks when
   * the Rovo bridge stops sending data unexpectedly.
   */ startInactivityTimeout(traceId) {
        this.clearInactivityTimeout();
        this.timeoutStartTime = performance.now();
        this.timeoutId = crypto.randomUUID();
        // Set new timeout for 30 seconds
        this.timeout = setTimeout(()=>{
            // abort when timeout occurs
            this.handleAbort('timeout');
            this.props.onStreamTimeout?.({
                streamType: this.streamType,
                traceId: traceId
            });
        }, 30000);
        // Set a warning timeout for instrumentation
        this.timeoutWarning = setTimeout(()=>{
            // Fire warning
            this.props.editorAPI.analytics?.actions.fireAnalyticsEvent((0, $abcc86a5daca4460$export$20f464321a86286c)({
                delayedAtMs: $5896f48a4d11c2fd$var$WARNING_TIMEOUT_MS,
                success: 'warning',
                id: this.timeoutId
            }));
        }, $5896f48a4d11c2fd$var$WARNING_TIMEOUT_MS);
    }
    /**
   * Main entry point for processing streaming commands.
   * Manages the complete lifecycle of a streaming operation including:
   * - Timeout management and state tracking
   * - Stream start notifications for first-time streams
   * - Processing individual stream chunks
   * - Stream completion and cleanup
   * - Error handling and recovery
   *
   * @param payload - Command payload containing stream data and completion status
   * @throws Will catch and forward any errors to the error callback
   */ async execute(payload) {
        try {
            // Reset timeout on each chunk to prevent premature timeouts
            this.startInactivityTimeout(typeof payload.traceId === 'string' ? payload.traceId : undefined);
            // Initialize streaming state and notify listeners on first chunk
            if (!this.isStreaming) {
                this.isStreaming = true;
                this.isStreamFinished = false;
                this.finalAdf = undefined;
                this.props.onStreamStart?.({
                    streamType: this.streamType,
                    payload: payload
                });
            }
            // Process the current stream chunk
            await this.process(payload);
            this.props.onStream?.({
                streamType: this.streamType,
                payload: payload
            });
            // Handle stream completion - finalize processing and run cleanup
            if (payload.isStreamComplete) {
                this.clearInactivityTimeout();
                await this.finish();
                this.isStreaming = false;
                this.props.onStreamEnd?.({
                    streamType: this.streamType,
                    payload: payload,
                    adfDoc: this.finalAdf
                });
            }
        } catch (error) {
            this.props.onStreamError?.({
                error: error,
                streamType: this.streamType,
                traceId: typeof payload.traceId === 'string' ? payload.traceId : undefined
            });
            this.handleAbort('aborted');
        }
    }
    /**
   * Finalizes the streaming operation.
   * Uses a flag to ensure finishAction is only called once during the stream lifecycle.
   * Automatically triggers image re-uploading for supported stream types.
   */ async finish() {
        if (this.isStreamFinished) return;
        this.isStreamFinished = true;
        this.finalAdf = await this.finishAction();
        // Trigger image re-uploading if we have a document and handler
        if (this.finalAdf && this.props.reuploadImages) {
            if ((0, $iDrrr.fg)('confluence_frontend_aifc_reupload_image')) await this.props.reuploadImages();
            else if (this.streamType !== 'update') await this.props.reuploadImages(this.finalAdf);
        }
    }
    handleAbort(reason) {
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)(`handle abort ${this.streamType} streaming command handler`);
        this.isStreaming = false;
        this.isStreamFinished = false;
        this.finalAdf = undefined;
        this.clearInactivityTimeout();
        this.abort(reason);
    }
    deregister() {
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)(`deregister ${this.streamType} streaming command handler`);
        this.isStreaming = false;
        this.isStreamFinished = false;
        this.finalAdf = undefined;
        this.clearInactivityTimeout();
    }
    /**
   * Creates a new streaming command handler instance.
   *
   * @param props - Pass-through props containing callbacks and utilities
   * @param streamType - The type of stream this handler manages (create, update, etc.)
   */ constructor(props, streamType){
        super(props), this.streamType = streamType;
        /** Flag tracking whether a streaming operation is currently active */ this.isStreaming = false;
        /** Handle for the inactivity timeout, null when no timeout is active */ this.timeout = null;
        this.timeoutWarning = null;
        this.timeoutStartTime = null;
        this.timeoutId = null;
        /** Flag indicating whether finish has been called for this stream */ this.isStreamFinished = false;
        this.finalAdf = void 0;
    }
}


function $ad501fd088efe15f$var$collectMediaNodes(node, nodes) {
    if (!node) return;
    if (node.type === 'media' && typeof node.attrs?.id === 'string') nodes.set(node.attrs.id, {
        id: node.attrs.id,
        collection: node.attrs.collection
    });
    if (Array.isArray(node.content)) for (const child of node.content)$ad501fd088efe15f$var$collectMediaNodes(child, nodes);
}
class $ad501fd088efe15f$export$53d8e34277e6a8ab extends (0, $5896f48a4d11c2fd$export$1673b811578d4e4e) {
    /**
   * Walks the streaming parser's current partial document for media nodes and
   * calls onTrackAIGeneratingMedia for any newly-seen file IDs.
   */ trackNewMediaNodes() {
        if (!(0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true)) return;
        const partialDoc = this.createCommandProcessor.getPartialDocument();
        if (!partialDoc) return;
        const currentNodes = new Map();
        $ad501fd088efe15f$var$collectMediaNodes(partialDoc, currentNodes);
        for (const [id, info] of currentNodes){
            if (this.trackedMediaIds.has(id)) continue;
            this.trackedMediaIds.add(id);
            this.props.onTrackAIGeneratingMedia?.(id, info.collection);
        }
    }
    process(payload) {
        if (!payload.data.adf) return;
        // Record (shape only) the receiver lifecycle facts at command arrival,
        // before any replay/init mutates processor state. No-op unless the debug
        // gate is enabled; the processor stores only the first arrival per stream.
        const previousAccumulatedData = payload.data.previousAccumulatedData;
        this.createCommandProcessor.markCommandArrived({
            processorWasInitializedWhenCommandArrived: this.createCommandProcessor.isInitialized(),
            previousAccumulatedDataPresent: !!previousAccumulatedData,
            previousAccumulatedDataStartsWithDocEnvelope: previousAccumulatedData ? previousAccumulatedData.trimStart().startsWith('{"type":"doc"') : undefined
        });
        if (!this.createCommandProcessor.isInitialized() && payload.data.previousAccumulatedData) {
            // The scenario where the command processor is not initialized but the payload contains
            // accumulated ADF can happen if the user closes and reopens the modal during streaming.
            // To handle this, we first clear the document (in case it first streamed for long enough
            // to trigger a draft sync) and then stream in the accumulated ADF so that streaming
            // subsequent chunks can continue correctly.
            this.props.editorAPI.core.actions.replaceDocument('', {
                addToHistory: false,
                scrollIntoView: false
            });
            // Record (shape only) that this stream is a replay of previously
            // accumulated data, so blank-page debug telemetry can attribute
            // failures to the modal close/reopen mid-stream path.
            this.createCommandProcessor.markPreviousAccumulatedDataReplay(payload.data.previousAccumulatedData);
            this.createCommandProcessor.stream(payload.data.previousAccumulatedData, false, typeof payload.traceId === 'string' ? payload.traceId : undefined, payload.singleInstrumentationId);
            this.trackNewMediaNodes();
        }
        if (!payload.isStreamComplete) {
            this.createCommandProcessor.stream(payload.data.adf, this.isStreamFinished, typeof payload.traceId === 'string' ? payload.traceId : undefined, payload.singleInstrumentationId);
            this.trackNewMediaNodes();
        }
    }
    async finishAction() {
        const adfDoc = await this.createCommandProcessor.finish({
            onError: this.props.onStreamError,
            onRepair: this.props.onStreamRepair
        });
        if (adfDoc) {
            this.props.editorAPI.core.actions.replaceDocument(adfDoc, {
                addToHistory: false,
                scrollIntoView: false
            });
            // Ensure all expands are open
            this.props.editorAPI.core.actions.execute(this.props.editorAPI.expand?.commands.toggleExpandRange());
        }
        return adfDoc;
    }
    abort(_reason) {
        this.createCommandProcessor.abort();
    }
    constructor(props, createCommandProcessor){
        super(props, 'create'), this.createCommandProcessor = createCommandProcessor;
        /**
     * Tracks media file IDs we've already reported via onTrackAIGeneratingMedia
     * during this streaming session, so we only call it once per file ID.
     */ this.trackedMediaIds = new Set();
    }
}












class $f427f81a62f6b31b$export$a5122c37a2351633 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute(payload) {
        const { editorAPI: editorAPI, onInsertContent: onInsertContent, onUploadAndInsertMedia: onUploadAndInsertMedia } = this.props;
        if (!editorAPI) return;
        const shouldInsertMediaAtStoredSelection = payload.mode === 'upload-and-insert-media' && payload.useStoredSelection && payload.interactionSource === 'remixModalFromMediaInserts';
        // Capture the saved selection before entering the transaction
        // callback — so it survives any state changes triggered by closing the
        // ephemeral preview (which clears savedSelection via stopRemixThinking).
        const savedSelection = payload.useStoredSelection && (payload.placement === 'after-block' || shouldInsertMediaAtStoredSelection || payload.placement === 'replace-selection' && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) ? editorAPI?.malleableUi?.sharedState?.currentState()?.savedSelection : undefined;
        editorAPI.core.actions.execute(({ tr: tr })=>{
            let start = tr.selection.from, end = tr.selection.to;
            // Page-level remix: append content at the very end of the document,
            // regardless of the current cursor position.
            if (payload.placement === 'end-of-doc') start = end = tr.doc.content.size - 1;
            else if (payload.placement === 'after-block' || payload.placement === 'replace-selection' && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                if (savedSelection) {
                    const { from: from, to: to, anchorCellPos: anchorCellPos, headCellPos: headCellPos } = savedSelection;
                    start = Math.min(from, anchorCellPos ?? Number.MAX_VALUE, headCellPos ?? Number.MAX_VALUE);
                    end = Math.max(to, anchorCellPos ?? 0, headCellPos ?? 0);
                }
                if (payload.placement === 'after-block' && !shouldInsertMediaAtStoredSelection) {
                    const sharedDepth = tr.doc.resolve(start).sharedDepth(end);
                    if (sharedDepth > 0) start = end = tr.doc.resolve(end).after(1);
                }
            }
            // upload-and-insert-media is async and handled separately via the React-layer callback
            // we are only setting the selection here.
            if (payload.mode === 'upload-and-insert-media' && onUploadAndInsertMedia) {
                const positions = payload.placement === 'replace-selection' || shouldInsertMediaAtStoredSelection ? [
                    start,
                    end
                ] : [
                    end,
                    end
                ];
                onUploadAndInsertMedia(payload.data.url, payload.remixSubtype && (0, $iDrrr.fg)('cc-maui-add-mark-for-remix-generated-images') ? {
                    dynamicUiSubtype: payload.remixSubtype
                } : undefined, payload.data.presentation, {
                    conversationChannelId: payload.conversationChannelId,
                    isAIGenerated: payload.isAIGenerated,
                    inputMethod: payload.interactionSource === 'remixModalFromMediaInserts' ? (0, $krYZG.INPUT_METHOD).REMIX_FROM_MEDIA_INSERTS : (0, $krYZG.INPUT_METHOD).REMIX,
                    aspectRatio: payload.aspectRatio,
                    positions: (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') || shouldInsertMediaAtStoredSelection ? positions : undefined
                }).then((result)=>{
                    if (!(0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) return;
                    if (!result || !payload.conversationChannelId) return;
                    const { fieldId: fieldId, type: type } = result;
                    if (type === 'create') editorAPI.core.actions.execute(editorAPI.malleableUi?.commands.updateRemixImageHistoryFieldId({
                        conversationId: payload.conversationChannelId,
                        fieldId: fieldId
                    }));
                });
                const selection = (0, $kCECX.TextSelection).create(tr.doc, end);
                return selection ? tr.setSelection(selection) : tr;
            }
            return editorAPI.aiExperience?.commands.insertContent(payload, [
                start,
                end
            ])?.({
                tr: tr
            }) ?? null;
        });
        onInsertContent?.(payload);
    }
    constructor(props){
        super(props);
    }
}



class $cf2c80d88893a2de$export$fe1e3dddf412c96a extends (0, $5896f48a4d11c2fd$export$1673b811578d4e4e) {
    async process(payload) {
        const strategy = this.strategies.get(payload.key);
        if (strategy) {
            this.activeStrategies.add(strategy);
            await strategy.process(payload);
        }
    }
    async finishAction() {
        const results = await Promise.all(Array.from(this.activeStrategies, (s)=>s.finish?.()));
        this.activeStrategies.clear();
        return results.find((r)=>r !== undefined);
    }
    abort(reason) {
        this.activeStrategies.forEach((s)=>s.abort?.(reason));
        this.activeStrategies.clear();
    }
    constructor(props, strategies){
        super(props, 'update'), this.strategies = strategies;
        this.activeStrategies = new Set();
    }
}



var $jTt8P = parcelRequire("jTt8P");









const $f22323296098f0eb$var$REMIX_UI_PATH_REGEX = new RegExp('remix\\/ui\\/([^/?#]+)', 'u');
const $f22323296098f0eb$var$isMediaNode = (node)=>{
    if (!node) return false;
    if (node.type === 'media') return typeof node.attrs?.id === 'string';
    if (node.type === 'mediaSingle' && Array.isArray(node.content) && node.content.length > 0) {
        const first = node.content[0];
        return first?.type === 'media' && typeof first.attrs?.id === 'string';
    }
    return false;
};
const $f22323296098f0eb$var$isMediaNodeSelected = (selection)=>{
    return selection?.localIds?.length === 1 && $f22323296098f0eb$var$isMediaNode(selection?.selectionFragment?.at(0));
};
/**
 * Extracts the media file ID from the selected ADF fragment when the selection is a media node.
 */ const $f22323296098f0eb$var$extractMediaFileId = (selectionFragment)=>{
    if (!Array.isArray(selectionFragment) || selectionFragment.length === 0) return undefined;
    const first = selectionFragment[0];
    if (!first) return undefined;
    if (first.type === 'media') return first.attrs?.id;
    if (first.type === 'mediaSingle' && Array.isArray(first.content) && first.content[0]) {
        const media = first.content[0];
        return media?.type === 'media' ? media.attrs?.id : undefined;
    }
    return undefined;
};
/**
 * Extracts the media collection id from the selected ADF fragment when the selection is a media node.
 * Sent to the backend so it can resolve the current media's collection when editing an existing image.
 */ const $f22323296098f0eb$var$extractMediaCollection = (selectionFragment)=>{
    if (!Array.isArray(selectionFragment) || selectionFragment.length === 0) return undefined;
    const first = selectionFragment[0];
    if (!first) return undefined;
    if (first.type === 'media') return first.attrs?.collection;
    if (first.type === 'mediaSingle' && Array.isArray(first.content) && first.content[0]) {
        const media = first.content[0];
        return media?.type === 'media' ? media.attrs?.collection : undefined;
    }
    return undefined;
};
const $f22323296098f0eb$var$isMauiAppNode = (node)=>{
    return node?.type === 'extension' && node.attrs?.extensionKey === 'native-embed:maui';
};
const $f22323296098f0eb$var$isMauiAppNodeSelected = (selection)=>{
    return selection?.localIds?.length === 1 && $f22323296098f0eb$var$isMauiAppNode(selection?.selectionFragment?.at(0));
};
const $f22323296098f0eb$var$isADFEntity = (value)=>typeof value === 'object' && value !== null && !Array.isArray(value) && typeof value.type === 'string';
// Safe here means "does not introduce external/contextual references that the
// editor-minion fast path cannot resolve." Formatting marks are allowed; link
// marks are checked separately because they can carry external context.
const $f22323296098f0eb$var$SAFE_PROMPT_NODE_TYPES = new Set([
    'doc',
    'paragraph',
    'text',
    'emoji',
    'hardBreak',
    'date',
    'status',
    'placeholder'
]);
// Unknown nodes are treated as rich by omission from SAFE_PROMPT_NODE_TYPES.
const $f22323296098f0eb$var$isSafePromptNode = (node)=>$f22323296098f0eb$var$SAFE_PROMPT_NODE_TYPES.has(node.type) && !node.marks?.some((mark)=>mark.type === 'link');
const $f22323296098f0eb$var$hasRichPromptContent = (prompt)=>{
    let hasRichContent = false;
    (0, $jTt8P.traverse)(prompt, {
        any: (node)=>{
            if (!$f22323296098f0eb$var$isSafePromptNode(node)) hasRichContent = true;
        }
    });
    return hasRichContent;
};
const $f22323296098f0eb$var$isPlainPrompt = (prompt)=>$f22323296098f0eb$var$isADFEntity(prompt) && prompt.type === 'doc' && !$f22323296098f0eb$var$hasRichPromptContent(prompt);
/**
 * Extracts the Maui content ID from the selected ADF fragment.
 */ const $f22323296098f0eb$var$extractMauiContentId = (selectionFragment)=>{
    if (!Array.isArray(selectionFragment) || selectionFragment.length === 0) return undefined;
    const mauiApp = selectionFragment.find((node)=>$f22323296098f0eb$var$isMauiAppNode(node));
    const attrs = mauiApp?.attrs;
    const url = attrs?.parameters?.macroParams?.url?.value;
    if (url) {
        // We only want the ID, which is the part after /remix/ui/
        const match = $f22323296098f0eb$var$REMIX_UI_PATH_REGEX.exec(url);
        return match?.[1];
    }
    return undefined;
};
const $f22323296098f0eb$export$41ff530af06c946f = async ({ props: props, doc: doc, selectionFragment: selectionFragment, selectionLocalIds: selectionLocalIds, selectionMarkdown: selectionMarkdown, contentMauiId: contentMauiId, dynamicUiSource: dynamicUiSource, dynamicUiType: dynamicUiType, mediaFileId: mediaFileId, mediaCollection: mediaCollection, startIndex: startIndex, endIndex: endIndex, isEditorInlineRovoActive: isEditorInlineRovoActive, aiExperienceProduct: aiExperienceProduct, source: source, prompt: prompt })=>{
    let additionalContextFromProps = props.additionalContext || {
        isViewMode: false
    };
    if (typeof additionalContextFromProps === 'function') try {
        additionalContextFromProps = await additionalContextFromProps();
    // eslint-disable-next-line no-unused-vars
    } catch (err) {
        additionalContextFromProps = {};
    }
    const { isViewMode: isViewMode = false, isDraftLockedForEditing: isDraftLockedForEditing = false, ...additionalContext } = additionalContextFromProps || {};
    // HTML+ v2 incremental tool-call streaming capability advertisement.
    // Per FE spec §2.5 + §3.8, FE sends a single int `editorStreamingContractVersion`
    // on the editor JSON block. Backend reads `>= 2` to opt the request into
    // the v2 wire format. Gated by `platform_editor_use_html_plus_streaming_parser`
    // — when the gate is off the field is omitted entirely so v1 wire bytes
    // stay byte-identical to today.
    const editorStreamingContractVersion = (0, $ieeJu.expValEquals)('platform_editor_use_html_plus_streaming_parser', 'isEnabled', true) ? 2 : undefined;
    // When true, the backend will skip the orchestrator and call the editor minion directly.
    const useFastPath = isEditorInlineRovoActive && aiExperienceProduct === 'CONFLUENCE' && source === 'CONFLUENCE_INLINE_EDITOR' && $f22323296098f0eb$var$isPlainPrompt(prompt) && (0, $ieeJu.expValEquals)('platform_editor_ai_minion_skip_orchestrator', 'isEnabled', true) ? true : undefined;
    return {
        contentId: props.contentId,
        contentType: props.contentType,
        contentMauiId: contentMauiId,
        dynamicUiSource: dynamicUiSource,
        dynamicUiType: dynamicUiType,
        mediaFileId: mediaFileId,
        mediaCollection: mediaCollection,
        pageBody: doc,
        selectionFragment: selectionFragment,
        selectionLocalIds: selectionLocalIds,
        selectionMarkdown: selectionMarkdown,
        startIndex: startIndex,
        endIndex: endIndex,
        isViewMode: isViewMode,
        isDraftLockedForEditing: isDraftLockedForEditing,
        useGenericEditorSkill: props.useGenericEditorSkill,
        additionalContext: Object.keys(additionalContext).length > 0 ? additionalContext : undefined,
        ...editorStreamingContractVersion !== undefined ? {
            editorStreamingContractVersion: editorStreamingContractVersion
        } : {},
        ...useFastPath !== undefined ? {
            useFastPath: useFastPath
        } : {}
    };
};
class $f22323296098f0eb$export$ada55596c5cc2d41 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    async execute(payload) {
        const defaultResult = await $f22323296098f0eb$export$41ff530af06c946f({
            props: this.props,
            doc: undefined,
            selectionFragment: '',
            selectionLocalIds: '',
            selectionMarkdown: ''
        });
        if ((0, $ieeJu.expValEquals)('cc-markdown-mode', 'isEnabled', true) && this.props.editorAPI?.markdownMode?.sharedState.currentState()?.isMarkdownMode) return null;
        try {
            const doc = (0, $iDrrr.fg)('platform_editor_aifc_rovo_bridge_partial_doc') ? this.props.editorAPI?.aiExperience?.actions.getPartialDocumentFromSelection() : await this.props.editorAPI.core.actions.requestDocumentAsync();
            if (!doc) // TODO: EDITOR-123 - report this error
            return defaultResult;
            const aiExperiencePluginState = this.props.editorAPI.aiExperience?.sharedState?.currentState()?.aiDecorationExperiencePluginState;
            const isEditorInlineRovoActive = aiExperiencePluginState?.isRunning;
            const aiExperienceProduct = aiExperiencePluginState?.product;
            const selection = this.props.editorAPI.aiExperience?.actions.getAISelectionContext();
            const selectionFragment = selection?.selectionFragment ? JSON.stringify(selection.selectionFragment) : '';
            const content = await $f22323296098f0eb$export$41ff530af06c946f({
                props: this.props,
                doc: doc,
                selectionFragment: selectionFragment,
                startIndex: selection?.startIndex ?? undefined,
                endIndex: selection?.endIndex ?? undefined,
                selectionLocalIds: selection?.localIds ? JSON.stringify(selection.localIds) : '',
                selectionMarkdown: selection?.selectionMarkdown ?? '',
                isEditorInlineRovoActive: isEditorInlineRovoActive,
                aiExperienceProduct: aiExperienceProduct,
                source: payload?.source,
                prompt: payload?.prompt,
                ...(0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true) ? {
                    ...$f22323296098f0eb$var$isMauiAppNodeSelected(selection) ? {
                        contentMauiId: $f22323296098f0eb$var$extractMauiContentId(selection?.selectionFragment)
                    } : {},
                    ...$f22323296098f0eb$var$isMediaNodeSelected(selection) ? {
                        mediaFileId: $f22323296098f0eb$var$extractMediaFileId(selection?.selectionFragment),
                        ...(0, $iDrrr.fg)('platform_editor_maui_remix_media_collection') ? {
                            mediaCollection: $f22323296098f0eb$var$extractMediaCollection(selection?.selectionFragment)
                        } : {},
                        dynamicUiType: 'infographic'
                    } : {},
                    dynamicUiSource: {
                        contentType: 'page',
                        startLocalId: selection?.localIds?.[0],
                        endLocalId: selection?.localIds?.[selection.localIds.length - 1],
                        startIndex: selection?.startIndex ?? undefined,
                        endIndex: selection?.endIndex ?? undefined,
                        fragmentAdf: selectionFragment
                    }
                } : {}
            });
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('handle read-content-command result', {
                additionalContext: this.props.additionalContext,
                doc: doc,
                selection: selection,
                content: content
            });
            return content ?? defaultResult;
        } catch  {
            // TODO: EDITOR-123 - report this error
            return defaultResult;
        }
    }
}



class $8930067984616c53$export$28d3a280fab599b5 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute() {
        this.props.onSendContextReady?.();
    }
}






var $as9lu = parcelRequire("as9lu");

const $61718a565463dd09$var$AGENT_TYPES = {
    twg: true,
    mcp: true,
    'convo-ai': true,
    rovo_chat: true,
    unknown: true
};
const $61718a565463dd09$export$216676272aec3502 = (value)=>typeof value === 'string' && Object.prototype.hasOwnProperty.call($61718a565463dd09$var$AGENT_TYPES, value);


const $195122be17374f99$export$b903a6e31c916a97 = ({ agentType: agentType, agentIdentityAccountId: agentIdentityAccountId })=>{
    if (!(0, $iDrrr.fg)('platform_editor_agentic_step_attribution')) return undefined;
    const normalizedAgentType = (0, $61718a565463dd09$export$216676272aec3502)(agentType) ? agentType : 'unknown';
    if (!agentIdentityAccountId) return {
        agentType: normalizedAgentType
    };
    if (!agentIdentityAccountId.startsWith('ari:')) return {
        agentId: agentIdentityAccountId,
        agentType: normalizedAgentType
    };
    try {
        return {
            agentId: (0, $as9lu.IdentityUserAri).parse(agentIdentityAccountId).userId,
            agentType: normalizedAgentType
        };
    } catch  {
        return {
            agentType: normalizedAgentType
        };
    }
};


class $9fb8b0078e18dd5e$export$ff883159d3c43ab1 {
    async process(payload) {
        const { data: data, isStreamComplete: isStreamComplete, traceId: traceId, singleInstrumentationId: singleInstrumentationId, agentName: agentName, agentId: agentId, agentIdentityAccountId: agentIdentityAccountId, isInlineEdit: isInlineEdit, agentNamedId: agentNamedId, agentType: agentType } = payload;
        const agentAttribution = (0, $195122be17374f99$export$b903a6e31c916a97)({
            agentType: agentType,
            agentIdentityAccountId: agentIdentityAccountId
        });
        await this.processor.streamChunk(data.toolCalls, isStreamComplete, traceId, singleInstrumentationId, agentName !== undefined ? {
            agentName: agentName,
            agentId: agentId,
            agentIdentityAccountId: agentIdentityAccountId,
            agentNamedId: agentNamedId
        } : undefined, isInlineEdit, agentAttribution);
    }
    async finish() {
        await this.processor.finish();
        return undefined;
    }
    abort(reason) {
        this.processor.abort(reason);
    }
    constructor(processor){
        this.processor = processor;
    }
}


class $ee2e6b9285b9c654$export$47ba439f8682d30d {
    async process(payload) {
        const { data: data, isStreamComplete: isStreamComplete, traceId: traceId, singleInstrumentationId: singleInstrumentationId } = payload;
        await this.processor.streamChunk(data, isStreamComplete, traceId, singleInstrumentationId);
    }
    finish() {
        this.processor.finish();
        return Promise.resolve(undefined);
    }
    constructor(processor){
        this.processor = processor;
    }
}





class $89cf1368fcb03552$export$34daae3f4eb40acc {
    async process(payload) {
        const { data: data, isStreamComplete: isStreamComplete, traceId: traceId, singleInstrumentationId: singleInstrumentationId } = payload;
        await this.processor.streamChunk(data, isStreamComplete, traceId, singleInstrumentationId);
    }
    abort(reason) {
        // Skip timeout-based aborts — image generation naturally takes longer than
        // the inactivity timeout window (10s). Only abort on explicit user cancel.
        if (reason === 'timeout') return;
        if ((0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_1', 'isEnabled', true)) {
            this.processor.abortAndClearStreamingState();
            return;
        }
        this.processor.abortIfPrepared();
    }
    constructor(processor){
        this.processor = processor;
    }
}



class $62e6e860c6a05106$export$c246e3e964a757d2 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute() {
    // Intentional no-op for stream complete. This handler is used to prevent
    // red herring errors in the console when such commands are received.
    }
}




class $1e1884497811d88d$export$1c85c9771012b466 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute() {
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('handle rovo-stream-errored-command');
        try {
            this.onError();
        } catch  {
        // TODO: EDITOR-123 - report this error
        }
    }
    constructor(props, onError){
        super(props), this.onError = onError;
    }
}





class $453761e88b44d120$export$9e34a8a16b80af23 extends (0, $5896f48a4d11c2fd$export$1673b811578d4e4e) {
    process(payload) {
        const agentAttribution = (0, $195122be17374f99$export$b903a6e31c916a97)({
            agentType: payload.agentType,
            agentIdentityAccountId: payload.agentIdentityAccountId
        });
        this.updateCommandProcessor.streamChunk(payload.data.toolCalls, payload.isStreamComplete, payload.traceId, payload.singleInstrumentationId, payload.agentName !== undefined ? {
            agentId: payload.agentId,
            agentName: payload.agentName,
            agentIdentityAccountId: payload.agentIdentityAccountId,
            agentNamedId: payload.agentNamedId
        } : undefined, payload.isInlineEdit, agentAttribution);
    }
    async finishAction() {
        await this.updateCommandProcessor.finish();
        return undefined;
    }
    abort(reason) {
        this.updateCommandProcessor.abort(reason);
    }
    constructor(props, updateCommandProcessor){
        super(props, 'update'), this.updateCommandProcessor = updateCommandProcessor;
    }
}





class $95728dc03de99a85$export$3ddb1d774e2cb647 extends Error {
    constructor(message, position){
        super(message);
        /** The position in the input where the error occurred (if applicable) */ this.position = void 0;
        this.name = 'AdfParseError';
        this.position = position;
        // Maintains proper stack trace for where error was thrown (V8 engines)
        if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    }
}
class $95728dc03de99a85$export$2856c7b7f8959298 extends $95728dc03de99a85$export$3ddb1d774e2cb647 {
    constructor(message, position){
        super(message, position);
        this.name = 'AdfTokenizerError';
    }
}
class $95728dc03de99a85$export$b9b452bff3ab7d90 extends $95728dc03de99a85$export$3ddb1d774e2cb647 {
    constructor(expected, actual, position){
        super(`Expected ${expected}, got ${actual} at position ${position}`, position);
        /** The token type that was expected */ this.expected = void 0;
        /** The token type that was actually found */ this.actual = void 0;
        this.name = 'AdfUnexpectedTokenError';
        this.expected = expected;
        this.actual = actual;
    }
}
class $95728dc03de99a85$export$a2c8f9e7fc157799 extends $95728dc03de99a85$export$3ddb1d774e2cb647 {
    constructor(expectedDelimiter, actual, position){
        super(`Expected ${expectedDelimiter} or STRING, got ${actual} at position ${position}`, position);
        /** The delimiter that was expected (LEFT_BRACE or LEFT_BRACKET) */ this.expectedDelimiter = void 0;
        /** The token type that was actually found */ this.actual = void 0;
        this.name = 'AdfUnexpectedDelimiterError';
        this.expectedDelimiter = expectedDelimiter;
        this.actual = actual;
    }
}
class $95728dc03de99a85$export$49aed713e532a2a1 extends $95728dc03de99a85$export$3ddb1d774e2cb647 {
    constructor(message){
        super(message);
        this.name = 'AdfParserStateError';
    }
}
class $95728dc03de99a85$export$b68a04045b90b51f extends $95728dc03de99a85$export$2856c7b7f8959298 {
    constructor(position){
        super(`Invalid number at position ${position}`, position);
        this.name = 'AdfInvalidNumberError';
    }
}
class $95728dc03de99a85$export$c7ceaefe1eaf3fa8 extends $95728dc03de99a85$export$2856c7b7f8959298 {
    constructor(character, position){
        super(`Unexpected character '${character}' at position ${position}`, position);
        /** The unexpected character that was encountered */ this.character = void 0;
        this.name = 'AdfUnexpectedCharacterError';
        this.character = character;
    }
}






// eslint-disable-next-line require-unicode-regexp
const $74c73f70fa440f5b$var$HEX_DIGIT_PATTERN_REGEX = /^[0-9a-fA-F]{4}$/;
class $74c73f70fa440f5b$export$947fa7da412978d0 {
    getPosition() {
        return this.position;
    }
    reset(input, position = 0) {
        this.input = input;
        this.position = position;
        this.lastTokenType = null;
    }
    isWhitespace(char) {
        return [
            ' ',
            '\n',
            '\t',
            '\r'
        ].includes(char);
    }
    isExpectingKey() {
        return this.lastTokenType === 'LEFT_BRACE' || this.lastTokenType === 'COMMA';
    }
    isDigit(char) {
        return char >= '0' && char <= '9';
    }
    isAlpha(char) {
        return char >= 'a' && char <= 'z' || char >= 'A' && char <= 'Z';
    }
    isHexDigit(char) {
        return char >= '0' && char <= '9' || char >= 'a' && char <= 'f' || char >= 'A' && char <= 'F';
    }
    peek() {
        return this.position < this.input.length ? this.input[this.position] || '\0' : '\0';
    }
    advance() {
        if (this.position < this.input.length) return this.input[this.position++] || '\0';
        return '\0';
    }
    skipWhitespace() {
        while(this.position < this.input.length && this.isWhitespace(this.peek()))this.advance();
    }
    /**
   * Check if a quote is actually closing the string by looking at what follows
   * A closing quote should be followed by: comma, right brace, right bracket, or colon
   * (with optional whitespace in between)
   */ isClosingQuote(position) {
        let i = position + 1; // Skip the quote itself
        // Skip whitespace
        while(i < this.input.length && this.isWhitespace(this.input[i] || ''))i++;
        // Check if followed by valid JSON delimiters or structural characters
        if (i < this.input.length) {
            const nextChar = this.input[i];
            return $74c73f70fa440f5b$export$947fa7da412978d0.CLOSING_DELIMITERS.has(nextChar || '');
        }
        // At EOF, consider it closing
        return true;
    }
    readString() {
        const start = this.position;
        this.advance(); // consume opening quote
        let value = '';
        let hasUnescapedQuotes = false;
        while(this.position < this.input.length){
            if (this.peek() === '\\') {
                this.advance(); // consume backslash
                const escaped = this.advance();
                switch(escaped){
                    case '"':
                        value += '"';
                        break;
                    case '\\':
                        value += '\\';
                        break;
                    case '/':
                        value += '/';
                        break;
                    case 'b':
                        value += '\b';
                        break;
                    case 'f':
                        value += '\f';
                        break;
                    case 'n':
                        value += '\n';
                        break;
                    case 'r':
                        value += '\r';
                        break;
                    case 't':
                        value += '\t';
                        break;
                    case 'u':
                        {
                            // Read hex digits (keep raw if incomplete for streaming)
                            let hex = '';
                            for(let i = 0; i < 4; i++){
                                const ch = this.peek();
                                if (this.isHexDigit(ch)) hex += this.advance();
                                else break;
                            }
                            if (hex.length < 4) {
                                value += '\\u' + hex;
                                break;
                            }
                            const codeUnit = parseInt(hex, 16);
                            // Handle surrogate pairs: \uD8xx\uDCxx
                            if (codeUnit >= 0xd800 && codeUnit <= 0xdbff) {
                                // Lookahead for low-surrogate
                                if (this.position + 6 <= this.input.length && this.input[this.position] === '\\' && this.input[this.position + 1] === 'u') {
                                    const lowHex = this.input.substring(this.position + 2, this.position + 6);
                                    if ($74c73f70fa440f5b$var$HEX_DIGIT_PATTERN_REGEX.test(lowHex)) {
                                        const low = parseInt(lowHex, 16);
                                        if (low >= 0xdc00 && low <= 0xdfff) {
                                            // Valid surrogate pair, consume and combine
                                            this.advance(); // backslash
                                            this.advance(); // 'u'
                                            for(let i = 0; i < 4; i++)this.advance();
                                            // eslint-disable-next-line no-bitwise
                                            const codePoint = (codeUnit - 0xd800 << 10) + (low - 0xdc00) + 0x10000;
                                            value += String.fromCodePoint(codePoint);
                                            break;
                                        }
                                    }
                                }
                                // No valid low surrogate; emit high surrogate code unit as-is
                                value += String.fromCharCode(codeUnit);
                            } else if (codeUnit >= 0xdc00 && codeUnit <= 0xdfff) // Lone low surrogate; emit as-is
                            value += String.fromCharCode(codeUnit);
                            else value += String.fromCharCode(codeUnit);
                            break;
                        }
                    default:
                        value += escaped;
                        break;
                }
            } else if (this.peek() === '"') {
                // For object keys, always treat quote as closing (strict parsing for missing colon detection)
                // For values, check if it's a real closing quote or unescaped quote inside
                if (this.isExpectingKey() || this.isClosingQuote(this.position)) break;
                else {
                    // Unescaped quote inside a value string - treat as literal character
                    value += this.advance();
                    hasUnescapedQuotes = true;
                }
            } else value += this.advance();
        }
        // Handle EOF mid-string for streaming (return partial, more data may come)
        if (this.peek() === '"') this.advance(); // consume closing quote
        // Report repair if we found unescaped quotes
        if (hasUnescapedQuotes) this.onRepair?.({
            type: 'infer',
            from: 'unescaped_quote',
            to: 'escaped_quote',
            context: 'tokenizer_string'
        });
        return {
            type: 'STRING',
            value: value,
            position: start
        };
    }
    readNumber() {
        const start = this.position;
        let value = '';
        // Handle negative sign
        if (this.peek() === '-') value += this.advance();
        // Handle integer part
        if (this.peek() === '0') value += this.advance();
        else if (this.isDigit(this.peek())) while(this.isDigit(this.peek()))value += this.advance();
        else throw new (0, $95728dc03de99a85$export$b68a04045b90b51f)(this.position);
        // Handle decimal part
        if (this.peek() === '.') {
            value += this.advance();
            if (!this.isDigit(this.peek())) throw new (0, $95728dc03de99a85$export$b68a04045b90b51f)(this.position);
            while(this.isDigit(this.peek()))value += this.advance();
        }
        // Handle exponent
        if (this.peek() === 'e' || this.peek() === 'E') {
            value += this.advance();
            if (this.peek() === '+' || this.peek() === '-') value += this.advance();
            if (!this.isDigit(this.peek())) throw new (0, $95728dc03de99a85$export$b68a04045b90b51f)(this.position);
            while(this.isDigit(this.peek()))value += this.advance();
        }
        return {
            type: 'NUMBER',
            value: value,
            position: start
        };
    }
    readLiteral() {
        const start = this.position;
        let value = '';
        while(this.position < this.input.length && this.isAlpha(this.peek()))value += this.advance();
        // Complete partial literals at EOF for streaming (t→true, f→false, n→null)
        const atEOF = this.position >= this.input.length;
        if (atEOF && value.length > 0 && value.length < 5) {
            const originalValue = value;
            if ('true'.startsWith(value)) value = 'true';
            else if ('false'.startsWith(value)) value = 'false';
            else if ('null'.startsWith(value)) value = 'null';
            if (originalValue !== value) this.onRepair?.({
                type: 'infer',
                from: originalValue,
                to: value,
                context: 'tokenizer_partial_literal'
            });
        }
        // Handle JSON literals
        if (value === 'true' || value === 'false') return {
            type: 'BOOLEAN',
            value: value === 'true' ? 'true' : 'false',
            position: start
        };
        if (value === 'null') return {
            type: 'NULL',
            value: 'null',
            position: start
        };
        // Check for misplaced quote after identifier: content"  :
        // Skip the quote if it's followed by whitespace and a colon
        if (this.peek() === '"') {
            const quotePos = this.position;
            this.advance(); // Skip the quote
            this.skipWhitespace();
            if (this.peek() === ':') // This was a misplaced quote, we've successfully skipped it
            this.onRepair?.({
                type: 'skip',
                from: 'misplaced_quote',
                to: '-',
                context: 'tokenizer_key'
            });
            else // Not a misplaced quote pattern, restore position
            this.position = quotePos;
        }
        // Treat any other unquoted identifier as a string value (lenient parsing)
        // This handles cases like: {"key": world} → {"key": "world"}
        this.onRepair?.({
            type: 'infer',
            from: value,
            to: `"${value}"`,
            context: 'tokenizer_unquoted_string'
        });
        return {
            type: 'STRING',
            value: value,
            position: start
        };
    }
    createSingleCharToken(type, value) {
        const position = this.position;
        this.advance();
        return {
            type: type,
            value: value,
            position: position
        };
    }
    nextToken() {
        this.skipWhitespace();
        if (this.position >= this.input.length) {
            const token = {
                type: 'EOF',
                value: '',
                position: this.position
            };
            this.lastTokenType = token.type;
            return token;
        }
        const char = this.peek();
        let token;
        switch(char){
            case '{':
                token = this.createSingleCharToken('LEFT_BRACE', '{');
                break;
            case '}':
                token = this.createSingleCharToken('RIGHT_BRACE', '}');
                break;
            case '[':
                token = this.createSingleCharToken('LEFT_BRACKET', '[');
                break;
            case ']':
                token = this.createSingleCharToken('RIGHT_BRACKET', ']');
                break;
            case ':':
                token = this.createSingleCharToken('COLON', ':');
                break;
            case ',':
                token = this.createSingleCharToken('COMMA', ',');
                break;
            case '"':
                token = this.readString();
                break;
            case '-':
            case '0':
            case '1':
            case '2':
            case '3':
            case '4':
            case '5':
            case '6':
            case '7':
            case '8':
            case '9':
                token = this.readNumber();
                break;
            default:
                if (this.isAlpha(char)) token = this.readLiteral();
                else {
                    // Skip unknown characters and emit repair event (lenient parsing)
                    this.onRepair?.({
                        type: 'skip',
                        from: char,
                        to: '-',
                        context: 'tokenizer_unknown_char'
                    });
                    this.advance();
                    // Recursively get the next valid token
                    return this.nextToken();
                }
        }
        this.lastTokenType = token.type;
        return token;
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(input, onRepair){
        this.input = input;
        this.onRepair = onRepair;
        this.position = 0;
        this.lastTokenType = null;
    }
}
// Characters that indicate a quote should close the string
// Includes standard delimiters and structural chars (for malformed JSON with missing braces)
$74c73f70fa440f5b$export$947fa7da412978d0.CLOSING_DELIMITERS = new Set([
    ',',
    '}',
    ']',
    ':',
    '{',
    '['
]);


const $10068d507b2ca0c8$export$c289a768a80ae97c = Symbol('lift');
function $10068d507b2ca0c8$export$3335a5cc0103143c(value) {
    return typeof value === 'object' && value !== null && $10068d507b2ca0c8$export$c289a768a80ae97c in value;
}


const $92670691a884989a$export$24f3e5766c70b302 = {
    type: 'doc',
    version: 1,
    content: []
};
class $92670691a884989a$export$f692212e574bcc60 {
    getRepairs() {
        return this.repairs;
    }
    /**
   * Process a new chunk of JSON data and return the current partial/complete document.
   * Use this for incremental parsing as data arrives (e.g., from LLM streaming).
   *
   * The parser gracefully handles incomplete JSON by completing open structures.
   * Each call returns a valid ADF document that can be rendered immediately.
   *
   * Note: Once isLastChunk=true is signaled, you must create a new parser instance
   * to parse another document. Use parse() for multiple documents.
   *
   * @param chunk - New JSON data to append
   * @param isLastChunk - If true, signals this is the final chunk (no more data coming)
   * @returns The current document (partial or complete)
   * @throws Error if called after isLastChunk=true was previously signaled
   */ processChunk(chunk, isLastChunk = false) {
        // Prevent reusing after explicit completion signal
        if (this.lastChunkReceived) throw new (0, $95728dc03de99a85$export$49aed713e532a2a1)("Cannot call processChunk() after isLastChunk=true was signaled. Create a new AdfParser instance or use parse() for multiple documents.");
        // Accumulate the chunk
        this.accumulatedInput += chunk;
        // Reset parser state for fresh parse (preserve nodeHandles for cross-chunk tracking)
        this.resetParserState(this.accumulatedInput, false);
        this.tokenizer.reset(this.accumulatedInput, 0);
        this.currentToken = this.tokenizer.nextToken();
        // Parse what we have so far - expect() handles EOF gracefully
        const doc = this.parseDocument();
        // Check if parsing is complete
        if (isLastChunk) {
            this.parseComplete = true;
            this.lastChunkReceived = true;
        } else this.parseComplete = this.currentToken.type === 'EOF' && !this.hitEofDuringExpect;
        this.cachedDocument = doc;
        return doc;
    }
    /**
   * Get the partial document parsed so far (even if incomplete)
   * @returns The cached document or null if not yet parsed
   */ getPartialDocument() {
        return this.cachedDocument;
    }
    /**
   * Check if the document is complete
   * @returns True if all data has been received and parsed
   */ isComplete() {
        return this.parseComplete;
    }
    countNodesInTree(node) {
        let count = 1;
        if (Array.isArray(node.marks)) count += node.marks.length;
        if (Array.isArray(node.content)) for (const child of node.content)count += this.countNodesInTree(child);
        return count;
    }
    recordRepair(repair) {
        this.repairs.push(repair);
        this.callbacks.onRepair?.(repair);
    }
    updateNodeHandle(handle, updates) {
        if (handle && this.callbacks.onNodeUpdate) this.callbacks.onNodeUpdate(handle, updates);
    }
    /**
   * Add lifted node(s) to the appropriate list based on closeContainer flag.
   * Handles both single nodes and arrays of nodes.
   */ addLiftedNodes(nodes, closeContainer) {
        const targetList = closeContainer ? this.immediateLiftedNodes : this.accumulatedLiftedNodes;
        if (Array.isArray(nodes)) targetList.push(...nodes);
        else targetList.push(nodes);
    }
    /**
   * Sanitize a node type name for use in repair records.
   * Returns the type if valid, otherwise returns a truncated unknown_prefix.
   */ sanitizeNodeTypeName(type) {
        if (!type) return 'unknown';
        return this.validator.isValidNodeType(type) ? type : `unknown`;
    }
    /**
   * Sanitize a mark type name for use in repair records.
   * Returns the type if valid, otherwise returns a truncated unknown_prefix.
   */ sanitizeMarkTypeName(type) {
        if (!type) return 'unknown';
        return this.validator.isValidMarkType(type) ? type : `unknown`;
    }
    addRepairedNode(repairedNode, content, originalNode, context) {
        if (Array.isArray(repairedNode) && repairedNode.length === 0) return;
        const originalNodeCount = this.countNodesInTree(originalNode);
        const repairedNodeCount = Array.isArray(repairedNode) ? repairedNode.reduce((sum, n)=>sum + this.countNodesInTree(n), 0) : this.countNodesInTree(repairedNode);
        const isUnwrap = Array.isArray(repairedNode);
        const expansion = repairedNodeCount - originalNodeCount;
        const repairedType = isUnwrap ? "\u274C" : repairedNode.type || "\u274C";
        // For unwrap: check if the original node is preserved in the array
        const nodePreserved = isUnwrap && Array.isArray(repairedNode) && repairedNode.length === 1 && repairedNode[0]?.type === originalNode.type;
        const repair = {
            type: isUnwrap ? 'unwrap' : 'wrap',
            // This is safe since we only `wrap` or `unwrap` nodes that are valid
            from: originalNode.type,
            to: repairedType,
            context: context,
            expansion: expansion,
            nodePreserved: isUnwrap ? nodePreserved : undefined
        };
        this.recordRepair(repair);
        if (Array.isArray(repairedNode)) content.push(...repairedNode);
        else content.push(repairedNode);
    }
    /**
   * Try to append a node to the content array, applying repairs if needed.
   * @returns true if lift mode should be enabled (close container), false otherwise
   */ tryAppendNodeToContent(parentType, node, content, isValidChild, options) {
        const topNodeType = options?.topNodeType || this.validator.getTopNodeType();
        // If node has no type, try to let repair strategy fix it
        if (!node?.type) {
            const repairedNode = this.repairStrategy.tryRepair(node, parentType, content, true);
            // Check if type was inferred (node mutated in place)
            if (node.type) this.recordRepair({
                type: 'infer',
                from: 'missing_type',
                to: node.type,
                context: `inferred_from_properties:${parentType || topNodeType}`
            });
            else if (repairedNode) {
                // Handle lifted nodes
                if ((0, $10068d507b2ca0c8$export$3335a5cc0103143c)(repairedNode)) {
                    const closeContainer = repairedNode.closeContainer ?? false;
                    this.addLiftedNodes(repairedNode.node, closeContainer);
                    this.recordRepair({
                        type: 'lift',
                        from: this.sanitizeNodeTypeName(node.type),
                        to: 'parent',
                        context: parentType || topNodeType
                    });
                    return closeContainer;
                }
                this.addRepairedNode(repairedNode, content, node, parentType || topNodeType);
                return false;
            } else // Still no type after repair - skip it
            return false;
        }
        // Handle empty text nodes (ProseMirror doesn't allow them)
        if (node.type === 'text' && (!node.text || node.text.length === 0)) {
            this.recordRepair({
                type: 'skip_empty_text',
                from: 'text',
                to: '-',
                context: parentType || topNodeType
            });
            // Also account for marks on the empty text node
            if (Array.isArray(node.marks)) {
                for (const mark of node.marks)if (mark.type) this.recordRepair({
                    type: 'skip_empty_text',
                    from: this.sanitizeMarkTypeName(mark.type),
                    to: '-',
                    context: `${parentType || topNodeType}:text`
                });
            }
            return false;
        }
        // Handle empty listItem/taskItem nodes whose content was lifted out.
        // Only skip when immediateLiftedNodes is non-empty
        // (indicating lifting actually occurred from this node, not just an empty streaming node)
        if ((node.type === 'listItem' || node.type === 'taskItem') && (!node.content || node.content.length === 0) && this.immediateLiftedNodes.length > 0) {
            this.recordRepair({
                type: 'skip',
                from: node.type,
                to: '-',
                context: `${parentType || topNodeType}:empty_after_lift`
            });
            return false;
        }
        // Apply mutations to all nodes (fix timestamps, infer types, etc.)
        this.repairStrategy.applyNodeMutations(node);
        // Check validity first
        const isValid = isValidChild(node.type);
        const needsStructuralFix = this.repairStrategy.shouldAttemptStructuralFix(node, parentType);
        if (!isValid || needsStructuralFix) {
            // Delegate all repairs to the repair strategy
            const repairedNode = this.repairStrategy.tryRepair(node, parentType, content, !isValid);
            if (repairedNode) {
                // Handle lifted nodes - add to appropriate list based on closeContainer
                if ((0, $10068d507b2ca0c8$export$3335a5cc0103143c)(repairedNode)) {
                    const closeContainer = repairedNode.closeContainer ?? false;
                    this.addLiftedNodes(repairedNode.node, closeContainer);
                    this.recordRepair({
                        type: 'lift',
                        from: this.sanitizeNodeTypeName(node.type),
                        to: 'parent',
                        context: parentType || topNodeType
                    });
                    return closeContainer;
                }
                this.addRepairedNode(repairedNode, content, node, parentType || topNodeType);
                return false;
            }
            this.recordRepair({
                type: 'skip',
                from: this.sanitizeNodeTypeName(node.type),
                to: '-',
                context: parentType || topNodeType
            });
            return false;
        }
        content.push(node);
        return false;
    }
    advance() {
        this.currentToken = this.tokenizer.nextToken();
    }
    peekType(...types) {
        return types.includes(this.currentToken.type);
    }
    isStartOfStructure(type) {
        return type === 'LEFT_BRACE' || type === 'LEFT_BRACKET';
    }
    isPrimitiveToken(type) {
        return type === 'STRING' || type === 'NUMBER' || type === 'BOOLEAN' || type === 'NULL';
    }
    // Check if token type could start an object property value
    isObjectPropertyValueStart(type) {
        return(// Normal: "key": value
        type === 'COLON' || // Missing colon: "key" "value"
        this.isPrimitiveToken(type) || // Missing colon: "key" {...}
        this.isStartOfStructure(type));
    }
    isObjectStart() {
        if (this.currentToken.type !== 'STRING') return false;
        const savedPosition = this.tokenizer.getPosition();
        const savedToken = this.currentToken;
        const nextToken = this.tokenizer.nextToken();
        const isObject = this.isObjectPropertyValueStart(nextToken.type);
        this.tokenizer.reset(this.accumulatedInput, savedPosition);
        this.currentToken = savedToken;
        return isObject;
    }
    /**
   * Process remaining lifted nodes at the end of a content array.
   * Both immediate and accumulated nodes are primarily processed inline during parsing,
   * but this handles any that couldn't be inserted and need to bubble up.
   * At root level, invalid nodes are repaired (wrapped) instead of being lost.
   * @param skipImmediateProcessing If true, skip processing immediate nodes (they all bubble up).
   *        This is used when liftMode was active - remaining siblings should go to parent, not back to current container.
   */ processLiftedNodes(parentType, content, isValidChild, immediateCountAtStart, accumulatedCountAtStart, skipImmediateProcessing = false) {
        const isRootLevel = parentType === this.validator.getTopNodeType();
        // Process immediate lifted nodes first - these should appear right after their parent container
        // Process in order (not reverse) since they were pushed in order
        // If skipImmediateProcessing is true (liftMode was active), all nodes bubble up
        const immediateStillLifted = [];
        const immediateToProcess = this.immediateLiftedNodes.splice(immediateCountAtStart);
        for (const lifted of immediateToProcess){
            if (!skipImmediateProcessing && isValidChild(lifted.type)) content.push(lifted);
            else if (isRootLevel) // At root level, try to repair (wrap) the node instead of losing it
            this.tryAppendNodeToContent(parentType, lifted, content, isValidChild, {
                topNodeType: parentType
            });
            else immediateStillLifted.push(lifted);
        }
        // Put back any immediate nodes that couldn't be added at this level
        this.immediateLiftedNodes.push(...immediateStillLifted);
        // Process remaining accumulated lifted nodes that couldn't be inserted inline
        const accumulatedStillLifted = [];
        const accumulatedToProcess = this.accumulatedLiftedNodes.splice(accumulatedCountAtStart);
        for (const lifted of accumulatedToProcess){
            if (isValidChild(lifted.type)) content.push(lifted);
            else if (isRootLevel) // At root level, try to repair (wrap) the node instead of losing it
            this.tryAppendNodeToContent(parentType, lifted, content, isValidChild, {
                topNodeType: parentType
            });
            else accumulatedStillLifted.push(lifted);
        }
        // Put back any accumulated nodes that couldn't be added at this level
        this.accumulatedLiftedNodes.push(...accumulatedStillLifted);
    }
    /**
   * Process lifted nodes inline during content array parsing.
   * Inserts valid nodes into content in FIFO order, stops at first invalid node.
   * @param liftedNodes The lifted nodes array to process (immediate or accumulated)
   * @param content The content array to append valid nodes to
   * @param isValidChild Validator function to check if a node type is valid
   * @param startIndex The index in liftedNodes to start processing from
   */ processLiftedNodesInline(liftedNodes, content, isValidChild, startIndex) {
        while(liftedNodes.length > startIndex){
            const lifted = liftedNodes[startIndex];
            if (lifted && isValidChild(lifted.type)) {
                liftedNodes.splice(startIndex, 1);
                content.push(lifted);
            } else break;
        }
    }
    // Consume and advance if token type matches, otherwise return null
    consume(type) {
        if (this.currentToken.type === type) {
            const tok = this.currentToken;
            this.advance();
            return tok;
        }
        return null;
    }
    expectAndAdvance(tokenType) {
        this.expect(tokenType);
        if (this.currentToken.type === tokenType) this.advance();
    }
    getTryAppendOptions() {
        return {
            topNodeType: this.currentParentType || this.validator.getTopNodeType()
        };
    }
    // Execute fn within parent context scope, then restore previous parent
    withParentContext(parentType, fn) {
        const previousParent = this.currentParentType;
        this.currentParentType = parentType;
        try {
            return fn();
        } finally{
            this.currentParentType = previousParent;
        }
    }
    expectOptionalDelimiter(delimiter, context) {
        if (this.peekType(delimiter)) {
            this.advance();
            return true;
        } else if (this.peekType('STRING')) {
            this.recordRepair({
                type: 'skip',
                from: `missing_${delimiter}`,
                to: 'inferred',
                context: context
            });
            return false;
        } else if (this.peekType('EOF')) {
            this.expect(delimiter);
            return false;
        } else if (this.peekType('LEFT_BRACE') && delimiter === 'LEFT_BRACKET') return false;
        else throw new (0, $95728dc03de99a85$export$a2c8f9e7fc157799)(delimiter, this.currentToken.type, this.currentToken.position);
    }
    expect(tokenType) {
        if (this.currentToken.type !== tokenType) {
            if (this.currentToken.type === 'EOF') {
                this.hitEofDuringExpect = true;
                this.recordRepair({
                    type: 'skip',
                    from: `expected_${tokenType}`,
                    to: 'EOF',
                    context: 'streaming'
                });
                return;
            } else throw new (0, $95728dc03de99a85$export$b9b452bff3ab7d90)(tokenType, this.currentToken.type, this.currentToken.position);
        }
    }
    parsePrimitiveValue() {
        if (this.currentToken.type === 'STRING') {
            const value = this.currentToken.value;
            this.advance();
            return value;
        } else if (this.currentToken.type === 'NUMBER') {
            const value = Number(this.currentToken.value);
            this.advance();
            return value;
        } else if (this.currentToken.type === 'BOOLEAN') {
            const value = this.currentToken.value === 'true';
            this.advance();
            return value;
        } else if (this.currentToken.type === 'NULL') {
            this.advance();
            return null;
        } else {
            this.skipValue();
            return undefined;
        }
    }
    parseObjectProperties(handler, context = 'object') {
        const hasOpeningBrace = this.expectOptionalDelimiter('LEFT_BRACE', context);
        if (!hasOpeningBrace && this.peekType('EOF')) return;
        const processedKeys = new Set();
        while(!this.peekType('RIGHT_BRACE') && !this.peekType('EOF')){
            // Handle dangling `]` - likely means the object is missing its closing `}`
            // and the `]` belongs to a parent array. Auto-close the object.
            // But if we've already parsed 'content', the `]` is likely from a parent array, not a missing `}`.
            if (this.peekType('RIGHT_BRACKET') && !processedKeys.has('content')) {
                this.recordRepair({
                    type: 'infer',
                    from: 'missing_closing_brace_on_object',
                    to: 'inferred',
                    context: context
                });
                // Track position of this `]` so parent can consume one orphaned `}` after it.
                // Only set if not already set for this same `]` (avoids double-counting at nested levels).
                if (this.autoClosedOnBracketPosition !== this.currentToken.position) this.autoClosedOnBracketPosition = this.currentToken.position;
                // Don't consume the `]` - let the parent array handle it
                return;
            }
            if (!this.peekType('STRING')) {
                this.skipValue();
                continue;
            }
            const keyToken = this.consume('STRING');
            const key = keyToken?.value;
            if (this.consume('COMMA')) {
                const from = this.sanitizeNodeTypeName(key);
                this.recordRepair({
                    type: 'skip',
                    from: from,
                    to: '-',
                    context: `${context}.${from}:empty_value`
                });
                continue;
            }
            if (this.consume('COLON')) ;
            else if (this.peekType('EOF')) continue;
            else this.recordRepair({
                type: 'skip',
                from: 'missing_colon',
                to: 'inferred',
                context: `${context}.${key}`
            });
            if (processedKeys.has(key)) this.recordRepair({
                type: 'duplicate_key',
                from: this.sanitizeNodeTypeName(key),
                to: 'overwritten',
                context: context
            });
            processedKeys.add(key);
            handler(key);
            this.consume('COMMA');
        }
        this.expect('RIGHT_BRACE');
        this.consume('RIGHT_BRACE');
    }
    skipValue() {
        switch(this.currentToken.type){
            case 'STRING':
            case 'NUMBER':
            case 'BOOLEAN':
            case 'NULL':
                this.advance();
                break;
            case 'LEFT_BRACE':
                this.skipObject();
                break;
            case 'LEFT_BRACKET':
                this.skipArray();
                break;
            case 'RIGHT_BRACE':
            case 'RIGHT_BRACKET':
            case 'COMMA':
            case 'COLON':
                this.recordRepair({
                    type: 'skip',
                    from: this.currentToken.type,
                    to: '-',
                    context: 'parser'
                });
                this.advance();
                break;
            case 'EOF':
                this.recordRepair({
                    type: 'skip',
                    from: this.currentToken.type,
                    to: '-',
                    context: 'parser'
                });
                break;
            default:
                {
                    const tok = this.currentToken;
                    this.recordRepair({
                        type: 'skip',
                        from: tok.type,
                        to: '-',
                        context: 'parser'
                    });
                    this.advance();
                    break;
                }
        }
    }
    skipDelimitedSequence(openDelimiter, closeDelimiter, skipItem) {
        this.expectAndAdvance(openDelimiter);
        while(this.currentToken.type !== closeDelimiter && this.currentToken.type !== 'EOF'){
            skipItem();
            if (this.currentToken.type === 'COMMA') this.advance();
        }
        this.expectAndAdvance(closeDelimiter);
    }
    skipObject() {
        this.skipDelimitedSequence('LEFT_BRACE', 'RIGHT_BRACE', ()=>{
            this.expect('STRING');
            this.advance();
            this.expect('COLON');
            this.advance();
            this.skipValue();
        });
    }
    skipArray() {
        this.skipDelimitedSequence('LEFT_BRACKET', 'RIGHT_BRACKET', ()=>{
            this.skipValue();
        });
    }
    parseArray(parseItem, onItem) {
        this.expectAndAdvance('LEFT_BRACKET');
        while(!this.peekType('RIGHT_BRACKET') && !this.peekType('EOF')){
            if (this.consume('COMMA')) continue;
            const item = parseItem();
            if (item !== null) onItem(item);
        }
        this.expectAndAdvance('RIGHT_BRACKET');
    }
    /**
   * State container for content array parsing.
   * Groups related state variables to reduce parameter passing.
   */ initContentParseState() {
        return {
            content: [],
            liftMode: false,
            immediateCountAtStart: this.immediateLiftedNodes.length,
            accumulatedCountAtStart: this.accumulatedLiftedNodes.length
        };
    }
    /**
   * Determine if the content parsing loop should continue.
   * @param isMalformed Whether the array is malformed (missing brackets)
   */ shouldContinueContentParsing(isMalformed) {
        if (isMalformed) return this.peekType('LEFT_BRACE') || this.isObjectStart();
        return !this.peekType('RIGHT_BRACKET') && !this.peekType('EOF');
    }
    /**
   * Handle delimiter consumption in malformed array mode.
   * @returns true if parsing should break out of the loop, false to continue
   */ handleMalformedArrayDelimiters() {
        if (this.consume('COMMA')) return false; // continue
        if (this.consume('RIGHT_BRACE')) {
            if (!this.peekType('LEFT_BRACE')) return true; // break
            return false; // continue
        }
        if (this.peekType('LEFT_BRACE')) return false; // continue
        return true; // break
    }
    /**
   * Check for implicit container breaks and handle them.
   * @returns Object with liftMode flag, or null if no break needed
   */ checkImplicitContainerBreak(node, parentType) {
        if (!this.repairStrategy.shouldAttemptStructuralFix(node, parentType)) return null;
        // Only break out of non-root containers
        if (parentType === this.validator.getTopNodeType()) return null;
        this.recordRepair({
            type: 'unwrap',
            from: 'implicit_container_end',
            to: 'break_container',
            context: parentType || 'unknown'
        });
        this.immediateLiftedNodes.push(node);
        return {
            liftMode: true
        };
    }
    /**
   * Process a single content array item (node) and update state.
   */ processContentArrayNode(node, parentType, isValidChild, state, isMalformed) {
        // If we're in lift mode, remaining siblings go to immediate list
        if (state.liftMode) {
            this.immediateLiftedNodes.push(node);
            return;
        }
        // Check for implicit container breaks (only in normal array mode)
        if (!isMalformed) {
            const breakResult = this.checkImplicitContainerBreak(node, parentType);
            if (breakResult) {
                state.liftMode = true;
                return;
            }
        }
        // Try to append node to content, applying repairs if needed
        const shouldCloseContainer = this.tryAppendNodeToContent(parentType, node, state.content, isValidChild, this.getTryAppendOptions());
        // Enter lift mode if closeContainer was signaled
        if (shouldCloseContainer) state.liftMode = true;
        // Process lifted nodes inline
        this.processLiftedNodesInline(this.immediateLiftedNodes, state.content, isValidChild, state.immediateCountAtStart);
        // Also process accumulated lifted nodes inline in normal array mode
        if (!isMalformed) this.processLiftedNodesInline(this.accumulatedLiftedNodes, state.content, isValidChild, state.accumulatedCountAtStart);
    }
    /**
   * Finalize content array parsing: handle closing bracket and orphaned braces.
   */ finalizeContentArray(parentType, state, isValidChild, isMalformed) {
        // Handle closing bracket for normal arrays
        if (!isMalformed) {
            this.expectAndAdvance('RIGHT_BRACKET');
            // Handle orphaned closing brace from auto-closed objects
            if (this.autoClosedOnBracketPosition >= 0 && this.peekType('RIGHT_BRACE')) {
                this.recordRepair({
                    type: 'skip',
                    from: 'orphaned_closing_brace',
                    to: '-',
                    context: parentType || 'content'
                });
                this.advance();
                this.autoClosedOnBracketPosition = -1;
            }
        }
        // Process any remaining lifted nodes
        this.processLiftedNodes(parentType, state.content, isValidChild, state.immediateCountAtStart, state.accumulatedCountAtStart, state.liftMode);
    }
    /**
   * Handle error cases when content array cannot be parsed.
   */ handleContentArrayError(parentType) {
        if (this.peekType('EOF')) {
            this.expect('LEFT_BRACKET');
            return [];
        }
        // Unexpected token
        this.recordRepair({
            type: 'skip',
            from: this.currentToken.type,
            to: 'empty_array',
            context: parentType || 'content'
        });
        this.skipValue();
        return [];
    }
    /**
   * Parse a content array, handling both malformed (missing brackets) and normal arrays.
   */ parseContentArray(parentType) {
        const isValidChild = this.validator.isValidChild(parentType);
        // Detect array format: malformed (missing brackets) vs normal
        const isMalformed = this.peekType('LEFT_BRACE');
        if (isMalformed) // Record repair for missing brackets
        this.recordRepair({
            type: 'skip',
            from: 'missing_brackets',
            to: 'inferred_array',
            context: parentType || 'content'
        });
        else if (!this.consume('LEFT_BRACKET')) // Handle EOF and unexpected token cases
        return this.handleContentArrayError(parentType);
        // Initialize parsing state
        const state = this.initContentParseState();
        // Unified parsing loop
        while(this.shouldContinueContentParsing(isMalformed)){
            // Handle delimiters in normal array mode
            if (!isMalformed && (this.consume('COMMA') || this.consume('RIGHT_BRACE'))) continue;
            // Parse content node if we're at an object start
            if (this.peekType('LEFT_BRACE') || this.isObjectStart()) {
                const node = this.parseContentNode();
                if (node) this.processContentArrayNode(node, parentType, isValidChild, state, isMalformed);
                // Handle delimiters in malformed array mode (after node parsing)
                if (isMalformed && this.handleMalformedArrayDelimiters()) break;
            } else if (!isMalformed) this.skipValue();
            else break;
        }
        // Finalize and return
        this.finalizeContentArray(parentType, state, isValidChild, isMalformed);
        return state.content;
    }
    parseMarks() {
        const marks = [];
        this.parseArray(()=>{
            if (this.currentToken.type !== 'LEFT_BRACE') {
                this.skipValue();
                return null;
            }
            const mark = {};
            this.parseObjectProperties((key)=>{
                if (key === 'type') {
                    if (this.currentToken.type === 'STRING') {
                        mark.type = this.currentToken.value;
                        this.advance();
                    } else this.skipValue();
                } else if (key === 'attrs') {
                    if (this.currentToken.type === 'LEFT_BRACE') mark.attrs = this.parseAttrs();
                    else this.skipValue();
                } else this.skipValue();
            }, 'marks');
            return mark.type ? mark : null;
        }, (m)=>marks.push(m));
        return marks;
    }
    parseArbitraryValue() {
        if (this.currentToken.type === 'LEFT_BRACE') return this.parseArbitraryObject();
        else if (this.currentToken.type === 'LEFT_BRACKET') return this.parseArbitraryArray();
        else return this.parsePrimitiveValue();
    }
    parseArbitraryObject() {
        const obj = {};
        this.parseObjectProperties((key)=>{
            obj[key] = this.parseArbitraryValue();
        }, 'attrs');
        return obj;
    }
    parseArbitraryArray() {
        const arr = [];
        this.parseArray(()=>this.parseArbitraryValue(), (item)=>arr.push(item));
        return arr;
    }
    parseAttrs() {
        if ((0, $iDrrr.fg)('platform_adf_parser_arbitrary_values')) return this.parseArbitraryObject();
        const attrs = {};
        this.parseObjectProperties((key)=>{
            attrs[key] = this.parsePrimitiveValue();
        }, 'attrs');
        return attrs;
    }
    parseRootNode() {
        const node = {};
        this.parseObjectProperties((key)=>{
            if (key === 'version') {
                if (this.currentToken.type === 'NUMBER') {
                    node.version = Number(this.currentToken.value);
                    this.advance();
                } else this.skipValue();
            } else if (key === 'type') {
                if (this.currentToken.type === 'STRING') {
                    node.type = this.currentToken.value;
                    this.advance();
                } else this.skipValue();
            } else if (key === 'content') node.content = this.withParentContext(node.type, ()=>this.parseContentArray(node.type));
            else if (key === 'attrs') {
                if (this.currentToken.type === 'LEFT_BRACE') node.attrs = this.parseAttrs();
                else this.skipValue();
            } else if (key === 'text') {
                if (this.currentToken.type === 'STRING') {
                    node.text = this.currentToken.value;
                    this.advance();
                } else this.skipValue();
            } else if (key === 'marks') {
                if (this.currentToken.type === 'LEFT_BRACKET') node.marks = this.parseMarks();
                else this.skipValue();
            } else if ((0, $iDrrr.fg)('platform_adf_parser_arbitrary_values')) {
                const value = this.parseArbitraryValue();
                node[key] = value;
            } else {
                const value = this.parsePrimitiveValue();
                node[key] = value;
            }
        }, node.type || 'root');
        // If no type specified, infer it as the top node type
        if (!node.type) {
            const topNodeType = this.validator.getTopNodeType();
            node.type = topNodeType;
            this.recordRepair({
                type: 'infer',
                from: 'missing_type',
                to: topNodeType,
                context: 'root'
            });
        }
        // Apply mutations to root node (fix timestamps, etc.)
        this.repairStrategy.applyNodeMutations(node);
        // Default content to empty array for non-leaf nodes if not provided
        if (node.content === undefined && !this.validator.isLeafNode(node.type)) node.content = [];
        return node;
    }
    parseContentNode() {
        const node = {};
        let handle;
        let nodeStartPosition;
        this.parseObjectProperties((key)=>{
            if (key === 'type') {
                this.expect('STRING');
                nodeStartPosition = this.currentToken.position;
                node.type = this.currentToken.value;
                this.advance();
                // Early fuzzy matching: correct unknown types before children are parsed
                // so that children see a valid parent context for their own fuzzy matching.
                if (node.type) {
                    const match = this.repairStrategy.tryFuzzyMatchType(node.type);
                    if (match) {
                        this.recordRepair({
                            type: 'infer',
                            from: 'unknown',
                            to: match.correctedType,
                            context: `fuzzy_match:d=${match.distance}:max=${match.maxDistance}`
                        });
                        node.type = match.correctedType;
                    }
                }
                // Check if we've already seen this node (by position) in a previous chunk
                const existingHandle = this.nodeHandlesByPosition.get(nodeStartPosition);
                if (existingHandle) // Reuse existing handle for updates
                handle = existingHandle;
                else if (this.callbacks.onNodeStart && node.type) {
                    // First time seeing this node - call onNodeStart
                    handle = this.callbacks.onNodeStart(node.type, this.currentParentType);
                    if (handle !== undefined) this.nodeHandlesByPosition.set(nodeStartPosition, handle);
                }
            } else if (key === 'content') {
                node.content = this.withParentContext(node.type, ()=>this.parseContentArray(node.type));
                this.updateNodeHandle(handle, {
                    content: node.content
                });
            } else if (key === 'attrs') {
                if (this.currentToken.type === 'LEFT_BRACE') {
                    node.attrs = this.parseAttrs();
                    this.updateNodeHandle(handle, {
                        attrs: node.attrs
                    });
                } else this.skipValue();
            } else if (key === 'text') {
                if (this.currentToken.type === 'STRING') {
                    node.text = this.currentToken.value;
                    this.advance();
                    this.updateNodeHandle(handle, {
                        text: node.text
                    });
                } else this.skipValue();
            } else if (key === 'marks') {
                if (this.currentToken.type === 'LEFT_BRACKET') {
                    node.marks = this.parseMarks();
                    this.updateNodeHandle(handle, {
                        marks: node.marks
                    });
                } else this.skipValue();
            } else if ((0, $iDrrr.fg)('platform_adf_parser_arbitrary_values')) {
                const value = this.parseArbitraryValue();
                node[key] = value;
                if (value !== undefined) this.updateNodeHandle(handle, {
                    [key]: value
                });
            } else {
                const value = this.parsePrimitiveValue();
                node[key] = value;
                if (value !== undefined) this.updateNodeHandle(handle, {
                    [key]: value
                });
            }
        }, 'node');
        // Let repair strategy handle missing types
        const completeNode = node;
        if (completeNode && handle) {
            this.callbacks.onNodeComplete?.(handle, completeNode);
            this.nodeHandles.set(completeNode, handle);
        }
        return completeNode;
    }
    resetParserState(input, clearNodeHandles = true) {
        this.repairs = [];
        this.accumulatedInput = input;
        this.parseComplete = false;
        this.cachedDocument = $92670691a884989a$export$24f3e5766c70b302;
        this.hitEofDuringExpect = false;
        this.immediateLiftedNodes = [];
        this.accumulatedLiftedNodes = [];
        this.autoClosedOnBracketPosition = -1;
        if (clearNodeHandles) this.nodeHandles.clear();
    }
    /**
   * Parse a complete JSON string into an ADF document.
   * This is for synchronous, non-streaming parsing.
   *
   * @param input - The complete JSON string to parse
   * @returns The parsed ADF document
   */ parse(input) {
        // Reset parser state for new document
        this.resetParserState(input);
        // Reset tokenizer with new input
        this.tokenizer.reset(input, 0);
        this.currentToken = this.tokenizer.nextToken();
        const doc = this.parseDocument();
        this.parseComplete = true;
        this.cachedDocument = doc;
        return doc;
    }
    // Internal: shared parsing logic (expects tokenizer to be initialized)
    parseDocument() {
        const rootNode = this.parseRootNode();
        // If root node has content, validate it
        if (Array.isArray(rootNode.content)) {
            const isValidChild = this.validator.isValidChild(rootNode.type);
            for (const node of rootNode.content)if (node.type) isValidChild(node.type);
        }
        // Handle any additional nodes after the root (for multiple top-level objects)
        const allContent = Array.isArray(rootNode.content) ? [
            ...rootNode.content
        ] : [];
        const isValidChild = this.validator.isValidChild(rootNode.type);
        while(this.currentToken.type !== 'EOF'){
            if (this.currentToken.type === 'COMMA') {
                this.advance();
                continue;
            }
            if (this.currentToken.type === 'LEFT_BRACE') {
                const fragment = this.parseContentNode();
                if (fragment && typeof fragment === 'object') this.tryAppendNodeToContent(rootNode.type, fragment, allContent, isValidChild, {
                    topNodeType: rootNode.type
                });
            } else this.advance();
        }
        // Update content if we added more nodes
        if (allContent.length > 0 || Array.isArray(rootNode.content)) rootNode.content = allContent;
        return rootNode;
    }
    constructor(options){
        this.tokenizer = void 0;
        this.currentToken = void 0;
        this.repairs = [];
        this.validator = void 0;
        this.repairStrategy = void 0;
        this.hitEofDuringExpect = false;
        this.config = void 0;
        // Nodes lifted from simple containers (closeContainer=true) - insert at next valid position
        this.immediateLiftedNodes = [];
        // Nodes lifted from compound nodes (closeContainer=false) - insert at next valid position
        this.accumulatedLiftedNodes = [];
        // Tracks the position of a `]` that triggered auto-close, to consume one orphaned `}`
        this.autoClosedOnBracketPosition = -1;
        // Streaming-specific state
        this.callbacks = void 0;
        this.currentParentType = undefined;
        this.nodeHandles = new Map();
        this.nodeHandlesByPosition = new Map();
        // Track handles by node position
        this.accumulatedInput = '';
        this.parseComplete = false;
        this.cachedDocument = $92670691a884989a$export$24f3e5766c70b302;
        this.lastChunkReceived = false;
        this.validator = options.schemaValidator;
        this.repairStrategy = options.repairStrategy;
        this.callbacks = options.callbacks ?? {};
        this.config = options.config ?? {};
        this.repairStrategy.setAdfParserConfig(this.config);
        // Initialize with empty input - will be set by parse() or processChunk()
        this.tokenizer = new (0, $74c73f70fa440f5b$export$947fa7da412978d0)('', (repair)=>this.recordRepair(repair));
        this.currentToken = this.tokenizer.nextToken();
        this.accumulatedInput = '';
    }
}


var $4fqm1 = parcelRequire("4fqm1");





// eslint-disable-next-line require-unicode-regexp
const $4a960532d31faece$var$DIGITS_ONLY_REGEX = /^\d+$/;
class $4a960532d31faece$export$62e711fe8d5e8f73 {
    setAdfParserConfig(_config) {
    // The built-in repair strategy currently has no configurable behavior.
    }
    getNodeType(nodeType) {
        const $nodeType = this.schema.nodes[nodeType];
        return $nodeType || null;
    }
    wrapNodeWithType(node, $nodeType) {
        const $content = this.schema.nodeFromJSON(node);
        const $newContent = $nodeType.createAndFill(null, $content);
        return $newContent?.toJSON() ?? null;
    }
    wrapNode(node, $nodeType, $parentNodeType, siblings) {
        const contentMatch = this.findContentMatchAtPosition($parentNodeType, siblings);
        const wrappers = contentMatch?.findWrapping($nodeType);
        if (!wrappers || wrappers.length === 0) return null;
        let $content = this.schema.nodeFromJSON(node);
        for(let i = wrappers.length - 1; i >= 0; i--){
            const wrapper = wrappers[i];
            const match = wrapper?.contentMatch?.matchType($content.type);
            if (!match || !match.validEnd) return null;
            const $newContent = wrapper?.createAndFill(null, $content);
            if (!$newContent) return null;
            $content = $newContent;
        }
        return $content.toJSON();
    }
    // Convert a mark node (e.g., strong, em) to a proper text node with marks
    convertMarkNodeToMark(node, $parentNodeType) {
        // ProseMirror doesn't allow empty text nodes, use space as fallback
        const text = node.text && node.text.length > 0 ? node.text : ' ';
        const $textNode = this.schema.text(text, [
            this.schema.mark(node.type)
        ]);
        if ($parentNodeType.isTextblock) /**
       * To produce valid ADF, we need to use JSON Transformer
       * However, it will slow down the repair process
       * So, we are ignoring it for now
       */ return $textNode.toJSON();
        // Convert to JSON before wrapping (don't pass the original mark-as-node)
        const textNodeJson = $textNode.toJSON();
        const wrapped = this.wrapNode(textNodeJson, $textNode.type, $parentNodeType, []);
        return wrapped ?? textNodeJson;
    }
    isTableCellNode(node) {
        return node.type === 'tableCell' || node.type === 'tableHeader';
    }
    isListNode(node) {
        return $4a960532d31faece$export$62e711fe8d5e8f73.LIST_NODE_TYPES.has(node.type);
    }
    // Block containers that should be lifted to parent level when invalid in current context
    isLiftableBlockContainer(nodeType) {
        return $4a960532d31faece$export$62e711fe8d5e8f73.LIFTABLE_BLOCK_CONTAINERS.has(nodeType);
    }
    // Simple containers: when an invalid liftable node is encountered, close the container
    // and lift everything (the invalid node + remaining siblings)
    // Compound nodes require multiple parts to function (list needs listItems, table needs rows/cells)
    // When lifting from these, we just accumulate and insert later, don't close the parent
    isSimpleContainer(parentType) {
        return parentType ? $4a960532d31faece$export$62e711fe8d5e8f73.SIMPLE_CONTAINERS.has(parentType) : false;
    }
    // Append node to last sibling if it matches targetType, otherwise null
    appendToLastSibling(node, siblings, targetType) {
        const lastSibling = siblings[siblings.length - 1];
        if (lastSibling && lastSibling.type === targetType) {
            if (!lastSibling.content) lastSibling.content = [];
            lastSibling.content.push(node);
            return []; // Node consumed
        }
        return null;
    }
    /**
   * Generic wrapper function that tries to append a node to existing structures or creates a new wrapper.
   *
   * @param node - The node to wrap/append
   * @param siblings - Sibling nodes to check
   * @param options - Configuration for how to append/wrap
   * @returns The wrapped node or empty array if consumed
   */ wrapOrAppendNode(node, siblings, options) {
        const lastSibling = siblings[siblings.length - 1];
        const parentTypes = Array.isArray(options.directParentTypes) ? options.directParentTypes : [
            options.directParentTypes
        ];
        if (lastSibling) {
            // Check for direct parent match at sibling level
            if (parentTypes.includes(lastSibling.type)) {
                // Handle nested parent type (e.g., table > tableRow for tableCell)
                if (options.nestedParentType) {
                    if (!lastSibling.content) lastSibling.content = [];
                    if (lastSibling.content.length > 0) {
                        const lastContent = lastSibling.content[lastSibling.content.length - 1];
                        if (lastContent && lastContent.type === options.nestedParentType) {
                            // Found nested parent - append to it
                            if (!lastContent.content) lastContent.content = [];
                            lastContent.content.push(node);
                            return []; // Node consumed
                        }
                    }
                    // Nested parent not found but createNestedIfMissing is true
                    if (options.createNestedIfMissing) {
                        lastSibling.content.push({
                            type: options.nestedParentType,
                            content: [
                                node
                            ]
                        });
                        return []; // Node consumed
                    }
                } else {
                    // No nested parent type - append directly
                    if (!lastSibling.content) lastSibling.content = [];
                    lastSibling.content.push(node);
                    return []; // Node consumed
                }
            }
            // Check one level deep for parent match (e.g., expand > bulletList for listItem)
            if (options.checkNestedParent && lastSibling.content && Array.isArray(lastSibling.content) && lastSibling.content.length > 0) {
                const lastContent = lastSibling.content[lastSibling.content.length - 1];
                if (lastContent && parentTypes.includes(lastContent.type)) {
                    if (!lastContent.content) lastContent.content = [];
                    lastContent.content.push(node);
                    return []; // Node consumed
                }
            }
        }
        // No match found - return default wrapper
        return options.defaultWrapper;
    }
    appendToLastTableRow(node, siblings) {
        return this.appendToLastSibling(node, siblings, 'tableRow');
    }
    wrapTableRow(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: 'table',
            defaultWrapper: {
                type: 'table',
                attrs: {
                    isNumberColumnEnabled: false
                },
                content: [
                    node
                ]
            }
        });
    }
    wrapListItem(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: [
                'bulletList',
                'orderedList'
            ],
            checkNestedParent: true,
            // Check expand > bulletList
            defaultWrapper: {
                type: 'bulletList',
                content: [
                    node
                ]
            }
        });
    }
    wrapTaskItem(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: 'taskList',
            checkNestedParent: true,
            // Check expand > taskList
            defaultWrapper: {
                type: 'taskList',
                attrs: {
                    localId: null
                },
                content: [
                    node
                ]
            }
        });
    }
    /**
   * Lift inner listItems from a nested list to the parent list level.
   * Used when a list appears as the first child of a listItem (invalid position).
   *
   * Example: listItem > bulletList > [listItem A, listItem B]
   * Returns: LiftedNode containing [listItem A, listItem B] to be inserted at bulletList level
   *
   * @param listNode - The nested list node containing listItems to lift
   * @returns LiftedNode with the inner listItems, or null if no items to lift
   */ liftNestedListItems(listNode) {
        if (!listNode.content || listNode.content.length === 0) return null;
        // Return the inner listItems as lifted nodes
        // closeContainer=true so the outer (now empty) listItem is closed
        return {
            [(0, $10068d507b2ca0c8$export$c289a768a80ae97c)]: true,
            node: listNode.content,
            closeContainer: true
        };
    }
    wrapTableCell(node, siblings) {
        return this.wrapOrAppendNode(node, siblings, {
            directParentTypes: 'table',
            nestedParentType: 'tableRow',
            // table > tableRow > tableCell
            createNestedIfMissing: true,
            // Create tableRow if table exists but no tableRow
            defaultWrapper: {
                type: 'table',
                attrs: {
                    isNumberColumnEnabled: false
                },
                content: [
                    {
                        type: 'tableRow',
                        content: [
                            node
                        ]
                    }
                ]
            }
        });
    }
    shouldAttemptStructuralFix(node, parentType) {
        if (parentType === 'table') // Only attempt structural fix (breaking out) if it's NOT a table part.
        // Table cells/headers are "invalid" but should be handled by wrapping, not breaking.
        return node.type !== 'tableRow' && !this.isTableCellNode(node);
        else if (this.isTableCellNode({
            type: parentType || ''
        }) && node.type === 'tableRow' || parentType === 'tableRow' && !this.isTableCellNode(node)) return true;
        return parentType === 'doc' && (node.type === 'tableRow' || this.isTableCellNode(node));
    }
    tryFuzzyMatchType(nodeType) {
        // Already a valid node or mark type, no correction needed
        if (this.getNodeType(nodeType) !== null || this.schema.marks[nodeType]) return null;
        const allTypes = this.getAllTypeNames();
        if (allTypes.length === 0) return null;
        const closestType = (0, $4fqm1.closest)(nodeType, allTypes);
        if (!closestType) return null;
        const actualDistance = (0, $4fqm1.distance)(nodeType, closestType);
        const maxDistance = Math.max($4a960532d31faece$export$62e711fe8d5e8f73.FUZZY_MIN_DISTANCE, Math.floor(nodeType.length * $4a960532d31faece$export$62e711fe8d5e8f73.FUZZY_DISTANCE_RATIO));
        if (actualDistance <= maxDistance) return {
            correctedType: closestType,
            distance: actualDistance,
            maxDistance: maxDistance
        };
        return null;
    }
    /**
   * Get all node and mark type names in the schema (cached after first call).
   */ getAllTypeNames() {
        if (this.allTypeNames === null) this.allTypeNames = [
            ...Object.keys(this.schema.nodes),
            ...Object.keys(this.schema.marks)
        ];
        return this.allTypeNames;
    }
    isMarkWithOutAttrs(nodeType) {
        const mark = this.schema.marks[nodeType];
        if (!mark) return false;
        return !mark.spec.attrs || Object.keys(mark.spec.attrs).length === 0;
    }
    /**
   * Check if a mark has valid attributes according to the schema.
   * A mark is valid if:
   * 1. It has a known type in the schema
   * 2. All required attributes (those without a default value) are present and non-null
   */ isMarkValid(mark) {
        const markType = mark.type;
        const markSpec = this.schema.marks[markType];
        // Mark type must exist in schema
        if (!markSpec) return false;
        // If the mark has no attribute spec, it's valid
        if (!markSpec.spec.attrs) return true;
        // Check each attribute defined in the schema
        const attrs = mark.attrs;
        for(const attrName in markSpec.spec.attrs){
            if (!markSpec.spec.attrs.hasOwnProperty(attrName)) continue;
            const attrSpec = markSpec.spec.attrs[attrName];
            if (!attrSpec) continue;
            // Check if this attribute has a default value
            // Attributes with defaults are optional, those without are required
            const hasDefault = attrSpec.default !== undefined;
            if (!hasDefault) {
                // This is a required attribute - check if it's present and non-null
                if (!attrs || attrs[attrName] === null || attrs[attrName] === undefined) return false;
            }
        }
        return true;
    }
    /**
   * Filters out marks that are mutually exclusive according to the schema's
   * `excludes` rules. Marks are processed in order; a mark is kept only if it
   * neither excludes, nor is excluded by, any mark already kept. This mirrors
   * ProseMirror's mark application semantics, where applying a mark that
   * excludes existing marks removes them. For example, `code` excludes all
   * other marks in the default schema, so a `[code, strong]` combination is
   * reduced to `[code]`.
   *
   * Marks whose types are not present in the schema are passed through
   * untouched here — attribute/type validity is handled separately by
   * `isMarkValid`.
   */ filterExcludedMarks(marks) {
        if (marks.length < 2) return marks;
        const kept = [];
        for (const mark of marks){
            const markType = this.schema.marks[mark.type];
            // Unknown mark type — leave it to other validation; keep as-is.
            if (!markType) {
                kept.push(mark);
                continue;
            }
            const conflicts = kept.some((keptMark)=>{
                const keptType = this.schema.marks[keptMark.type];
                if (!keptType) return false;
                return markType.excludes(keptType) || keptType.excludes(markType);
            });
            if (!conflicts) kept.push(mark);
        }
        return kept;
    }
    findContentMatchAtPosition($parentNodeType, siblings) {
        let currentMatch = $parentNodeType.contentMatch;
        for (const sibling of siblings){
            if (!currentMatch) return null;
            const siblingType = this.getNodeType(sibling.type);
            currentMatch = siblingType ? currentMatch.matchType(siblingType) : null;
        }
        return currentMatch;
    }
    isTypeAllowedAt($parentNodeType, siblings) {
        return ($nodeType)=>this.findContentMatchAtPosition($parentNodeType, siblings)?.matchType($nodeType) !== null;
    }
    applyNodeMutations(node) {
        let wasMutated = false;
        // Infer missing type from node properties
        if (!node.type && node.text !== undefined) {
            node.type = 'text';
            wasMutated = true;
        }
        // If still no type, can't proceed with type-specific mutations
        if (!node.type) return wasMutated;
        switch(node.type){
            case 'date':
                const today = new Date().getTime().toString();
                node.attrs = node.attrs || {};
                if (node.attrs.timestamp) {
                    if (typeof node.attrs.timestamp === 'string' && !node.attrs.timestamp.match($4a960532d31faece$var$DIGITS_ONLY_REGEX)) {
                        const d = new Date(node.attrs.timestamp);
                        node.attrs.timestamp = isNaN(d.getTime()) ? today : d.getTime().toString();
                        wasMutated = true;
                    }
                } else {
                    node.attrs.timestamp = today;
                    wasMutated = true;
                }
                break;
        }
        if (node.attrs && node.attrs.localId && typeof node.attrs.localId === 'string') {
            node.attrs.localId = node.attrs.localId.substring(0, 36);
            wasMutated = true;
        }
        // Fix marks with invalid attributes
        let hasInvalidMarks = false;
        if (node.marks && Array.isArray(node.marks)) {
            const filteredMarks = [];
            for (const mark of node.marks)// Validate mark has valid attributes according to schema
            if (this.isMarkValid(mark)) filteredMarks.push(mark);
            else // Mark has invalid attributes, skip it
            hasInvalidMarks = true;
            // Drop marks that are mutually exclusive per the schema's `excludes`
            // rules (e.g. `code` excludes `strong`). Individual marks can each be
            // valid in isolation but invalid in combination, which would later make
            // `node.check()` throw `Invalid collection of marks` and silently drop
            // the whole node downstream.
            const exclusivityFiltered = (0, $iDrrr.fg)('platform_editor_adf_repair_filter_excluded_marks') ? this.filterExcludedMarks(filteredMarks) : filteredMarks;
            if (exclusivityFiltered.length !== filteredMarks.length) hasInvalidMarks = true;
            if (hasInvalidMarks) {
                wasMutated = true;
                node.marks = exclusivityFiltered;
            }
        }
        return wasMutated;
    }
    tryRepair(node, parentType, siblings, isInvalid = false) {
        // Apply mutations first (in-place data type fixes, including type inference)
        const wasMutated = this.applyNodeMutations(node);
        // If still no type after mutations, can't repair
        if (!node.type) return null;
        let $parentNodeType;
        if (parentType) $parentNodeType = this.schema.nodes[parentType];
        // Handle marks (strong, em, etc.) appearing as nodes FIRST
        // before trying to access as node types
        if (this.isMarkWithOutAttrs(node.type)) return this.convertMarkNodeToMark(node, $parentNodeType || this.schema.topNodeType);
        const $nodeType = this.schema.nodes[node.type];
        if (!$nodeType) return null;
        if (parentType && $parentNodeType) {
            // Wrap orphaned inline nodes in paragraphs where allowed
            if ($nodeType.isInline) {
                const wrapped = this.wrapNode(node, $nodeType, $parentNodeType, siblings);
                if (wrapped) return wrapped;
            }
            // Unwrap textblocks nested inside other textblocks
            // paragraph -> taskItem, heading -> paragraph, etc.
            if ($parentNodeType.isTextblock && $nodeType.isTextblock) return node.content || null;
            // Handle block containers (panel, blockquote, expand, table) when invalid in current context
            // For simple containers (panel, blockquote): close container and lift all remaining
            // For compound nodes (listItem, tableCell): just accumulate and insert later
            if (isInvalid && this.isLiftableBlockContainer(node.type)) return {
                [(0, $10068d507b2ca0c8$export$c289a768a80ae97c)]: true,
                node: node,
                closeContainer: this.isSimpleContainer(parentType)
            };
            const isTypeAllowed = this.isTypeAllowedAt($parentNodeType, siblings);
            const $nestedExpandType = this.schema.nodes['nestedExpand'];
            if ($nestedExpandType && node.type === 'expand' && isTypeAllowed($nestedExpandType)) return {
                ...node,
                type: 'nestedExpand'
            };
            const $tableType = this.schema.nodes['table'];
            if ($tableType && this.isTableCellNode(node) && isTypeAllowed($tableType)) return this.wrapTableCell(node, siblings);
            // Handle special cases that need custom logic
            switch(parentType){
                case 'doc':
                    if (node.type === 'tableRow') return this.wrapTableRow(node, siblings);
                    if (node.type === 'listItem') return this.wrapListItem(node, siblings);
                    if (node.type === 'taskItem') return this.wrapTaskItem(node, siblings);
                    break;
                case 'expand':
                case 'nestedExpand':
                    if (node.type === 'listItem') return this.wrapListItem(node, siblings);
                    if (node.type === 'taskItem') return this.wrapTaskItem(node, siblings);
                    break;
                case 'table':
                    if (this.isTableCellNode(node)) return this.appendToLastTableRow(node, siblings);
                    break;
                case 'listItem':
                case 'taskItem':
                    // When a list is the first child of a listItem (invalid position), lift its items.
                    // The inner listItems are lifted to the parent list level, replacing the outer listItem.
                    // This transforms: bulletList > listItem > bulletList > [listItem A, listItem B]
                    // Into: bulletList > [listItem A, listItem B]
                    if (isInvalid && this.isListNode(node) && siblings.length === 0) return this.liftNestedListItems(node);
                    break;
                case 'bulletList':
                case 'orderedList':
                    if (this.isListNode(node)) return {
                        type: 'listItem',
                        content: [
                            node
                        ]
                    };
                    else {
                        const wrapped = this.wrapNode(node, $nodeType, $parentNodeType, siblings);
                        if (wrapped) return wrapped;
                    }
                    break;
                case 'paragraph':
                    // bulletList/orderedList/taskList nodes cannot be children of paragraph
                    // Return as array to signal unwrap operation (will replace paragraph with bulletList)
                    if (this.isListNode(node)) return [
                        node
                    ];
                    break;
            }
            // Generic wrapping fallback
            for (const [nodeType, wrapperType] of this.wrappingMap){
                const $wrapperType = this.schema.nodes[wrapperType];
                if ($wrapperType && node.type === nodeType && isTypeAllowed($wrapperType)) return this.wrapNodeWithType(node, $wrapperType);
            }
        }
        // Return mutated node if no structural repair was needed
        return wasMutated ? node : null;
    }
    // eslint-disable-next-line no-useless-constructor
    constructor(schema){
        this.schema = schema;
        /** Cached list of all node + mark type names in the schema (computed once). */ this.allTypeNames = null;
        this.wrappingMap = [
            // NOTE: listItem and taskItem have special handling in switch statement below for intelligent append
            [
                'paragraph',
                'blockTaskItem'
            ],
            [
                'listItem',
                'bulletList'
            ],
            [
                'taskItem',
                'taskList'
            ]
        ];
    }
}
/**
 * Fuzzy matching thresholds:
 * maxDistance = max(FUZZY_MIN_DISTANCE, floor(typeLength * FUZZY_DISTANCE_RATIO))
 *
 * - FUZZY_MIN_DISTANCE: Allow at least 2 edits — covers single-char typos
 *   and prefix errors like ":paragraph" → "paragraph" (distance 1).
 * - FUZZY_DISTANCE_RATIO: Allow up to 30% of the type name length for longer
 *   names, e.g. 3 edits for a 10-char type like "+tableHeader".
 */ $4a960532d31faece$export$62e711fe8d5e8f73.FUZZY_MIN_DISTANCE = 2;
$4a960532d31faece$export$62e711fe8d5e8f73.FUZZY_DISTANCE_RATIO = 0.3;
$4a960532d31faece$export$62e711fe8d5e8f73.LIST_NODE_TYPES = new Set([
    'bulletList',
    'orderedList',
    'taskList'
]);
$4a960532d31faece$export$62e711fe8d5e8f73.LIFTABLE_BLOCK_CONTAINERS = new Set([
    'panel',
    'blockquote',
    'expand',
    'nestedExpand',
    'table',
    'codeBlock',
    'bodiedExtension',
    'extensionFrame'
]);
$4a960532d31faece$export$62e711fe8d5e8f73.SIMPLE_CONTAINERS = new Set([
    'panel',
    'blockquote',
    'expand',
    'nestedExpand',
    'bodiedExtension'
]);

class $201c35c7e4a749b1$export$c034a5beeae7d184 {
    isValidChild(parentType) {
        const resolvedParentType = parentType || this.getTopNodeType();
        const $parentNodeType = this.schema.nodes[resolvedParentType];
        if (!$parentNodeType || !$parentNodeType.contentMatch) return ()=>true;
        // Closure maintains contentMatch state
        let currentMatch = $parentNodeType.contentMatch;
        return (childType)=>{
            const childNodeType = this.schema.nodes[childType];
            if (!childNodeType) return false;
            const nextMatch = currentMatch.matchType(childNodeType);
            if (nextMatch) {
                currentMatch = nextMatch;
                return true;
            }
            return false;
        };
    }
    isLeafNode(nodeType) {
        const $nodeType = this.schema.nodes[nodeType];
        return $nodeType ? $nodeType.isLeaf : false;
    }
    getTopNodeType() {
        return this.schema.topNodeType?.name || 'doc';
    }
    isValidNodeType(nodeType) {
        return this.nodes.has(nodeType);
    }
    isValidMarkType(markType) {
        return this.marks.has(markType);
    }
    constructor(schema){
        this.schema = schema;
        this.nodes = void 0;
        this.marks = void 0;
        this.nodes = new Set(Object.keys(schema.nodes));
        this.marks = new Set(Object.keys(schema.marks));
    }
}



const $e45e8781eebf51c5$var$DOC_ENVELOPE_PREFIX = '{"type":"doc"';
function $e45e8781eebf51c5$var$firstNonWhitespaceChar(value) {
    if (!value) return null;
    return value.trimStart().charAt(0) || null;
}
function $e45e8781eebf51c5$var$startsWithDocEnvelope(value) {
    return Boolean(value?.trimStart().startsWith($e45e8781eebf51c5$var$DOC_ENVELOPE_PREFIX));
}
/**
 * Build a shape-only debug descriptor for a create-stream chunk.
 *
 * IMPORTANT: never include the raw `chunk` or `accumulatedBefore` values in the
 * returned object — only lengths, booleans and the first structural token.
 */ function $e45e8781eebf51c5$var$describeCreateChunk({ actionId: actionId, traceId: traceId, chunk: chunk, chunkIndex: chunkIndex, accumulatedBefore: accumulatedBefore, isFinished: isFinished, parserPhase: parserPhase }) {
    const chunkFirstToken = $e45e8781eebf51c5$var$firstNonWhitespaceChar(chunk);
    const accumulatedFirstToken = $e45e8781eebf51c5$var$firstNonWhitespaceChar(accumulatedBefore);
    return {
        streamDebugVersion: 2,
        streamType: 'create',
        parserPhase: parserPhase,
        actionId: actionId,
        traceId: traceId,
        chunkIndex: chunkIndex,
        chunkLength: chunk.length,
        chunkFirstNonWhitespaceChar: chunkFirstToken,
        chunkStartsWithComma: chunkFirstToken === ',',
        chunkStartsWithDocEnvelope: $e45e8781eebf51c5$var$startsWithDocEnvelope(chunk),
        isFinished: isFinished,
        accumulatedLengthBefore: accumulatedBefore.length,
        accumulatedFirstNonWhitespaceCharBefore: accumulatedFirstToken,
        accumulatedStartsWithDocEnvelopeBefore: $e45e8781eebf51c5$var$startsWithDocEnvelope(accumulatedBefore),
        accumulatedWasEmptyBefore: accumulatedBefore.length === 0
    };
}
function $e45e8781eebf51c5$var$withError(debug, error) {
    return {
        ...debug,
        errorName: error instanceof Error ? error.name : undefined,
        errorMessage: error instanceof Error ? error.message : String(error)
    };
}
function $e45e8781eebf51c5$var$withReplay(debug, replay) {
    if (!replay) return debug;
    return {
        ...debug,
        previousAccumulatedDataWasReplayed: true,
        previousAccumulatedDataLength: replay.length,
        previousAccumulatedDataFirstNonWhitespaceChar: replay.firstNonWhitespaceChar
    };
}
function $e45e8781eebf51c5$var$createStreamLifecycle() {
    return {
        receivedChunkCount: 0,
        sawDocEnvelopeChunk: false,
        sawCommaPrefixedChunkBeforeDocEnvelope: false,
        processorWasResetDuringStream: false
    };
}
function $e45e8781eebf51c5$var$withLifecycle(debug, lifecycle, arrival) {
    return {
        ...debug,
        receivedChunkCount: lifecycle.receivedChunkCount,
        firstNonEmptyChunkIndex: lifecycle.firstNonEmptyChunkIndex,
        firstNonEmptyChunkFirstChar: lifecycle.firstNonEmptyChunkFirstChar,
        firstNonEmptyChunkStartsWithDocEnvelope: lifecycle.firstNonEmptyChunkStartsWithDocEnvelope,
        firstNonEmptyChunkStartsWithComma: lifecycle.firstNonEmptyChunkStartsWithComma,
        sawDocEnvelopeChunk: lifecycle.sawDocEnvelopeChunk,
        sawCommaPrefixedChunkBeforeDocEnvelope: lifecycle.sawCommaPrefixedChunkBeforeDocEnvelope,
        firstParserErrorChunkIndex: lifecycle.firstParserErrorChunkIndex,
        firstParserErrorMessage: lifecycle.firstParserErrorMessage,
        processorWasResetDuringStream: lifecycle.processorWasResetDuringStream,
        ...arrival ? {
            processorWasInitializedWhenCommandArrived: arrival.processorWasInitializedWhenCommandArrived,
            previousAccumulatedDataPresent: arrival.previousAccumulatedDataPresent,
            previousAccumulatedDataStartsWithDocEnvelope: arrival.previousAccumulatedDataStartsWithDocEnvelope
        } : {}
    };
}
class $e45e8781eebf51c5$export$6d1dc40d9d0d1446 {
    init(traceId, singleInstrumentationId) {
        this.isAborted = false;
        this.editorApi.aiStreamingOrchestrator?.actions.startSession(traceId, {
            singleInstrumentationId: singleInstrumentationId,
            // This processor creates the initial content, so mark it a create stream to
            // suppress Post Stream Review. Subsequent update streams open PSR as normal.
            isCreateSession: true
        });
        this.actionId = this.editorApi.aiStreamingOrchestrator?.actions.initAction({
            type: 'appendNode',
            streamingType: 'create'
        }, {
            /**
       * Always hide the loading screen as staging area always shows Rovo conversation
       * and will already have a loading indicator.
       */ hideLoadingScreen: this.contentLocation === 'staging-area'
        });
        if (!this.actionId) throw new Error('Failed to initialize streaming action for create');
        const schema = this.editorApi.core.sharedState.currentState()?.schema;
        if (schema) this.parser = new (0, $92670691a884989a$export$f692212e574bcc60)({
            schemaValidator: new (0, $201c35c7e4a749b1$export$c034a5beeae7d184)(schema),
            repairStrategy: new (0, $4a960532d31faece$export$62e711fe8d5e8f73)(schema)
        });
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Initialized editor streaming action', {
            streamType: 'create',
            actionId: this.actionId
        });
    }
    isInitialized() {
        return !!this.actionId;
    }
    /**
   * Record (shape only) that the next `stream()` call is a
   * `previousAccumulatedData` replay — i.e. the user closed and reopened the
   * Smart Create modal mid-stream and the previously accumulated ADF is being
   * re-streamed. Used purely for blank-page debug telemetry; no-op unless the
   * debug feature gate is enabled. The raw data is never stored.
   */ markPreviousAccumulatedDataReplay(previousAccumulatedData) {
        if (!(0, $iDrrr.fg)('platform_editor_aifc_create_stream_debug')) return;
        this.previousAccumulatedDataReplay = {
            length: previousAccumulatedData.length,
            firstNonWhitespaceChar: $e45e8781eebf51c5$var$firstNonWhitespaceChar(previousAccumulatedData)
        };
    }
    /**
   * Record (shape only) the receiver lifecycle facts known at the moment a
   * create command arrives at the handler: whether the processor was already
   * initialized, and whether/what shape of previousAccumulatedData the payload
   * carried. Used purely for blank-page debug telemetry; no-op unless the
   * debug feature gate is enabled. The raw data is never stored.
   */ markCommandArrived(arrival) {
        if (!(0, $iDrrr.fg)('platform_editor_aifc_create_stream_debug')) return;
        // Only record the first arrival of a stream; subsequent chunks for the
        // same stream re-enter process() but the lifecycle anchor is the first
        // command.
        if (!this.commandArrival) this.commandArrival = arrival;
    }
    /**
   * Update the whole-stream lifecycle accumulator for a received chunk
   * (shape only). Records first-non-empty-chunk facts, doc-envelope/comma
   * ordering, a non-empty chunk counter, and detects a mid-stream reset
   * (a doc-envelope chunk seen after content had already accumulated).
   */ updateLifecycleForChunk(chunk, chunkIndex) {
        const firstChar = $e45e8781eebf51c5$var$firstNonWhitespaceChar(chunk);
        const isDocEnvelope = $e45e8781eebf51c5$var$startsWithDocEnvelope(chunk);
        const isComma = firstChar === ',';
        this.lifecycle.receivedChunkCount += 1;
        if (this.lifecycle.firstNonEmptyChunkIndex === undefined) {
            this.lifecycle.firstNonEmptyChunkIndex = chunkIndex;
            this.lifecycle.firstNonEmptyChunkFirstChar = firstChar;
            this.lifecycle.firstNonEmptyChunkStartsWithDocEnvelope = isDocEnvelope;
            this.lifecycle.firstNonEmptyChunkStartsWithComma = isComma;
        }
        if (isDocEnvelope) {
            // A doc-envelope chunk arriving after content already accumulated
            // indicates the accumulator/stream was reset mid-stream.
            if (this.accumulated.length > 0) this.lifecycle.processorWasResetDuringStream = true;
            this.lifecycle.sawDocEnvelopeChunk = true;
        } else if (isComma && !this.lifecycle.sawDocEnvelopeChunk) this.lifecycle.sawCommaPrefixedChunkBeforeDocEnvelope = true;
    }
    /**
   * Record (shape only) the first parser error observed across the whole
   * stream — its chunk index and message — so root-cause analysis can see
   * where parsing first broke, not just the terminal finish error.
   */ recordFirstParserError(chunkIndex, error) {
        if (this.lifecycle.firstParserErrorChunkIndex !== undefined) return;
        this.lifecycle.firstParserErrorChunkIndex = chunkIndex;
        this.lifecycle.firstParserErrorMessage = error instanceof Error ? error.message : String(error);
    }
    stream(adf, isFinished = false, traceId, singleInstrumentationId) {
        if (!this.actionId) this.init(traceId, singleInstrumentationId);
        if (!adf || !this.actionId) return;
        const streamDebugEnabled = (0, $iDrrr.fg)('platform_editor_aifc_create_stream_debug');
        if (streamDebugEnabled) this.updateLifecycleForChunk(adf, this.chunkIndex);
        const debug = streamDebugEnabled ? $e45e8781eebf51c5$var$withLifecycle($e45e8781eebf51c5$var$withReplay($e45e8781eebf51c5$var$describeCreateChunk({
            actionId: this.actionId,
            traceId: traceId,
            chunk: adf,
            chunkIndex: this.chunkIndex,
            accumulatedBefore: this.accumulated,
            isFinished: isFinished,
            parserPhase: 'stream-process-chunk'
        }), this.previousAccumulatedDataReplay), this.lifecycle, this.commandArrival) : undefined;
        if (streamDebugEnabled) {
            this.chunkIndex += 1;
            this.lastCreateStreamDebug = debug;
        }
        if (this.parser) {
            try {
                this.parser.processChunk(adf, isFinished);
            } catch (error) {
                if (error instanceof (0, $95728dc03de99a85$export$3ddb1d774e2cb647)) // We want to ignore any parsing errors during streaming, but we
                // still capture shape-only debug context (when gated) so a later
                // finish-parse failure can report what the parser observed.
                {
                    if (streamDebugEnabled && debug) {
                        this.recordFirstParserError(this.chunkIndex - 1, error);
                        this.lastCreateStreamDebug = $e45e8781eebf51c5$var$withLifecycle($e45e8781eebf51c5$var$withError(debug, error), this.lifecycle, this.commandArrival);
                    }
                } else // We still want to throw any other unexpected errors
                throw error;
            }
            this.editorApi.aiStreamingOrchestrator?.actions.streamValue(// NOTE: This is a temporary solution before we move the streamer inside `/platform`
            this.actionId, JSON.stringify(this.parser.getPartialDocument()) ?? '');
        } else this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, adf);
        if (traceId) this.traceId = traceId;
        this.accumulated += adf;
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Streaming content', {
            actionId: this.actionId,
            adf: adf
        });
    }
    async finish({ onError: onError, onRepair: onRepair }) {
        if (this.isAborted && (0, $iDrrr.fg)('platform_editor_ai_fix_create_abort_end_session')) {
            this.isAborted = false;
            this.actionId = undefined;
            this.accumulated = '';
            return undefined;
        }
        if (this.actionId) {
            this.editorApi?.aiStreamingOrchestrator?.actions.finishAction(this.actionId);
            await this.editorApi?.aiStreamingOrchestrator?.actions.endSession();
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Finished action', {
                actionId: this.actionId,
                fullAdf: this.accumulated
            });
            let finalDoc;
            try {
                const schema = this.editorApi.core.sharedState.currentState()?.schema;
                if (!schema) throw new Error('Schema is not available');
                const parser = new (0, $92670691a884989a$export$f692212e574bcc60)({
                    schemaValidator: new (0, $201c35c7e4a749b1$export$c034a5beeae7d184)(schema),
                    repairStrategy: new (0, $4a960532d31faece$export$62e711fe8d5e8f73)(schema)
                });
                finalDoc = parser.parse(this.accumulated);
                const repairs = parser.getRepairs();
                if (repairs.length > 0) onRepair?.({
                    repairs: repairs,
                    streamType: 'create'
                });
            } catch (error) {
                // If we fail here record it, and finalDoc is set to `undefined` -> this means that we'll retain
                // whatever we have streamed in, and we don't do any additional work as per the remaining logic
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('New ADF Parser failed, falling back to ADF Streamer', {
                    error: error
                });
                let streamDebug;
                if ((0, $iDrrr.fg)('platform_editor_aifc_create_stream_debug')) {
                    // The finish-parse failure is the terminal error; record it as
                    // the first parser error too if nothing was captured during
                    // streaming.
                    this.recordFirstParserError(this.chunkIndex, error);
                    const baseDebug = this.lastCreateStreamDebug ?? $e45e8781eebf51c5$var$withReplay($e45e8781eebf51c5$var$describeCreateChunk({
                        actionId: this.actionId,
                        traceId: this.traceId,
                        chunk: '',
                        chunkIndex: this.chunkIndex,
                        accumulatedBefore: this.accumulated,
                        isFinished: true,
                        parserPhase: 'finish-parse'
                    }), this.previousAccumulatedDataReplay);
                    streamDebug = $e45e8781eebf51c5$var$withError($e45e8781eebf51c5$var$withLifecycle({
                        ...baseDebug,
                        parserPhase: 'finish-parse',
                        accumulatedLengthBefore: this.accumulated.length,
                        accumulatedFirstNonWhitespaceCharBefore: $e45e8781eebf51c5$var$firstNonWhitespaceChar(this.accumulated),
                        accumulatedStartsWithDocEnvelopeBefore: $e45e8781eebf51c5$var$startsWithDocEnvelope(this.accumulated),
                        accumulatedWasEmptyBefore: this.accumulated.length === 0,
                        // Replayed === a replay was marked AND at least one chunk
                        // was actually streamed for it.
                        previousAccumulatedDataReplayed: !!this.previousAccumulatedDataReplay && this.lifecycle.receivedChunkCount > 0
                    }, this.lifecycle, this.commandArrival), error);
                }
                onError?.({
                    error: error,
                    streamType: 'create',
                    traceId: this.traceId,
                    streamDebug: streamDebug
                });
            }
            this.accumulated = '';
            this.actionId = undefined;
            this.traceId = undefined;
            this.chunkIndex = 0;
            this.lastCreateStreamDebug = undefined;
            this.previousAccumulatedDataReplay = undefined;
            this.lifecycle = $e45e8781eebf51c5$var$createStreamLifecycle();
            this.commandArrival = undefined;
            this.isAborted = false;
            return finalDoc;
        }
    }
    abort() {
        this.isAborted = true;
        this.editorApi.aiStreamingOrchestrator?.actions.abortSession();
    }
    /**
   * Returns the current best-effort parsed ADF from the streaming parser.
   * Used during streaming to extract media node IDs before the stream completes.
   */ getPartialDocument() {
        return this.parser?.getPartialDocument();
    }
    constructor(editorApi, contentLocation){
        this.editorApi = void 0;
        this.contentLocation = void 0;
        this.actionId = void 0;
        this.accumulated = '';
        this.parser = void 0;
        this.traceId = void 0;
        this.chunkIndex = 0;
        this.lastCreateStreamDebug = void 0;
        this.previousAccumulatedDataReplay = void 0;
        this.lifecycle = $e45e8781eebf51c5$var$createStreamLifecycle();
        this.commandArrival = void 0;
        this.isAborted = false;
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
    }
}



var $cXtTj = parcelRequire("cXtTj");








var $fqVYq = parcelRequire("fqVYq");





var $391569749e6ea431$var$_AdfToolCallsDebugger;
class $391569749e6ea431$export$edb06a538ac9271 {
    /**
   * Returns the singleton instance of the debugger if the feature flag is enabled.
   * Also attaches the public API to `window.__adfToolCallsDebugger__`.
   */ static getInstance() {
        if (!(0, $iDrrr.fg)('platform_editor_ai_adf_tool_calls_debugger')) return null;
        if (!$391569749e6ea431$export$edb06a538ac9271.instance) {
            $391569749e6ea431$export$edb06a538ac9271.instance = new $391569749e6ea431$export$edb06a538ac9271();
            $391569749e6ea431$export$edb06a538ac9271.instance.attachToWindow();
        }
        return $391569749e6ea431$export$edb06a538ac9271.instance;
    }
    /**
   * Attaches the public debugging API to the window object.
   */ attachToWindow() {
        try {
            const target = window.top ?? window;
            target.__adfToolCallsDebugger__ = {
                getErrors: (traceId)=>this.getErrors(traceId),
                getSessions: ()=>this.getSessions(),
                getSession: (traceId)=>this.getSession(traceId),
                getSummary: ()=>this.getSummary(),
                clear: ()=>this.clear()
            };
        } catch  {
        // Ignore cross-origin frame access errors
        }
    }
    getSessionKey(traceId) {
        if (traceId) return traceId;
        return `__anonymous_${++this.anonymousCounter}__`;
    }
    evictExpired() {
        const now = Date.now();
        const keysToRemove = [];
        for (const key of this.sessionOrder){
            const session = this.sessions.get(key);
            if (session && now - session.started_at > this.maxAgeMsec) keysToRemove.push(key);
        }
        for (const key of keysToRemove){
            this.sessions.delete(key);
            this.sessionOrder = this.sessionOrder.filter((k)=>k !== key);
        }
    }
    evictOldest() {
        while(this.sessionOrder.length > this.maxSessions){
            const oldest = this.sessionOrder.shift();
            if (oldest) this.sessions.delete(oldest);
        }
    }
    computeSummary(session) {
        const results = session.results;
        const total = results.length;
        const fail = results.filter((r)=>r.apply_status === 'fail').length;
        const success = total - fail;
        const successRate = total > 0 ? Math.round(success / total * 10000) / 100 : 100;
        const errorBreakdown = {};
        for (const r of results)if (r.error_type) errorBreakdown[r.error_type] = (errorBreakdown[r.error_type] || 0) + 1;
        return {
            total: total,
            success: success,
            fail: fail,
            success_rate: successRate,
            error_breakdown: errorBreakdown
        };
    }
    toPublicSession(session) {
        return {
            ...session,
            results: [
                ...session.results
            ],
            summary: this.computeSummary(session)
        };
    }
    /**
   * Records the start of a new streaming session.
   */ startSession(traceId, streamType = 'update') {
        this.evictExpired();
        const key = this.getSessionKey(traceId);
        this.currentSessionKey = key;
        const session = {
            trace_id: traceId ?? null,
            stream_type: streamType,
            started_at: Date.now(),
            ended_at: null,
            status: 'streaming',
            results: []
        };
        this.sessions.set(key, session);
        this.sessionOrder.push(key);
        this.evictOldest();
    }
    /**
   * Records a successful tool call in the current session.
   */ recordToolCallSuccess(toolCall, localId, rawCommand) {
        const session = this.getCurrentSession();
        if (!session) return;
        session.results.push({
            apply_status: 'success',
            error_type: null,
            tool_call: toolCall,
            local_id: localId,
            message: null,
            raw_command: rawCommand ?? null,
            timestamp: Date.now()
        });
    }
    /**
   * Records a failed tool call in the current session.
   */ recordToolCallError(toolCall, localId, errorType, message, rawCommand) {
        const session = this.getCurrentSession();
        if (!session) return;
        session.results.push({
            apply_status: 'fail',
            error_type: errorType,
            tool_call: toolCall,
            local_id: localId,
            message: message,
            raw_command: rawCommand ?? null,
            timestamp: Date.now()
        });
    }
    /**
   * Records a session-level error (not tied to a specific tool call).
   */ recordSessionError(errorType, message) {
        const session = this.getCurrentSession();
        if (!session) return;
        session.results.push({
            apply_status: 'fail',
            error_type: errorType,
            tool_call: 'session',
            local_id: null,
            message: message,
            raw_command: null,
            timestamp: Date.now()
        });
    }
    /**
   * Marks the current session as completed with the given status.
   */ endSession(status = 'completed') {
        const session = this.getCurrentSession();
        if (!session) return;
        session.ended_at = Date.now();
        session.status = status;
        this.currentSessionKey = null;
    }
    getCurrentSession() {
        if (!this.currentSessionKey) return undefined;
        return this.sessions.get(this.currentSessionKey);
    }
    // --- Public query API (exposed on window) ---
    /**
   * Returns all error results, optionally filtered by trace ID.
   */ getErrors(traceId) {
        this.evictExpired();
        if (traceId) {
            const session = this.sessions.get(traceId);
            if (!session) return [];
            return session.results.filter((r)=>r.apply_status === 'fail');
        }
        const errors = [];
        for (const session of this.sessions.values()){
            for (const result of session.results)if (result.apply_status === 'fail') errors.push(result);
        }
        return errors;
    }
    /**
   * Returns all tracked sessions with computed summaries.
   */ getSessions() {
        this.evictExpired();
        return Array.from(this.sessions.values()).map((s)=>this.toPublicSession(s));
    }
    /**
   * Returns a single session by trace ID.
   */ getSession(traceId) {
        this.evictExpired();
        const session = this.sessions.get(traceId);
        if (!session) return undefined;
        return this.toPublicSession(session);
    }
    /**
   * Returns aggregate summary statistics across all tracked sessions.
   */ getSummary() {
        this.evictExpired();
        let totalToolCalls = 0;
        let totalSuccess = 0;
        const errorBreakdown = {};
        const sessionsByStatus = {};
        for (const session of this.sessions.values()){
            sessionsByStatus[session.status] = (sessionsByStatus[session.status] || 0) + 1;
            for (const result of session.results){
                totalToolCalls++;
                if (result.apply_status === 'success') totalSuccess++;
                if (result.error_type) errorBreakdown[result.error_type] = (errorBreakdown[result.error_type] || 0) + 1;
            }
        }
        return {
            total_sessions: this.sessions.size,
            total_tool_calls: totalToolCalls,
            overall_success_rate: totalToolCalls > 0 ? Math.round(totalSuccess / totalToolCalls * 10000) / 100 : 100,
            error_breakdown: errorBreakdown,
            sessions_by_status: sessionsByStatus
        };
    }
    /**
   * Clears all tracked session data.
   */ clear() {
        this.sessions.clear();
        this.sessionOrder = [];
        this.currentSessionKey = null;
    }
    /**
   * Resets the singleton instance. Only intended for use in tests.
   * @internal
   */ static resetForTesting() {
        $391569749e6ea431$export$edb06a538ac9271.instance = null;
    }
    constructor(maxSessions = 50, maxAgeMsec = 1800000){
        this.sessions = new Map();
        this.sessionOrder = [];
        /** Maximum number of sessions to retain */ this.maxSessions = void 0;
        /** Maximum age of a session in milliseconds before eviction */ this.maxAgeMsec = void 0;
        /** Key used for sessions that have no trace ID */ this.anonymousCounter = 0;
        // --- Public recording API (called by the streaming infrastructure) ---
        /** The key of the current active session, used by the command processor */ this.currentSessionKey = null;
        this.maxSessions = maxSessions;
        this.maxAgeMsec = maxAgeMsec;
    }
}
$391569749e6ea431$var$_AdfToolCallsDebugger = $391569749e6ea431$export$edb06a538ac9271;
$391569749e6ea431$export$edb06a538ac9271.instance = null;



var $Mgq5A = parcelRequire("Mgq5A");





var $6yHkF = parcelRequire("6yHkF");





const $53861ea5f5f93b7f$export$caff763714441bf4 = ({ errorMessage: errorMessage, conversationChannelId: conversationChannelId, errorFlagShown: errorFlagShown })=>({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'uploadAndInsertMedia',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: errorMessage,
            ...conversationChannelId ? {
                conversationChannelId: conversationChannelId
            } : {},
            ...errorFlagShown !== undefined ? {
                errorFlagShown: errorFlagShown
            } : {},
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: false
            }
        }
    });
function $53861ea5f5f93b7f$export$56bc5406a64f1fd4({ editorApi: editorApi, errorMessage: errorMessage, conversationChannelId: conversationChannelId, errorFlagShown: errorFlagShown }) {
    editorApi.analytics?.actions.fireAnalyticsEvent($53861ea5f5f93b7f$export$caff763714441bf4({
        errorMessage: errorMessage,
        conversationChannelId: conversationChannelId,
        errorFlagShown: errorFlagShown
    }));
}
const $53861ea5f5f93b7f$export$d07ad804be5185d1 = (frozenCollection, currentContentId)=>({
        action: 'staleCollectionDetected',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'uploadAndInsertMedia',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            frozenCollection: frozenCollection,
            currentContentId: currentContentId
        }
    });
function $53861ea5f5f93b7f$export$ca6ec3543ab362f8(editorApi, frozenCollection, currentContentId) {
    editorApi.analytics?.actions.fireAnalyticsEvent($53861ea5f5f93b7f$export$d07ad804be5185d1(frozenCollection, currentContentId));
}
function $53861ea5f5f93b7f$export$59f8e7f95aedfc2e(editorApi, result) {
    editorApi.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'Infinite loop detected',
            errorData: {
                action: result.name,
                localId: result.localId
            },
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: false
            }
        }
    });
}
function $53861ea5f5f93b7f$export$71f0d1fa0ae1d1b2(editorApi, { envelopeId: envelopeId, toolCallName: toolCallName }) {
    editorApi.analytics?.actions.fireAnalyticsEvent({
        action: 'error',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'adfStreaming',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: {
            errorMessage: 'Unsupported v2 tool call',
            errorData: {
                envelopeId: envelopeId,
                toolCallName: toolCallName
            },
            experienceName: null,
            selectionType: null,
            selectionCategory: null,
            streamId: null,
            source: {
                type: 'orchestrator',
                isCreateAction: false
            }
        }
    });
}
const $53861ea5f5f93b7f$export$dd0a7cf44f03f1c7 = (attributes)=>({
        action: 'forceFinished',
        actionSubject: 'editorPluginAI',
        actionSubjectId: 'parallelToolCall',
        eventType: (0, $krYZG.EVENT_TYPE).OPERATIONAL,
        attributes: attributes
    });
function $53861ea5f5f93b7f$export$ed3edfc0aa43b26c(editorApi, attributes) {
    editorApi.analytics?.actions.fireAnalyticsEvent($53861ea5f5f93b7f$export$dd0a7cf44f03f1c7(attributes));
}





// Map of JSON escape sequences to their unescaped values
const $a18d17e874c074f6$var$ESCAPE_MAP = {
    '"': '"',
    '\\': '\\',
    '/': '/',
    b: '\b',
    f: '\f',
    n: '\n',
    r: '\r',
    t: '\t'
};
function $a18d17e874c074f6$export$ecec02ace5330ac6(str) {
    // eslint-disable-next-line require-unicode-regexp
    return str.replace(/\\(?:u[0-9a-fA-F]{4}|.)/g, (match)=>{
        // Valid unicode escape is always 6 characters: \uXXXX
        if (match[1] === 'u' && match.length === 6) return String.fromCharCode(parseInt(match.slice(2), 16));
        // Single-character escape: 2 characters (\X)
        return $a18d17e874c074f6$var$ESCAPE_MAP[match[1]] ?? match;
    });
}


class $afa352eef06d31ac$var$ToolCall {
    constructor(){
        this.initialized = false;
        this.name = '';
        this.nameKeyIdx = null;
        this.arguments = {
            anchorLocalId: null,
            localId: null,
            contentType: null,
            localIds: null,
            noStream: false,
            relationship: null,
            trueValue: '',
            value: '',
            valueStartIdx: null,
            wrapperAttrs: null,
            wrapperType: null,
            attrs: null
        };
    }
}
// KEYS
const $afa352eef06d31ac$var$NAME = '"name"';
const $afa352eef06d31ac$var$LOCAL_ID = '"localId"';
const $afa352eef06d31ac$var$LOCAL_IDS = '"localIds"';
const $afa352eef06d31ac$var$ANCHOR_LOCAL_ID = '"anchorLocalId"';
const $afa352eef06d31ac$var$RELATIONSHIP = '"relationship"';
const $afa352eef06d31ac$var$CONTENT_TYPE = '"contentType"';
const $afa352eef06d31ac$var$VALUE = '"value"';
const $afa352eef06d31ac$var$WRAPPER_ATTRS = '"wrapperAttrs"';
const $afa352eef06d31ac$var$WRAPPER_TYPE = '"wrapperType"';
const $afa352eef06d31ac$var$ATTRIBUTES_TYPE = '"attrs"';
const $afa352eef06d31ac$var$VALID_CONTENT_TYPES = new Set([
    'text/markdown',
    'text/html',
    'application/adf+json'
]);
// ACTIONS
const $afa352eef06d31ac$var$REPLACE_DOC = 'replaceDoc';
const $afa352eef06d31ac$var$REPLACE = 'replaceNode';
const $afa352eef06d31ac$var$INSERT_BEFORE = 'insertNodeBefore';
const $afa352eef06d31ac$var$INSERT_AFTER = 'insertNodeAfter';
const $afa352eef06d31ac$var$APPEND = 'appendNode';
const $afa352eef06d31ac$var$APPEND_TO_END = 'appendNodeToEnd';
const $afa352eef06d31ac$var$REMOVE = 'removeNode';
const $afa352eef06d31ac$var$REMOVE_NODES = 'removeNodes';
const $afa352eef06d31ac$var$MOVE = 'moveNode';
const $afa352eef06d31ac$var$WRAP = 'wrap';
const $afa352eef06d31ac$var$WRAP_NODE = 'wrapNode';
const $afa352eef06d31ac$var$SET_ATTRIBUTES = 'setAttrs';
const $afa352eef06d31ac$var$actionsRequiringValue = new Set([
    $afa352eef06d31ac$var$REPLACE_DOC,
    $afa352eef06d31ac$var$REPLACE,
    $afa352eef06d31ac$var$INSERT_BEFORE,
    $afa352eef06d31ac$var$INSERT_AFTER,
    $afa352eef06d31ac$var$APPEND,
    $afa352eef06d31ac$var$APPEND_TO_END
]);
function $afa352eef06d31ac$export$f328ddc089839110(actionName) {
    return $afa352eef06d31ac$var$actionsRequiringValue.has(actionName);
}
const $afa352eef06d31ac$var$actionsRequiringLocalId = new Set([
    $afa352eef06d31ac$var$REPLACE,
    $afa352eef06d31ac$var$INSERT_BEFORE,
    $afa352eef06d31ac$var$INSERT_AFTER,
    $afa352eef06d31ac$var$REMOVE,
    $afa352eef06d31ac$var$MOVE,
    $afa352eef06d31ac$var$WRAP,
    $afa352eef06d31ac$var$WRAP_NODE,
    $afa352eef06d31ac$var$SET_ATTRIBUTES
]);
function $afa352eef06d31ac$var$requiresLocalId(actionName) {
    return $afa352eef06d31ac$var$actionsRequiringLocalId.has(actionName);
}
function $afa352eef06d31ac$var$isMoveAction(actionName) {
    return actionName === $afa352eef06d31ac$var$MOVE;
}
function $afa352eef06d31ac$var$isWrapAction(actionName) {
    return actionName === $afa352eef06d31ac$var$WRAP || actionName === $afa352eef06d31ac$var$WRAP_NODE;
}
function $afa352eef06d31ac$var$isUpdateAction(actionName) {
    return actionName === $afa352eef06d31ac$var$SET_ATTRIBUTES;
}
function $afa352eef06d31ac$var$isRemoveNodesAction(actionName) {
    return actionName === $afa352eef06d31ac$var$REMOVE_NODES;
}
class $afa352eef06d31ac$export$c8af4b703b22343c {
    constructor(name, localId, contentType, wrapperType, wrapperAttrs, attrs, anchorLocalId = null, relationship = null, localIds = null, noStream = false){
        this.name = void 0;
        this.localId = void 0;
        this.contentType = void 0;
        this.localIds = void 0;
        this.wrapperType = void 0;
        this.wrapperAttrs = void 0;
        this.attrs = void 0;
        this.anchorLocalId = void 0;
        this.relationship = void 0;
        this.noStream = void 0;
        this.name = name;
        this.localId = localId;
        this.contentType = contentType;
        this.localIds = localIds;
        this.wrapperType = wrapperType;
        this.wrapperAttrs = wrapperAttrs;
        this.attrs = attrs;
        this.anchorLocalId = anchorLocalId;
        this.relationship = relationship;
        this.noStream = noStream;
    }
}
class $afa352eef06d31ac$export$5730dcf0c67ac93b {
    constructor(rawPartialValue){
        this.partialValue = void 0;
        this.rawPartialValue = void 0;
        this.rawPartialValue = rawPartialValue;
        this.partialValue = (0, $a18d17e874c074f6$export$ecec02ace5330ac6)(rawPartialValue);
    }
}
class $afa352eef06d31ac$export$576d226276925ad4 {
    constructor(){
        this.isFinished = void 0;
        this.isFinished = true;
    }
}
function $afa352eef06d31ac$var$findValue(input, key) {
    const keyIndex = input.indexOf(key);
    if (keyIndex === -1) return null;
    else {
        let i = keyIndex + key.length;
        let value = '';
        while(i < input.length){
            const char = input[i];
            const prevChar = i > 0 ? input[i - 1] : undefined;
            if ((char === ':' || char === ' ' || char === '"') && value.length === 0) i++;
            else if (char === '"' && prevChar !== '\\') return {
                value: value,
                keyIndex: keyIndex
            };
            else {
                value += char;
                i++;
            }
        }
    }
    return null;
}
/**
 * Finds a JSON array value for the given key in the input string.
 * Returns the full array as a string (e.g., '["id-1","id-2"]') along with
 * the index of the key, or null if the key is not found or the array is incomplete.
 */ function $afa352eef06d31ac$var$findArrayValue(input, key) {
    const keyIndex = input.indexOf(key);
    if (keyIndex === -1) return null;
    // Find the '[' after the key
    let i = keyIndex + key.length;
    while(i < input.length && input[i] !== '[')i++;
    if (i >= input.length) return null;
    // Track bracket depth to find the matching ']'
    let depth = 0;
    let value = '';
    while(i < input.length){
        const char = input[i];
        if (char === '[') depth++;
        else if (char === ']') depth--;
        value += char;
        i++;
        if (depth === 0) return {
            keyIndex: keyIndex,
            value: value
        };
    }
    // Array not yet complete (still streaming)
    return null;
}
function $afa352eef06d31ac$var$findAdfStartIdx(searchSpace) {
    const key = $afa352eef06d31ac$var$VALUE;
    const keyIndex = searchSpace.indexOf($afa352eef06d31ac$var$VALUE);
    if (keyIndex === -1) return null;
    else {
        let i = keyIndex + key.length;
        while(i < searchSpace.length){
            const char = searchSpace[i];
            if (char === '"') return i + 1;
            i++;
        }
    }
    return null;
}
function $afa352eef06d31ac$var$findAdfEndIdx(searchSpace, startIdx) {
    let partial = '';
    for(let i = startIdx; i < searchSpace.length; i++){
        const char = searchSpace[i];
        const prevChar = i > 0 ? searchSpace[i - 1] : undefined;
        if (char === '"' && prevChar !== '\\') return {
            partial: partial,
            endIndex: i
        };
        else partial += char;
    }
    return {
        partial: partial,
        endIndex: null
    };
}
class $afa352eef06d31ac$export$6366aec646e3c75 {
    reset() {
        this.toolCalls = [];
        this.accumulated = '';
    }
    parse(input) {
        this.accumulated += input;
        const results = [];
        while(true){
            let toolCall = this.toolCalls.at(-1);
            if (!toolCall) {
                toolCall = new $afa352eef06d31ac$var$ToolCall();
                this.toolCalls.push(toolCall);
            }
            /**
       * Step 1:
       * Populate the name/type of the command (e.g., appendNode).
       */ if (!toolCall.name) {
                // Start searching from the previous tool call, offset
                // by 1 so we don't find the same one again.
                const previousToolCall = this.toolCalls.at(-2);
                const startIdx = (previousToolCall?.nameKeyIdx ?? -1) + 1;
                const result = $afa352eef06d31ac$var$findValue(this.accumulated.slice(startIdx), $afa352eef06d31ac$var$NAME);
                if (result) {
                    toolCall.name = result.value;
                    toolCall.nameKeyIdx = startIdx + result.keyIndex;
                } else return results;
            }
            const searchStartIdx = toolCall.nameKeyIdx;
            if (searchStartIdx === null) return results;
            // TODO: EDITOR-123 - Can we guarantee that the other keys will come after `name`?
            const searchSpace = this.accumulated.slice(searchStartIdx);
            /**
       * Step 1.5:
       * For replaceDoc, enforce that contentType is 'text/html' or
       * 'application/adf+json'. Any other contentType is rejected at the
       * parser level — no InitAction is emitted. We wait until the
       * contentType key appears before deciding.
       */ if (toolCall.name === $afa352eef06d31ac$var$REPLACE_DOC && (0, $ieeJu.expValEquals)('platform_editor_ai_replace_doc', 'isEnabled', true)) {
                if (!toolCall.arguments.contentType) {
                    const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$CONTENT_TYPE);
                    if (result) {
                        if (result.value !== 'text/html' && result.value !== 'application/adf+json') {
                            // Unsupported contentType for replaceDoc — skip this tool call entirely.
                            results.push(new $afa352eef06d31ac$export$576d226276925ad4());
                            this.toolCalls.push(new $afa352eef06d31ac$var$ToolCall());
                            continue;
                        }
                        toolCall.arguments.contentType = result.value;
                    } else if (searchSpace.indexOf($afa352eef06d31ac$var$VALUE) !== -1) {
                        // "value" key is present but no contentType — reject (missing required field).
                        results.push(new $afa352eef06d31ac$export$576d226276925ad4());
                        this.toolCalls.push(new $afa352eef06d31ac$var$ToolCall());
                        continue;
                    } else // Neither contentType nor value have appeared yet — wait for more data.
                    return results;
                }
            } else if (toolCall.name === $afa352eef06d31ac$var$REPLACE_DOC && !(0, $ieeJu.expValEquals)('platform_editor_ai_replace_doc', 'isEnabled', true)) {
                // Experiment is off — silently drop the replaceDoc tool call.
                results.push(new $afa352eef06d31ac$export$576d226276925ad4());
                this.toolCalls.push(new $afa352eef06d31ac$var$ToolCall());
                continue;
            }
            /**
       * Step 2:
       * Populate the local ID if it's required, or localIds for removeNodes.
       */ if ($afa352eef06d31ac$var$isRemoveNodesAction(toolCall.name) && !toolCall.arguments.localIds) {
                const result = $afa352eef06d31ac$var$findArrayValue(searchSpace, $afa352eef06d31ac$var$LOCAL_IDS);
                if (result) // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                toolCall.arguments.localIds = JSON.parse(result.value.replace(/\\/g, ''));
                else return results;
            } else if ($afa352eef06d31ac$var$requiresLocalId(toolCall.name) && !toolCall.arguments.localId) {
                const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$LOCAL_ID);
                if (result) toolCall.arguments.localId = result.value;
                else return results;
            }
            /**
       * Step 2.1:
       * Populate moveNode-specific parameters.
       */ if ($afa352eef06d31ac$var$isMoveAction(toolCall.name)) {
                if (!toolCall.arguments.anchorLocalId) {
                    const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$ANCHOR_LOCAL_ID);
                    if (result) toolCall.arguments.anchorLocalId = result.value;
                    else return results;
                }
                if (!toolCall.arguments.relationship) {
                    const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$RELATIONSHIP);
                    if (result && (result.value === 'before' || result.value === 'after')) toolCall.arguments.relationship = result.value;
                    else return results;
                }
            }
            /**
       * Step 2.2:
       * Populate the contentType if present (multi-format streaming).
       * When the flag is on we must wait until either contentType is fully
       * parsed or the "value" key appears (proving contentType is absent)
       * before initializing the tool call — otherwise a partial chunk could
       * cause us to emit InitAction with contentType: null prematurely.
       */ if ($afa352eef06d31ac$export$f328ddc089839110(toolCall.name) && !toolCall.arguments.contentType && ((0, $ieeJu.expValEquals)('platform_editor_ai_multi_format_streaming', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_use_html_plus_parser', 'isEnabled', true))) {
                const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$CONTENT_TYPE);
                if (result && $afa352eef06d31ac$var$VALID_CONTENT_TYPES.has(result.value)) toolCall.arguments.contentType = result.value;
                else if (searchSpace.indexOf($afa352eef06d31ac$var$VALUE) === -1) return results;
            }
            /**
       * Step 3:
       * Populate the additional wrap parameters if this is a wrap action.
       */ if ($afa352eef06d31ac$var$isWrapAction(toolCall.name)) {
                if (!toolCall.arguments.wrapperType) {
                    const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$WRAPPER_TYPE);
                    if (result) toolCall.arguments.wrapperType = result.value;
                    else return results;
                }
                if (!toolCall.arguments.wrapperAttrs) {
                    const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$WRAPPER_ATTRS);
                    if (result) // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    toolCall.arguments.wrapperAttrs = JSON.parse(result.value.replace(/\\/g, ''));
                    else return results;
                }
            }
            /**
       * Step 3.1:
       * Populate the additional update parameters for update attribute actions
       */ if ($afa352eef06d31ac$var$isUpdateAction(toolCall.name)) {
                if (!toolCall.arguments.attrs) {
                    const result = $afa352eef06d31ac$var$findValue(searchSpace, $afa352eef06d31ac$var$ATTRIBUTES_TYPE);
                    if (result) // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
                    toolCall.arguments.attrs = JSON.parse(result.value.replace(/\\/g, ''));
                    else return results;
                }
            }
            /**
       * Step 3.2:
       * Check for noStream flag to skip streaming
       */ if (!toolCall.arguments.noStream) {
                if (searchSpace.includes('"noStream":true') || searchSpace.includes('"noStream": true')) toolCall.arguments.noStream = true;
            }
            /**
       * Step 4:
       * At this point, all the information required for initializing
       * the tool call has been gathered, so push an InitAction and mark
       * the tool call as initialized.
       */ if (!toolCall.initialized) {
                results.push(new $afa352eef06d31ac$export$c8af4b703b22343c(toolCall.name, // May be null
                toolCall.arguments.localId, // May be null
                toolCall.arguments.contentType ?? null, // May be null
                toolCall.arguments.wrapperType, // May be null
                toolCall.arguments.wrapperAttrs, // May be null
                toolCall.arguments.attrs, toolCall.arguments.anchorLocalId, toolCall.arguments.relationship, // May be null
                toolCall.arguments.localIds, toolCall.arguments.noStream));
                toolCall.initialized = true;
            }
            /**
       * Step 5:
       * If this tool call isn't streamable (e.g., removeNode), then
       * we can finalize it and move on to the next tool call.
       */ if (!$afa352eef06d31ac$export$f328ddc089839110(toolCall.name)) {
                // If this is an action we don't need an ADF value for (e.g., remove), then
                // we're done and can move on to the next tool call.
                results.push(new $afa352eef06d31ac$export$576d226276925ad4());
                this.toolCalls.push(new $afa352eef06d31ac$var$ToolCall());
                continue;
            }
            /**
       * Step 6:
       * Find the starting index of the ADF value.
       * Example:
       * "value": "{\"content..."
       *           ^
       *           |
       *           +-- This is the start of the ADF value
       */ if (!toolCall.arguments.valueStartIdx) {
                const adfStartIdx = $afa352eef06d31ac$var$findAdfStartIdx(searchSpace);
                if (adfStartIdx !== null) toolCall.arguments.valueStartIdx = searchStartIdx + adfStartIdx;
                else return results;
            }
            /**
       * Step 7:
       * Start looking for the end of the ADF value. If partial ADF has been
       * found, we push a StreamAction with the new content. If the end index
       * has been found, we push a FinishAction and move to the next tool call.
       */ // This will push the trailing slashes to the next chunk
            // eslint-disable-next-line require-unicode-regexp, @atlassian/perf-linting/no-expensive-split-replace -- Ignored via go/ees017 (to be fixed)
            const valueEndIdx = this.accumulated.replace(/\\+$/g, '').length;
            const valueEnd = $afa352eef06d31ac$var$findAdfEndIdx(this.accumulated.slice(toolCall.arguments.valueStartIdx, valueEndIdx), toolCall.arguments.value.length);
            if (valueEnd.partial.length > 0) {
                toolCall.arguments.value += valueEnd.partial;
                results.push(new $afa352eef06d31ac$export$5730dcf0c67ac93b(valueEnd.partial));
            }
            if (valueEnd.endIndex === null) // We haven't reached the end of the ADF yet
            return results;
            else {
                // Move to the next tool call
                results.push(new $afa352eef06d31ac$export$576d226276925ad4());
                this.toolCalls.push(new $afa352eef06d31ac$var$ToolCall());
            }
        }
        return results;
    }
    constructor(){
        this.toolCalls = [];
        this.accumulated = '';
    }
}







/**
 * Returns `true` if `name` may travel through the v2 envelope path. Streamable
 * commands always go through v2; non-streamable commands do so only when the
 * `platform_editor_ai_v2_non_streamable_tool_calls` gate is on, otherwise they
 * are downgraded to the legacy v1 path.
 */ function $ddff8cc3b3759d5c$var$canRouteThroughV2(name) {
    if ((0, $afa352eef06d31ac$export$f328ddc089839110)(name)) return true;
    return (0, $iDrrr.fg)('platform_editor_ai_v2_non_streamable_tool_calls');
}
/**
 * Full v2 envelope shape check.
 */ function $ddff8cc3b3759d5c$var$isV2Envelope(raw) {
    if (!raw || typeof raw !== 'object') return false;
    const obj = raw;
    return typeof obj.id === 'string' && obj.id.length > 0 && (typeof obj.sequence === 'number' && Number.isFinite(obj.sequence) || typeof obj.sequence === 'string' && obj.sequence.length > 0 && Number.isFinite(Number(obj.sequence))) && (obj.status === 'partial' || obj.status === 'complete');
}
class $ddff8cc3b3759d5c$export$99fe3c5ad8c69f0f {
    reset() {
        this.v2States.clear();
        this.v2Queue = [];
    // The injected v1Parser is reset by its owner (DocumentUpdateCommandProcessor).
    }
    /**
   * Feed a new chunk of raw `toolCalls` text into the parser.
   *
   * A v2 envelope is never partially sent: every chunk carrying v2 metadata is
   * a complete, closed JSON array, so we parse the chunk directly before
   * falling back to v1 buffering.
   *
   * - Parses and any element carries a v2 `id` → split into v2 envelopes
   *   (queued for {@link drainV2Envelopes}) and v1 raw objects.
   * - Parses but no element carries an `id` → forward the raw chunk verbatim
   *   to v1 so v1 wire bytes stay unchanged.
   * - Does not parse → forward verbatim to v1, which owns its own buffer.
   *
   * Returns whatever v1 {@link ParseResult}s the underlying parser emits.
   */ feed(chunk) {
        const parsedArray = $ddff8cc3b3759d5c$var$tryParseClosedArray(chunk);
        if (!parsedArray) // Mid-v1-array fragment or not a complete array: forward to v1.
        return this.v1Parser.parse(chunk);
        // No element matches the v2 envelope shape: forward verbatim so v1 wire
        // bytes stay unchanged. A v2-shaped-but-malformed chunk is treated as v1
        // here (no malformed analytic) since there's no positive v2 signal.
        const hasAnyV2Candidate = parsedArray.some($ddff8cc3b3759d5c$var$isV2Envelope);
        if (!hasAnyV2Candidate) return this.v1Parser.parse(chunk);
        // Mixed (or pure-v2) array: split element-by-element.
        const v1Raw = [];
        for (const item of parsedArray){
            if (!$ddff8cc3b3759d5c$var$isV2Envelope(item)) {
                // V2-candidate (has `id`) but malformed: fire the malformed analytic
                // and downgrade to v1.
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.contract_violation.v2_envelope_malformed', {
                    streamingContract: 'v2',
                    reason: 'malformed_envelope',
                    ...$ddff8cc3b3759d5c$var$safeMetadata(item)
                });
                v1Raw.push(item);
                continue;
            }
            if (!$ddff8cc3b3759d5c$var$canRouteThroughV2(item.name)) {
                // Non-streamable name in v2 format while the gate is off: downgrade
                // to v1 and fire the malformed analytic.
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.contract_violation.v2_envelope_malformed', {
                    streamingContract: 'v2',
                    name: item.name,
                    reason: 'non_streamable_name'
                });
                v1Raw.push(item);
                continue;
            }
            // Normalise `sequence` to a number: the type guard admits a numeric
            // string (some serialisers emit large integers as strings), but
            // comparing strings uses lexicographic ordering (e.g. `"10" <= "9"`),
            // which would drop envelopes past single digits. Mutate the envelope
            // so downstream consumers also see a number.
            const sequenceAsNumber = typeof item.sequence === 'number' ? item.sequence : Number(item.sequence);
            item.sequence = sequenceAsNumber;
            const state = this.v2States.get(item.id) ?? {
                latestSequence: -1,
                completed: false
            };
            if (state.completed) {
                // Envelope after `complete` on the same id: drop and fire analytic.
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.contract_violation.partial_after_complete', {
                    streamingContract: 'v2',
                    id: item.id,
                    sequence: sequenceAsNumber,
                    status: item.status
                });
                continue;
            }
            if (sequenceAsNumber <= state.latestSequence) {
                // Stale / duplicate sequence: drop and fire analytic.
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.v2_stale_sequence', {
                    streamingContract: 'v2',
                    id: item.id,
                    receivedSequence: sequenceAsNumber,
                    latestSequence: state.latestSequence
                });
                continue;
            }
            state.latestSequence = sequenceAsNumber;
            if (item.status === 'complete') state.completed = true;
            this.v2States.set(item.id, state);
            this.v2Queue.push(item);
        }
        // Forward the v1 portion (including downgraded envelopes) to the legacy
        // parser, re-serialised into the shape it expects.
        let v1Results = [];
        if (v1Raw.length > 0) v1Results = this.v1Parser.parse(JSON.stringify(v1Raw));
        return v1Results;
    }
    /** Pull and clear the queued v2 envelopes for the processor to dispatch. */ drainV2Envelopes() {
        if (this.v2Queue.length === 0) return [];
        const out = this.v2Queue;
        this.v2Queue = [];
        return out;
    }
    /**
   * The v1 fall-through parser is injected rather than owned so the outer
   * `DocumentUpdateCommandProcessor` can share its own `PartialStreamParser`
   * instance with this wrapper.
   */ constructor(v1Parser){
        this.v1Parser = v1Parser;
        this.v2States = new Map();
        /** Queue of v2 envelopes that survived sequence-filtering and have not yet been drained. */ this.v2Queue = [];
    }
}
/**
 * Try to parse `input` as a complete JSON array. Returns the parsed array on
 * success, or `null` if `input` is not yet a complete JSON array. The caller
 * is responsible for inspecting elements.
 *
 * Free function (rather than a method) because {@link PartialStreamParserV2}
 * no longer owns an accumulation buffer — v2 envelopes always arrive as one
 * complete closed JSON array per chunk, so we parse the chunk directly.
 */ function $ddff8cc3b3759d5c$var$tryParseClosedArray(input) {
    const trimmed = input.trim();
    if (!trimmed.startsWith('[') || !trimmed.endsWith(']')) return null;
    let parsed;
    try {
        parsed = JSON.parse(trimmed);
    } catch  {
        return null;
    }
    if (!Array.isArray(parsed)) return null;
    return parsed;
}
/**
 * Allow-list extractor for analytics on malformed v2 envelopes.
 *
 * We never serialise the raw `item` (or any `arguments.value` it may
 * carry) because a malformed envelope can still contain a partially-written
 * ADF document fragment that constitutes user-generated content (UGC).
 * Only well-typed v2 metadata fields are emitted; everything else is
 * dropped on the floor. See HOT-120175 / `analytics-review` skill for the
 * class of leak this prevents.
 */ function $ddff8cc3b3759d5c$var$safeMetadata(value) {
    if (!value || typeof value !== 'object') return {};
    const obj = value;
    const out = {};
    if (typeof obj.id === 'string') out.id = obj.id;
    if (typeof obj.name === 'string') out.name = obj.name;
    if (typeof obj.sequence === 'number' && Number.isFinite(obj.sequence)) out.sequence = obj.sequence;
    else if (typeof obj.sequence === 'string' && obj.sequence.length > 0 && Number.isFinite(Number(obj.sequence))) out.sequence = Number(obj.sequence);
    if (typeof obj.status === 'string') out.status = obj.status;
    return out;
}
function $ddff8cc3b3759d5c$export$1972b7c87576a9fc(envelope) {
    const ct = envelope.arguments?.contentType;
    if (ct === 'text/html' || ct === 'text/markdown' || ct === 'application/adf+json') return ct;
    return 'application/adf+json';
}






/**
 * Chunk strategy for the HTML+ v2 incremental tool-call streaming contract.
 *
 * The HTML+ backend ALWAYS returns the tool-call value in
 * `application/adf+json` format (see the contract proposal under HTML+ Editor
 * Incremental Tool-Call Streaming Contract). Other content types are not
 * supported under v2; if one is observed we treat it as a contract violation,
 * fire an analytics event, and fall back to the ADF strategy so the snapshot
 * still parses (best-effort) rather than throwing mid-session.
 *
 * In v2 each chunk carries the **full snapshot** of the tool-call value (not a
 * delta appended to previous chunks). The strategy therefore MUST NOT
 * accumulate input across calls — it replaces internal state on every call.
 *
 * The corresponding v1 strategies in `tool-processor-chunk-strategies.ts`
 * remain unchanged; v1 callers continue to append per chunk and continue to
 * support all three content types.
 *
 * Gated by `platform_editor_use_html_plus_streaming_parser`. The v1 vs v2
 * decision is taken at the parser/processor layer, so by the time this
 * factory is invoked the gate has already been checked.
 */ const $035e75a193519be4$var$SUPPORTED_CONTENT_TYPE = 'application/adf+json';
/**
 * ADF chunk strategy for v2. Each call instantiates a fresh `AdfParser` so the
 * parser's internal accumulator (`accumulatedInput += chunk`) never grows
 * across snapshots. The `AdfSchemaValidator` and `AdfRepairStrategy` are
 * hoisted onto the strategy instance and reused for every snapshot — those
 * are the only construction-time costs worth amortising.
 *
 * If profiling later shows the per-snapshot `new AdfParser(...)` cost is
 * measurable at real backend chunk rates, the `@atlassian/adf-parser`
 * package can grow a `processFullSnapshot(fullValue, isLastChunk)` method
 * and this strategy can switch to calling it without changing its public
 * surface. See `docs/html-plus-incremental-streaming-plan.md` §1f.
 */ class $035e75a193519be4$var$AdfChunkStrategyV2 {
    replaceSnapshot(fullValue, isFinished) {
        if (!this.schemaValidator || !this.repairStrategy) return fullValue;
        const parser = new (0, $92670691a884989a$export$f692212e574bcc60)({
            schemaValidator: this.schemaValidator,
            repairStrategy: this.repairStrategy
        });
        try {
            parser.processChunk(fullValue, isFinished);
        } catch (error) {
            if (!(error instanceof (0, $95728dc03de99a85$export$3ddb1d774e2cb647))) throw error;
        // Tolerate partial / malformed snapshots — fall through to whatever
        // the parser was able to recover.
        }
        // Track whether any schema content was rejected during this snapshot.
        // Detect schema-invalidity drops: the AdfParser records a 'skip' repair whenever
        // a node is dropped because it cannot fit in its parent context. Among all skip
        // repair patterns in the parser, the schema-invalidity path (parser.ts line ~361)
        // is uniquely identified by:
        //   - to === '-'            : node dropped, not moved/inferred elsewhere
        //   - context has no ':'    : excludes 'empty_after_lift' ('listItem:empty_after_lift')
        //                            and 'empty_value' ('parent.key:empty_value')
        //   - context !== 'parser'  : excludes parser-token errors (orphaned braces, EOF, etc.)
        // All other non-schema skip patterns either use to !== '-' (inferred delimiters, arrays)
        // or include ':' in their context string. This filter is therefore both necessary
        // and sufficient to identify genuine ADF schema content rejection.
        const schemaRejections = parser.getRepairs().filter((r)=>r.type === 'skip' && r.to === '-' && !r.context.includes(':') && r.context !== 'parser' && // Exclude orphaned_closing_brace — a parser structural artifact, not a schema error.
            // Its context is parentType || 'content' so it passes the other checks.
            r.from !== 'orphaned_closing_brace');
        this.lastHadSchemaContentRejection = schemaRejections.length > 0;
        this.lastSchemaRejectionDetails = schemaRejections.length > 0 ? schemaRejections.map((r)=>`${r.from} in ${r.context}`).join(', ') : undefined;
        // `getPartialDocument()` may return `null` when the parser has not
        // yet recovered any usable partial document (e.g. the very first
        // chunk was malformed). `JSON.stringify(null)` returns the literal
        // string `'null'` (not `undefined`), so a naïve
        // `JSON.stringify(parser.getPartialDocument()) ?? this.lastSerialisedDoc`
        // would ship `'null'` to the orchestrator, which would then try to
        // parse it as an ADF body — wiping the user's document. Guard the
        // `null`/`undefined` case explicitly and keep the previous snapshot.
        const partial = parser.getPartialDocument();
        if (partial !== null && partial !== undefined) this.lastSerialisedDoc = JSON.stringify(partial);
        return this.lastSerialisedDoc;
    }
    getHadSchemaContentRejection() {
        return this.lastHadSchemaContentRejection;
    }
    getSchemaRejectionDetails() {
        return this.lastSchemaRejectionDetails;
    }
    constructor(schema){
        this.schemaValidator = void 0;
        this.repairStrategy = void 0;
        this.lastSerialisedDoc = '';
        this.lastHadSchemaContentRejection = false;
        this.lastSchemaRejectionDetails = undefined;
        if (schema) {
            this.schemaValidator = new (0, $201c35c7e4a749b1$export$c034a5beeae7d184)(schema);
            this.repairStrategy = new (0, $4a960532d31faece$export$62e711fe8d5e8f73)(schema);
        }
    }
}
const $035e75a193519be4$export$e38d7e69d12a7c84 = (contentType, schema)=>{
    if (contentType !== undefined && contentType !== $035e75a193519be4$var$SUPPORTED_CONTENT_TYPE) (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.contract_violation.v2_unexpected_content_type', {
        streamingContract: 'v2',
        expectedContentType: $035e75a193519be4$var$SUPPORTED_CONTENT_TYPE,
        receivedContentType: contentType
    });
    return new $035e75a193519be4$var$AdfChunkStrategyV2(schema);
};


class $dd51e19691492330$export$26145b66c4ce3eba {
    /**
   * Apply one v2 envelope to this tool call. Idempotent against repeat /
   * stale sequences — the parser is expected to filter those out before
   * calling, but we still guard against `finished` here.
   */ apply(envelope) {
        if (this.finished || this.initFailed) return;
        // Lazy init on first envelope so the command is built from the most
        // recent metadata available. After `initAction`, subsequent envelopes
        // only stream a new snapshot.
        if (!this.actionId) {
            const command = $dd51e19691492330$var$buildCommandFromEnvelope(envelope);
            if (!command) {
                // Couldn't build a valid command: refuse to init (matching v1's
                // silent-drop) and latch `initFailed` so later envelopes don't retry.
                this.initFailed = true;
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('V2: init failed (malformed envelope)', {
                    streamingContract: 'v2',
                    envelopeId: envelope.id
                });
                return;
            }
            this.command = command;
            const actionId = this.editorApi?.aiStreamingOrchestrator?.actions.initAction(command, {
                hideLoadingScreen: this.contentLocation === 'staging-area'
            });
            if (!actionId) {
                // `initAction` returned falsy: latch `initFailed` so later `apply()`
                // calls short-circuit instead of queueing un-finishable commands.
                this.initFailed = true;
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('V2: init failed (initAction returned falsy)', {
                    streamingContract: 'v2',
                    envelopeId: envelope.id
                });
                return;
            }
            this.actionId = actionId;
            const contentType = (0, $ddff8cc3b3759d5c$export$1972b7c87576a9fc)(envelope);
            const schema = this.editorApi.core.sharedState.currentState()?.schema;
            this.strategy = (0, $035e75a193519be4$export$e38d7e69d12a7c84)(contentType, schema);
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('V2: initialized streaming action', {
                streamingContract: 'v2',
                streamType: 'update',
                actionId: actionId,
                command: command,
                envelopeId: envelope.id
            });
        }
        const isComplete = envelope.status === 'complete';
        const rawValue = typeof envelope.arguments?.value === 'string' ? envelope.arguments.value : '';
        if (rawValue) {
            const processed = this.strategy?.replaceSnapshot(rawValue, isComplete) ?? rawValue;
            this.editorApi.aiStreamingOrchestrator?.actions.replaceValue(this.actionId, processed);
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('V2: replace snapshot', {
                streamingContract: 'v2',
                actionId: this.actionId,
                envelopeId: envelope.id,
                sequence: envelope.sequence,
                status: envelope.status
            });
        } else if (this.command?.type === 'replaceDoc' && isComplete) // Mirror v1's special case for replaceDoc with an empty value: the
        // orchestrator needs at least one streamValue/replaceValue call so it
        // can dispatch the empty-paragraph fallback rather than no-oping.
        this.editorApi.aiStreamingOrchestrator?.actions.replaceValue(this.actionId, '');
        if (isComplete) {
            if (this.strategy?.getHadSchemaContentRejection() && this.actionId) this.editorApi.aiStreamingOrchestrator?.actions.notifySchemaContentRejection(this.actionId, this.strategy.getSchemaRejectionDetails());
            this.finish();
        }
    }
    /** Returns the envelope id this processor is bound to, or undefined if not yet initialised. */ getEnvelopeId() {
        return this.boundEnvelopeId;
    }
    /**
   * Returns `true` if this processor latched `initFailed`. The FIFO scheduler
   * uses this to release the queue slot immediately rather than waiting for the
   * parallel-queue timeout.
   */ getInitFailed() {
        return this.initFailed;
    }
    /**
   * Finish the streaming action. When called with an `error`, propagate it via
   * `finishAction(actionId, error)` so the orchestrator dispatches an error
   * event instead of treating the last partial snapshot as a success.
   */ finish(error, options) {
        if (this.finished) return;
        this.finished = true;
        if (this.actionId) {
            // On timeout force-finish, pass the bound tool-call id so the orchestrator
            // captures its working positions before ending the experience, enabling
            // resume at the mapped position.
            if (options?.abortedDueToTimeout) this.editorApi?.aiStreamingOrchestrator?.actions.finishAction(this.actionId, error, {
                abortedToolCallId: this.boundEnvelopeId
            });
            else // Preserve the original 2-arg call shape for the normal finish path.
            this.editorApi?.aiStreamingOrchestrator?.actions.finishAction(this.actionId, error);
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('V2: finished action', {
                streamingContract: 'v2',
                actionId: this.actionId,
                hasError: !!error,
                abortedDueToTimeout: !!options?.abortedDueToTimeout
            });
        }
    }
    /** The streaming command this processor was initialised with, if any. */ getCommand() {
        return this.command;
    }
    /** Bind the envelope id (called by the wrapper on first apply). */ bindEnvelopeId(id) {
        this.boundEnvelopeId = id;
    }
    constructor(editorApi, contentLocation){
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
        this.actionId = void 0;
        this.command = void 0;
        this.strategy = void 0;
        this.finished = false;
        /**
     * Set to `true` when `initAction` returns falsy. Once latched, subsequent
     * `apply()` calls short-circuit so we don't re-init per chunk and leak
     * un-finishable commands into the `StreamCommandQueue`.
     */ this.initFailed = false;
        this.boundEnvelopeId = void 0;
    }
}
/**
 * Translate a v2 envelope into a {@link StreamingCommand} the orchestrator
 * understands. Returns `undefined` when required fields are missing (the caller
 * silently drops the envelope, matching v1). The non-streamable cases mirror the
 * v1 mapping in `DocumentUpdateCommandProcessor.createToolCallProcessor` so both
 * paths build identical commands.
 */ function $dd51e19691492330$var$buildCommandFromEnvelope(envelope) {
    const args = envelope.arguments ?? {};
    const contentType = typeof args.contentType === 'string' ? args.contentType : undefined;
    const localId = typeof args.localId === 'string' ? args.localId : '';
    const noStream = args.noStream === true ? {
        noStream: true
    } : undefined;
    switch(envelope.name){
        case 'replaceDoc':
            return {
                type: 'replaceDoc',
                contentType: contentType,
                ...noStream ?? {}
            };
        case 'replaceNode':
        case 'insertNodeBefore':
        case 'insertNodeAfter':
            if (!localId) return undefined;
            return {
                type: envelope.name,
                localId: localId,
                contentType: contentType,
                ...noStream ?? {}
            };
        case 'appendNode':
        case 'appendNodeToEnd':
            return {
                type: envelope.name,
                contentType: contentType
            };
        // Non-streamable commands: no `value` to stream — fully described by
        // `arguments`. Required-field checks match v1; a missing field returns
        // `undefined` so the caller drops the tool call.
        case 'removeNode':
            if (!localId) return undefined;
            return {
                type: 'removeNode',
                localId: localId
            };
        case 'removeNodes':
            {
                const localIds = Array.isArray(args.localIds) ? args.localIds.filter((id)=>typeof id === 'string') : [];
                if (localIds.length === 0) return undefined;
                return {
                    type: 'removeNodes',
                    localIds: localIds
                };
            }
        case 'moveNode':
            {
                const anchorLocalId = typeof args.anchorLocalId === 'string' ? args.anchorLocalId : '';
                const relationship = args.relationship === 'before' || args.relationship === 'after' ? args.relationship : undefined;
                if (!localId || !anchorLocalId || !relationship) return undefined;
                return {
                    type: 'moveNode',
                    localId: localId,
                    anchorLocalId: anchorLocalId,
                    relationship: relationship
                };
            }
        case 'wrap':
        case 'wrapNode':
            {
                const wrapperType = typeof args.wrapperType === 'string' ? args.wrapperType : '';
                const wrapperAttrs = args.wrapperAttrs && typeof args.wrapperAttrs === 'object' && !Array.isArray(args.wrapperAttrs) ? args.wrapperAttrs : undefined;
                if (!localId || !wrapperType || !wrapperAttrs) return undefined;
                return {
                    type: envelope.name,
                    localId: localId,
                    wrapperType: wrapperType,
                    wrapperAttrs: wrapperAttrs
                };
            }
        case 'setAttrs':
            {
                const attrs = args.attrs && typeof args.attrs === 'object' && !Array.isArray(args.attrs) ? args.attrs : undefined;
                if (!localId || !attrs) return undefined;
                return {
                    type: 'setAttrs',
                    localId: localId,
                    attrs: attrs
                };
            }
        default:
            return undefined;
    }
}



var $4XbfY = parcelRequire("4XbfY");


var $1hQ0e = parcelRequire("1hQ0e");


var $3xuv0 = parcelRequire("3xuv0");


var $c9zHD = parcelRequire("c9zHD");


var $aPdNQ = parcelRequire("aPdNQ");






var $97CWy = parcelRequire("97CWy");


var $aQ6Yc = parcelRequire("aQ6Yc");

const $06b7d051ab0bb4ac$var$jsonTransformer = new (0, $3xuv0.JSONTransformer)();
const $06b7d051ab0bb4ac$var$createFallbackDoc = (text)=>({
        version: 1,
        type: 'doc',
        content: [
            {
                type: 'paragraph',
                content: [
                    {
                        type: 'text',
                        text: text
                    }
                ]
            }
        ]
    });
class $06b7d051ab0bb4ac$var$AdfChunkStrategy {
    processChunk(delta, isFinished) {
        if (!this.parser) return delta;
        try {
            this.parser.processChunk(delta, isFinished);
        } catch (error) {
            if (!(error instanceof (0, $95728dc03de99a85$export$3ddb1d774e2cb647))) throw error;
        }
        return JSON.stringify(this.parser.getPartialDocument()) ?? '';
    }
    constructor(schema){
        this.parser = void 0;
        if (schema) this.parser = new (0, $92670691a884989a$export$f692212e574bcc60)({
            schemaValidator: new (0, $201c35c7e4a749b1$export$c034a5beeae7d184)(schema),
            repairStrategy: new (0, $4a960532d31faece$export$62e711fe8d5e8f73)(schema)
        });
    }
}
class $06b7d051ab0bb4ac$var$MarkdownChunkStrategy {
    getMarkdownTransformer() {
        if (!this.markdownTransformer) this.markdownTransformer = new (0, $c9zHD.MarkdownTransformer)(this.schema);
        return this.markdownTransformer;
    }
    processChunk(delta) {
        this.accumulated += delta;
        try {
            if (this.useMarkdownPlus) {
                const { pmFragment: pmFragment } = (0, $97CWy.convertMarkdownToProsemirror)({
                    schema: this.schema,
                    markdown: this.accumulated,
                    idMap: {},
                    featureToggles: {
                        markdownPlus: true,
                        markdownPlusExtensions: true,
                        markdownPlusPanels: true,
                        markdownPlusDecisions: true,
                        markdownPlusRemoveUnclosedTokens: true,
                        allowAttributesMatchDefault: true
                    }
                });
                const doc = this.schema.nodes.doc.create(null, pmFragment);
                return JSON.stringify($06b7d051ab0bb4ac$var$jsonTransformer.encode(doc));
            }
            return JSON.stringify($06b7d051ab0bb4ac$var$jsonTransformer.encode(this.getMarkdownTransformer().parse(this.accumulated)));
        } catch  {
            return JSON.stringify($06b7d051ab0bb4ac$var$createFallbackDoc(this.accumulated));
        }
    }
    constructor(schema){
        this.accumulated = '';
        this.markdownTransformer = void 0;
        this.schema = void 0;
        this.useMarkdownPlus = void 0;
        this.schema = schema ?? (0, $4XbfY.defaultSchema);
        this.useMarkdownPlus = (0, $ieeJu.expValEquals)('platform_editor_use_markdown_plus_parser', 'isEnabled', true);
    }
}
class $06b7d051ab0bb4ac$var$HtmlChunkStrategy {
    processChunk(delta) {
        this.accumulated += delta;
        try {
            if (this.useHtmlPlus) {
                const adf = (0, $aQ6Yc.htmlToAdf)(this.accumulated);
                if (!adf) return JSON.stringify($06b7d051ab0bb4ac$var$createFallbackDoc(this.accumulated));
                return JSON.stringify(adf);
            }
            const element = (0, $1hQ0e.getDocument)()?.createElement('div');
            if (!element) return JSON.stringify($06b7d051ab0bb4ac$var$createFallbackDoc(this.accumulated));
            element.innerHTML = this.accumulated;
            return JSON.stringify($06b7d051ab0bb4ac$var$jsonTransformer.encode((0, $aPdNQ.DOMParser).fromSchema(this.schema).parse(element)));
        } catch  {
            return JSON.stringify($06b7d051ab0bb4ac$var$createFallbackDoc(this.accumulated));
        }
    }
    constructor(schema){
        this.accumulated = '';
        this.schema = void 0;
        this.useHtmlPlus = void 0;
        this.schema = schema ?? (0, $4XbfY.defaultSchema);
        this.useHtmlPlus = (0, $ieeJu.expValEquals)('platform_editor_use_html_plus_parser', 'isEnabled', true);
    }
}
const $06b7d051ab0bb4ac$export$2b60e5c7b30aac70 = (contentType, schema)=>{
    switch(contentType){
        case 'text/markdown':
            return new $06b7d051ab0bb4ac$var$MarkdownChunkStrategy(schema);
        case 'text/html':
            return new $06b7d051ab0bb4ac$var$HtmlChunkStrategy(schema);
        case 'application/adf+json':
        default:
            return new $06b7d051ab0bb4ac$var$AdfChunkStrategy(schema);
    }
};


/**
 * Read once at construction time so behaviour stays stable for the duration
 * of one stream processor instance even if the exp-val is toggled.
 */ function $1c5b0b9ec452e760$var$isHtmlPlusV2StreamingEnabled() {
    return (0, $ieeJu.expValEquals)('platform_editor_use_html_plus_streaming_parser', 'isEnabled', true);
}
/** Default queue timeout (ms) when the Statsig dynamic config is unavailable. */ const $1c5b0b9ec452e760$var$DEFAULT_PARALLEL_QUEUE_TIMEOUT_MS = 2000;
function $1c5b0b9ec452e760$var$isPositiveNumber(value) {
    return typeof value === 'number' && Number.isFinite(value) && value > 0;
}
/** Statsig dynamic-config name that holds tunable parallel-tool-call parameters. */ const $1c5b0b9ec452e760$var$QUEUE_CONFIG_NAME = 'platform_editor_ai_parallel_tool_calls_config';
function $1c5b0b9ec452e760$export$a0bfc33c513958e() {
    try {
        if (!(0, $cXtTj.default).initializeCompleted()) return $1c5b0b9ec452e760$var$DEFAULT_PARALLEL_QUEUE_TIMEOUT_MS;
        const dynamicConfig = (0, $cXtTj.default).getExperiment($1c5b0b9ec452e760$var$QUEUE_CONFIG_NAME);
        const queueTimeoutMs = dynamicConfig?.value?.value;
        return $1c5b0b9ec452e760$var$isPositiveNumber(queueTimeoutMs) ? queueTimeoutMs : $1c5b0b9ec452e760$var$DEFAULT_PARALLEL_QUEUE_TIMEOUT_MS;
    } catch  {
        return $1c5b0b9ec452e760$var$DEFAULT_PARALLEL_QUEUE_TIMEOUT_MS;
    }
}
/**
 * The total amount of times we're happy to process the same toolcall command. If more sequential toolcalls exist then
 * what this value is set too, then we have detected a possible infinite loop and we will abort the stream.
 */ const $1c5b0b9ec452e760$var$MAX_INFINITE_LOOP_COUNT = 5;
const $1c5b0b9ec452e760$var$SKIP_INFINITE_LOOP_ACTIONS = [
    'insertNodeAfter',
    'insertNodeBefore'
];
class $1c5b0b9ec452e760$var$ToolCallProcessor {
    stream(chunk, isFinished) {
        if (!chunk) {
            // For replaceDoc, an empty value signals "clear the entire document".
            // We must still call streamValue so the streaming orchestrator can dispatch
            // the empty-paragraph fallback (instead of silently no-oping).
            if (this.command.type === 'replaceDoc') this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, '');
            return;
        }
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_multi_format_streaming', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_use_html_plus_parser', 'isEnabled', true)) {
            this.accumulated += chunk;
            const processedAdf = this.strategy?.processChunk(chunk, isFinished) ?? chunk;
            this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, processedAdf);
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Streaming content', {
                actionId: this.actionId,
                chunk: chunk
            });
            return;
        }
        if (this.parser) {
            try {
                this.parser.processChunk(chunk, isFinished);
            } catch (error) {
                if (error instanceof (0, $95728dc03de99a85$export$3ddb1d774e2cb647)) ;
                else // We still want to throw any other unexpected errors
                throw error;
            }
            this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, JSON.stringify(this.parser.getPartialDocument()) ?? '');
        } else this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, chunk);
        this.accumulated += chunk;
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Streaming content', {
            actionId: this.actionId,
            chunk: chunk
        });
    }
    finish() {
        // For replaceDoc with an empty value, no StreamAction is emitted by the parser
        // (the "value" string is empty so `valueEnd.partial.length > 0` is never true).
        // We must call streamValue with an empty string so the orchestrator receives at
        // least one stream call and can apply its empty-paragraph fallback instead of
        // silently no-oping.
        if (this.command.type === 'replaceDoc' && this.accumulated === '') this.editorApi.aiStreamingOrchestrator?.actions.streamValue(this.actionId, '');
        this.editorApi?.aiStreamingOrchestrator?.actions.finishAction(this.actionId);
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Finished action', {
            actionId: this.actionId,
            fullAdf: this.accumulated
        });
        this.accumulated = '';
    }
    constructor(editorApi, contentLocation, command){
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
        this.actionId = void 0;
        this.accumulated = '';
        this.parser = void 0;
        this.strategy = void 0;
        this.command = void 0;
        this.command = command;
        const actionId = this.editorApi?.aiStreamingOrchestrator?.actions.initAction(command, {
            /**
       * Always hide the loading screen as staging area always shows Rovo conversation
       * and will already have a loading indicator.
       */ hideLoadingScreen: this.contentLocation === 'staging-area'
        });
        if (!actionId) throw new Error('Failed to initialize streaming action for update');
        this.actionId = actionId;
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Initialized editor streaming action', {
            streamType: 'update',
            actionId: actionId,
            command: command
        });
        const schema = this.editorApi.core.sharedState.currentState()?.schema;
        if ((0, $ieeJu.expValEquals)('platform_editor_ai_multi_format_streaming', 'isEnabled', true) || (0, $ieeJu.expValEquals)('platform_editor_use_html_plus_parser', 'isEnabled', true)) {
            const contentType = 'contentType' in command ? command.contentType : undefined;
            this.strategy = (0, $06b7d051ab0bb4ac$export$2b60e5c7b30aac70)(contentType, schema);
        } else if (schema) this.parser = new (0, $92670691a884989a$export$f692212e574bcc60)({
            schemaValidator: new (0, $201c35c7e4a749b1$export$c034a5beeae7d184)(schema),
            repairStrategy: new (0, $4a960532d31faece$export$62e711fe8d5e8f73)(schema)
        });
    }
}
function $1c5b0b9ec452e760$var$assertUnreachable(_x) {}
class $1c5b0b9ec452e760$export$37d5c27ac1ce34a8 {
    /**
   * Reset all per-session state.
   *
   * If `error` is provided, this is an error-teardown reset (called from
   * `abort()` or the infinite-loop branch of `finish()`). In that case we
   * propagate the error through `activeV2Processor.finish(error)` so the
   * orchestrator dispatches an error event rather than treating the
   * last-seen partial v2 snapshot as a successful tool-call result. Mirrors
   * how the v1 path calls `finishAction(actionId, error)` via the queue's
   * `endStreamCommand`.
   */ reset(error) {
        this.accumulated = '';
        this.hasOpenSession = false;
        this.lastAction = null;
        this.currentToolCall = undefined;
        this.currentToolCallName = null;
        this.currentToolCallLocalId = null;
        this.currentRawCommand = null;
        this.currentStreamedValue = '';
        this.hasDetectedInfiniteLoop = false;
        this.loopsDetected = 0;
        this.parser.reset();
        if (this.parserV2) this.parserV2.reset();
        // Finish any leftover v2 processor first so it emits its final
        // `finishAction` to the orchestrator. Propagate `error` so the
        // orchestrator does NOT commit the last partial snapshot to the
        // document as a successful result on abort / error teardown.
        if (this.activeV2Processor) this.activeV2Processor.finish(error);
        this.activeV2Processor = undefined;
        this.activeV2EnvelopeId = undefined;
        // Reset the FIFO parallel-queue state (finishes any in-flight
        // processors that belong to the new scheduler path).
        this.resetParallelQueueState(error);
        this.streamingContractResolved = false;
    }
    createToolCallProcessor(toolCall) {
        const type = toolCall.name;
        const localId = toolCall.localId ?? '';
        const contentType = toolCall.contentType ?? undefined;
        let command;
        switch(type){
            case 'replaceDoc':
                // replaceDoc has no localId — it replaces the entire document.
                // contentType is 'text/html' or 'application/adf+json' (enforced by the parser).
                command = {
                    type: type,
                    contentType: contentType,
                    ...toolCall.noStream && {
                        noStream: true
                    }
                };
                break;
            case 'replaceNode':
            case 'insertNodeBefore':
            case 'insertNodeAfter':
                command = {
                    type: type,
                    localId: localId,
                    contentType: contentType,
                    ...toolCall.noStream && {
                        noStream: true
                    }
                };
                break;
            case 'removeNode':
                command = {
                    type: type,
                    localId: localId
                };
                break;
            case 'removeNodes':
                const localIds = toolCall.localIds;
                if (!localIds) return;
                command = {
                    type: type,
                    localIds: localIds
                };
                break;
            case 'moveNode':
                const anchorLocalId = toolCall.anchorLocalId;
                const relationship = toolCall.relationship;
                if (!localId || !anchorLocalId || !relationship) return;
                command = {
                    type: type,
                    localId: localId,
                    anchorLocalId: anchorLocalId,
                    relationship: relationship
                };
                break;
            case 'appendNode':
            case 'appendNodeToEnd':
                command = {
                    type: type,
                    contentType: contentType
                };
                break;
            case 'wrap':
            case 'wrapNode':
                const wrapperType = toolCall.wrapperType;
                const wrapperAttrs = toolCall.wrapperAttrs;
                if (!wrapperType || !wrapperAttrs) return;
                command = {
                    type: type,
                    localId: localId,
                    wrapperType: wrapperType,
                    wrapperAttrs: wrapperAttrs
                };
                break;
            case 'setAttrs':
                const attrs = toolCall.attrs;
                if (!attrs) return;
                command = {
                    type: type,
                    localId: localId,
                    attrs: attrs
                };
                break;
            default:
                $1c5b0b9ec452e760$var$assertUnreachable(type);
                return;
        }
        return new $1c5b0b9ec452e760$var$ToolCallProcessor(this.editorApi, this.contentLocation, command);
    }
    streamChunk(chunk, isFinished, traceId, singleInstrumentationId, agentInfo, // True when the originating Rovo-chat edit was an inline edit
    // (`experience === 'inline_edit'`). Forwarded to the orchestrator so the
    // Post Stream Review "Review moment" only auto-opens for inline edits.
    isInlineEditSession, agentAttribution) {
        // The last message contains a copy of the full, accumulated tool call structure. We
        // don't want to reprocess this, so we just return instead.
        if (isFinished) return;
        if (this.accumulated.length === 0) {
            this.reset();
            this.editorApi.aiStreamingOrchestrator?.actions.startSession(traceId, {
                singleInstrumentationId: singleInstrumentationId,
                promptVersion: (0, $iDrrr.fg)('platform_editor_ai_promptversion_in_analytics') ? this.actionMetadata?.promptVersion : undefined,
                agentInfo: (0, $fqVYq.editorExperiment)('platform_editor_agent_mentions', true) ? agentInfo : undefined,
                isInlineEditSession: isInlineEditSession,
                agentAttribution: (0, $iDrrr.fg)('platform_editor_agentic_step_attribution') ? agentAttribution : undefined
            });
            this.debugger?.startSession(traceId, 'update');
            this.hasOpenSession = true;
        }
        this.accumulated += chunk;
        return this.stream(chunk, isFinished);
    }
    stream(chunk, isFinished) {
        // Once we detect an infinite loop and call finish(), we won't be able to recover
        if (this.hasDetectedInfiniteLoop) return;
        // V2 path: feed the hybrid parser when the gate is on AND the chunk
        // looks like it might carry v2 provisional metadata. The primary
        // discriminator per spec §1.4 is the presence of a top-level `"id"`
        // inside a `toolCalls` object; the substring check below is a fast
        // pre-filter to avoid the JSON-array parse work on the vast majority
        // of chunks that are clearly mid-v1-array.
        let results;
        const looksLikeV2 = this.useV2Streaming && this.parserV2 !== undefined && chunk.includes('"id"');
        if (looksLikeV2 && this.parserV2) {
            results = this.parserV2.feed(chunk);
            const envelopes = this.parserV2.drainV2Envelopes();
            for (const envelope of envelopes){
                // Spec §6.2: fire `streaming_contract_resolved` exactly once per
                // session, on first observed v2 chunk. Include
                // `streamingContract: 'v2'` for uniform queryability alongside
                // the other v2 analytics events (`v2_envelope_malformed`,
                // `v2_stale_sequence`, `partial_after_complete`).
                if (!this.streamingContractResolved) {
                    this.streamingContractResolved = true;
                    (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.streaming_contract_resolved', {
                        streamingContract: 'v2',
                        feContractVersion: 2,
                        resolvedV2: true
                    });
                }
                if ((0, $iDrrr.fg)('platform_editor_ai_parallel_tool_calls_v2')) {
                    // Force-finish is terminal for an id: record late chunks and discard.
                    if (this.v2ForceFinishedRecords.has(envelope.id)) {
                        this.recordLateChunkIfForceFinished(envelope);
                        continue;
                    }
                    // Init-failure is terminal for an id too: silently discard any
                    // late/duplicate envelope so we don't re-queue or re-fire analytics.
                    if (this.v2InitFailedIds.has(envelope.id)) continue;
                    this.v2ToolCallNameById.set(envelope.id, envelope.name);
                    if (!this.v2OrderedIds.includes(envelope.id)) this.v2OrderedIds.push(envelope.id);
                    if (!this.v2CurrentActiveId) this.v2CurrentActiveId = envelope.id;
                    if (envelope.id === this.v2CurrentActiveId) this.applyActiveV2Envelope(envelope);
                    else {
                        // Queue latest snapshot per id; v2 envelopes are full snapshots.
                        this.v2PendingSnapshotById.set(envelope.id, envelope);
                        this.armParallelQueueTimeout();
                    }
                } else {
                    // Legacy single-active-id model (spec §2.2 / §3.6). If the
                    // envelope's `id` differs from the currently-active id, finalise
                    // the previous processor before starting a new one.
                    if (this.activeV2EnvelopeId !== undefined && this.activeV2EnvelopeId !== envelope.id) {
                        if (this.activeV2Processor) this.activeV2Processor.finish();
                        this.activeV2Processor = undefined;
                        this.activeV2EnvelopeId = undefined;
                    }
                    if (!this.activeV2Processor) {
                        this.activeV2Processor = new (0, $dd51e19691492330$export$26145b66c4ce3eba)(this.editorApi, this.contentLocation);
                        this.activeV2Processor.bindEnvelopeId(envelope.id);
                        this.activeV2EnvelopeId = envelope.id;
                    }
                    this.activeV2Processor.apply(envelope);
                    if (envelope.status === 'complete') {
                        // The processor has already called `finishAction`. Clear the
                        // active slot so a subsequent (different-id) envelope starts
                        // fresh.
                        this.activeV2Processor = undefined;
                        this.activeV2EnvelopeId = undefined;
                    }
                }
            }
        } else results = this.parser.parse(chunk);
        for (const result of results){
            if (result instanceof (0, $afa352eef06d31ac$export$c8af4b703b22343c)) {
                if (result.localId) {
                    if (this.lastAction === `${result.name}-${result.localId}` && !$1c5b0b9ec452e760$var$SKIP_INFINITE_LOOP_ACTIONS.includes(result.name)) {
                        this.loopsDetected++;
                        if (this.loopsDetected >= $1c5b0b9ec452e760$var$MAX_INFINITE_LOOP_COUNT) {
                            this.hasDetectedInfiniteLoop = true;
                            (0, $53861ea5f5f93b7f$export$59f8e7f95aedfc2e)(this.editorApi, result);
                            this.debugger?.recordSessionError('infinite_loop_detected', `Infinite loop detected for ${result.name} on localId ${result.localId}`);
                            return;
                        } else this.initToolCallWithDebugger(result);
                    } else {
                        this.loopsDetected = 0;
                        this.initToolCallWithDebugger(result);
                    }
                    this.lastAction = `${result.name}-${result.localId}`;
                } else {
                    this.lastAction = null;
                    this.initToolCallWithDebugger(result);
                }
            } else if (result instanceof (0, $afa352eef06d31ac$export$5730dcf0c67ac93b)) {
                this.currentToolCall?.stream(result.partialValue, isFinished);
                this.currentStreamedValue += result.partialValue;
            } else if (result instanceof (0, $afa352eef06d31ac$export$576d226276925ad4)) {
                this.currentToolCall?.finish();
                if (this.currentToolCallName) {
                    const fullRawCommand = this.currentRawCommand ? {
                        ...this.currentRawCommand,
                        ...this.currentStreamedValue ? {
                            value: this.currentStreamedValue
                        } : {}
                    } : null;
                    this.debugger?.recordToolCallSuccess(this.currentToolCallName, this.currentToolCallLocalId, fullRawCommand);
                }
                this.currentToolCallName = null;
                this.currentToolCallLocalId = null;
                this.currentRawCommand = null;
                this.currentStreamedValue = '';
            } else throw new Error('Unknown action type from partial stream parser');
        }
    }
    // ---------------------------------------------------------------------------
    // FIFO parallel-queue helpers (used only when gate is ON)
    // ---------------------------------------------------------------------------
    /**
   * Apply one v2 envelope for the currently-active tool-call id.
   * Creates a processor on first use; on `status === 'complete'` advances
   * to the next queued id.
   */ applyActiveV2Envelope(envelope) {
        let processor = this.v2ProcessorById.get(envelope.id);
        if (!processor) {
            processor = new (0, $dd51e19691492330$export$26145b66c4ce3eba)(this.editorApi, this.contentLocation);
            processor.bindEnvelopeId(envelope.id);
            this.v2ProcessorById.set(envelope.id, processor);
        }
        processor.apply(envelope);
        // If the processor latched `initFailed` (unsupported name or missing
        // arguments) it will never call `finishAction`. Release the FIFO slot,
        // advance to the next queued id, and fire an analytics event to monitor
        // these drops.
        if (processor.getInitFailed()) {
            (0, $53861ea5f5f93b7f$export$71f0d1fa0ae1d1b2)(this.editorApi, {
                envelopeId: envelope.id,
                toolCallName: this.v2ToolCallNameById.get(envelope.id) ?? envelope.name
            });
            // Mark the id terminal so any late/duplicate envelope is discarded
            // rather than re-queued and re-fired.
            this.v2InitFailedIds.add(envelope.id);
            this.v2ProcessorById.delete(envelope.id);
            this.advanceToNextV2();
            return;
        }
        if (envelope.status === 'complete') {
            this.v2ProcessorById.delete(envelope.id);
            this.advanceToNextV2();
        }
    }
    /**
   * Called when the currently-active id finishes (or is force-finished by
   * the timeout). Removes the id from the FIFO queue and starts the next
   * queued id if one is waiting.
   */ advanceToNextV2() {
        this.clearParallelQueueTimeout();
        this.v2OrderedIds = this.v2OrderedIds.filter((id)=>id !== this.v2CurrentActiveId);
        this.v2CurrentActiveId = undefined;
        const nextId = this.v2OrderedIds.find((id)=>this.v2PendingSnapshotById.has(id));
        if (!nextId) return;
        this.v2CurrentActiveId = nextId;
        const snapshot = this.v2PendingSnapshotById.get(nextId);
        this.v2PendingSnapshotById.delete(nextId);
        if (!snapshot) {
            // Defensive: should not happen because we found `nextId` via `.has()`,
            // but if it does, skip this id and try the next one rather than stalling.
            this.advanceToNextV2();
            return;
        }
        this.applyActiveV2Envelope(snapshot);
        // Re-arm only while other ids are still queued behind this one.
        const queueStillHasOthers = this.v2OrderedIds.some((id)=>id !== this.v2CurrentActiveId && this.v2PendingSnapshotById.has(id));
        if (queueStillHasOthers) this.armParallelQueueTimeout();
    }
    /** Arms a one-shot timeout that force-finishes the active id if it stalls. */ armParallelQueueTimeout() {
        if (this.v2QueueTimeout) return;
        const timeoutMs = $1c5b0b9ec452e760$export$a0bfc33c513958e();
        this.v2QueueTimeout = setTimeout(()=>{
            this.v2QueueTimeout = null;
            const forcedId = this.v2CurrentActiveId;
            const activeProcessor = forcedId ? this.v2ProcessorById.get(forcedId) : undefined;
            // Skip force-finish if no other id is waiting on the queue.
            const hasPendingOtherIds = this.v2OrderedIds.some((id)=>id !== forcedId && this.v2PendingSnapshotById.has(id));
            if (!hasPendingOtherIds) return;
            if (activeProcessor && forcedId) {
                const handleAborted = (0, $iDrrr.fg)('platform_editor_ai_handle_aborted_toolcall');
                if (handleAborted) {
                    // Timeout force-finish: capture the command and flag the finish so the
                    // orchestrator records this tool call's working positions before the
                    // experience ends. It is resumed at its mapped position once streaming
                    // finishes (see resumeAbortedToolCalls).
                    const forcedCommand = activeProcessor.getCommand();
                    if (forcedCommand) this.v2CommandByForceFinishedId.set(forcedId, forcedCommand);
                }
                activeProcessor.finish(undefined, handleAborted ? {
                    abortedDueToTimeout: true
                } : undefined);
                this.v2ProcessorById.delete(forcedId);
                if (!this.v2ForceFinishedRecords.has(forcedId)) this.v2ForceFinishedRecords.set(forcedId, {
                    timeoutMs: timeoutMs,
                    forceFinishedAt: Date.now(),
                    lateChunkCount: 0,
                    firstLateChunkDelayMs: null,
                    lastLateChunkDelayMs: null,
                    completedAfterTimeout: false,
                    toolCallName: this.v2ToolCallNameById.get(forcedId) ?? ''
                });
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.parallel_tool_call.force_finished', {
                    streamingContract: 'v2',
                    envelopeId: forcedId,
                    reason: 'queue_timeout',
                    timeoutMs: timeoutMs
                });
            }
            this.advanceToNextV2();
        }, timeoutMs);
    }
    /** Updates late-chunk counters for a previously force-finished id. */ recordLateChunkIfForceFinished(envelope) {
        const record = this.v2ForceFinishedRecords.get(envelope.id);
        if (!record) return;
        const delayMs = Date.now() - record.forceFinishedAt;
        record.lateChunkCount += 1;
        if (record.firstLateChunkDelayMs === null) record.firstLateChunkDelayMs = delayMs;
        record.lastLateChunkDelayMs = delayMs;
        if (envelope.status === 'complete') record.completedAfterTimeout = true;
        // Retain the latest late snapshot so the aborted tool call can be resumed at
        // stream end instead of lost. Full snapshots, so the latest supersedes.
        if ((0, $iDrrr.fg)('platform_editor_ai_handle_aborted_toolcall')) this.v2LateSnapshotByForceFinishedId.set(envelope.id, envelope);
    }
    /** Clears any armed parallel-queue timeout. */ clearParallelQueueTimeout() {
        if (this.v2QueueTimeout) {
            clearTimeout(this.v2QueueTimeout);
            this.v2QueueTimeout = null;
        }
    }
    /** Reset all FIFO parallel-queue state fields. */ resetParallelQueueState(error) {
        this.clearParallelQueueTimeout();
        for (const processor of this.v2ProcessorById.values())processor.finish(error);
        this.v2ProcessorById.clear();
        this.v2PendingSnapshotById.clear();
        this.v2OrderedIds = [];
        this.v2CurrentActiveId = undefined;
        // Drop force-finished records on abort; `finish()` flushes them first.
        this.v2ForceFinishedRecords.clear();
        // Drop retained snapshots/commands; `finish()` resumes them before reset.
        this.v2LateSnapshotByForceFinishedId.clear();
        this.v2CommandByForceFinishedId.clear();
        this.v2InitFailedIds.clear();
        this.v2ToolCallNameById.clear();
    }
    /**
   * Resume tool calls force-finished by the queue timeout that later received
   * envelopes. Re-applies each latest snapshot via `resumeAction` at the tool
   * call's mapped position, in FIFO arrival order, within the still-open session.
   * `resumeAction` reads the stored positions, streams the snapshot, finishes the
   * action, and clears the positions.
   */ resumeAbortedToolCalls() {
        if (this.v2LateSnapshotByForceFinishedId.size === 0) return;
        // Preserve original arrival order where known; fall back to insertion order.
        const orderedIds = [
            ...this.v2OrderedIds.filter((id)=>this.v2LateSnapshotByForceFinishedId.has(id)),
            ...[
                ...this.v2LateSnapshotByForceFinishedId.keys()
            ].filter((id)=>!this.v2OrderedIds.includes(id))
        ];
        for (const id of orderedIds){
            const snapshot = this.v2LateSnapshotByForceFinishedId.get(id);
            const command = this.v2CommandByForceFinishedId.get(id);
            if (!snapshot || !command) continue;
            // Skip resume if the snapshot has no string value: resuming with an empty
            // value would silently overwrite the aborted tool call's content.
            if (typeof snapshot.arguments?.value !== 'string') continue;
            const value = snapshot.arguments.value;
            this.editorApi.aiStreamingOrchestrator?.actions.resumeAction(id, command, value);
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('htmleditor.parallel_tool_call.resumed_aborted_tool_call', {
                streamingContract: 'v2',
                envelopeId: id,
                status: snapshot.status
            });
        }
        this.v2LateSnapshotByForceFinishedId.clear();
        this.v2CommandByForceFinishedId.clear();
    }
    /** Fires one `parallelToolCall.forceFinished` analytics event per force-finished id. */ flushForceFinishedAnalyticsEvents() {
        if (this.v2ForceFinishedRecords.size === 0) return;
        for (const [envelopeId, record] of this.v2ForceFinishedRecords)(0, $53861ea5f5f93b7f$export$ed3edfc0aa43b26c)(this.editorApi, {
            envelopeId: envelopeId,
            timeoutMs: record.timeoutMs,
            lateChunkCount: record.lateChunkCount,
            firstLateChunkDelayMs: record.firstLateChunkDelayMs,
            lastLateChunkDelayMs: record.lastLateChunkDelayMs,
            completedAfterTimeout: record.completedAfterTimeout,
            toolCallName: record.toolCallName
        });
        this.v2ForceFinishedRecords.clear();
    }
    static buildRawCommand(result) {
        const raw = {
            name: result.name
        };
        if (result.localId != null) raw.localId = result.localId;
        if (result.anchorLocalId != null) raw.anchorLocalId = result.anchorLocalId;
        if (result.relationship != null) raw.relationship = result.relationship;
        if (result.contentType != null) raw.contentType = result.contentType;
        if (result.wrapperType != null) raw.wrapperType = result.wrapperType;
        if (result.wrapperAttrs != null) raw.wrapperAttrs = result.wrapperAttrs;
        if (result.attrs != null) raw.attrs = result.attrs;
        return raw;
    }
    initToolCallWithDebugger(result) {
        this.currentToolCallName = result.name;
        this.currentToolCallLocalId = result.localId ?? null;
        this.currentRawCommand = $1c5b0b9ec452e760$export$37d5c27ac1ce34a8.buildRawCommand(result);
        try {
            this.currentToolCall = this.createToolCallProcessor(result);
            if (!this.currentToolCall) this.debugger?.recordToolCallError(result.name, result.localId ?? null, 'invalid_command_found', `Failed to create tool call processor for ${result.name}: missing required attributes`, this.currentRawCommand);
        } catch (error) {
            const message = error instanceof Error ? error.message : String(error);
            this.debugger?.recordToolCallError(result.name, result.localId ?? null, 'tool_call_init_failed', message, this.currentRawCommand);
        }
    }
    async finish() {
        if (this.hasDetectedInfiniteLoop) {
            this.rovoBridgeAPI.send((0, $6yHkF.InlineInputBoxAbortMessageCommand), {
                receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                senderId: this.clientId
            });
            this.debugger?.endSession('errored');
            // Propagate an error to any in-flight v2 processor so its
            // `finishAction(actionId, error)` reflects the infinite-loop
            // teardown rather than committing the last partial snapshot as a
            // successful result.
            this.reset({
                failureReason: (0, $Mgq5A.FAILURE_REASON).ADF_STREAMING_ERROR,
                errorKey: 'infinite_loop_detected'
            });
            await this.editorApi.aiStreamingOrchestrator?.actions.endSession();
        } else {
            this.debugger?.endSession('completed');
            this.accumulated = '';
            // Flush an unfinished v2 processor if the stream ended before a
            // `status: 'complete'` envelope was seen (e.g. backend aborted
            // early). Spec §3.6.
            if (this.activeV2Processor) {
                this.activeV2Processor.finish();
                this.activeV2Processor = undefined;
                this.activeV2EnvelopeId = undefined;
            }
            // Best-effort drain of any queued v2 snapshots.
            if ((0, $iDrrr.fg)('platform_editor_ai_parallel_tool_calls_v2')) {
                // Finish the active processor first (it already had apply() called; just needs finish()).
                const activeProc = this.v2CurrentActiveId ? this.v2ProcessorById.get(this.v2CurrentActiveId) : undefined;
                if (activeProc && this.v2CurrentActiveId) {
                    activeProc.finish();
                    this.v2ProcessorById.delete(this.v2CurrentActiveId);
                }
                // Drain queued (non-active) snapshots — these haven't had apply() yet.
                for (const id of this.v2OrderedIds){
                    if (id === this.v2CurrentActiveId) continue; // already finished above
                    const snapshot = this.v2PendingSnapshotById.get(id);
                    if (snapshot) {
                        const drainProcessor = new (0, $dd51e19691492330$export$26145b66c4ce3eba)(this.editorApi, this.contentLocation);
                        drainProcessor.bindEnvelopeId(id);
                        drainProcessor.apply(snapshot);
                        if (snapshot.status !== 'complete') drainProcessor.finish();
                    }
                }
                // Resume aborted tool calls: runs after active/queued processors and
                // before reset. Enqueues commands the queue drains while the session is
                // still open, so this must stay before endSession() below.
                if ((0, $iDrrr.fg)('platform_editor_ai_handle_aborted_toolcall')) this.resumeAbortedToolCalls();
                // Must run BEFORE reset (which clears the records map).
                this.flushForceFinishedAnalyticsEvents();
                this.resetParallelQueueState();
            }
            this.streamingContractResolved = false;
            if ((0, $iDrrr.fg)('platform_editor_ai_fix_update_backend_end_experience')) {
                if (this.hasOpenSession) {
                    await this.editorApi.aiStreamingOrchestrator?.actions.endSession();
                    this.hasOpenSession = false;
                } else // Backend-persisted edits complete without streaming any chunk, so no
                // session was ever opened. `endSession()` throws in that state, and the
                // resulting abort skips the completion callbacks that dismiss the inline
                // prompt. Tear the experience down directly instead: there is no
                // streamed content to accept, reject or review.
                this.editorApi.aiExperience?.actions.endAIExperience();
            } else await this.editorApi.aiStreamingOrchestrator?.actions.endSession();
            this.lastAction = null;
            this.currentToolCall = undefined;
            this.currentToolCallName = null;
            this.currentToolCallLocalId = null;
            this.currentRawCommand = null;
            this.currentStreamedValue = '';
            this.parser.reset();
            if (this.parserV2) this.parserV2.reset();
        }
    }
    abort(reason) {
        this.debugger?.endSession(reason === 'user_abort' ? 'aborted' : reason ?? 'aborted');
        // Propagate an error to any in-flight v2 processor so the orchestrator
        // dispatches an error event for the last partial snapshot rather than
        // silently committing it. Matches the error-propagation semantics of
        // the v1 path's `finishAction(actionId, error)` flow.
        this.reset({
            failureReason: (0, $Mgq5A.FAILURE_REASON).UNKNOWN,
            errorKey: reason ?? 'aborted'
        });
        this.editorApi.aiStreamingOrchestrator?.actions.abortSession();
    }
    setActionMetadata(metadata) {
        this.actionMetadata = metadata;
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('Set action metadata', {
            metadata: metadata
        });
    }
    constructor(editorApi, contentLocation, clientId, rovoBridgeAPI){
        this.editorApi = editorApi;
        this.contentLocation = contentLocation;
        this.clientId = clientId;
        this.rovoBridgeAPI = rovoBridgeAPI;
        /**
     * v1 parser. Owned even when the v2 gate is on: in that case it lives
     * inside `parserV2` and the wrapper forwards non-streamable tool calls to
     * it so today's behaviour for `removeNode`, `setAttrs`, `moveNode`,
     * `wrap`, etc. is preserved bit-for-bit.
     */ this.parser = void 0;
        /**
     * v2 hybrid parser, only constructed when the
     * `platform_editor_use_html_plus_streaming_parser` exp-val is on.
     * Routes streamable tool calls through the v2 envelope path and forwards
     * non-streamable ones to the embedded v1 parser.
     */ this.parserV2 = void 0;
        /** Legacy single-active-id v2 processor (used when parallel gate is OFF). */ this.activeV2Processor = void 0;
        this.activeV2EnvelopeId = void 0;
        // --- FIFO parallel-queue state (used only when gate is ON) ---
        /** All distinct ids seen so far, in FIFO arrival order. */ this.v2OrderedIds = [];
        /** Latest envelope snapshot per queued (non-active) id. */ this.v2PendingSnapshotById = new Map();
        /** Per-id processor instances (active + already-finished ones still draining). */ this.v2ProcessorById = new Map();
        /** The id currently being actively applied. */ this.v2CurrentActiveId = void 0;
        /** Timeout handle for force-finishing a stalled active id. */ this.v2QueueTimeout = null;
        /** Latest observed `name` per envelope id (used for force-finished analytics). */ this.v2ToolCallNameById = new Map();
        /**
     * Latest envelope snapshot received for an id after it was force-finished by the
     * parallel-queue timeout. v2 envelopes are full snapshots, so the latest wins.
     * Retained (not dropped) so {@link finish} can resume the tool call and avoid
     * losing chunks that arrive post-timeout.
     */ this.v2LateSnapshotByForceFinishedId = new Map();
        /** Command for each force-finished id, captured at force-finish time so the tool call can be resumed. */ this.v2CommandByForceFinishedId = new Map();
        /** Per-id tracking for force-finished ids; flushed as analytics on stream end. */ this.v2ForceFinishedRecords = new Map();
        /**
     * Ids whose v2 processor latched `initFailed` and were dropped from the FIFO
     * queue. Terminal for the id: lets us silently discard late/duplicate
     * envelopes so we don't re-queue or re-fire the analytics event.
     */ this.v2InitFailedIds = new Set();
        /**
     * Tracks whether the per-session `htmleditor.streaming_contract_resolved`
     * event has been fired yet. Spec §6.2: fire exactly once per session on
     * first observed chunk.
     */ this.streamingContractResolved = false;
        this.useV2Streaming = void 0;
        this.currentToolCall = void 0;
        this.currentToolCallName = null;
        this.currentToolCallLocalId = null;
        this.currentRawCommand = null;
        this.currentStreamedValue = '';
        this.accumulated = '';
        this.lastAction = void 0;
        this.hasDetectedInfiniteLoop = false;
        this.loopsDetected = 0;
        this.debugger = null;
        this.actionMetadata = null;
        /**
     * Whether a streaming session was opened for the current stream.
     *
     * The session is opened lazily on the first non-final chunk. Backend-persisted
     * edits stream no chunks at all, so no session exists to close and
     * `endSession()` would throw. See `finish()`.
     */ this.hasOpenSession = false;
        this.parser = new (0, $afa352eef06d31ac$export$6366aec646e3c75)();
        this.useV2Streaming = $1c5b0b9ec452e760$var$isHtmlPlusV2StreamingEnabled();
        if (this.useV2Streaming) // Share the same v1 parser instance so that test mocks set on
        // `this.parser` still observe the v1 fall-through (e.g. when v1
        // tool calls are forwarded by the v2 wrapper).
        this.parserV2 = new (0, $ddff8cc3b3759d5c$export$99fe3c5ad8c69f0f)(this.parser);
        this.lastAction = null;
        this.debugger = (0, $391569749e6ea431$export$edb06a538ac9271).getInstance();
    }
}














const $6bbebd245884f275$var$REMIX_REGENERATE_EXPERIENCE = 'aiMateRemixRegenerate';
const $6bbebd245884f275$export$d4e0a6ad65c67b9f = {
    start: ()=>(0, $gQrdE.sendAIFCExperienceTrackingToParent)({
            status: 'start',
            experienceName: $6bbebd245884f275$var$REMIX_REGENERATE_EXPERIENCE
        }),
    success: (args)=>(0, $gQrdE.sendAIFCExperienceTrackingToParent)({
            status: 'success',
            experienceName: $6bbebd245884f275$var$REMIX_REGENERATE_EXPERIENCE,
            ...args?.remixType && {
                remixType: args.remixType
            },
            ...args?.remixSubtype && {
                remixSubtype: args.remixSubtype
            }
        }),
    fail: ({ error: error })=>(0, $gQrdE.sendAIFCExperienceTrackingToParent)({
            status: 'fail',
            experienceName: $6bbebd245884f275$var$REMIX_REGENERATE_EXPERIENCE,
            error: error
        }),
    abort: ({ reason: reason })=>(0, $gQrdE.sendAIFCExperienceTrackingToParent)({
            status: 'abort',
            experienceName: $6bbebd245884f275$var$REMIX_REGENERATE_EXPERIENCE,
            reason: reason
        })
};


// Format mirrors `getMauiUrl` in @atlassian/malleable-ui-components/src/ui/editor-remix/utils/message.ts.
// Inlined here to avoid a cross-package dependency for one URL formula.
const $7242e0da8bf5b4b8$var$buildMauiUrl = (appId)=>`${window.location.origin}/remix/ui/${encodeURIComponent(appId)}`;
class $7242e0da8bf5b4b8$export$49fd996878dc7f33 {
    async streamChunk(data, isFinished, _traceId, _singleInstrumentationId) {
        if (!isFinished) return;
        // A safety / AUP violation is streamed as a finished ACTION_COMPLETE with
        // `isSafetyViolation: true` and no MAUI content. This is an expected
        // outcome, not a system failure, so it must not publish a `taskFail`
        // operational metric (which is pure noise). End the AI experience overlay
        // via finish(), publish the outcome as a success, and skip the (impossible)
        // duplicate/replace.
        if (data.isSafetyViolation) {
            (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).success({
                remixType: data.contentType,
                remixSubtype: data.dynamicUiSubtype
            });
            return;
        }
        // Variant-picker updates are inserted FE-side (useUpdateRemix ->
        // useOnComplete); processing the BE push here would double-insert.
        // Rovo-chat updates aren't tracked, so they still flow through.
        if (data.previousMauiId && this.editorApi.malleableUi?.actions.isVariantUpdateInFlight(data.previousMauiId) && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            // Mark success so the AI experience overlay ends normally; the
            // update did succeed, the FE just owns the insertion.
            (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).success({
                remixType: data.contentType,
                remixSubtype: data.dynamicUiSubtype
            });
            return;
        }
        // Awaiting matters: it keeps the existing AI experience overlay covering
        // the duplicate roundtrip. `endAIExperience()` is only called from
        // `finish()` after this resolves, via PageUpdateCommandHandler.finishAction.
        try {
            // `duplicateAndReplaceMauiApp` may duplicate the BE-provided MAUI app
            // under the current page (for permissions). When it does, the live
            // node ends up with the duplicated id — NOT `data.id`. Capture that
            // id so the stack entry URL we record matches the live node, which
            // is what the toolbar lookup keys off.
            const replaceResult = await this.editorApi.malleableUi?.actions.duplicateAndReplaceMauiApp({
                previousMauiId: data.previousMauiId,
                newMauiId: data.id,
                localId: data.selectionLocalId
            });
            (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).NODE_INSERTED);
            (0, $irnO2.remixEditExistingExperience).success();
            (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).success({
                remixType: data.contentType,
                remixSubtype: data.dynamicUiSubtype
            });
            if (data.previousMauiId && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                // Fall back to data.id if the action didn't run (e.g. malleableUi
                // plugin unavailable) — better to record an entry keyed off the
                // BE id than to skip recording entirely.
                const insertedMauiId = replaceResult?.insertedMauiId ?? data.id;
                // Forward the backend-confirmed subtype so a type-changing edit
                // ("change to a bar chart", "make it a tree map") updates the style
                // picker. The reducer falls back to inheriting the previous subtype
                // when the backend omits one.
                const backendSubtype = (0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_2', 'isEnabled', true) ? data.dynamicUiSubtype : undefined;
                // Stash the command; it is dispatched in finish() after the AI
                // experience ends (see field comment).
                this.pendingHistoryStackEntryCommand = this.editorApi.malleableUi?.commands.addBackendRemixHistoryStackEntry({
                    previousMauiId: data.previousMauiId,
                    url: $7242e0da8bf5b4b8$var$buildMauiUrl(insertedMauiId),
                    dynamicUiType: data.contentType,
                    dynamicUiSubtype: backendSubtype
                });
            }
        } catch (error) {
            (0, $irnO2.remixEditExistingExperience).failure({
                metadata: {
                    reason: 'duplicate_replace_failed'
                }
            });
            (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).fail({
                error: error instanceof Error ? error.message : 'duplicate_replace_failed'
            });
            throw error;
        }
    }
    finish() {
        this.editorApi.aiExperience?.actions.endAIExperience();
        // Record the remix-history stack entry only after the AI experience has
        // ended, so the transaction does not land in the still-open session where a
        // click/type would discard-and-revert the update.
        if (this.pendingHistoryStackEntryCommand) {
            this.editorApi.core?.actions.execute(this.pendingHistoryStackEntryCommand);
            this.pendingHistoryStackEntryCommand = undefined;
        }
    }
    constructor(editorApi){
        this.editorApi = editorApi;
        // Deferred to finish() so the remix-history transaction is dispatched only
        // after endAIExperience(). Dispatching it while the AI session is still open
        // lets a subsequent click/type discard-and-revert the just-applied update.
        this.pendingHistoryStackEntryCommand = void 0;
    }
}






class $1cf39e92d97f738f$export$a81ea6073ad8424c {
    updateCallback(onUploadAndInsertMedia) {
        this.onUploadAndInsertMedia = onUploadAndInsertMedia;
    }
    updatePrepareCallback(onPrepareImageUpdate) {
        this.onPrepareImageUpdate = onPrepareImageUpdate;
    }
    updateClearCallback(onClearAIGenerating) {
        this.onClearAIGenerating = onClearAIGenerating;
    }
    streamChunk(data, isFinished, _traceId, _singleInstrumentationId) {
        // If the stream errored, clear the AI generating state and bail out
        if ('__isError' in data && data.__isError) {
            this.streamError();
            return;
        }
        // A safety / AUP violation is streamed as a finished ACTION_COMPLETE with
        // `isSafetyViolation: true` and no media. This is an expected outcome, not
        // a system failure, so it must not publish a `taskFail` operational metric
        // (which is pure noise). Clear the AI generating state, publish the outcome
        // as a success, and skip the (impossible) media insertion.
        if (isFinished && data.isSafetyViolation) {
            if (this.lastPreviousMediaFileId) {
                this.onClearAIGenerating?.(this.lastPreviousMediaFileId);
                this.lastPreviousMediaFileId = undefined;
            }
            this.hasPrepared = false;
            (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).success();
            return;
        }
        // Variant-picker image updates are handled FE-side (useUpdateRemix ->
        // useOnComplete uploads + inserts and drives the loading state); the BE
        // push here would double both. Rovo-chat updates aren't tracked, so they
        // still flow through.
        if (data.previousMediaFileId && this.editorAPI?.malleableUi?.actions.isVariantUpdateInFlight(data.previousMediaFileId) && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
            if (isFinished) // Surface success so the experience tracker closes normally.
            (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).success();
            return;
        }
        // On the first chunk, if there's a previousMediaFileId, trigger the loading
        // state on the existing image immediately (before the upload starts)
        if (!this.hasPrepared && data.previousMediaFileId) {
            this.hasPrepared = true;
            this.lastPreviousMediaFileId = data.previousMediaFileId;
            this.onPrepareImageUpdate?.(data.previousMediaFileId);
        }
        if (isFinished) {
            this.hasPrepared = false;
            this.lastPreviousMediaFileId = undefined;
            this.onUploadAndInsertMedia?.(data.mediaUrl, data)?.then((result)=>{
                (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).success();
                // `result.fieldId` is the upload-side upfront id assigned by
                // mediaClient and written onto mediaNode.attrs.id; the BE-side
                // `data.mediaFileId` is a different identifier and won't match
                // the live node when the toolbar looks up the stack entry.
                const liveFieldId = result?.fieldId;
                if (data.previousMediaFileId && liveFieldId && (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar')) {
                    // `dynamicUiSubtype` is intentionally omitted: the reducer inherits
                    // it from the matched entry (the backend's echoed value is
                    // unreliable for edits that aren't told the current subtype).
                    const cmd = this.editorAPI?.malleableUi?.commands.addBackendRemixHistoryStackEntry({
                        previousFieldId: data.previousMediaFileId,
                        fieldId: liveFieldId
                    });
                    if (cmd) this.editorAPI?.core?.actions.execute(cmd);
                }
            })?.catch((error)=>{
                (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).fail({
                    error: error instanceof Error ? error.message : 'upload_and_insert_failed'
                });
            });
        }
    }
    /**
   * Clears editor-side loading state for image updates. This is safe even before
   * image prepare data arrives, which can happen when Rovo chat blocks a request.
   */ clearStreamingState() {
        const editorAPI = this.editorAPI;
        editorAPI?.aiExperience?.actions.endInlineRovoStreaming?.();
        editorAPI?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        if (this.lastPreviousMediaFileId) {
            this.onClearAIGenerating?.(this.lastPreviousMediaFileId);
            this.lastPreviousMediaFileId = undefined;
        }
        this.hasPrepared = false;
    }
    /**
   * Called when the SSE stream errors (ACTION_ERROR) to clear the AI generating
   * state from the existing image node.
   */ streamError() {
        if (this.lastPreviousMediaFileId) {
            this.onClearAIGenerating?.(this.lastPreviousMediaFileId);
            this.lastPreviousMediaFileId = undefined;
        }
        this.hasPrepared = false;
        (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).fail({
            error: 'stream_error'
        });
    }
    /**
   * Called on abort when ACTION_PREPARE was received, matching the legacy image
   * abort behavior.
   */ abortIfPrepared() {
        if (this.hasPrepared) this.streamError();
    }
    /**
   * Called on abort to clear any editor-side image loading state. When ACTION_PREPARE
   * was received, also fail the remix experience before clearing state.
   */ abortAndClearStreamingState() {
        if (this.hasPrepared) (0, $6bbebd245884f275$export$d4e0a6ad65c67b9f).fail({
            error: 'stream_error'
        });
        this.clearStreamingState();
    }
    constructor(onUploadAndInsertMedia, onPrepareImageUpdate, onClearAIGenerating, editorAPI){
        this.onUploadAndInsertMedia = void 0;
        this.onPrepareImageUpdate = void 0;
        this.onClearAIGenerating = void 0;
        this.editorAPI = void 0;
        this.hasPrepared = false;
        this.lastPreviousMediaFileId = void 0;
        this.onUploadAndInsertMedia = onUploadAndInsertMedia;
        this.onPrepareImageUpdate = onPrepareImageUpdate;
        this.onClearAIGenerating = onClearAIGenerating;
        this.editorAPI = editorAPI;
    }
}


const $6489ad8027ee6082$export$bb3d6eff667f4678 = 'aifc-adf-update';
const $6489ad8027ee6082$export$740b9b28cb05ebd6 = 'dynamic-ui-create';
const $6489ad8027ee6082$export$4a9884303bce30ff = 'image-create';



class $b23b470658d57b0a$export$475014de15a4c342 {
    /**
   * Products can use this method to add custom command handlers
   * they can also add default command handlers using addDefaultCommandHandlers
   *
   * @param command - The command constructor
   * @param handler - The command handler
   * @returns The command manager
   */ addCommandHandler(command, handler) {
        this.commandHandlers.set(command, handler);
        return this;
    }
    /**
   * Products can use this method to add default command handlers
   * they can also add custom command handlers using addCommandHandler
   *
   * @returns The command manager
   */ addDefaultCommandHandlers() {
        this.addCreateCommandHandler();
        this.addUpdateCommandHandler();
        this.addActionClassificationCommandHandler();
        this.addReadCommandHandler();
        this.addAbortCommandHandler();
        this.addSendContextReadyCommandHandler();
        this.addRovoStreamCompletedCommandHandler();
        if ((0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_1', 'isEnabled', true)) this.addRovoStreamErroredCommandHandler();
        this.addInsertContentCommandHandler();
        return this;
    }
    registerCommandsToRovoBridge() {
        this.commandHandlers.forEach((handler, command)=>{
            this.rovoBridgeAPI.on(this.clientId, command, (payload)=>{
                return handler.execute(payload);
            });
        });
    }
    /**
   * Add commands and register them to the rovo bridge
   */ addAndRegisterCommands() {
        if (this.addCommandHandlers) this.addCommandHandlers({
            commandManager: this
        });
        else this.addDefaultCommandHandlers();
        this.registerCommandsToRovoBridge();
    }
    deregisterCommandsFromRovoBridge() {
        this.commandHandlers.forEach((handler, command)=>{
            this.rovoBridgeAPI.off(this.clientId, command);
            handler.deregister();
        });
    }
    /**
   * Deregister all commands
   */ /**
   * Signals the image update processor to clear the AI generating state (e.g. on ACTION_ERROR).
   */ streamImageError() {
        this.imageUpdateCommandProcessor?.streamError();
    }
    deregisterCommands() {
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('deregister commands');
        this.deregisterCommandsFromRovoBridge();
        this.commandHandlers.clear();
    }
    /**
   * Update clientId
   */ updateClientId(clientId, rovoBridgeAPI) {
        if (this.clientId === clientId && this.rovoBridgeAPI === rovoBridgeAPI) return;
        // add analytics event for the re-registration
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('update clientId');
        this.deregisterCommandsFromRovoBridge();
        this.clientId = clientId;
        this.rovoBridgeAPI = rovoBridgeAPI;
        this.registerCommandsToRovoBridge();
    }
    /**
   * Update commandProps
   */ updateCommandProps(commandProps) {
        if (this.commandProps === commandProps) return;
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('update commandProps');
        this.commandProps = commandProps;
        this.commandHandlers.forEach((handler)=>{
            handler.updateProps(commandProps);
        });
        if (this.imageUpdateCommandProcessor && commandProps.onUploadAndInsertMedia) this.imageUpdateCommandProcessor.updateCallback(commandProps.onUploadAndInsertMedia);
        if (this.imageUpdateCommandProcessor && commandProps.onPrepareImageUpdate) this.imageUpdateCommandProcessor.updatePrepareCallback(commandProps.onPrepareImageUpdate);
        if (this.imageUpdateCommandProcessor && commandProps.onClearAIGenerating) this.imageUpdateCommandProcessor.updateClearCallback(commandProps.onClearAIGenerating);
    }
    /**
   * Update addCommandHandlers
   */ updateAddCommandHandlers(addCommandHandlers) {
        if (this.addCommandHandlers === addCommandHandlers) return;
        (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('update addCommandHandlers');
        this.addCommandHandlers = addCommandHandlers;
        this.deregisterCommands();
        this.addAndRegisterCommands();
    }
    addCreateCommandHandler() {
        const createCommandHandler = new (0, $ad501fd088efe15f$export$53d8e34277e6a8ab)(this.commandProps, this.createCommandProcessor);
        this.addCommandHandler((0, $hwIq7.ConfluencePageCreateCommand), createCommandHandler);
    }
    addUpdateCommandHandler() {
        if (this.dynamicUiUpdateCommandProcessor && this.imageUpdateCommandProcessor && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true)) {
            const strategies = new Map([
                [
                    (0, $6489ad8027ee6082$export$bb3d6eff667f4678),
                    new (0, $9fb8b0078e18dd5e$export$ff883159d3c43ab1)(this.updateCommandProcessor)
                ],
                [
                    (0, $6489ad8027ee6082$export$740b9b28cb05ebd6),
                    new (0, $ee2e6b9285b9c654$export$47ba439f8682d30d)(this.dynamicUiUpdateCommandProcessor)
                ],
                [
                    (0, $6489ad8027ee6082$export$4a9884303bce30ff),
                    new (0, $89cf1368fcb03552$export$34daae3f4eb40acc)(this.imageUpdateCommandProcessor)
                ]
            ]);
            this.addCommandHandler((0, $dE5YE.ConfluenceUpdatePageCommand), new (0, $cf2c80d88893a2de$export$fe1e3dddf412c96a)(this.commandProps, strategies));
        } else this.addCommandHandler((0, $dE5YE.ConfluenceUpdatePageCommand), new (0, $453761e88b44d120$export$9e34a8a16b80af23)(this.commandProps, this.updateCommandProcessor));
    }
    addActionClassificationCommandHandler() {
        this.addCommandHandler((0, $lzoay.ActionClassificationCommand), new (0, $6f058edf70792236$export$7806cb7ced51ef0f)(this.commandProps, this.updateCommandProcessor));
    }
    addReadCommandHandler() {
        const readCommandHandler = new (0, $f22323296098f0eb$export$ada55596c5cc2d41)(this.commandProps);
        this.addCommandHandler((0, $1r5s7.ReadContentCommand), readCommandHandler);
    }
    addAbortCommandHandler() {
        const abortCommandHandler = new (0, $a8b95bbe20f101c9$export$3a9b6d9d6180d66)(this.commandProps, ()=>{
            this.commandHandlers.forEach((handler)=>{
                if (handler instanceof (0, $5896f48a4d11c2fd$export$1673b811578d4e4e)) handler.handleAbort('user_abort');
            });
            if ((0, $ieeJu.expValEquals)('cc_maui_polish_changes_batch_1', 'isEnabled', true)) this.imageUpdateCommandProcessor?.clearStreamingState();
            this.commandProps.onStreamAbort?.();
        });
        this.addCommandHandler((0, $4nKqn.RovoStreamAbortedCommand), abortCommandHandler);
    }
    addSendContextReadyCommandHandler() {
        const sendContextReadyHandler = new (0, $8930067984616c53$export$28d3a280fab599b5)(this.commandProps);
        this.addCommandHandler((0, $4nKqn.RovoSendContextReadyCommand), sendContextReadyHandler);
    }
    addRovoStreamCompletedCommandHandler() {
        const streamCompletedHandler = new (0, $62e6e860c6a05106$export$c246e3e964a757d2)(this.commandProps);
        this.addCommandHandler((0, $4nKqn.RovoStreamCompletedCommand), streamCompletedHandler);
    }
    addRovoStreamErroredCommandHandler() {
        const streamErroredHandler = new (0, $1e1884497811d88d$export$1c85c9771012b466)(this.commandProps, ()=>{
            this.imageUpdateCommandProcessor?.clearStreamingState();
        });
        this.addCommandHandler((0, $4nKqn.RovoStreamErroredCommand), streamErroredHandler);
    }
    addInsertContentCommandHandler() {
        const insertContentCommandHandler = new (0, $f427f81a62f6b31b$export$a5122c37a2351633)(this.commandProps);
        this.addCommandHandler((0, $d5NOj.EditorInsertContentCommand), insertContentCommandHandler);
    }
    constructor(clientId, rovoBridgeAPI, commandProps, addCommandHandlers){
        this.clientId = clientId;
        this.rovoBridgeAPI = rovoBridgeAPI;
        this.commandProps = commandProps;
        this.addCommandHandlers = addCommandHandlers;
        this.commandHandlers = new Map();
        this.createCommandProcessor = void 0;
        this.updateCommandProcessor = void 0;
        this.dynamicUiUpdateCommandProcessor = void 0;
        this.imageUpdateCommandProcessor = void 0;
        this.createCommandProcessor = new (0, $e45e8781eebf51c5$export$6d1dc40d9d0d1446)(this.commandProps.editorAPI, this.commandProps.contentLocation);
        this.updateCommandProcessor = new (0, $1c5b0b9ec452e760$export$37d5c27ac1ce34a8)(this.commandProps.editorAPI, this.commandProps.contentLocation, this.clientId, this.rovoBridgeAPI);
        this.dynamicUiUpdateCommandProcessor = new (0, $7242e0da8bf5b4b8$export$49fd996878dc7f33)(this.commandProps.editorAPI);
        this.imageUpdateCommandProcessor = new (0, $1cf39e92d97f738f$export$a81ea6073ad8424c)(this.commandProps.onUploadAndInsertMedia, this.commandProps.onPrepareImageUpdate, this.commandProps.onClearAIGenerating, this.commandProps.editorAPI);
    }
}











// eslint-disable-next-line require-unicode-regexp
const $4e3ce21a89bb0972$var$CONTENT_ID_COLLECTION_REGEX = /^contentId-(\d+)$/;
const $4e3ce21a89bb0972$export$62377526511be117 = ({ mediaProvider: mediaProvider, createMediaProvider: createMediaProvider, onUploadImageError: onUploadImageError })=>{
    const mediaProviderRef = (0, $cozmU.useRef)(Promise.resolve());
    const mediaClientCacheRef = (0, $cozmU.useRef)(new Map());
    // Store media provider as a ref so it can be accessed mid-processing without recreating callbacks or triggering re-renders
    (0, $cozmU.useEffect)(()=>{
        if (mediaProvider) mediaProviderRef.current = mediaProvider;
    }, [
        mediaProvider
    ]);
    // Get or create media client for a specific content ID, used for retrieving the original image URL
    // Leverages a cache to avoid creating multiple media clients for the same content ID
    const getViewMediaClientForContentId = (0, $cozmU.useCallback)(async (originalContentId)=>{
        // Check media client cache first
        const cache = mediaClientCacheRef.current;
        const item = cache.get(originalContentId);
        if (item) return item;
        if (!createMediaProvider) throw new Error('No createMediaProvider function provided');
        // Create renderer media provider for the original content
        const mediaProvider = await createMediaProvider({
            contentId: originalContentId
        });
        // Get media client from the provider
        const mediaClient = (0, $g9ZnD.getMediaClient)(mediaProvider.viewMediaClientConfig);
        // Cache it
        cache.set(originalContentId, mediaClient);
        return mediaClient;
    }, [
        createMediaProvider
    ]);
    // Processes ADF nodes recursively, reuploading images when necessary, and tracking whether ADF changes (reuploads) were made
    const processAdfNodes = (0, $cozmU.useCallback)(async (adfContent, mediaClient, targetCollection, getViewMediaClientForContentId)=>{
        let hasChanges = false; // Stable state in closure
        const changedNodesByLocalId = new Map(); // Track changed nodes by their localId
        // Inner recursive function - no change tracking in return type
        const processNode = async (node)=>{
            if (!node || typeof node !== 'object') return node;
            // Process single image node
            if ($4e3ce21a89bb0972$var$isImageNode(node) && $4e3ce21a89bb0972$var$needsReupload(node, targetCollection)) {
                hasChanges = true;
                try {
                    const newImageData = await $4e3ce21a89bb0972$var$reuploadImageNode(node, mediaClient, targetCollection, getViewMediaClientForContentId);
                    const updatedNode = {
                        ...node,
                        attrs: {
                            ...node.attrs,
                            ...newImageData
                        }
                    };
                    if ((0, $iDrrr.fg)('confluence_frontend_aifc_reupload_image')) {
                        const localId = node.attrs?.localId;
                        if (!localId) throw new Error('localId is required for image re-uploading');
                        changedNodesByLocalId.set(localId, updatedNode);
                    }
                    return updatedNode;
                } catch (error) {
                    onUploadImageError?.({
                        error: $4e3ce21a89bb0972$var$enhanceError(error, `Failed to reupload image to collection ${targetCollection}`)
                    });
                    return node; // Return original ADF on error
                }
            }
            // Process objects like: `{ type: "table", content: [...] } or { type: "mediaSingle", content: [...] }`
            const processedNode = {
                ...node
            };
            if (node.content && Array.isArray(node.content)) processedNode.content = await Promise.all(node.content.map((item)=>{
                return item ? processNode(item) : item;
            }));
            return processedNode;
        };
        const processedAdf = await processNode(adfContent);
        return {
            processedAdf: processedAdf,
            hasChanges: hasChanges,
            changedNodesByLocalId: changedNodesByLocalId
        };
    }, [
        onUploadImageError
    ]);
    /**
	 * Process ADF content to fix image collection IDs by reuploading images to mediaProvider's collection
	 * @param adfContent - The ADF content to process
	 * @returns Promise resolving to an object containing:
	 *   - processedAdf: The processed ADF content with updated, reuploaded image collection IDs
	 *   - hasChanges: Boolean indicating if any changes were made to the ADF
	 *   - error?: Optional error if processing failed
	 *   - changedNodesByLocalId?: Map of localId to updated media nodes
	 */ const processImagesInAdf = (0, $cozmU.useCallback)(async (adfContent)=>{
        try {
            const mediaProvider = await mediaProviderRef.current;
            if (!mediaProvider?.uploadMediaClientConfig || !mediaProvider.uploadParams?.collection) return {
                processedAdf: adfContent,
                hasChanges: false,
                error: new Error('No media provider')
            }; // Return original ADF if no media provider
            let mediaClient;
            let targetCollection;
            try {
                mediaClient = (0, $g9ZnD.getMediaClient)(mediaProvider.uploadMediaClientConfig);
                targetCollection = mediaProvider.uploadParams.collection;
            } catch (error) {
                return {
                    processedAdf: adfContent,
                    hasChanges: false,
                    error: $4e3ce21a89bb0972$var$enhanceError(error, 'Error getting media client')
                }; // Return original ADF on error
            }
            try {
                return await processAdfNodes(adfContent, mediaClient, targetCollection, getViewMediaClientForContentId);
            } catch (error) {
                return {
                    processedAdf: adfContent,
                    hasChanges: false,
                    error: $4e3ce21a89bb0972$var$enhanceError(error, 'Error processing ADF nodes')
                }; // Return original ADF on error
            }
        } catch (error) {
            return {
                processedAdf: adfContent,
                hasChanges: false,
                error: $4e3ce21a89bb0972$var$enhanceError(error, 'Error processing images in ADF')
            }; // Return original ADF on error
        }
    }, [
        getViewMediaClientForContentId,
        processAdfNodes
    ]);
    return (0, $cozmU.useMemo)(()=>{
        return {
            processImagesInAdf: processImagesInAdf
        };
    }, [
        processImagesInAdf
    ]);
};
// Adds helpful message to error object
function $4e3ce21a89bb0972$var$enhanceError(error, message) {
    return new Error(`${message}: ${error.message}`);
}
// Helper function to extract content ID from collection pattern
function $4e3ce21a89bb0972$var$extractContentIdFromCollection(collection) {
    const match = collection.match($4e3ce21a89bb0972$var$CONTENT_ID_COLLECTION_REGEX);
    return match ? match[1] : null;
}
// Checks if a node is an image node
function $4e3ce21a89bb0972$var$isImageNode(node) {
    return node?.type && (node?.attrs?.id || node?.attrs?.url) && [
        'media',
        'mediaInline',
        'mediaSingle'
    ].includes(node?.type);
}
// Determines if an image node needs re-uploading
function $4e3ce21a89bb0972$var$needsReupload(node, targetCollection) {
    return !node.attrs?.collection || // no collection
    node.attrs.collection !== targetCollection // collection needs to change
    ;
}
// Re-uploads an image node with correct collection ID
async function $4e3ce21a89bb0972$var$reuploadImageNode(node, editorMediaClient, targetCollection, getViewMediaClientForContentId) {
    let sourceUrl = node.attrs?.url;
    // If we have an ID but wrong collection, try to get the URL from original content
    if (node.attrs?.id && node.attrs?.collection && !sourceUrl) try {
        // Extract original content ID from collection pattern
        const originalContentId = $4e3ce21a89bb0972$var$extractContentIdFromCollection(node.attrs.collection);
        if (originalContentId) {
            // Get media client for the original content
            const originalViewMediaClient = await getViewMediaClientForContentId(originalContentId);
            // Use MediaClient's getImageUrl method to properly construct the absolute URL
            // This handles auth and baseUrl construction automatically
            sourceUrl = await originalViewMediaClient.getImageUrl(node.attrs.id, {
                collection: node.attrs.collection
            });
        } else throw new Error(`Invalid collection format: ${node.attrs.collection}`);
    } catch (error) {
        // Fall back to using the original ID/collection if we can't get URL
        throw $4e3ce21a89bb0972$var$enhanceError(error, `Could not access source image: ${node.attrs.id}`);
    }
    if (!sourceUrl) throw new Error('No source URL available for image re-upload');
    // Upload to target collection
    const uploader = await editorMediaClient.file.uploadExternal(sourceUrl, targetCollection);
    const result = await uploader;
    return {
        id: result.uploadableFileUpfrontIds.id,
        collection: targetCollection
    };
}




/* eslint-disable @atlaskit/platform/no-preconditioning -- gate + experiment layering for MAUI rollout (cc-maui-phase-2 + cc-maui-experiment); preconditioning is intentional and will be removed when cleanup lands */ const $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled = ()=>(0, $iDrrr.fg)('cc-maui-phase-2') && (0, $ieeJu.expValEquals)('cc-maui-experiment', 'isEnabled', true);
const $8a735ad9012f833e$export$3b66bb874c405f9 = {
    '16:9': {
        width: 760,
        height: 424
    },
    '3:2': {
        width: 700,
        height: 470
    },
    '1:1': {
        width: 592,
        height: 592
    },
    '2:3': {
        width: 470,
        height: 701
    },
    '9:16': {
        width: 424,
        height: 760
    }
};
const $8a735ad9012f833e$export$a1558edde17053fc = (meta)=>{
    if (meta?.inputMethod !== (0, $krYZG.INPUT_METHOD).REMIX_FROM_MEDIA_INSERTS) return null;
    const aspectRatio = meta?.aspectRatio;
    if (!aspectRatio) return null;
    return $8a735ad9012f833e$export$3b66bb874c405f9[aspectRatio] ?? null;
};
const $8a735ad9012f833e$export$23da1d24a38b0bde = ()=>{
    if (typeof window === 'undefined') return false;
    const host = window.location.host;
    return host.includes('.stg.atlassian') || host.includes('.stg-east.frontend.public.atl-paas.net') || host.includes('jira-dev.com');
};
const $8a735ad9012f833e$var$bindRovoBridgeTeardown = (teardown)=>{
    const run = ()=>{
        /**
		 * @description We do NOT want to yield a return value here. It can cause certain unload
		 * handlers to display a window alert with "Are you sure you want to leave this page?".
		 * Specifically, see @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event,
		 * which is remarked to be a cancellable event by browsers.
		 */ teardown();
        // Although unnecessary (the JS context is being destroyed), we remove the event listeners
        // to avoid any potential memory leaks due to hanging references - side effects can cause this.
        unbind();
    };
    // Below, we attempt to teardown on different event handlers which we know will trigger
    // on complete unmount of the document in this JS context. Note: Same-origin iframes are
    // indeed considered their own JS context here; just that they have access to other contexts.
    // Browsers report `unload` and `beforeunload` to be unreliable. Hence, we leverage a chain
    // of these events. See official MDN documentation for more (linked below).
    /**
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event
	 * TODO - bring beforeunload back by consolidating handlers per discussion at -
	 * https://bitbucket.org/atlassian/atlassian-frontend-monorepo/pull-requests/207747/overview#comment-674441389
	 */ // window.addEventListener('beforeunload', run, { once: true });
    /**
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/unload_event
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/pagehide_event
	 */ const unbind = (0, $cbY7C.bindAll)(window, [
        {
            type: 'unload',
            listener: run,
            options: {
                once: true
            }
        },
        {
            type: 'pagehide',
            listener: run,
            options: {
                once: true
            }
        }
    ]);
    return unbind;
};
function $8a735ad9012f833e$var$useRovoBridgeLifecycle(props) {
    const contentType = 'page';
    const { clientId: clientId, contentLocation: contentLocation, contentId: contentId, rovoBridgeAPI: rovoBridgeAPI, onBridgeReady: onBridgeReady } = props;
    (0, $cozmU.useEffect)(()=>{
        if (!rovoBridgeAPI) return;
        // When the fix gate is OFF, call ready() here (original behaviour) —
        // AFTER ContentReadyCommand has been delivered synchronously to BridgeAPIHandlers.
        // When the fix gate is ON, ready() is called in the command-registration
        // effect (after addAndRegisterCommands()) so queued commands are only
        // drained once command handlers are ready.
        if (!(0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) rovoBridgeAPI.ready(clientId);
        rovoBridgeAPI.send((0, $2BLI8.ContentReadyCommand), {
            senderId: clientId,
            receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
            contentId: contentId,
            contentType: contentType,
            canProvideContext: true,
            contentContext: contentLocation
        });
        if (!(0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) // Fire after both sides of the bridge are ready and ContentReadyCommand
        // has been delivered synchronously to BridgeAPIHandlers.
        onBridgeReady?.();
        function rovoBridgeTeardown() {
            if (!rovoBridgeAPI) return;
            rovoBridgeAPI.send((0, $2BLI8.ContentDestroyCommand), {
                senderId: clientId,
                receiverId: (0, $5Tn11.ROVO_CHAT_CLIENT_ID),
                contentId: contentId,
                contentType: contentType,
                contentContext: contentLocation
            });
            rovoBridgeAPI.teardown(clientId);
        }
        const unbind = $8a735ad9012f833e$var$bindRovoBridgeTeardown(()=>rovoBridgeTeardown());
        return ()=>{
            try {
                unbind();
                rovoBridgeTeardown();
            // TODO: EDITOR-123 - clear inactivity timeouts?
            } catch  {
            // TODO: EDITOR-123 - handle errors; should go to Sentry
            // could be sent in future by navigation lockout
            }
        };
    }, [
        clientId,
        contentLocation,
        contentId,
        contentType,
        rovoBridgeAPI,
        onBridgeReady
    ]);
}
/**
 * Builds the `dataConsumerSource` mark value for remix-generated images.
 * Returns `undefined` when the feature gate is off.
 *
 * Format: `remix:<type>:<subtype>` when the subtype is provided,
 * otherwise falls back to `remix`.
 */ const $8a735ad9012f833e$var$getRemixDataConsumerSource = (remixSubtype)=>{
    if (!(0, $iDrrr.fg)('cc-maui-add-mark-for-remix-generated-images')) return undefined;
    if (!remixSubtype) return 'remix';
    // Unlike remixSubtype, dynamicUiType isn't available on the image-create backend payload or the insert
    // content command. Sourcing it would require either a backend change or importing from malleable-ui-components.
    // This simple inference avoids both while producing the correct result, at least until additional 'image'
    // subtypes are added. Ticket: https://hello.jira.atlassian.cloud/jira/browse/A4C-7193
    const remixType = remixSubtype === 'image' ? 'image' : 'infographic';
    return `remix:${remixType}:${remixSubtype}`;
};
const $8a735ad9012f833e$export$5203c6a0fdaaa3b = ({ contentLocation: contentLocation, contentId: contentId, userId: userId, editorAPI: editorAPI, skipAiExperienceRequirement: skipAiExperienceRequirement, useGenericEditorSkill: useGenericEditorSkill, additionalContext: additionalContext, mediaProvider: mediaProvider, createMediaProvider: createMediaProvider, onUploadImageError: onUploadImageError, onUploadAndInsertMediaError: onUploadAndInsertMediaError, onStreamStart: onStreamStart, onStream: onStream, onStreamEnd: onStreamEnd, onStreamAbort: onStreamAbort, onStreamTimeout: onStreamTimeout, onStreamError: onStreamError, onStreamRepair: onStreamRepair, onSendContextReady: onSendContextReady, onBridgeReady: onBridgeReady, onInsertContent: onInsertContent, addCommandHandlers: addCommandHandlers })=>{
    const { propertiesRef: propertiesRef } = (0, $89QZA.useAnalyticsPropertiesContext)();
    const product = 'confluence';
    const contentType = 'page';
    const clientId = (0, $5OXoi.getConfluenceEditorClientId)(contentId);
    const contentIdRef = (0, $cozmU.useRef)(contentId);
    contentIdRef.current = contentId;
    (0, $cozmU.useEffect)(()=>{
        if (!editorAPI) return;
        editorAPI.aiExperience?.actions.updateTargetId(contentId);
    }, [
        editorAPI,
        contentId
    ]);
    const rovoBridgeAPI = (0, $cozmU.useMemo)(()=>{
        if (!editorAPI || !skipAiExperienceRequirement && !editorAPI.aiExperience || !editorAPI.aiStreamingOrchestrator) return null;
        return (0, $85mU8.getBrowserBridgeAPI)();
    }, [
        editorAPI,
        skipAiExperienceRequirement
    ]);
    const imageProcessor = (0, $4e3ce21a89bb0972$export$62377526511be117)({
        mediaProvider: mediaProvider,
        createMediaProvider: createMediaProvider,
        onUploadImageError: onUploadImageError
    });
    const mediaProviderRef = (0, $cozmU.useRef)(undefined);
    (0, $cozmU.useEffect)(()=>{
        mediaProviderRef.current = mediaProvider;
    }, [
        mediaProvider
    ]);
    // Behind the `cc-maui-overlay-by-localid` experiment the AI-generating overlay
    // is driven solely by the inline-Rovo streaming target (a per-node localId
    // staged at Ask Rovo / Edit image submit, cleared when the session ends,
    // errors, or is cancelled). In that mode we skip the ACTION_PREPARE overlay
    // path below, because its payload only carries a media file id which is shared
    // by copy/pasted duplicates and would light up every copy. When the experiment
    // is off, these callbacks keep the previous media-file-id behaviour.
    const onPrepareImageUpdate = (0, $cozmU.useCallback)((previousMediaFileId)=>{
        if ((0, $ieeJu.expValEquals)('cc-maui-overlay-by-localid', 'isEnabled', true)) return;
        if (!$8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled()) return;
        const mediaAPI = editorAPI?.media;
        if (!mediaAPI) return;
        editorAPI.core.actions.execute(mediaAPI.commands.setAIGenerating(previousMediaFileId));
    }, [
        editorAPI
    ]);
    const onClearAIGenerating = (0, $cozmU.useCallback)((previousMediaFileId)=>{
        if ((0, $ieeJu.expValEquals)('cc-maui-overlay-by-localid', 'isEnabled', true)) return;
        if (!$8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled()) return;
        const mediaAPI = editorAPI?.media;
        if (!mediaAPI) return;
        editorAPI.core.actions.execute(mediaAPI.commands.clearAIGenerating(previousMediaFileId));
    }, [
        editorAPI
    ]);
    // Set of file IDs that we've set AI generating decoration on and are waiting
    // for the media card to signal that the image preview has rendered.
    const pendingAIClearIds = (0, $cozmU.useRef)(new Set());
    /**
	 * Tracks an AI-generated media file during the CWR streaming flow.
	 * Sets the AI generating decoration (START). The decoration is cleared (END)
	 * when the media card signals that the image preview has rendered, via the
	 * media plugin's sharedState.onChange subscription below.
	 */ const onTrackAIGeneratingMedia = (0, $cozmU.useCallback)((fileId, _collectionName)=>{
        if (!(0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true)) return;
        const mediaAPI = editorAPI?.media;
        if (!mediaAPI) return;
        editorAPI.core.actions.execute(mediaAPI.commands.setAIGenerating(fileId, 'cwr'));
        pendingAIClearIds.current.add(fileId);
    }, [
        editorAPI
    ]);
    // Subscribe to the media plugin's shared state to detect when a media card's
    // image preview has rendered. When a file ID we're tracking appears in
    // previewRenderedMediaIds, clear the AI generating decoration.
    (0, $1KOhB.usePluginStateEffect)(editorAPI, [
        'media'
    ], ({ mediaState: mediaState })=>{
        if (!(0, $ieeJu.expValEquals)('aifc_page_create_with_rovo_include_infographics', 'isEnabled', true)) return;
        if (!mediaState?.previewRenderedMediaIds || pendingAIClearIds.current.size === 0) return;
        for (const fileId of Array.from(pendingAIClearIds.current))if (mediaState.previewRenderedMediaIds.has(fileId)) {
            if (editorAPI?.media) editorAPI.core.actions.execute(editorAPI.media.commands.clearAIGenerating(fileId));
            pendingAIClearIds.current.delete(fileId);
        }
    });
    // When the AI plugin's `inlineRovoStreamingTargetId` flips on
    // or off (session end / cancel), mirror it onto the media plugin's
    // existing AI-generating decoration. This gives media nodes an
    // optimistic prompt submit-time loading overlay without
    // coupling `editor-plugin-media` to `editor-plugin-ai`.
    const previousInlineRovoTargetIdRef = (0, $cozmU.useRef)(null);
    (0, $1KOhB.usePluginStateEffect)(editorAPI, [
        'aiExperience'
    ], ({ aiExperienceState: aiExperienceState })=>{
        if (!$8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled()) return;
        const mediaCommands = editorAPI?.media?.commands;
        const coreActions = editorAPI?.core?.actions;
        if (!mediaCommands || !coreActions) return;
        const next = aiExperienceState?.aiDecorationExperiencePluginState?.inlineRovoStreamingTargetId ?? null;
        const previous = previousInlineRovoTargetIdRef.current;
        if (next === previous) return;
        previousInlineRovoTargetIdRef.current = next;
        if (next != null) coreActions.execute(mediaCommands.setAIGenerating(next));
        else if (previous != null) coreActions.execute(mediaCommands.clearAIGenerating(previous));
    });
    const onUploadAndInsertMedia = (0, $cozmU.useCallback)(async (sourceUrl, payload, _presentation, meta)=>{
        if (!editorAPI || !editorAPI.media) {
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('onUploadAndInsertMedia: Editor API or media plugin not available');
            return;
        }
        const resolvedProvider = await mediaProviderRef.current;
        if (!resolvedProvider?.uploadMediaClientConfig || !resolvedProvider.uploadParams?.collection) {
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('onUploadAndInsertMedia: No media provider available');
            return;
        }
        const { mediaFileId: mediaFileId, previousMediaFileId: previousMediaFileId, dynamicUiSource: dynamicUiSource, dynamicUiSubtype: dynamicUiSubtype } = payload ?? {};
        const localId = dynamicUiSource?.startLocalId;
        try {
            const mediaClient = (0, $g9ZnD.getMediaClient)(resolvedProvider.uploadMediaClientConfig);
            const targetCollection = resolvedProvider.uploadParams.collection;
            // Detect stale collection: if the frozen uploadParams.collection doesn't match
            // contentId-${contentId}, the MediaProvider was created for a different page
            // IMPORTANT!!! This only works for Confluence and is designed to be temporary.
            // Other products behave differently
            if ((0, $iDrrr.fg)('platform_editor_ai_stale_media_collection_analytic')) {
                const expectedCollection = `contentId-${contentIdRef.current}`;
                if (targetCollection !== expectedCollection) (0, $53861ea5f5f93b7f$export$ca6ec3543ab362f8)(editorAPI, targetCollection, contentIdRef.current);
            }
            if (previousMediaFileId && mediaFileId && userId) {
                const { token: token, collection: collection } = await (0, $iF7Yl.fetchMauiPersonalReadToken)(product);
                const imageUrl = (0, $aYC8J.buildImageUrl)({
                    fileId: mediaFileId,
                    token: token.split('Bearer ')[1],
                    collection: collection,
                    clientId: userId,
                    isStaging: $8a735ad9012f833e$export$23da1d24a38b0bde()
                });
                const result = await mediaClient.file.uploadExternal(imageUrl, targetCollection, undefined, true);
                const { id: id, occurrenceKey: occurrenceKey } = result.uploadableFileUpfrontIds;
                const { height: height, width: width } = result.dimensions;
                const aiGeneratedDimensions = $8a735ad9012f833e$export$a1558edde17053fc(meta);
                const mediaAttrs = {
                    id: id,
                    collection: targetCollection,
                    occurrenceKey: occurrenceKey,
                    type: 'file',
                    __fileMimeType: result.mimeType,
                    width: aiGeneratedDimensions?.width ?? (0, $7Y8M5.akEditorDefaultLayoutWidth),
                    height: aiGeneratedDimensions?.height ?? Math.round((0, $7Y8M5.akEditorDefaultLayoutWidth) * (height / width))
                };
                // Replace existing media node and set AI generating decoration on the new node
                editorAPI.core.actions.execute(({ tr: tr })=>{
                    // Get the editor's schema
                    const schema = editorAPI.core.sharedState.currentState()?.schema;
                    if (!schema) throw new Error('Could not get editor schema for replacing media node');
                    const { selection: selection } = tr;
                    let found = false;
                    // Fast path: if the current selection is a NodeSelection on a mediaSingle
                    // that contains the target media node, use that position directly.
                    if (selection instanceof (0, $kCECX.NodeSelection)) {
                        const selectedNode = selection.node;
                        if (selectedNode.type === schema.nodes.mediaSingle) {
                            const mediaNode = selectedNode.content.child(0);
                            if (mediaNode && mediaNode.attrs.id === previousMediaFileId && (localId ? mediaNode.attrs.localId === localId : true)) {
                                tr.setNodeMarkup(selection.from + 1, undefined, {
                                    ...mediaNode.attrs,
                                    ...mediaAttrs
                                });
                                found = true;
                            }
                        }
                    }
                    // Slow path: traverse the whole document
                    let foundMediaParentPos;
                    if (!found) tr.doc.descendants((node, pos, parent)=>{
                        if (!found && node.type === schema.nodes.media && node.attrs.id === previousMediaFileId && (localId ? parent?.attrs.localId === localId : true)) {
                            tr.setNodeMarkup(pos, undefined, {
                                ...node.attrs,
                                ...mediaAttrs
                            });
                            found = true;
                            // media is the first child of mediaSingle, so parent pos = pos - 1
                            if (parent?.type === schema.nodes.mediaSingle) foundMediaParentPos = pos - 1;
                            return false;
                        }
                    });
                    if (found) {
                        // Restore NodeSelection on the edited mediaSingle node
                        if ((0, $iDrrr.fg)('platform_remix_fix_node_replacement_selection')) {
                            const selectPos = selection instanceof (0, $kCECX.NodeSelection) ? selection.from : foundMediaParentPos;
                            if (selectPos !== undefined) try {
                                tr.setSelection((0, $kCECX.NodeSelection).create(tr.doc, selectPos));
                            } catch  {
                            // If NodeSelection creation fails, leave selection as-is
                            }
                        }
                        tr.scrollIntoView();
                        // Mark insertion complete and succeed the remix-edit-existing UFO experience.
                        (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).NODE_INSERTED);
                        (0, $irnO2.remixEditExistingExperience).success();
                    } else (0, $irnO2.remixEditExistingExperience).failure({
                        metadata: {
                            reason: 'media_node_not_found'
                        }
                    });
                    return tr;
                });
                // Set AI generating decoration on the new media node
                if (editorAPI.media && $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled() && meta?.isAIGenerated === true) editorAPI.core.actions.execute(editorAPI.media.commands.setAIGenerating(id));
                // Clear AI generating decoration after the upload completes
                const subscription = mediaClient.file.getFileState(id).subscribe({
                    next: (fileState)=>{
                        if (fileState.status !== 'uploading') {
                            if (editorAPI.media && $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled() && meta?.isAIGenerated === true) editorAPI.core.actions.execute(editorAPI.media.commands.clearAIGenerating(id));
                            subscription.unsubscribe();
                        }
                    },
                    error: (error)=>{
                        if (editorAPI.media && $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled()) editorAPI.core.actions.execute(editorAPI.media.commands.clearAIGenerating(id));
                        const errorMessage = error instanceof Error ? error.message : typeof error === 'object' && error !== null ? JSON.stringify(error) : String(error);
                        const conversationChannelId = meta?.conversationChannelId || propertiesRef.current.conversationChannelId || undefined;
                        (0, $53861ea5f5f93b7f$export$56bc5406a64f1fd4)({
                            editorApi: editorAPI,
                            errorMessage: errorMessage,
                            conversationChannelId: conversationChannelId,
                            errorFlagShown: true
                        });
                        onUploadAndInsertMediaError?.({
                            retry: async ()=>{
                                await onUploadAndInsertMedia?.(sourceUrl, payload, _presentation, meta);
                            }
                        });
                        subscription.unsubscribe();
                    }
                });
                return (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? {
                    type: 'update',
                    fieldId: id
                } : undefined;
            } else {
                const result = await mediaClient.file.uploadExternal(sourceUrl, targetCollection, undefined, true);
                const { id: id, occurrenceKey: occurrenceKey } = result.uploadableFileUpfrontIds;
                const { height: height, width: width } = result.dimensions;
                const aiGeneratedDimensions = $8a735ad9012f833e$export$a1558edde17053fc(meta);
                const mediaAttrs = {
                    id: id,
                    collection: targetCollection,
                    occurrenceKey: occurrenceKey,
                    type: 'file',
                    __fileMimeType: result.mimeType,
                    width: aiGeneratedDimensions?.width ?? (0, $7Y8M5.akEditorDefaultLayoutWidth),
                    height: aiGeneratedDimensions?.height ?? Math.round((0, $7Y8M5.akEditorDefaultLayoutWidth) * (height / width))
                };
                // Insert new media node
                if (!editorAPI.media) return;
                const dataConsumerSource = $8a735ad9012f833e$var$getRemixDataConsumerSource(dynamicUiSubtype);
                const insertMediaSingleCommand = editorAPI.media.commands.insertMediaSingle(mediaAttrs, meta?.inputMethod ?? (0, $krYZG.INPUT_METHOD).REMIX, (0, $krYZG.INSERT_MEDIA_VIA).LOCAL_UPLOAD, meta?.positions, dataConsumerSource);
                editorAPI.core.actions.execute(({ tr: tr })=>insertMediaSingleCommand({
                        tr: tr
                    })?.scrollIntoView() ?? tr);
                // Mark image node insertion complete and succeed the remix-edit-existing
                (0, $irnO2.remixEditExistingExperience).mark((0, $irnO2.REMIX_EDIT_EXISTING_MARKS).NODE_INSERTED);
                (0, $irnO2.remixEditExistingExperience).success();
                // Set AI generating decoration on the newly inserted node
                if (editorAPI.media && $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled() && meta?.isAIGenerated === true) editorAPI.core.actions.execute(editorAPI.media.commands.setAIGenerating(id));
                // Clear AI generating decoration after the upload completes
                const subscription = mediaClient.file.getFileState(id).subscribe({
                    next: (fileState)=>{
                        if (fileState.status !== 'uploading') {
                            if (editorAPI.media && $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled() && meta?.isAIGenerated === true) editorAPI.core.actions.execute(editorAPI.media.commands.clearAIGenerating(id));
                            subscription.unsubscribe();
                        }
                    },
                    error: (error)=>{
                        if (editorAPI.media && $8a735ad9012f833e$var$isMauiInlineEditLoadingEnabled()) editorAPI.core.actions.execute(editorAPI.media.commands.clearAIGenerating(id));
                        const errorMessage = error instanceof Error ? error.message : typeof error === 'object' && error !== null ? JSON.stringify(error) : String(error);
                        const conversationChannelId = meta?.conversationChannelId || propertiesRef.current.conversationChannelId || undefined;
                        (0, $53861ea5f5f93b7f$export$56bc5406a64f1fd4)({
                            editorApi: editorAPI,
                            errorMessage: errorMessage,
                            conversationChannelId: conversationChannelId,
                            errorFlagShown: true
                        });
                        onUploadAndInsertMediaError?.({
                            retry: async ()=>{
                                await onUploadAndInsertMedia?.(sourceUrl, payload, _presentation, meta);
                            }
                        });
                        subscription.unsubscribe();
                    }
                });
                return (0, $iDrrr.fg)('platform_editor_ai_remix_toolbar') ? {
                    type: 'create',
                    fieldId: id
                } : undefined;
            }
        } catch (error) {
            (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('onUploadAndInsertMedia: Error uploading media', {
                error: error
            });
            const errorMessage = error instanceof Error ? error.message : typeof error === 'object' && error !== null ? JSON.stringify(error) : String(error);
            const conversationChannelId = meta?.conversationChannelId || propertiesRef.current.conversationChannelId || undefined;
            (0, $53861ea5f5f93b7f$export$56bc5406a64f1fd4)({
                editorApi: editorAPI,
                errorMessage: errorMessage,
                conversationChannelId: conversationChannelId
            });
        } finally{
            editorAPI.aiExperience?.actions.endAIExperience();
        }
    }, // propertiesRef is a ref; reading propertiesRef.current.conversationChannelId at call time
    // is intentional and must not be a dep (would defeat the ref pattern).
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        editorAPI,
        userId
    ]);
    const reuploadImages = (0, $cozmU.useCallback)(async (adfDoc)=>{
        const processImagesAndUpdateDocument = async ()=>{
            if (!imageProcessor?.processImagesInAdf) throw new Error('Image processor not available for image re-uploading in editor streaming');
            if (!editorAPI) throw new Error('Editor API not available for image re-uploading in editor streaming');
            if ((0, $iDrrr.fg)('confluence_frontend_aifc_reupload_image')) {
                const editorDoc = await editorAPI.core.actions.requestDocumentAsync();
                if (!editorDoc) throw new Error('Could not get document from editor for image re-uploading');
                const { error: error, hasChanges: hasChanges, changedNodesByLocalId: changedNodesByLocalId } = await imageProcessor.processImagesInAdf(editorDoc);
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('reuploadImages', {
                    error: error,
                    hasChanges: hasChanges,
                    adfDoc: adfDoc,
                    changedNodesByLocalId: changedNodesByLocalId
                });
                if (error) throw error;
                if (hasChanges && changedNodesByLocalId && changedNodesByLocalId.size > 0) {
                    // Get the editor's schema to convert ADF to ProseMirror nodes
                    const schema = editorAPI.core.sharedState.currentState()?.schema;
                    if (!schema) throw new Error('Could not get editor schema for image re-uploading');
                    // Replace individual nodes
                    changedNodesByLocalId.forEach((adfNode, localId)=>{
                        // Convert ADF to ProseMirror node
                        const pmNode = schema.nodeFromJSON(adfNode);
                        editorAPI?.localId?.actions.replaceNode({
                            localId: localId,
                            value: pmNode
                        });
                    });
                }
            } else {
                if (!adfDoc) throw new Error('adfDoc is required for image re-uploading when feature flag is off');
                const { error: error, hasChanges: hasChanges, processedAdf: processedAdf } = await imageProcessor.processImagesInAdf(adfDoc);
                (0, $2eb6b59988ab18a7$export$bef1f36f5486a6a3)('reuploadImages', {
                    error: error,
                    hasChanges: hasChanges,
                    processedAdf: processedAdf,
                    adfDoc: adfDoc
                });
                if (error) throw error;
                if (hasChanges) editorAPI?.core.actions.replaceDocument(processedAdf, {
                    scrollIntoView: false
                });
            }
        };
        try {
            await processImagesAndUpdateDocument();
        } catch (error) {
            (0, $gQrdE.sendAIFCExperienceTrackingToParent)({
                status: 'fail',
                actionType: 'page',
                actionId: contentId,
                contentContext: contentLocation,
                experienceName: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
                error: error.message
            });
            onUploadImageError?.({
                error: error
            });
        }
    }, [
        imageProcessor,
        editorAPI,
        contentId,
        contentLocation,
        onUploadImageError
    ]);
    const commandProps = (0, $cozmU.useMemo)(()=>{
        if (!editorAPI) return null;
        return {
            clientId: clientId,
            contentLocation: contentLocation,
            contentId: contentId,
            contentType: contentType,
            editorAPI: editorAPI,
            useGenericEditorSkill: useGenericEditorSkill,
            additionalContext: additionalContext,
            onStreamStart: onStreamStart,
            onStream: onStream,
            onStreamEnd: onStreamEnd,
            onStreamAbort: onStreamAbort,
            onStreamTimeout: onStreamTimeout,
            onStreamError: onStreamError,
            onStreamRepair: onStreamRepair,
            onSendContextReady: onSendContextReady,
            onInsertContent: onInsertContent,
            onPrepareImageUpdate: onPrepareImageUpdate,
            onClearAIGenerating: onClearAIGenerating,
            onTrackAIGeneratingMedia: onTrackAIGeneratingMedia,
            onUploadAndInsertMedia: onUploadAndInsertMedia,
            reuploadImages: reuploadImages
        };
    }, [
        clientId,
        contentLocation,
        contentId,
        contentType,
        editorAPI,
        useGenericEditorSkill,
        additionalContext,
        onStreamStart,
        onStream,
        onStreamEnd,
        onStreamAbort,
        onStreamTimeout,
        onStreamError,
        onStreamRepair,
        onSendContextReady,
        onInsertContent,
        onPrepareImageUpdate,
        onClearAIGenerating,
        onTrackAIGeneratingMedia,
        onUploadAndInsertMedia,
        reuploadImages
    ]);
    const commandManagerRef = (0, $cozmU.useRef)(null);
    (0, $cozmU.useEffect)(()=>{
        if (!editorAPI || !rovoBridgeAPI || !commandProps) return;
        // only initialize command manager once because
        // createCommandProcessor is stateful and doesn't support re-creation for now
        if (!commandManagerRef.current) {
            commandManagerRef.current = new (0, $b23b470658d57b0a$export$475014de15a4c342)(clientId, rovoBridgeAPI, commandProps, addCommandHandlers);
            commandManagerRef.current.addAndRegisterCommands();
            // When the fix gate is ON, call ready() here AFTER command handlers
            // are registered so that bridge-queued commands (e.g.
            // ConfluencePageCreateCommand buffered during AIFC reconnection) are
            // only drained once the editor has handlers ready to process them.
            // When the gate is OFF, ready() is called in useRovoBridgeLifecycle
            // (original behaviour, before editorAPI was available).
            if ((0, $iDrrr.fg)('aifc_fix_reconnect_stream_overlap')) {
                rovoBridgeAPI.ready(clientId);
                // Fire onBridgeReady AFTER ready() so callers know the full bridge
                // handshake (handlers registered + receiver announced) is complete.
                onBridgeReady?.();
            }
        }
    }, [
        editorAPI,
        clientId,
        rovoBridgeAPI,
        commandProps,
        addCommandHandlers,
        onBridgeReady
    ]);
    // clientId shouldn't change, but just in case
    // when it changes, we re-register the commands to the updated clientId
    (0, $cozmU.useEffect)(()=>{
        if (!commandManagerRef.current || !rovoBridgeAPI) return;
        commandManagerRef.current.updateClientId(clientId, rovoBridgeAPI);
    }, [
        clientId,
        rovoBridgeAPI
    ]);
    // when commandProps changes, we update the command props
    (0, $cozmU.useEffect)(()=>{
        if (!commandManagerRef.current || !commandProps) return;
        commandManagerRef.current.updateCommandProps(commandProps);
    }, [
        commandProps
    ]);
    // when addCommandHandlers changes, we deregister and register the commands
    (0, $cozmU.useEffect)(()=>{
        if (!commandManagerRef.current) return;
        commandManagerRef.current.updateAddCommandHandlers(addCommandHandlers);
    }, [
        addCommandHandlers
    ]);
    // When enabled, also run this cleanup on bridge client changes so page transitions create
    // a fresh command manager for the next client.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            commandManagerRef.current?.deregisterCommands();
            if ((0, $iDrrr.fg)('aifc_reset_command_manager_on_transition')) commandManagerRef.current = null;
        };
    }, [
        clientId,
        rovoBridgeAPI
    ]);
    $8a735ad9012f833e$var$useRovoBridgeLifecycle({
        contentLocation: contentLocation,
        contentId: contentId,
        editorAPI: editorAPI,
        onStreamStart: onStreamStart,
        onStream: onStream,
        onStreamEnd: onStreamEnd,
        onStreamAbort: onStreamAbort,
        onStreamTimeout: onStreamTimeout,
        onStreamError: onStreamError,
        onStreamRepair: onStreamRepair,
        addCommandHandlers: addCommandHandlers,
        clientId: clientId,
        rovoBridgeAPI: rovoBridgeAPI,
        onBridgeReady: onBridgeReady
    });
};



var $9lHB9 = parcelRequire("9lHB9");





var $8akfd = parcelRequire("8akfd");


var $laFNM = parcelRequire("laFNM");


var $3IBnw = parcelRequire("3IBnw");


var $4IoVL = parcelRequire("4IoVL");


var $6mKj3 = parcelRequire("6mKj3");


var $9wGTI = parcelRequire("9wGTI");


var $5ZqQS = parcelRequire("5ZqQS");


var $8aF6s = parcelRequire("8aF6s");


var $bQm3c = parcelRequire("bQm3c");


var $9cZ1w = parcelRequire("9cZ1w");


var $cJeDc = parcelRequire("cJeDc");


var $jyA9t = parcelRequire("jyA9t");


var $6FNab = parcelRequire("6FNab");


var $4wRTw = parcelRequire("4wRTw");


var $hUsog = parcelRequire("hUsog");


function $908492137eb1f6c4$export$bef1f36f5486a6a3(message, ...args) {
    try {
        if (window.top?.__aifcDebuggerEnabled__) // eslint-disable-next-line no-console
        console.log(`[AIFC]: ${message}`, ...args);
    } catch (e) {
    // Ignore cross origin frame access errors
    }
}


class $e1270e15c69ffc89$export$a7898906d711def9 extends (0, $5896f48a4d11c2fd$export$1673b811578d4e4e) {
    async process(payload) {
        if (payload.isStreamComplete) this.streamedMd = payload.data.content;
        else this.streamedMd += payload.data.content;
        const adfDoc = this.streamingAdfEncoder.encode(this.streamedMd);
        // Temporarily using replaceDocument since the editor streaming plugin does not support streaming MD or multiple ADF docs
        this.props.editorAPI.core.actions.replaceDocument(adfDoc, {
            scrollIntoView: false
        });
    }
    async finishAction() {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle confluence-deep-research-page-create-command');
        const adfDoc = this.streamedMd ? this.streamingAdfEncoder.encode(this.streamedMd) : undefined;
        this.streamedMd = '';
        return adfDoc;
    }
    abort() {
    // No-op
    }
    constructor(props){
        super(props, 'deep-research-create');
        // Streaming Markdown -> ADF encoder for Deep Research content
        this.streamingAdfEncoder = void 0;
        this.streamedMd = '';
        const pluginConfig = {
            linkify: {
                findFilepaths: $4wRTw.findFilepaths,
                isLinkInMatches: $4wRTw.isLinkInMatches
            },
            smartLinks: {
                regexStorage: globalThis.localStorage
            }
        };
        this.streamingAdfEncoder = new (0, $6FNab.ADFEncoder)((schema)=>new (0, $hUsog.AiMateMarkdownTransformer)(schema, pluginConfig, true));
    }
}



var $aAERY = parcelRequire("aAERY");







var $9K5In = parcelRequire("9K5In");

class $a9ad9677fcca25bd$export$8b2d6af8570e89fc extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    async execute(payload) {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle confluence-page-init-command');
        const document = await (0, $9K5In.getDocument)(this.props.editorAPI);
        if (!document) {
            (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('PageInitCommand received but document is not available');
            return;
        }
        const isEmpty = (0, $9K5In.isEmptyDocument)(document);
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)(`Received ConfluencePageInitCommand with isEmpty: ${isEmpty}`, payload?.data);
        if (!isEmpty) return;
        const editorSchema = this.props.editorAPI.core.sharedState.currentState()?.schema;
        if (!editorSchema) {
            (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Editor schema is not available');
            return;
        }
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Streaming initial ADF from ConfluencePageInitCommand', payload?.data.adf);
        this.props.onStreamStart?.({
            streamType: 'init',
            payload: payload
        });
        this.props.onStream?.({
            streamType: 'init',
            payload: payload
        });
        // In case ADF is invalid, we chunk it to retain as much of the ADF as possible
        const streamer = new (0, $aAERY.ADFStreamer)(editorSchema);
        const adfChunks = (0, $9K5In.chunkSubstr)(payload.data.adf, 50);
        for (const chunk of adfChunks){
            (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Processing chunk from ConfluencePageInitCommand', chunk);
            streamer.processChunk(chunk);
        }
        const adfDoc = streamer.getLastDoc();
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Replacing document with ADF from ConfluencePageInitCommand', adfDoc);
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Replace document function - ', this.props.editorAPI.core.actions.replaceDocument);
        this.props.editorAPI.core.actions.replaceDocument(adfDoc, {
            scrollIntoView: false
        });
        // Trigger image re-uploading if handler is available
        if ((0, $9wGTI.fg)('confluence_frontend_aifc_reupload_image')) await this.props.reuploadImages?.();
        else if (adfDoc) await this.props.reuploadImages?.(adfDoc);
        this.props.onStreamEnd?.({
            streamType: 'init',
            payload: payload,
            adfDoc: adfDoc
        });
    }
}




class $dab8e08b53df3f80$export$1591457cbf726478 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    execute() {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle prepare-content-for-finalization-command');
        return new Promise(async (resolve)=>{
            try {
                const document = await this.extraProps.forceDraftSync?.();
                resolve({
                    success: true,
                    content: document
                });
            } catch  {
                resolve({
                    success: false,
                    content: undefined
                });
            }
        });
    }
    constructor(props, extraProps){
        super(props), this.extraProps = extraProps;
    }
}




class $2d58d664ae64ca90$export$60cb93fdd3fa65f9 extends (0, $0b03e6df869fefe4$export$54019a4b43471d88) {
    async execute(_payload) {
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('handle confluence-prompt-submit-on-page-create-command');
    }
}







var $aSsfA = parcelRequire("aSsfA");


var $efvKr = parcelRequire("efvKr");


var $cD1qu = parcelRequire("cD1qu");

function $6110298a09c933b1$export$9f74cfd73dac3627() {
    const pageMode = (0, $aSsfA.useGetPageMode)();
    const [{ isViewMode: isViewMode }] = (0, $efvKr.useLivePageMode)();
    // Handle each page mode explicitly
    if (pageMode === (0, $cD1qu.PageMode).EDIT) return false;
    if (pageMode === (0, $cD1qu.PageMode).LIVE) return isViewMode;
    // PageMode.VIEW or unknown modes default to view mode
    return true;
}









var $ihAew = parcelRequire("ihAew");





var $1kHsc = parcelRequire("1kHsc");








var $irVI7 = parcelRequire("irVI7");

const $3e2bc58650b598e9$var$ANALYTICS_SOURCE = 'aifcBridgeObservability';
const $3e2bc58650b598e9$var$ANALYTICS_ACTION_SUBJECT = 'rovoContentBridge';
const $3e2bc58650b598e9$export$ff09a1ab88732c54 = (event, { experienceTracker: experienceTracker, createAnalyticsEvent: createAnalyticsEvent, submitError: submitError })=>{
    switch(event.signal){
        case 'registration-pending':
            experienceTracker.start({
                name: (0, $irVI7.AIFC_BRIDGE_REGISTRATION_EXPERIENCE),
                id: event.clientId
            });
            break;
        case 'registration-succeeded':
            experienceTracker.succeed({
                name: (0, $irVI7.AIFC_BRIDGE_REGISTRATION_EXPERIENCE)
            });
            break;
        case 'registration-aborted':
            experienceTracker.abort({
                name: (0, $irVI7.AIFC_BRIDGE_REGISTRATION_EXPERIENCE),
                reason: 'Bridge client torn down before registering'
            });
            break;
        case 'registration-gap':
            {
                const error = new Error(`Rovo content bridge client "${event.clientId}" did not register within ${event.waitedMs}ms; streamed messages were left unconsumed`);
                submitError(error);
                experienceTracker.stopOnError({
                    name: (0, $irVI7.AIFC_BRIDGE_REGISTRATION_EXPERIENCE),
                    error: error
                });
                break;
            }
        case 'message-queued':
        case 'message-dropped':
            createAnalyticsEvent({
                type: 'sendOperationalEvent',
                data: {
                    source: $3e2bc58650b598e9$var$ANALYTICS_SOURCE,
                    action: event.signal === 'message-dropped' ? 'messageDropped' : 'backpressure',
                    actionSubject: $3e2bc58650b598e9$var$ANALYTICS_ACTION_SUBJECT,
                    attributes: {
                        clientId: event.clientId,
                        queueDepth: event.queueDepth,
                        reason: event.reason
                    }
                }
            }).fire();
            break;
        default:
            break;
    }
};


const $29862c53c2e42530$export$75b775a8debf0e58 = ()=>{
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const queueRef = (0, $cozmU.useRef)([]);
    const [drainToken, scheduleDrain] = (0, $cozmU.useReducer)((token)=>token + 1, 0);
    const enqueueSignal = (0, $cozmU.useCallback)((event)=>{
        queueRef.current.push(event);
        scheduleDrain();
    }, []);
    (0, $cozmU.useEffect)(()=>{
        const queued = queueRef.current;
        queueRef.current = [];
        for (const event of queued)(0, $3e2bc58650b598e9$export$ff09a1ab88732c54)(event, {
            experienceTracker: experienceTracker,
            createAnalyticsEvent: createAnalyticsEvent,
            submitError: (error)=>(0, $5ZqQS.getMonitoringClient)().submitError(error, {
                    attribution: (0, $3IBnw.Attribution).CONTENT_TYPES
                })
        });
    }, [
        drainToken,
        experienceTracker,
        createAnalyticsEvent
    ]);
    (0, $cozmU.useEffect)(()=>{
        if (!(0, $9wGTI.fg)('confluence_aifc_bridge_observability')) return;
        const consumer = (0, $ihAew.getObservabilityConsumer)();
        consumer.enable(enqueueSignal);
        return ()=>consumer.disable();
    }, [
        enqueueSignal
    ]);
};















var $1xpoY = parcelRequire("1xpoY");

const $bad23b1fb5e9cddc$export$ae18511ba45c9191 = 30000;
const $bad23b1fb5e9cddc$export$525ddea8932d8f78 = 'aifc_content_retention_delay_ms';
const $bad23b1fb5e9cddc$export$964f7af3b367486 = 0.5;
function $bad23b1fb5e9cddc$export$c177e9a1ea3e78da(node) {
    if (!node) return '';
    const adfNode = node;
    if (adfNode.type === 'text') return adfNode.text ?? '';
    const children = adfNode.content ?? [];
    return children.map($bad23b1fb5e9cddc$export$c177e9a1ea3e78da).join(' ');
}
function $bad23b1fb5e9cddc$var$tokenize(text) {
    return text.toLowerCase().match(RegExp("[\\p{L}\\p{N}]+", "gu")) ?? [];
}
function $bad23b1fb5e9cddc$export$e95d47b44388673b(originalText, currentText) {
    const originalTokens = $bad23b1fb5e9cddc$var$tokenize(originalText);
    if (originalTokens.length === 0) // Nothing meaningful streamed in; treat any remaining content as retained.
    return $bad23b1fb5e9cddc$var$tokenize(currentText).length > 0 ? 1 : 0;
    const originalSet = new Set(originalTokens);
    const currentSet = new Set($bad23b1fb5e9cddc$var$tokenize(currentText));
    let retained = 0;
    originalSet.forEach((token)=>{
        if (currentSet.has(token)) retained += 1;
    });
    return retained / originalSet.size;
}





const $165a2fd40a223403$export$389f8b651933d9e5 = ({ editorAPI: editorAPI, contentId: contentId })=>{
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const pendingRef = (0, $cozmU.useRef)(null);
    // Keep the latest contentId/editorAPI reachable from the timer callback
    // without re-creating the tracking callback on every change.
    const contentIdRef = (0, $cozmU.useRef)(contentId);
    contentIdRef.current = contentId;
    const editorAPIRef = (0, $cozmU.useRef)(editorAPI);
    editorAPIRef.current = editorAPI;
    const emitRetentionEvent = (0, $cozmU.useCallback)((attributes)=>{
        sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'smartCreateContent',
            action: 'contentRetentionMeasured',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: 'page',
                contentId: contentIdRef.current,
                ...attributes
            }
        });
    }, [
        sendAnalyticsEvent
    ]);
    const runMeasurement = (0, $cozmU.useCallback)(async ()=>{
        const pending = pendingRef.current;
        if (!pending) return;
        pendingRef.current = null;
        const doc = editorAPIRef.current ? await (0, $9K5In.getDocument)(editorAPIRef.current) : null;
        const emptied = doc ? (0, $9K5In.isEmptyDocument)(doc) : true;
        const currentText = doc ? (0, $bad23b1fb5e9cddc$export$c177e9a1ea3e78da)(doc) : '';
        const retentionRatio = (0, $bad23b1fb5e9cddc$export$e95d47b44388673b)(pending.originalText, currentText);
        const retained = !emptied && retentionRatio >= (0, $bad23b1fb5e9cddc$export$964f7af3b367486);
        emitRetentionEvent({
            singleInstrumentationId: pending.singleInstrumentationId,
            measurementDelayMs: pending.measurementDelayMs,
            streamedContentLength: pending.originalLength,
            finalContentLength: currentText.length,
            retentionRatio: retentionRatio,
            retained: retained,
            emptied: emptied
        });
    }, [
        emitRetentionEvent
    ]);
    const trackContentRetention = (0, $cozmU.useCallback)(async ({ singleInstrumentationId: singleInstrumentationId, adfDoc: adfDoc })=>{
        if (!(0, $9wGTI.fg)('aifc_content_retention_metric') && !(0, $6mKj3.expValEquals)('cwr_blank_object_experiment', 'isEnabled', true)) return;
        const api = editorAPIRef.current;
        if (!api) return;
        const doc = adfDoc ?? await (0, $9K5In.getDocument)(api);
        if (!doc || (0, $9K5In.isEmptyDocument)(doc)) return;
        const originalText = (0, $bad23b1fb5e9cddc$export$c177e9a1ea3e78da)(doc);
        // Tunable post-stream window; defaults to RETENTION_MEASUREMENT_DELAY_MS.
        const measurementDelayMs = (0, $1xpoY.default).getNumber((0, $bad23b1fb5e9cddc$export$525ddea8932d8f78), (0, $bad23b1fb5e9cddc$export$ae18511ba45c9191));
        // Replace any in-flight measurement (e.g. a re-stream into the same page).
        if (pendingRef.current) clearTimeout(pendingRef.current.timerId);
        const timerId = setTimeout(()=>{
            runMeasurement();
        }, measurementDelayMs);
        pendingRef.current = {
            timerId: timerId,
            originalText: originalText,
            originalLength: originalText.length,
            measurementDelayMs: measurementDelayMs,
            singleInstrumentationId: singleInstrumentationId
        };
    }, [
        runMeasurement
    ]);
    // On unmount (e.g. SPA navigation away before the window elapses) cancel any
    // pending measurement so the timer can't fire after the editor is gone.
    (0, $cozmU.useEffect)(()=>{
        return ()=>{
            if (pendingRef.current) {
                clearTimeout(pendingRef.current.timerId);
                pendingRef.current = null;
            }
        };
    }, []);
    return {
        trackContentRetention: trackContentRetention
    };
};


const $2d5e3600e3d9fa76$var$i18nMessages = (0, $kSwu1.defineMessages)({
    uploadErrorTitle: {
        id: "rovo-editor-bridge-listener.image-upload-error.title",
        defaultMessage: "An error occurred"
    },
    uploadErrorDescription: {
        id: "rovo-editor-bridge-listener.image-upload-error.description",
        defaultMessage: "We weren't able to add your infographic."
    },
    uploadErrorTryAgain: {
        id: "rovo-editor-bridge-listener.image-upload-error.try-again",
        defaultMessage: "Try again"
    },
    previewModeBlockedTitle: {
        id: "rovo-editor-bridge-listener.preview-mode-blocked.title",
        defaultMessage: "This content has been updated"
    },
    previewModeBlockedDescription: {
        id: "rovo-editor-bridge-listener.preview-mode-blocked.description",
        defaultMessage: "To view recent changes made via Rovo, select <b>Back</b> or type <code>E</code> to exit preview mode."
    }
});
const $2d5e3600e3d9fa76$var$getAIFCHeaderImageGenerationProps = (title)=>{
    if ((0, $9wGTI.fg)('header_images_migrate_image_gen_to_remix')) return {
        adfContent: `Create a visually engaging wide header image depicting the core subject, setting, or concept described by this page title. Treat the title as context rather than something to illustrate literally. Ignore content-type framing such as "poem about", "article about", "guide to", or "notes on", and depict the underlying subject itself. Page title: "${title}"`,
        aspectRatio: '21:9'
    };
    return {
        adfContent: title
    };
};
const $2d5e3600e3d9fa76$export$123c48b30e85000 = ({ contentId: contentId, contentLocation: contentLocation, editorAPI: editorAPI, setEditorDisabled: setEditorDisabled, setTitlePlaceholderState: setTitlePlaceholderState, onTitleChange: onTitleChange, mediaProvider: mediaProvider, fakeGenerateAIHeaderImage: fakeGenerateAIHeaderImage, generateAIHeaderImage: generateAIHeaderImage, suggestPageEmoji: suggestPageEmoji, forceDraftSync: forceDraftSync, flags: flags, useGenericEditorSkill: useGenericEditorSkill, onStreamEnd: onStreamEndCallback, onSendContextReady: onSendContextReady, additionalContext: additionalContextFromProps, onBridgeReady: onBridgeReady, isPreviewMode: isPreviewMode, skipAiExperienceRequirement: skipAiExperienceRequirement })=>{
    const contentType = 'page';
    const { sendAnalyticsEvent: sendAnalyticsEvent } = (0, $Ou0Zz.useAnalytics)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const isViewMode = (0, $6110298a09c933b1$export$9f74cfd73dac3627)();
    const { isDraftLockedForEditing: isDraftLockedForEditing } = (0, $laFNM.useApprovals)();
    const isViewModeForRovo = isViewMode || isDraftLockedForEditing;
    const intl = (0, $kSwu1.useIntl)();
    const { showModal: showModal } = (0, $8aF6s.useDialogs)();
    const { cloudId: cloudId, userId: userId } = (0, $bQm3c.useSessionData)();
    const { showSmartCreationModal: showSmartCreationModal } = (0, $jyA9t.useSmartCreationModalState)();
    const { stagingAreaMode: stagingAreaMode } = (0, $8akfd.useStagingAreaState)();
    const { trackContentRetention: trackContentRetention } = (0, $165a2fd40a223403$export$389f8b651933d9e5)({
        editorAPI: editorAPI,
        contentId: contentId
    });
    (0, $29862c53c2e42530$export$75b775a8debf0e58)();
    const getCreatedContentFeatureAttributes = (0, $cozmU.useCallback)((features)=>{
        return features ? {
            createdContentAdfLength: features.adfLength,
            createdContentTextLength: features.textLength,
            createdContentWordCount: features.wordCount,
            createdContentIsEmpty: features.textLength === 0 && features.wordCount === 0
        } : {};
    }, []);
    const createMediaProvider = (0, $cozmU.useCallback)(async ({ contentId: contentId })=>{
        return (0, $4IoVL.createRendererMediaProvider)({
            contentId: contentId,
            isExternalShare: false
        });
    }, []);
    const onUploadImageError = (0, $cozmU.useCallback)(({ error: error })=>{
        (0, $5ZqQS.getMonitoringClient)().submitError(error, {
            attribution: (0, $3IBnw.Attribution).PAGE_MODES
        });
    }, []);
    const onUploadAndInsertMediaError = (0, $cozmU.useCallback)(({ retry: retry })=>{
        const flagId = 'rovo-bridge-upload-error';
        flags?.showErrorFlag({
            id: flagId,
            title: intl.formatMessage($2d5e3600e3d9fa76$var$i18nMessages.uploadErrorTitle),
            description: intl.formatMessage($2d5e3600e3d9fa76$var$i18nMessages.uploadErrorDescription),
            actions: [
                {
                    content: intl.formatMessage($2d5e3600e3d9fa76$var$i18nMessages.uploadErrorTryAgain),
                    onClick: ()=>{
                        retry().then(()=>{
                            flags?.hideFlag(flagId);
                        }).catch(()=>{
                        // retry failed — keep the flag visible so the user can try again
                        });
                    }
                }
            ]
        });
    }, [
        flags,
        intl
    ]);
    const sendInitialCreationAnalytics = (0, $cozmU.useCallback)(async ()=>{
        try {
            let features;
            if (editorAPI) {
                const doc = await (0, $9K5In.getDocument)(editorAPI);
                if (doc) features = (0, $l2exp.extractContentFeatures)(doc);
            }
            sendAnalyticsEvent({
                eventType: 'track',
                actionSubject: 'smartCreateContent',
                action: 'initialContentCreated',
                attributes: {
                    createdContentProduct: 'confluence',
                    createdContentType: contentType,
                    createdContentFeatures: features,
                    ...getCreatedContentFeatureAttributes(features),
                    createdContentMetadata: {
                        contentId: contentId
                    }
                }
            });
        } catch (error) {
            (0, $5ZqQS.getMonitoringClient)().submitError(error, {
                attribution: (0, $3IBnw.Attribution).PAGE_MODES
            });
        }
    }, [
        editorAPI,
        contentId,
        contentType,
        sendAnalyticsEvent,
        getCreatedContentFeatureAttributes
    ]);
    const sendIframeInitialContentAppliedAnalytics = (0, $cozmU.useCallback)(({ streamType: streamType, payload: payload, adfDoc: adfDoc, contentApplicationSource: contentApplicationSource })=>{
        const features = adfDoc ? (0, $l2exp.extractContentFeatures)(adfDoc) : undefined;
        const initialAdfPayload = 'adf' in payload.data ? payload.data.adf : undefined;
        sendAnalyticsEvent({
            eventType: 'track',
            actionSubject: 'smartCreateContent',
            action: 'iframeInitialContentApplied',
            attributes: {
                createdContentProduct: 'confluence',
                createdContentType: contentType,
                createdContentFeatures: features,
                ...getCreatedContentFeatureAttributes(features),
                contentId: contentId,
                streamType: streamType,
                contentApplicationSource: contentApplicationSource,
                singleInstrumentationId: payload.singleInstrumentationId,
                initialAdfPayloadPresent: !!initialAdfPayload,
                initialAdfPayloadLength: initialAdfPayload?.length,
                adfDocIsEmpty: adfDoc ? (0, $9K5In.isEmptyDocument)(adfDoc) : undefined,
                appliedAdfLength: features?.adfLength
            }
        });
    }, [
        contentId,
        contentType,
        sendAnalyticsEvent,
        getCreatedContentFeatureAttributes
    ]);
    // Use a ref so that the latest preview mode state is accessible inside callbacks
    const isPreviewModeRef = (0, $cozmU.useRef)(isPreviewMode);
    isPreviewModeRef.current = isPreviewMode;
    // Tracks whether quick image generation was already triggered during onStream,
    // preventing duplicate calls if onStream fires multiple times with the title.
    const quickImageGenerationTriggeredRef = (0, $cozmU.useRef)(false);
    // Once-per-stream guard for AIFC emoji suggestion (mirrors the header-image ref above).
    const quickEmojiSuggestionTriggeredRef = (0, $cozmU.useRef)(false);
    // Called once when streaming starts
    const onStreamStart = (0, $cozmU.useCallback)(({ streamType: streamType, payload: payload })=>{
        if (isPreviewModeRef.current) {
            flags?.showWarningFlag({
                title: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), $2d5e3600e3d9fa76$var$i18nMessages.previewModeBlockedTitle),
                description: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
                    ...$2d5e3600e3d9fa76$var$i18nMessages.previewModeBlockedDescription,
                    values: {
                        b: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks),
                        code: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("b", null, chunks)
                    }
                })
            });
            return;
        }
        if (payload?.data?.isRemixGenerated) editorAPI?.aiExperience?.actions.toggleAiEntryPoints?.(true);
        else setEditorDisabled?.(true);
        if (streamType === 'create' || streamType === 'deep-research-create') {
            setTitlePlaceholderState?.(true);
            // Only show skeleton if real image generation hasn't already been triggered
            if ((0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img') && !quickImageGenerationTriggeredRef.current) fakeGenerateAIHeaderImage?.();
        }
        // Succeed the AIFC_INITIAL_DATA_RECEIVED experience since content has started streaming.
        // This ensures this experience won't timeout and then fail the AIFC_GENERATE_CONTENT or AIFC_UPDATE_CONTENT experience.
        // NOTE: This experience isn't started for all flows, it'll be a no-op if it's not started.
        (0, $gQrdE.sendAIFCExperienceTrackingToParent)({
            status: 'success',
            actionType: contentType,
            actionId: contentId,
            contentContext: contentLocation,
            experienceName: (0, $irnO2.ExperienceName).AIFC_INITIAL_DATA_RECEIVED
        });
    }, [
        editorAPI,
        setEditorDisabled,
        fakeGenerateAIHeaderImage,
        setTitlePlaceholderState,
        contentId,
        contentType,
        contentLocation,
        flags
    ]);
    // Called on every stream chunk
    const onStream = (0, $cozmU.useCallback)(({ payload: payload, streamType: streamType })=>{
        if ('title' in payload.data) {
            const title = payload?.data?.title;
            onTitleChange?.(title);
            if (title) {
                setTitlePlaceholderState?.(false);
                // Trigger header image generation as soon as the title arrives in the
                // stream rather than waiting for the stream to fully complete. The title
                // arrives as a complete string early in the stream, allowing us to start
                // image generation in parallel with body content streaming.
                if ((streamType === 'create' || streamType === 'deep-research-create') && (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img') && !quickImageGenerationTriggeredRef.current) {
                    generateAIHeaderImage?.($2d5e3600e3d9fa76$var$getAIFCHeaderImageGenerationProps(title));
                    quickImageGenerationTriggeredRef.current = true;
                }
                // AIFC emoji suggestion, fired in parallel with the header image as soon as a
                // title chunk arrives. Title-only input; BE takes a plain string (not ADF).
                if ((streamType === 'create' || streamType === 'deep-research-create') && (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_page_emoji') && !quickEmojiSuggestionTriggeredRef.current) {
                    suggestPageEmoji?.({
                        title: title
                    });
                    quickEmojiSuggestionTriggeredRef.current = true;
                }
            }
        }
    }, [
        onTitleChange,
        setTitlePlaceholderState,
        generateAIHeaderImage,
        suggestPageEmoji
    ]);
    const showCreateWithRovoModalCloseFeedbackFlag = (0, $9cZ1w.useLazyShowFeedbackFlag)(flags, intl, showModal, createAnalyticsEvent);
    // Called when streaming ends
    const onStreamEnd = (0, $cozmU.useCallback)(async ({ streamType: streamType, payload: payload, adfDoc: adfDoc })=>{
        try {
            // reuploadImages is handled in platform
            if (streamType === 'create') {
                const title = 'title' in payload?.data ? payload.data.title : undefined;
                // Fallback: if image generation wasn't already kicked off during onStream
                // (e.g. the title only became available at stream end), trigger it now so
                // the header image is still generated.
                if (title && (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_header_img') && !quickImageGenerationTriggeredRef.current) {
                    generateAIHeaderImage?.($2d5e3600e3d9fa76$var$getAIFCHeaderImageGenerationProps(title));
                    quickImageGenerationTriggeredRef.current = true;
                }
                // Stream-end fallback: title only materialised here.
                if (title && (0, $6mKj3.isExperimentEnabled)('cc_page_experiences_aifc_auto_generated_page_emoji') && !quickEmojiSuggestionTriggeredRef.current) {
                    suggestPageEmoji?.({
                        title: title
                    });
                    quickEmojiSuggestionTriggeredRef.current = true;
                }
            }
            // This experience success is a no-op if AIFC_ALL_DATA_HANDLED is not started. It may not be started for all flows.
            (0, $gQrdE.sendAIFCExperienceTrackingToParent)({
                status: 'success',
                actionType: contentType,
                actionId: contentId,
                contentContext: contentLocation,
                experienceName: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED
            });
            if (streamType === 'create' || streamType === 'deep-research-create') {
                sendIframeInitialContentAppliedAnalytics({
                    streamType: streamType,
                    payload: payload,
                    adfDoc: adfDoc,
                    contentApplicationSource: 'stream'
                });
                sendInitialCreationAnalytics();
                if (streamType === 'create') {
                    const singleInstrumentationId = typeof payload?.singleInstrumentationId === 'string' ? payload.singleInstrumentationId : undefined;
                    trackContentRetention({
                        singleInstrumentationId: singleInstrumentationId,
                        adfDoc: adfDoc
                    });
                }
            } else if (streamType === 'init') sendIframeInitialContentAppliedAnalytics({
                streamType: streamType,
                payload: payload,
                adfDoc: adfDoc,
                contentApplicationSource: 'initFallback'
            });
            else if (streamType === 'update') {
                if (!showSmartCreationModal && stagingAreaMode !== 'modal') {
                    const traceId = typeof payload?.traceId === 'string' ? payload.traceId : undefined;
                    const requestId = typeof payload?.requestId === 'string' ? payload.requestId : undefined;
                    showCreateWithRovoModalCloseFeedbackFlag({
                        feedbackVariant: (0, $cJeDc.FeedbackVariant).AFTER_UPDATE_STREAM_COMPLETE,
                        contentType: contentType,
                        cloudId: cloudId,
                        traceId: traceId,
                        requestId: requestId
                    });
                }
            }
        } finally{
            setEditorDisabled?.(false);
            editorAPI?.aiExperience?.actions.toggleAiEntryPoints?.(false);
        }
        onStreamEndCallback?.();
    }, [
        editorAPI,
        contentId,
        contentType,
        contentLocation,
        setEditorDisabled,
        generateAIHeaderImage,
        suggestPageEmoji,
        sendInitialCreationAnalytics,
        sendIframeInitialContentAppliedAnalytics,
        showCreateWithRovoModalCloseFeedbackFlag,
        showSmartCreationModal,
        stagingAreaMode,
        cloudId,
        onStreamEndCallback,
        trackContentRetention
    ]);
    const onStreamAbort = (0, $cozmU.useCallback)(()=>{
        setEditorDisabled?.(false);
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'aborted',
            actionSubject: 'smartCreateContent',
            attributes: {
                contentType: contentType,
                contentId: contentId
            }
        });
    }, [
        setEditorDisabled,
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    const onStreamTimeout = (0, $cozmU.useCallback)(({ streamType: streamType, traceId: traceId })=>{
        setEditorDisabled?.(false);
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'timeout',
            actionSubject: 'smartCreateContent',
            attributes: {
                contentType: contentType,
                contentId: contentId,
                streamType: streamType,
                traceId: traceId
            }
        });
    }, [
        setEditorDisabled,
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    const onStreamError = (0, $cozmU.useCallback)(({ error: error, streamType: streamType, traceId: traceId, streamDebug: streamDebug })=>{
        (0, $908492137eb1f6c4$export$bef1f36f5486a6a3)('Error in command handler:', error);
        sendAnalyticsEvent({
            eventType: 'operational',
            action: 'error',
            actionSubject: 'smartCreateContent',
            attributes: {
                contentType: contentType,
                error: error instanceof Error ? error.message : String(error),
                stack: error instanceof Error && error.stack ? error.stack : undefined,
                streamType: streamType,
                traceId: traceId,
                contentId: contentId,
                // Shape-only debug metadata for blank-page create investigations.
                // Only populated when the bridge feature gate is enabled; the
                // object never contains UGC/raw content (see CreateStreamDebug).
                ...streamDebug ? {
                    streamDebug: streamDebug
                } : {}
            }
        });
        (0, $gQrdE.sendAIFCExperienceTrackingToParent)({
            status: 'fail',
            actionType: contentType,
            actionId: contentId,
            contentContext: contentLocation,
            experienceName: (0, $irnO2.ExperienceName).AIFC_ALL_DATA_HANDLED,
            error: error instanceof Error ? error.message : String(error)
        });
        setEditorDisabled?.(false);
    }, [
        contentId,
        contentType,
        contentLocation,
        sendAnalyticsEvent,
        setEditorDisabled
    ]);
    const onStreamRepair = (0, $cozmU.useCallback)(({ streamType: streamType, repairs: repairs })=>{
        sendAnalyticsEvent({
            eventType: 'operational',
            actionSubject: 'smartCreateContent',
            action: 'adfRepaired',
            attributes: {
                contentType: contentType,
                contentId: contentId,
                streamType: streamType,
                repairCount: repairs.length,
                // Manually selecting properties to avoid sending UGC
                // in case more properties are added in the future.
                repairs: repairs.map((repair)=>({
                        type: repair.type,
                        from: repair.from,
                        to: repair.to,
                        context: repair.context,
                        expansion: repair.expansion
                    }))
            }
        });
    }, [
        contentId,
        contentType,
        sendAnalyticsEvent
    ]);
    const additionalContext = (0, $cozmU.useMemo)(()=>{
        return async ()=>{
            const more = typeof additionalContextFromProps === 'function' ? await additionalContextFromProps() : additionalContextFromProps;
            return {
                ...more,
                isViewMode: isViewModeForRovo,
                isDraftLockedForEditing: isDraftLockedForEditing
            };
        };
    }, [
        isViewModeForRovo,
        isDraftLockedForEditing,
        additionalContextFromProps
    ]);
    const addCommandHandlers = (0, $cozmU.useCallback)(({ commandManager: commandManager })=>{
        commandManager.addDefaultCommandHandlers().addCommandHandler((0, $9lHB9.ConfluenceDeepResearchPageCreateCommand), new (0, $e1270e15c69ffc89$export$a7898906d711def9)(commandManager.commandProps)).addCommandHandler((0, $9lHB9.ConfluencePageInitCommand), new (0, $a9ad9677fcca25bd$export$8b2d6af8570e89fc)(commandManager.commandProps)).addCommandHandler((0, $9lHB9.PrepareContentForFinalizationCommand), new (0, $dab8e08b53df3f80$export$1591457cbf726478)(commandManager.commandProps, {
            forceDraftSync: forceDraftSync
        })).addCommandHandler((0, $9lHB9.ConfluenceSubmitPromptOnPageCreateCommand), new (0, $2d58d664ae64ca90$export$60cb93fdd3fa65f9)(commandManager.commandProps));
    }, [
        forceDraftSync
    ]);
    (0, $8a735ad9012f833e$export$5203c6a0fdaaa3b)({
        userId: userId ?? undefined,
        contentLocation: contentLocation,
        contentId: contentId,
        editorAPI: editorAPI,
        addCommandHandlers: addCommandHandlers,
        additionalContext: additionalContext,
        mediaProvider: mediaProvider,
        createMediaProvider: createMediaProvider,
        onUploadImageError: onUploadImageError,
        onUploadAndInsertMediaError: onUploadAndInsertMediaError,
        onStreamStart: onStreamStart,
        onStream: onStream,
        onStreamEnd: onStreamEnd,
        onStreamAbort: onStreamAbort,
        onStreamTimeout: onStreamTimeout,
        onStreamError: onStreamError,
        onStreamRepair: onStreamRepair,
        onSendContextReady: onSendContextReady,
        useGenericEditorSkill: useGenericEditorSkill,
        onBridgeReady: onBridgeReady,
        skipAiExperienceRequirement: skipAiExperienceRequirement
    });
};


const $93a541b5565bf74f$var$EditorRovoBridgeCommandListenerImpl = (props)=>{
    (0, $2d5e3600e3d9fa76$export$123c48b30e85000)(props);
    return null;
};
const $93a541b5565bf74f$var$RovoBridgeCommandListenerInternal = (props)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($93a541b5565bf74f$var$EditorRovoBridgeCommandListenerImpl, props);
};
const $93a541b5565bf74f$export$f25e76eabfc04dee = (0, $7aRa9.withFlags)($93a541b5565bf74f$var$RovoBridgeCommandListenerInternal);
module.exports["RovoBridgeCommandListener"] = $93a541b5565bf74f$export$f25e76eabfc04dee;

});

parcelRegister("9K5In", function(module, exports) {
const $f5dd267bff559452$export$f65ca476c09acec0 = async (editorApi)=>{
    return new Promise((resolve)=>{
        try {
            editorApi.core.actions.requestDocument((doc)=>{
                resolve(doc);
            }, {
                alwaysFire: true
            });
        } catch  {
            resolve(null);
        }
    });
};
function $f5dd267bff559452$export$2da47a16c0b6bcb(doc) {
    if (!doc.content || doc.content.length === 0) return true;
    if (doc.content.length === 1) {
        const node = doc.content[0];
        if (node.type === 'paragraph') {
            if (!node.content || node.content.length === 0) return true;
            return $f5dd267bff559452$var$isOnlyWhitespaceContent(node.content);
        }
        if (node.type === 'heading') {
            if (!node.content || node.content.length === 0) return true;
            return $f5dd267bff559452$var$isOnlyWhitespaceContent(node.content);
        }
    }
    return false;
}
function $f5dd267bff559452$var$isOnlyWhitespaceContent(content) {
    for (const node of content){
        if (node.type === 'text') {
            if (node.text && node.text.trim().length > 0) return false;
        } else return false;
    }
    return true;
}
function $f5dd267bff559452$export$276c2a3f5f3dea14(str, size) {
    const numChunks = Math.ceil(str.length / size);
    const chunks = new Array(numChunks);
    for(let i = 0, o = 0; i < numChunks; ++i, o += size)chunks[i] = str.substring(o, o + size);
    return chunks;
}
module.exports["getDocument"] = $f5dd267bff559452$export$f65ca476c09acec0;
module.exports["isEmptyDocument"] = $f5dd267bff559452$export$2da47a16c0b6bcb;
module.exports["chunkSubstr"] = $f5dd267bff559452$export$276c2a3f5f3dea14;

});

parcelRegister("aQ6Yc", function(module, exports) {
"use strict";
/**
 * Confluence HTML Format — bidirectional ADF ↔ HTML converter.
 *
 * @example
 * ```typescript
 * import { adfToHtml, htmlToAdf } from '@atlassian/atlassian-html-format';
 *
 * const html = adfToHtml(adfJson);
 * const adf = htmlToAdf(htmlString);
 * ```
 *
 * @module @atlassian/atlassian-html-format
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateHtml = module.exports.preserveTextLikeAngleTokens = module.exports.htmlToAdfFromDom = module.exports.htmlToAdf = module.exports.adfToHtml = void 0;

var $bZf8E = parcelRequire("bZf8E");

Object.defineProperty(module.exports, "adfToHtml", {
    enumerable: true,
    get: function() {
        return $bZf8E.adfToHtml;
    }
});

var $9T4kN = parcelRequire("9T4kN");

Object.defineProperty(module.exports, "htmlToAdf", {
    enumerable: true,
    get: function() {
        return $9T4kN.htmlToAdf;
    }
});
Object.defineProperty(module.exports, "htmlToAdfFromDom", {
    enumerable: true,
    get: function() {
        return $9T4kN.htmlToAdfFromDom;
    }
});
Object.defineProperty(module.exports, "preserveTextLikeAngleTokens", {
    enumerable: true,
    get: function() {
        return $9T4kN.preserveTextLikeAngleTokens;
    }
});

var $3Anyi = parcelRequire("3Anyi");

Object.defineProperty(module.exports, "validateHtml", {
    enumerable: true,
    get: function() {
        return $3Anyi.validateHtml;
    }
});

});

parcelRegister("bZf8E", function(module, exports) {
"use strict";
/**
 * ADF → HTML converter.
 *
 * Converts Atlassian Document Format (ADF) JSON to an AI-agent-friendly HTML subset.
 *
 * @module @atlassian/atlassian-html-format
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.adfToHtml = $8ba1226f705511e9$var$adfToHtml;

var $2lsBU = parcelRequire("2lsBU");

// HTML escaping utility
function $8ba1226f705511e9$var$escapeHtml(text) {
    return String(text).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#039;");
}
// Deep clone utility
function $8ba1226f705511e9$var$deepClone(obj) {
    if (obj === null || typeof obj !== "object") return obj;
    if (Array.isArray(obj)) return obj.map($8ba1226f705511e9$var$deepClone);
    const cloned = {};
    for(const key in obj)if (Object.prototype.hasOwnProperty.call(obj, key)) cloned[key] = $8ba1226f705511e9$var$deepClone(obj[key]);
    return cloned;
}
// Collapse Mermaid extension + expand pairs into a single codeBlock
function $8ba1226f705511e9$var$collapseMermaidPairs(node) {
    const content = node.content;
    if (!Array.isArray(content)) return;
    let i = 0;
    while(i < content.length - 1){
        const current = content[i];
        const next = content[i + 1];
        if (current.type === "extension" && current.attrs?.extensionType === $2lsBU.ECOSYSTEM_EXTENSION_TYPE && current.attrs?.extensionKey?.includes("mermaid-diagram") && next.type === "expand") {
            // Found mermaid extension + expand pair
            const expandContent = next.content || [];
            const codeBlockNode = expandContent.find((n)=>n.type === "codeBlock");
            if (codeBlockNode) {
                // Extract mermaid code from codeBlock
                const codeBlockContent = codeBlockNode.content || [];
                const textNode = codeBlockContent.find((n)=>n.type === "text");
                const mermaidCode = textNode?.text;
                if (mermaidCode) {
                    // Replace pair with single codeBlock
                    const newCodeBlock = {
                        type: "codeBlock",
                        attrs: {
                            language: "mermaid"
                        },
                        content: [
                            {
                                type: "text",
                                text: mermaidCode
                            }
                        ]
                    };
                    content.splice(i, 2, newCodeBlock);
                }
            }
        }
        i++;
    }
    // Recursively process nested content
    for (const item of content)if (item.content) $8ba1226f705511e9$var$collapseMermaidPairs(item);
}
// Collapse Chart extension + expand pairs into synthetic __chart_with_data nodes
function $8ba1226f705511e9$var$collapseChartPairs(node) {
    const content = node.content;
    if (!Array.isArray(content)) return;
    let i = 0;
    while(i < content.length - 1){
        const current = content[i];
        const next = content[i + 1];
        if (current.type === "extension" && String(current.attrs?.extensionKey || "").startsWith($2lsBU.CHART_EXTENSION_KEY_PREFIX) && String(current.attrs?.extensionType || "") === $2lsBU.ECOSYSTEM_EXTENSION_TYPE && next.type === "expand") {
            // Found chart extension + expand pair
            const expandContent = next.content || [];
            const tableNode = expandContent.find((n)=>n.type === "table");
            if (tableNode) {
                // Create synthetic __chart_with_data node
                const chartNode = {
                    type: "__chart_with_data",
                    attrs: current.attrs,
                    content: [
                        tableNode
                    ]
                };
                content.splice(i, 2, chartNode);
            }
        }
        i++;
    }
    // Recursively process nested content
    for (const item of content)if (item.content) $8ba1226f705511e9$var$collapseChartPairs(item);
}
// Convert content array to HTML
function $8ba1226f705511e9$var$convertContent(node) {
    const content = node.content;
    if (!Array.isArray(content)) return "";
    return content.map((child)=>$8ba1226f705511e9$var$adfNodeToHtml(child)).join("");
}
// Extract style attributes from marks
function $8ba1226f705511e9$var$marksToStyle(node) {
    const attrs = node.attrs;
    const styles = [];
    const classes = [];
    // Block marks: alignment, indentation, fontSize — all from node.marks per ADF schema
    const marks = node.marks;
    if (Array.isArray(marks)) for (const mark of marks){
        const markAttrs = mark.attrs;
        switch(mark.type){
            case "alignment":
                {
                    const align = markAttrs?.align;
                    if (align && $2lsBU.ALIGNMENT_VALUES.has(align)) styles.push(`text-align: ${align}`);
                    break;
                }
            case "indentation":
                {
                    const level = markAttrs?.level;
                    if (level) styles.push(`margin-left: ${level * 30}px`);
                    break;
                }
            case "fontSize":
                {
                    const fsValue = markAttrs?.fontSize;
                    if (fsValue === "small") styles.push(`font-size: 12px`);
                    else if (typeof fsValue === "number") styles.push(`font-size: ${fsValue}px`);
                    break;
                }
        }
    }
    const breakout = attrs?.breakout;
    if (breakout && $2lsBU.BREAKOUT_MODES.has(breakout)) classes.push(`breakout-${breakout}`);
    let result = "";
    if (styles.length > 0) result += ` style="${styles.join("; ")}"`;
    if (classes.length > 0) result += ` class="${classes.join(" ")}"`;
    return result;
}
// Apply a single mark to text
function $8ba1226f705511e9$var$applyMark(text, mark) {
    const type = mark.type;
    const attrs = mark.attrs;
    switch(type){
        case "strong":
            return `<strong>${text}</strong>`;
        case "em":
            return `<em>${text}</em>`;
        case "underline":
            return `<u>${text}</u>`;
        case "strike":
            return `<s>${text}</s>`;
        case "code":
            return `<code>${text}</code>`;
        case "subsup":
            {
                const subtype = attrs?.type;
                return subtype === "sup" ? `<sup>${text}</sup>` : `<sub>${text}</sub>`;
            }
        case "link":
            {
                const href = attrs?.href;
                const title = attrs?.title;
                const linkAttrs = [
                    `href="${$8ba1226f705511e9$var$escapeHtml(href || "")}"`
                ];
                if (title) linkAttrs.push(`title="${$8ba1226f705511e9$var$escapeHtml(title)}"`);
                return `<a ${linkAttrs.join(" ")}>${text}</a>`;
            }
        case "textColor":
            {
                const color = attrs?.color;
                return color ? `<span style="color: ${$8ba1226f705511e9$var$escapeHtml(color)}">${text}</span>` : text;
            }
        case "backgroundColor":
            {
                const bgColor = attrs?.color;
                return bgColor ? `<span style="background-color: ${$8ba1226f705511e9$var$escapeHtml(bgColor)}">${text}</span>` : text;
            }
        case "annotation":
            {
                const annotationId = attrs?.id;
                const annotationType = attrs?.annotationType;
                const annotationAttrs = [
                    'class="annotation"'
                ];
                if (annotationId) annotationAttrs.push(`data-annotation-id="${$8ba1226f705511e9$var$escapeHtml(annotationId)}"`);
                if (annotationType) annotationAttrs.push(`data-annotation-type="${$8ba1226f705511e9$var$escapeHtml(annotationType)}"`);
                return `<span ${annotationAttrs.join(" ")}>${text}</span>`;
            }
        case "border":
            {
                const borderStyle = attrs?.style;
                const borderColor = attrs?.color;
                const borderSize = attrs?.size;
                const borderStyles = [];
                if (borderStyle) borderStyles.push(borderStyle);
                if (borderColor) borderStyles.push($8ba1226f705511e9$var$escapeHtml(borderColor));
                if (borderSize) borderStyles.push(`${borderSize}px solid`);
                return borderStyles.length > 0 ? `<span style="border: ${borderStyles.join(" ")}">${text}</span>` : text;
            }
        case "fontSize":
            {
                const size = attrs?.size;
                return size ? `<span style="font-size: ${$8ba1226f705511e9$var$escapeHtml(size)}">${text}</span>` : text;
            }
        case "dataConsumer":
            {
                const sources = attrs?.sources;
                const consumerAttrs = [
                    'data-mark="dataConsumer"'
                ];
                if (sources) consumerAttrs.push(`data-sources="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(sources))}"`);
                return `<span ${consumerAttrs.join(" ")}>${text}</span>`;
            }
        case "fragment":
            {
                const localId = attrs?.localId;
                const name = attrs?.name;
                const fragmentAttrs = [
                    'data-mark="fragment"'
                ];
                if (localId) fragmentAttrs.push(`data-local-id="${$8ba1226f705511e9$var$escapeHtml(localId)}"`);
                if (name) fragmentAttrs.push(`data-name="${$8ba1226f705511e9$var$escapeHtml(name)}"`);
                return `<span ${fragmentAttrs.join(" ")}>${text}</span>`;
            }
        default:
            return text;
    }
}
// Build cell HTML attributes
function $8ba1226f705511e9$var$breakoutAttrs(node) {
    const marks = node.marks;
    if (!Array.isArray(marks)) return "";
    for (const mark of marks)if (mark.type === "breakout") {
        const attrs = mark.attrs;
        const mode = attrs?.mode;
        if (mode && $2lsBU.BREAKOUT_MODES.has(mode)) {
            let result = ` data-breakout="${$8ba1226f705511e9$var$escapeHtml(mode)}"`;
            const width = attrs?.width;
            if (width && Number.isInteger(width) && width > 0) result += ` data-breakout-width="${width}"`;
            return result;
        }
    }
    return "";
}
function $8ba1226f705511e9$var$cellAttrs(node) {
    const attrs = node.attrs;
    if (!attrs) return "";
    const cellAttrs = [];
    const colspan = attrs.colspan;
    if (colspan && colspan > 1) cellAttrs.push(`colspan="${colspan}"`);
    const rowspan = attrs.rowspan;
    if (rowspan && rowspan > 1) cellAttrs.push(`rowspan="${rowspan}"`);
    const background = attrs.background;
    if (background) {
        cellAttrs.push(`data-background="${$8ba1226f705511e9$var$escapeHtml(background)}"`);
        cellAttrs.push(`style="background-color: ${$8ba1226f705511e9$var$escapeHtml(background)}"`);
    }
    const colwidth = attrs.colwidth;
    if (colwidth && colwidth.length > 0) cellAttrs.push(`data-colwidth="${colwidth.join(",")}"`);
    return cellAttrs.length > 0 ? " " + cellAttrs.join(" ") : "";
}
// Node handlers
function $8ba1226f705511e9$var$adfDoc(node) {
    return $8ba1226f705511e9$var$convertContent(node);
}
function $8ba1226f705511e9$var$adfHeading(node) {
    const attrs = node.attrs;
    const level = attrs?.level;
    const headingLevel = level ?? 1;
    const styleAttr = $8ba1226f705511e9$var$marksToStyle(node);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<h${headingLevel}${styleAttr}>${content}</h${headingLevel}>`;
}
function $8ba1226f705511e9$var$adfParagraph(node) {
    const styleAttr = $8ba1226f705511e9$var$marksToStyle(node);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<p${styleAttr}>${content}</p>`;
}
function $8ba1226f705511e9$var$adfBulletList(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<ul>${content}</ul>`;
}
function $8ba1226f705511e9$var$adfOrderedList(node) {
    const attrs = node.attrs;
    const order = attrs?.order;
    const startAttr = order && order !== 1 ? ` start="${order}"` : "";
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<ol${startAttr}>${content}</ol>`;
}
function $8ba1226f705511e9$var$adfListItem(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<li>${content}</li>`;
}
function $8ba1226f705511e9$var$adfTaskList(node) {
    const attrs = node.attrs;
    const localId = attrs?.localId;
    const localIdAttr = localId ? ` data-local-id="${$8ba1226f705511e9$var$escapeHtml(localId)}"` : "";
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<ul data-type="task-list"${localIdAttr}>${content}</ul>`;
}
function $8ba1226f705511e9$var$adfTaskItem(node) {
    const attrs = node.attrs;
    const localId = attrs?.localId;
    const state = attrs?.state;
    const localIdAttr = localId ? ` data-local-id="${$8ba1226f705511e9$var$escapeHtml(localId)}"` : "";
    const checked = state === "DONE" ? " checked" : "";
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<li data-type="task-item"${localIdAttr}><input type="checkbox"${checked}> ${content}</li>`;
}
function $8ba1226f705511e9$var$adfTable(node) {
    const content = node.content;
    if (!Array.isArray(content) || content.length === 0) return "<table></table>";
    const attrs = node.attrs;
    const layoutWidths = attrs?.layoutWidth;
    let layoutClass = "";
    if (layoutWidths && layoutWidths.length > 0) {
        const layoutKey = layoutWidths.map((w)=>w.toFixed(2)).join(",");
        layoutClass = $2lsBU.LAYOUT_WIDTHS_TO_CLASS[layoutKey] || "";
    }
    const tableAttrs = [];
    if (layoutClass) tableAttrs.push(`data-layout="${$8ba1226f705511e9$var$escapeHtml(layoutClass)}"`);
    const displayMode = attrs?.displayMode;
    if (displayMode && displayMode !== "default") tableAttrs.push(`data-display-mode="${$8ba1226f705511e9$var$escapeHtml(displayMode)}"`);
    const tableWidth = attrs?.width;
    if (tableWidth) tableAttrs.push(`data-width="${tableWidth}"`);
    if (attrs?.isNumberColumnEnabled) tableAttrs.push('data-number-column="true"');
    const tableAttrsStr = tableAttrs.length > 0 ? " " + tableAttrs.join(" ") : "";
    // Determine if first row has headers
    const firstRow = content[0];
    const firstRowCells = firstRow?.content || [];
    const hasHeaders = firstRowCells.some((cell)=>cell.type === "tableHeader");
    let result = `<table${tableAttrsStr}>`;
    if (hasHeaders) {
        result += "<thead>";
        result += $8ba1226f705511e9$var$adfTableRow(firstRow);
        result += "</thead><tbody>";
        for(let i = 1; i < content.length; i++)result += $8ba1226f705511e9$var$adfTableRow(content[i]);
        result += "</tbody>";
    } else {
        result += "<tbody>";
        for (const row of content)result += $8ba1226f705511e9$var$adfTableRow(row);
        result += "</tbody>";
    }
    result += "</table>";
    return result;
}
function $8ba1226f705511e9$var$adfTableRow(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<tr>${content}</tr>`;
}
function $8ba1226f705511e9$var$adfTableHeader(node) {
    const attrs = $8ba1226f705511e9$var$cellAttrs(node);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<th${attrs}>${content}</th>`;
}
function $8ba1226f705511e9$var$adfTableCell(node) {
    const attrs = $8ba1226f705511e9$var$cellAttrs(node);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<td${attrs}>${content}</td>`;
}
function $8ba1226f705511e9$var$adfBlockquote(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<blockquote>${content}</blockquote>`;
}
function $8ba1226f705511e9$var$adfCodeBlock(node) {
    const attrs = node.attrs;
    const language = attrs?.language;
    const uniqueId = attrs?.uniqueId;
    const codeAttrs = [];
    if (uniqueId) codeAttrs.push(`data-unique-id="${$8ba1226f705511e9$var$escapeHtml(uniqueId)}"`);
    const langClass = language ? `language-${$8ba1226f705511e9$var$escapeHtml(language)}` : "";
    const codeClassAttr = langClass ? ` class="${langClass}"` : "";
    const content = $8ba1226f705511e9$var$convertContent(node);
    const codeAttrsStr = codeAttrs.length > 0 ? " " + codeAttrs.join(" ") : "";
    const bk = $8ba1226f705511e9$var$breakoutAttrs(node);
    return `<pre${codeAttrsStr}${bk}><code${codeClassAttr}>${content}</code></pre>`;
}
function $8ba1226f705511e9$var$adfPanel(node) {
    const attrs = node.attrs;
    const panelType = attrs?.panelType;
    const panelAttrs = [];
    if (panelType === "custom") {
        panelAttrs.push(`data-type="panel-custom"`);
        const icon = attrs?.panelIcon ?? attrs?.icon;
        if (icon) panelAttrs.push(`data-icon="${$8ba1226f705511e9$var$escapeHtml(icon)}"`);
        const color = attrs?.panelColor ?? attrs?.color;
        if (color) panelAttrs.push(`data-color="${$8ba1226f705511e9$var$escapeHtml(color)}"`);
        const iconId = attrs?.panelIconId;
        if (iconId) panelAttrs.push(`data-icon-id="${$8ba1226f705511e9$var$escapeHtml(iconId)}"`);
        const iconText = attrs?.panelIconText;
        if (iconText) panelAttrs.push(`data-icon-text="${$8ba1226f705511e9$var$escapeHtml(iconText)}"`);
    } else {
        const type = panelType && $2lsBU.PANEL_TYPES.has(panelType) ? panelType : "info";
        panelAttrs.push(`data-type="panel-${type}"`);
    }
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div ${panelAttrs.join(" ")}>${content}</div>`;
}
function $8ba1226f705511e9$var$adfLayoutSection(node) {
    const attrs = node.attrs;
    const content = node.content;
    if (!Array.isArray(content) || content.length === 0) return '<section data-type="layout-section"></section>';
    // Extract column widths to determine layout class
    const columns = content.filter((col)=>col.type === "layoutColumn");
    const columnWidths = columns.map((col)=>{
        const colAttrs = col.attrs;
        return colAttrs?.width;
    }).filter((w)=>w !== undefined);
    let layoutClass = "layout-section";
    if (columnWidths.length > 0) {
        // Try to match layout key - first with exact integers, then with 2 decimals
        let layoutKey = columnWidths.map((w)=>String(w === Math.floor(w) ? Math.floor(w) : w)).join(",");
        let mapped = $2lsBU.LAYOUT_WIDTHS_TO_CLASS[layoutKey];
        if (!mapped) {
            layoutKey = columnWidths.map((w)=>w.toFixed(2)).join(",");
            mapped = $2lsBU.LAYOUT_WIDTHS_TO_CLASS[layoutKey];
        }
        layoutClass = mapped || "layout-section";
    }
    const bk = $8ba1226f705511e9$var$breakoutAttrs(node);
    const sectionAttrs = [];
    if (bk) sectionAttrs.push(bk.trim());
    sectionAttrs.push(`data-type="${layoutClass}"`);
    const columnRuleStyle = attrs?.columnRuleStyle;
    if (columnRuleStyle) sectionAttrs.push(`data-column-rule-style="${$8ba1226f705511e9$var$escapeHtml(columnRuleStyle)}"`);
    const contentHtml = $8ba1226f705511e9$var$convertContent(node);
    return `<section ${sectionAttrs.join(" ")}>${contentHtml}</section>`;
}
function $8ba1226f705511e9$var$adfLayoutColumn(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div data-type="column">${content}</div>`;
}
function $8ba1226f705511e9$var$adfExpand(node) {
    const attrs = node.attrs;
    const title = attrs?.title;
    const content = $8ba1226f705511e9$var$convertContent(node);
    const titleHtml = title ? $8ba1226f705511e9$var$escapeHtml(title) : "";
    const bk = $8ba1226f705511e9$var$breakoutAttrs(node);
    return `<details${bk}><summary>${titleHtml}</summary>${content}</details>`;
}
function $8ba1226f705511e9$var$adfText(node) {
    const text = node.text;
    const marks = node.marks;
    let result = $8ba1226f705511e9$var$escapeHtml(text || "");
    if (Array.isArray(marks)) for (const mark of marks)result = $8ba1226f705511e9$var$applyMark(result, mark);
    return result;
}
function $8ba1226f705511e9$var$adfInlineCard(node) {
    const attrs = node.attrs;
    const url = attrs?.url;
    const escapedUrl = $8ba1226f705511e9$var$escapeHtml(url || "");
    return `<a href="${escapedUrl}" data-card-appearance="inline">${escapedUrl}</a>`;
}
function $8ba1226f705511e9$var$adfBlockCard(node) {
    const attrs = node.attrs;
    const url = attrs?.url;
    const datasource = attrs?.datasource;
    const cardAttrs = [
        'data-type="block-card"'
    ];
    if (url) cardAttrs.push(`data-url="${$8ba1226f705511e9$var$escapeHtml(url)}"`);
    if (datasource) cardAttrs.push(`data-datasource="${$8ba1226f705511e9$var$escapeHtml(datasource)}"`);
    const escapedUrl = $8ba1226f705511e9$var$escapeHtml(url || "");
    return `<div ${cardAttrs.join(" ")}><a href="${escapedUrl}">${escapedUrl}</a></div>`;
}
function $8ba1226f705511e9$var$adfEmbedCard(node) {
    const attrs = node.attrs;
    const url = attrs?.url;
    const layout = attrs?.layout;
    const width = attrs?.width;
    const originalWidth = attrs?.originalWidth;
    const originalHeight = attrs?.originalHeight;
    const cardAttrs = [
        'data-type="embed-card"'
    ];
    if (layout) cardAttrs.push(`data-layout="${$8ba1226f705511e9$var$escapeHtml(layout)}"`);
    if (width) cardAttrs.push(`data-width="${width}"`);
    if (originalWidth) cardAttrs.push(`data-original-width="${originalWidth}"`);
    if (originalHeight) cardAttrs.push(`data-original-height="${originalHeight}"`);
    const escapedUrl = $8ba1226f705511e9$var$escapeHtml(url || "");
    return `<div ${cardAttrs.join(" ")}><iframe src="${escapedUrl}"></iframe></div>`;
}
function $8ba1226f705511e9$var$adfStatus(node) {
    const attrs = node.attrs;
    const color = attrs?.color;
    const text = attrs?.text;
    const statusAttrs = [
        'data-type="status"'
    ];
    if (color) statusAttrs.push(`data-color="${$8ba1226f705511e9$var$escapeHtml(color)}"`);
    const content = $8ba1226f705511e9$var$escapeHtml(text || "");
    return `<span ${statusAttrs.join(" ")}>${content}</span>`;
}
function $8ba1226f705511e9$var$adfDate(node) {
    const attrs = node.attrs;
    const raw = attrs?.timestamp;
    if (!raw) return "<time></time>";
    const ts = typeof raw === "string" ? Number(raw) : raw;
    if (Number.isNaN(ts)) return "<time></time>";
    const date = new Date(ts);
    // Format as date-only (YYYY-MM-DD) per spec
    const dateOnly = date.toISOString().slice(0, 10);
    const formatted = date.toLocaleDateString("en-US", {
        year: "numeric",
        month: "long",
        day: "numeric"
    });
    return `<time datetime="${dateOnly}">${formatted}</time>`;
}
function $8ba1226f705511e9$var$adfEmoji(node) {
    const attrs = node.attrs;
    const shortName = attrs?.shortName;
    const text = attrs?.text;
    const emojiAttrs = [
        'data-type="emoji"'
    ];
    if (shortName) emojiAttrs.push(`data-shortname="${$8ba1226f705511e9$var$escapeHtml(shortName)}"`);
    const content = $8ba1226f705511e9$var$escapeHtml(text || "");
    return `<span ${emojiAttrs.join(" ")}>${content}</span>`;
}
function $8ba1226f705511e9$var$adfMention(node) {
    const attrs = node.attrs;
    const id = attrs?.id;
    const accessLevel = attrs?.accessLevel;
    const userType = attrs?.userType;
    const localId = attrs?.localId;
    const text = attrs?.text;
    const mentionAttrs = [
        'data-type="mention"'
    ];
    if (id) mentionAttrs.push(`data-user-id="${$8ba1226f705511e9$var$escapeHtml(id)}"`);
    if (accessLevel) mentionAttrs.push(`data-access-level="${$8ba1226f705511e9$var$escapeHtml(accessLevel)}"`);
    if (userType) mentionAttrs.push(`data-user-type="${$8ba1226f705511e9$var$escapeHtml(userType)}"`);
    if (localId) mentionAttrs.push(`data-local-id="${$8ba1226f705511e9$var$escapeHtml(localId)}"`);
    let content = $8ba1226f705511e9$var$escapeHtml(text || "");
    // Apply marks if present
    const marks = node.marks;
    if (Array.isArray(marks)) for (const mark of marks)content = $8ba1226f705511e9$var$applyMark(content, mark);
    return `<span ${mentionAttrs.join(" ")}>${content}</span>`;
}
function $8ba1226f705511e9$var$adfPlaceholder(node) {
    const attrs = node.attrs;
    const text = attrs?.text;
    const content = $8ba1226f705511e9$var$escapeHtml(text || "");
    return `<span data-type="placeholder">${content}</span>`;
}
function $8ba1226f705511e9$var$adfMediaSingle(node) {
    const attrs = node.attrs;
    const layout = attrs?.layout;
    const width = attrs?.width;
    const widthType = attrs?.widthType;
    const figureAttrs = [
        'data-type="media-single"'
    ];
    if (layout) figureAttrs.push(`data-layout="${$8ba1226f705511e9$var$escapeHtml(layout)}"`);
    if (width) figureAttrs.push(`data-width="${width}"`);
    if (widthType) figureAttrs.push(`data-width-type="${$8ba1226f705511e9$var$escapeHtml(widthType)}"`);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<figure ${figureAttrs.join(" ")}>${content}</figure>`;
}
function $8ba1226f705511e9$var$adfMedia(node) {
    const attrs = node.attrs;
    const type = attrs?.type;
    const id = attrs?.id;
    const collection = attrs?.collection;
    const url = attrs?.url;
    const alt = attrs?.alt;
    const width = attrs?.width;
    const height = attrs?.height;
    const occurrenceKey = attrs?.occurrenceKey;
    // External media (has url)
    if (url) {
        const mediaAttrs = [];
        if (alt) mediaAttrs.push(`alt="${$8ba1226f705511e9$var$escapeHtml(alt)}"`);
        if (width) mediaAttrs.push(`width="${width}"`);
        if (height) mediaAttrs.push(`height="${height}"`);
        return `<img src="${$8ba1226f705511e9$var$escapeHtml(url)}" ${mediaAttrs.join(" ")}>`;
    }
    // File-based media
    const mediaAttrs = [
        'data-type="media"'
    ];
    if (type) mediaAttrs.push(`data-media-type="${$8ba1226f705511e9$var$escapeHtml(type)}"`);
    if (id) mediaAttrs.push(`data-id="${$8ba1226f705511e9$var$escapeHtml(id)}"`);
    if (collection) mediaAttrs.push(`data-collection="${$8ba1226f705511e9$var$escapeHtml(collection)}"`);
    if (width) mediaAttrs.push(`data-width="${width}"`);
    if (height) mediaAttrs.push(`data-height="${height}"`);
    if (occurrenceKey) mediaAttrs.push(`data-occurrence-key="${$8ba1226f705511e9$var$escapeHtml(occurrenceKey)}"`);
    const content = $8ba1226f705511e9$var$escapeHtml(alt || "");
    return `<div ${mediaAttrs.join(" ")}>${content}</div>`;
}
function $8ba1226f705511e9$var$adfMediaGroup(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div data-type="media-group">${content}</div>`;
}
function $8ba1226f705511e9$var$adfMediaInline(node) {
    const attrs = node.attrs;
    const id = attrs?.id;
    const collection = attrs?.collection;
    const occurrenceKey = attrs?.occurrenceKey;
    const alt = attrs?.alt;
    const mediaAttrs = [
        'data-type="media-inline"'
    ];
    if (id) mediaAttrs.push(`data-media-id="${$8ba1226f705511e9$var$escapeHtml(id)}"`);
    if (collection) mediaAttrs.push(`data-media-collection="${$8ba1226f705511e9$var$escapeHtml(collection)}"`);
    if (occurrenceKey) mediaAttrs.push(`data-occurrence-key="${$8ba1226f705511e9$var$escapeHtml(occurrenceKey)}"`);
    const content = $8ba1226f705511e9$var$escapeHtml(alt || "");
    return `<span ${mediaAttrs.join(" ")}>${content}</span>`;
}
function $8ba1226f705511e9$var$adfCaption(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<figcaption>${content}</figcaption>`;
}
function $8ba1226f705511e9$var$adfDecisionList(node) {
    const attrs = node.attrs;
    const localId = attrs?.localId;
    const listAttrs = [
        'data-type="decision-list"'
    ];
    if (localId) listAttrs.push(`data-local-id="${$8ba1226f705511e9$var$escapeHtml(localId)}"`);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<ul ${listAttrs.join(" ")}>${content}</ul>`;
}
function $8ba1226f705511e9$var$adfDecisionItem(node) {
    const attrs = node.attrs;
    const state = attrs?.state;
    const localId = attrs?.localId;
    const itemAttrs = [
        'data-type="decision-item"'
    ];
    if (state) itemAttrs.push(`data-state="${$8ba1226f705511e9$var$escapeHtml(state)}"`);
    if (localId) itemAttrs.push(`data-local-id="${$8ba1226f705511e9$var$escapeHtml(localId)}"`);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<li ${itemAttrs.join(" ")}>${content}</li>`;
}
function $8ba1226f705511e9$var$adfExtension(node) {
    const attrs = node.attrs;
    const extensionKey = attrs?.extensionKey;
    const extensionType = attrs?.extensionType;
    const layout = attrs?.layout;
    const parameters = attrs?.parameters;
    const extAttrs = [
        'data-type="extension"'
    ];
    if (extensionKey) extAttrs.push(`data-extension-key="${$8ba1226f705511e9$var$escapeHtml(extensionKey)}"`);
    if (extensionType) extAttrs.push(`data-extension-type="${$8ba1226f705511e9$var$escapeHtml(extensionType)}"`);
    if (layout) extAttrs.push(`data-layout="${$8ba1226f705511e9$var$escapeHtml(layout)}"`);
    if (parameters) extAttrs.push(`data-parameters="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(parameters))}"`);
    const text = attrs?.text;
    const content = $8ba1226f705511e9$var$escapeHtml(text || "");
    return `<div ${extAttrs.join(" ")}>${content}</div>`;
}
function $8ba1226f705511e9$var$adfBodiedExtension(node) {
    const attrs = node.attrs;
    const extensionKey = attrs?.extensionKey;
    const extensionType = attrs?.extensionType;
    const layout = attrs?.layout;
    const parameters = attrs?.parameters;
    const extAttrs = [
        'data-type="bodied-extension"'
    ];
    if (extensionKey) extAttrs.push(`data-extension-key="${$8ba1226f705511e9$var$escapeHtml(extensionKey)}"`);
    if (extensionType) extAttrs.push(`data-extension-type="${$8ba1226f705511e9$var$escapeHtml(extensionType)}"`);
    if (layout) extAttrs.push(`data-layout="${$8ba1226f705511e9$var$escapeHtml(layout)}"`);
    if (parameters) extAttrs.push(`data-parameters="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(parameters))}"`);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div ${extAttrs.join(" ")}>${content}</div>`;
}
function $8ba1226f705511e9$var$adfInlineExtension(node) {
    const attrs = node.attrs;
    const extensionKey = attrs?.extensionKey;
    const extensionType = attrs?.extensionType;
    const parameters = attrs?.parameters;
    const extAttrs = [
        'data-type="inline-extension"'
    ];
    if (extensionKey) extAttrs.push(`data-extension-key="${$8ba1226f705511e9$var$escapeHtml(extensionKey)}"`);
    if (extensionType) extAttrs.push(`data-extension-type="${$8ba1226f705511e9$var$escapeHtml(extensionType)}"`);
    if (parameters) extAttrs.push(`data-parameters="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(parameters))}"`);
    const text = attrs?.text;
    const content = $8ba1226f705511e9$var$escapeHtml(text || "");
    return `<span ${extAttrs.join(" ")}>${content}</span>`;
}
function $8ba1226f705511e9$var$adfMultiBodiedExtension(node) {
    const attrs = node.attrs;
    const extensionKey = attrs?.extensionKey;
    const extensionType = attrs?.extensionType;
    const parameters = attrs?.parameters;
    const extAttrs = [
        'data-type="multi-bodied-extension"'
    ];
    if (extensionKey) extAttrs.push(`data-extension-key="${$8ba1226f705511e9$var$escapeHtml(extensionKey)}"`);
    if (extensionType) extAttrs.push(`data-extension-type="${$8ba1226f705511e9$var$escapeHtml(extensionType)}"`);
    if (parameters) extAttrs.push(`data-parameters="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(parameters))}"`);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div ${extAttrs.join(" ")}>${content}</div>`;
}
function $8ba1226f705511e9$var$adfExtensionFrame(node) {
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div data-type="extension-frame">${content}</div>`;
}
function $8ba1226f705511e9$var$adfSyncBlock(node) {
    const attrs = node.attrs;
    const resourceId = attrs?.resourceId;
    const syncAttrs = [
        'data-type="sync-block"'
    ];
    if (resourceId) syncAttrs.push(`data-resource-id="${$8ba1226f705511e9$var$escapeHtml(resourceId)}"`);
    const bk = $8ba1226f705511e9$var$breakoutAttrs(node);
    return `<div ${syncAttrs.join(" ")}${bk}></div>`;
}
function $8ba1226f705511e9$var$adfBodiedSyncBlock(node) {
    const attrs = node.attrs;
    const resourceId = attrs?.resourceId;
    const syncAttrs = [
        'data-type="bodied-sync-block"'
    ];
    if (resourceId) syncAttrs.push(`data-resource-id="${$8ba1226f705511e9$var$escapeHtml(resourceId)}"`);
    const bk = $8ba1226f705511e9$var$breakoutAttrs(node);
    const content = $8ba1226f705511e9$var$convertContent(node);
    return `<div ${syncAttrs.join(" ")}${bk}>${content}</div>`;
}
function $8ba1226f705511e9$var$adfChartWithData(node) {
    const attrs = node.attrs;
    const parameters = attrs?.parameters;
    // Extract chart parameters
    const chartType = parameters?.chartType;
    const titles = parameters?.titles;
    const colors = parameters?.colors;
    const height = parameters?.height;
    const orientation = parameters?.orientation;
    const legend = parameters?.legend;
    const chartAttrs = [
        'data-type="chart"'
    ];
    if (chartType) chartAttrs.push(`data-chart-type="${$8ba1226f705511e9$var$escapeHtml(chartType)}"`);
    if (titles) chartAttrs.push(`data-chart-title="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(titles))}"`);
    if (colors) chartAttrs.push(`data-chart-colors="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(colors))}"`);
    if (height) chartAttrs.push(`data-chart-height="${height}"`);
    if (orientation) chartAttrs.push(`data-chart-orientation="${$8ba1226f705511e9$var$escapeHtml(orientation)}"`);
    if (legend) chartAttrs.push(`data-chart-legend="${$8ba1226f705511e9$var$escapeHtml(JSON.stringify(legend))}"`);
    // Get the table content
    const content = node.content;
    const tableNode = content?.[0];
    const tableHtml = tableNode ? $8ba1226f705511e9$var$adfTable(tableNode) : "";
    return `<div ${chartAttrs.join(" ")}>${tableHtml}</div>`;
}
// Dispatch table for node type handlers
const $8ba1226f705511e9$var$ADF_TO_HTML_HANDLERS = {
    doc: $8ba1226f705511e9$var$adfDoc,
    heading: $8ba1226f705511e9$var$adfHeading,
    paragraph: $8ba1226f705511e9$var$adfParagraph,
    bulletList: $8ba1226f705511e9$var$adfBulletList,
    orderedList: $8ba1226f705511e9$var$adfOrderedList,
    listItem: $8ba1226f705511e9$var$adfListItem,
    taskList: $8ba1226f705511e9$var$adfTaskList,
    taskItem: $8ba1226f705511e9$var$adfTaskItem,
    blockTaskItem: $8ba1226f705511e9$var$adfTaskItem,
    // alias
    table: $8ba1226f705511e9$var$adfTable,
    tableRow: $8ba1226f705511e9$var$adfTableRow,
    tableHeader: $8ba1226f705511e9$var$adfTableHeader,
    tableCell: $8ba1226f705511e9$var$adfTableCell,
    blockquote: $8ba1226f705511e9$var$adfBlockquote,
    codeBlock: $8ba1226f705511e9$var$adfCodeBlock,
    rule: ()=>"<hr>",
    panel: $8ba1226f705511e9$var$adfPanel,
    layoutSection: $8ba1226f705511e9$var$adfLayoutSection,
    layoutColumn: $8ba1226f705511e9$var$adfLayoutColumn,
    expand: $8ba1226f705511e9$var$adfExpand,
    nestedExpand: $8ba1226f705511e9$var$adfExpand,
    // same handler
    text: $8ba1226f705511e9$var$adfText,
    hardBreak: ()=>"<br>",
    inlineCard: $8ba1226f705511e9$var$adfInlineCard,
    blockCard: $8ba1226f705511e9$var$adfBlockCard,
    embedCard: $8ba1226f705511e9$var$adfEmbedCard,
    status: $8ba1226f705511e9$var$adfStatus,
    date: $8ba1226f705511e9$var$adfDate,
    emoji: $8ba1226f705511e9$var$adfEmoji,
    mention: $8ba1226f705511e9$var$adfMention,
    placeholder: $8ba1226f705511e9$var$adfPlaceholder,
    mediaSingle: $8ba1226f705511e9$var$adfMediaSingle,
    media: $8ba1226f705511e9$var$adfMedia,
    mediaGroup: $8ba1226f705511e9$var$adfMediaGroup,
    mediaInline: $8ba1226f705511e9$var$adfMediaInline,
    caption: $8ba1226f705511e9$var$adfCaption,
    decisionList: $8ba1226f705511e9$var$adfDecisionList,
    decisionItem: $8ba1226f705511e9$var$adfDecisionItem,
    extension: $8ba1226f705511e9$var$adfExtension,
    bodiedExtension: $8ba1226f705511e9$var$adfBodiedExtension,
    inlineExtension: $8ba1226f705511e9$var$adfInlineExtension,
    multiBodiedExtension: $8ba1226f705511e9$var$adfMultiBodiedExtension,
    extensionFrame: $8ba1226f705511e9$var$adfExtensionFrame,
    syncBlock: $8ba1226f705511e9$var$adfSyncBlock,
    bodiedSyncBlock: $8ba1226f705511e9$var$adfBodiedSyncBlock,
    __chart_with_data: $8ba1226f705511e9$var$adfChartWithData
};
// Main node dispatcher
function $8ba1226f705511e9$var$adfNodeToHtml(node) {
    if (node === null || node === undefined) return "";
    if (typeof node !== "object") return String(node);
    const adfNode = node;
    const nodeType = adfNode.type;
    if (!nodeType) return $8ba1226f705511e9$var$convertContent(adfNode);
    const handler = $8ba1226f705511e9$var$ADF_TO_HTML_HANDLERS[nodeType];
    if (handler) return handler(adfNode);
    // Fallback: try to convert content
    return $8ba1226f705511e9$var$convertContent(adfNode);
}
const $8ba1226f705511e9$var$BLOCK_TAGS = new Set([
    "address",
    "article",
    "aside",
    "blockquote",
    "caption",
    "col",
    "colgroup",
    "dd",
    "details",
    "dialog",
    "div",
    "dl",
    "dt",
    "fieldset",
    "figcaption",
    "figure",
    "footer",
    "form",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "header",
    "hgroup",
    "hr",
    "legend",
    "li",
    "main",
    "menu",
    "nav",
    "ol",
    "p",
    "pre",
    "search",
    "section",
    "summary",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    "ul"
]);
const $8ba1226f705511e9$var$VOID_TAGS = new Set([
    "area",
    "base",
    "br",
    "col",
    "embed",
    "hr",
    "img",
    "input",
    "link",
    "meta",
    "param",
    "source",
    "track",
    "wbr"
]);
const $8ba1226f705511e9$var$INDENT = "  ";
function $8ba1226f705511e9$var$tokenizeHtml(html) {
    // The `[^>]` inside the tag pattern assumes the input never contains a raw
    // `>` inside an attribute value. This is safe for `adfToHtml` output because
    // every attribute value goes through `escapeHtml`, which encodes `>` as
    // `&gt;`. Do not feed arbitrary HTML through this tokenizer.
    const tokens = [];
    const re = /<[^>]+>|[^<]+/g;
    let match;
    while((match = re.exec(html)) !== null){
        const raw = match[0];
        if (!raw.startsWith("<")) {
            tokens.push({
                type: "text",
                raw: raw
            });
            continue;
        }
        const closeMatch = raw.match(/^<\/\s*([a-z0-9-]+)/i);
        if (closeMatch) {
            tokens.push({
                type: "close",
                raw: raw,
                tag: closeMatch[1].toLowerCase()
            });
            continue;
        }
        const openMatch = raw.match(/^<\s*([a-z0-9-]+)/i);
        if (!openMatch) {
            tokens.push({
                type: "text",
                raw: raw
            });
            continue;
        }
        const tag = openMatch[1].toLowerCase();
        tokens.push({
            type: "open",
            raw: raw,
            tag: tag,
            void: $8ba1226f705511e9$var$VOID_TAGS.has(tag) || /\/\s*>$/.test(raw)
        });
    }
    return tokens;
}
function $8ba1226f705511e9$var$nextMeaningfulToken(tokens, start) {
    for(let i = start; i < tokens.length; i++){
        const token = tokens[i];
        if (token.type === "text" && token.raw.trim().length === 0) continue;
        return token;
    }
    return undefined;
}
function $8ba1226f705511e9$var$prettifyHtml(html) {
    const tokens = $8ba1226f705511e9$var$tokenizeHtml(html);
    if (!tokens.some((token)=>token.type !== "text")) return html;
    const parts = [];
    const stack = [];
    let depth = 0;
    let endsWithNewline = false;
    const append = (value)=>{
        parts.push(value);
        endsWithNewline = value.endsWith("\n");
    };
    for(let i = 0; i < tokens.length; i++){
        const token = tokens[i];
        if (token.type === "text") {
            if (endsWithNewline && token.raw.trim().length === 0) continue;
            append(token.raw);
            continue;
        }
        if (token.type === "open") {
            const isBlock = $8ba1226f705511e9$var$BLOCK_TAGS.has(token.tag);
            const indent = $8ba1226f705511e9$var$INDENT.repeat(depth);
            if (token.void) {
                append(isBlock ? `${indent}${token.raw}\n` : token.raw);
                continue;
            }
            const next = $8ba1226f705511e9$var$nextMeaningfulToken(tokens, i + 1);
            const hasBlockChildren = isBlock && next?.type === "open" && $8ba1226f705511e9$var$BLOCK_TAGS.has(next.tag);
            append(isBlock ? `${indent}${token.raw}${hasBlockChildren ? "\n" : ""}` : token.raw);
            stack.push({
                block: isBlock,
                blockChildren: hasBlockChildren
            });
            if (isBlock) depth++;
            continue;
        }
        const current = stack.pop();
        if (current?.block) {
            depth = Math.max(0, depth - 1);
            append(current.blockChildren ? `${$8ba1226f705511e9$var$INDENT.repeat(depth)}${token.raw}\n` : `${token.raw}\n`);
        } else append(token.raw);
    }
    return parts.join("").replace(/\n$/, "");
}
// Main export: Convert ADF to HTML
function $8ba1226f705511e9$var$adfToHtml(adf, options) {
    // Deep clone to avoid mutations
    const cloned = $8ba1226f705511e9$var$deepClone(adf);
    // Pre-process: collapse mermaid and chart pairs
    $8ba1226f705511e9$var$collapseMermaidPairs(cloned);
    $8ba1226f705511e9$var$collapseChartPairs(cloned);
    // Convert to HTML
    const raw = $8ba1226f705511e9$var$adfNodeToHtml(cloned);
    return options?.pretty ? $8ba1226f705511e9$var$prettifyHtml(raw) : raw;
}

});

parcelRegister("9T4kN", function(module, exports) {
"use strict";
/**
 * HTML → ADF converter.
 *
 * Converts the AI-agent-friendly HTML subset back to Atlassian Document Format (ADF) JSON.
 *
 * @module @atlassian/atlassian-html-format
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.escapeUnknownTags = void 0;
module.exports.preserveTextLikeAngleTokens = $732c9cd53da04012$var$preserveTextLikeAngleTokens;
module.exports.htmlToAdf = $732c9cd53da04012$var$htmlToAdf;
module.exports.htmlToAdfFromDom = $732c9cd53da04012$var$htmlToAdfFromDom;
module.exports.htmlToAdfFromParsedRoot = $732c9cd53da04012$var$htmlToAdfFromParsedRoot;
module.exports.convertChildrenToBlocks = $732c9cd53da04012$var$convertChildrenToBlocks;
module.exports.htmlElementToAdf = $732c9cd53da04012$var$htmlElementToAdf;
module.exports.convertInlineContent = $732c9cd53da04012$var$convertInlineContent;
module.exports.convertInlineElement = $732c9cd53da04012$var$convertInlineElement;
module.exports.makeText = $732c9cd53da04012$var$makeText;
module.exports.makeParagraph = $732c9cd53da04012$var$makeParagraph;
module.exports.makeMark = $732c9cd53da04012$var$makeMark;
module.exports.extractBlockMarks = $732c9cd53da04012$var$extractBlockMarks;
module.exports.hasClass = $732c9cd53da04012$var$hasClass;
module.exports.getClasses = $732c9cd53da04012$var$getClasses;
module.exports.salvageChildren = $732c9cd53da04012$var$salvageChildren;
module.exports.addMarkToNode = $732c9cd53da04012$var$addMarkToNode;
module.exports.htmlInlineMark = $732c9cd53da04012$var$htmlInlineMark;

var $2lsBU = parcelRequire("2lsBU");

// IMPORTANT: activeContext relies on JS single-threaded execution and on every
// public entry point wrapping its work in `withConversionContext` (which uses a
// try/finally save/restore so re-entrant calls like `parseHtmlFragment` nest
// safely). The conversion pipeline MUST stay fully synchronous — there are no
// `await`s on the path between entry and the final tree. If async steps are
// ever introduced, two interleaved conversions in the same task would clobber
// each other's context, and the context must instead be threaded explicitly
// through every handler.
let $732c9cd53da04012$var$activeContext;
function $732c9cd53da04012$var$defaultIdGenerator() {
    const randomUUID = globalThis.crypto?.randomUUID?.bind(globalThis.crypto);
    if (randomUUID) return randomUUID();
    return `generated-${Math.random().toString(36).slice(2)}-${Date.now().toString(36)}`;
}
function $732c9cd53da04012$var$withConversionContext(options, fn) {
    const previous = $732c9cd53da04012$var$activeContext;
    $732c9cd53da04012$var$activeContext = {
        document: options?.document,
        idGenerator: options?.idGenerator ?? $732c9cd53da04012$var$defaultIdGenerator,
        onWarning: options?.onWarning,
        strict: options?.strict ?? false,
        parseFragment: options?.parseFragment
    };
    try {
        return fn();
    } finally{
        $732c9cd53da04012$var$activeContext = previous;
    }
}
function $732c9cd53da04012$var$generateId() {
    return ($732c9cd53da04012$var$activeContext?.idGenerator ?? $732c9cd53da04012$var$defaultIdGenerator)();
}
function $732c9cd53da04012$var$warn(warning) {
    $732c9cd53da04012$var$activeContext?.onWarning?.(warning);
    if ($732c9cd53da04012$var$activeContext?.strict) throw new Error(warning.message);
}
function $732c9cd53da04012$var$toArray(nodes) {
    if (!nodes) return [];
    if (typeof nodes[Symbol.iterator] === "function") return Array.from(nodes);
    return Array.from(nodes);
}
function $732c9cd53da04012$var$childNodes(parent) {
    return $732c9cd53da04012$var$toArray(parent.childNodes);
}
function $732c9cd53da04012$var$isElement(node) {
    return !!node && typeof node === "object" && node.nodeType === 1;
}
function $732c9cd53da04012$var$isTextNode(node) {
    return !!node && typeof node === "object" && node.nodeType === 3;
}
function $732c9cd53da04012$var$tagName(el) {
    return String(el.rawTagName || el.tagName || "").toLowerCase();
}
function $732c9cd53da04012$var$getText(node) {
    // Prefer DOM-style `textContent` (decoded). `node-html-parser` exposes a
    // decoded `.text`. We deliberately do NOT fall back to `.rawText` here:
    // `rawText` returns the raw HTML source (with un-decoded entities), so a
    // fallback would silently introduce double-encoded text in callers that
    // expect decoded characters.
    const asAny = node;
    if (typeof asAny.textContent === "string") return asAny.textContent;
    if (typeof asAny.text === "string") return asAny.text;
    return "";
}
function $732c9cd53da04012$var$getInnerHtml(el) {
    if (typeof el.innerHTML === "string") return el.innerHTML;
    return "";
}
function $732c9cd53da04012$var$hasAttribute(el, name) {
    const hasAttributeFn = el.hasAttribute;
    if (typeof hasAttributeFn === "function") return hasAttributeFn.call(el, name);
    const value = el.getAttribute(name);
    return value !== null && value !== undefined;
}
function $732c9cd53da04012$var$query(parent, selector) {
    const querySelector = parent.querySelector;
    if (typeof querySelector === "function") return querySelector.call(parent, selector) ?? null;
    // Minimal fallback used only for synthetic HtmlParent values that don't
    // implement querySelector. Supports bare tag-name selectors only — anything
    // more complex (e.g. `code[data-language]`, `div.panel`) returns null. All
    // real DOM/JSDOM/node-html-parser inputs hit the native path above, so this
    // limitation is acceptable in practice.
    if (/^[a-z][a-z0-9-]*$/i.test(selector)) for (const child of $732c9cd53da04012$var$childNodes(parent)){
        if (!$732c9cd53da04012$var$isElement(child)) continue;
        if ($732c9cd53da04012$var$tagName(child) === selector.toLowerCase()) return child;
        const descendant = $732c9cd53da04012$var$query(child, selector);
        if (descendant) return descendant;
    }
    return null;
}
function $732c9cd53da04012$var$queryAll(parent, selector) {
    const querySelectorAll = parent.querySelectorAll;
    if (typeof querySelectorAll === "function") return $732c9cd53da04012$var$toArray(querySelectorAll.call(parent, selector)).filter($732c9cd53da04012$var$isElement);
    if (/^[a-z][a-z0-9-]*$/i.test(selector)) {
        const matches = [];
        for (const child of $732c9cd53da04012$var$childNodes(parent)){
            if (!$732c9cd53da04012$var$isElement(child)) continue;
            if ($732c9cd53da04012$var$tagName(child) === selector.toLowerCase()) matches.push(child);
            matches.push(...$732c9cd53da04012$var$queryAll(child, selector));
        }
        return matches;
    }
    return [];
}
function $732c9cd53da04012$var$parseHtmlFragment(html) {
    if ($732c9cd53da04012$var$activeContext?.parseFragment) return $732c9cd53da04012$var$activeContext.parseFragment(html);
    const doc = $732c9cd53da04012$var$activeContext?.document ?? globalThis.document;
    if (!doc) throw new Error("htmlToAdf(html) requires a browser Document. In Node, import htmlToAdf from '@atlassian/atlassian-html-format/node' or pass a JSDOM document.");
    const template = doc.createElement("template");
    template.innerHTML = html;
    return template.content;
}
function $732c9cd53da04012$var$decodeHtmlEntities(value) {
    // Fast path: nothing to decode. Avoids any DOM allocation for the common
    // case (most code-block / text content has no entities).
    if (!value.includes("&")) return value;
    const doc = $732c9cd53da04012$var$activeContext?.document ?? globalThis.document;
    if (doc) {
        // Use the browser's own entity decoder by writing the value into a
        // detached <textarea> and reading `.value`. We allocate one textarea per
        // call rather than caching on the conversion context: caching would add
        // mutable state to the context (see the activeContext note above) and
        // matters only for documents with very many entity-bearing code blocks.
        // Correctness over micro-optimisation — the regex fallback below covers
        // only a handful of named entities, while textarea handles every HTML5
        // entity (including &copy;, &hellip;, &mdash;, numeric refs, etc.).
        const textarea = doc.createElement("textarea");
        textarea.innerHTML = value;
        return textarea.value;
    }
    return value.replace(/&(#x[0-9a-f]+|#\d+|[a-z][a-z0-9]+);/gi, (entity, body)=>{
        const lower = body.toLowerCase();
        if (lower.startsWith("#x")) {
            const codePoint = parseInt(lower.slice(2), 16);
            return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : entity;
        }
        if (lower.startsWith("#")) {
            const codePoint = parseInt(lower.slice(1), 10);
            return Number.isFinite(codePoint) ? String.fromCodePoint(codePoint) : entity;
        }
        switch(lower){
            case "amp":
                return "&";
            case "lt":
                return "<";
            case "gt":
                return ">";
            case "quot":
                return '"';
            case "apos":
                return "'";
            case "nbsp":
                return "\u00a0";
            default:
                return entity;
        }
    });
}
// ---------------------------------------------------------------------------
// Pre-processing: preserve angle-bracket tokens that look like HTML tags but
// are not standard HTML elements. Browsers, node-html-parser, Jsoup and BS4 all
// interpret sequences like <worker name> as elements and lose the angle
// brackets. Escaping them before parsing preserves them as literal text.
// ---------------------------------------------------------------------------
const $732c9cd53da04012$var$KNOWN_HTML_TAGS = new Set([
    // Document / metadata
    "html",
    "head",
    "body",
    "base",
    "link",
    "meta",
    "style",
    "title",
    // Sections
    "address",
    "article",
    "aside",
    "footer",
    "header",
    "hgroup",
    "main",
    "nav",
    "section",
    "search",
    // Headings
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    // Grouping / text-block
    "blockquote",
    "dd",
    "details",
    "dialog",
    "div",
    "dl",
    "dt",
    "figcaption",
    "figure",
    "hr",
    "li",
    "menu",
    "ol",
    "p",
    "pre",
    "summary",
    "ul",
    // Inline text
    "a",
    "abbr",
    "b",
    "bdi",
    "bdo",
    "br",
    "cite",
    "code",
    "data",
    "dfn",
    "em",
    "i",
    "kbd",
    "mark",
    "q",
    "rp",
    "rt",
    "ruby",
    "s",
    "samp",
    "small",
    "span",
    "strong",
    "sub",
    "sup",
    "time",
    "u",
    "var",
    "wbr",
    // Edits
    "del",
    "ins",
    // Embedded / media
    "area",
    "audio",
    "canvas",
    "embed",
    "iframe",
    "img",
    "map",
    "object",
    "param",
    "picture",
    "portal",
    "source",
    "track",
    "video",
    // SVG / MathML
    "svg",
    "math",
    // Scripting
    "noscript",
    "script",
    // Table
    "caption",
    "col",
    "colgroup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "tr",
    // Forms
    "button",
    "datalist",
    "fieldset",
    "form",
    "input",
    "label",
    "legend",
    "meter",
    "optgroup",
    "option",
    "output",
    "progress",
    "select",
    "textarea",
    // Web components
    "slot",
    "template"
]);
function $732c9cd53da04012$var$preserveTextLikeAngleTokens(html) {
    return html.replace(/<([^>]*)>/g, (full, inner)=>{
        if (inner.startsWith("!") || inner.startsWith("?")) return full;
        const parts = inner.replace(/^\//, "").trim().split(/\s+/);
        const candidate = (parts[0] || "").replace(/\/$/, "").toLowerCase();
        if ($732c9cd53da04012$var$KNOWN_HTML_TAGS.has(candidate)) return full;
        return "&lt;" + inner + "&gt;";
    });
}
/**
 * @deprecated Use `preserveTextLikeAngleTokens` instead. Retained as a
 * backwards-compatible alias for tests/consumers that imported the old name.
 */ module.exports.escapeUnknownTags = $732c9cd53da04012$var$preserveTextLikeAngleTokens;
// Main browser/core export
function $732c9cd53da04012$var$htmlToAdf(html, options) {
    return $732c9cd53da04012$var$withConversionContext(options, ()=>{
        const preprocessed = options?.preserveTextLikeAngleTokens === false ? html : $732c9cd53da04012$var$preserveTextLikeAngleTokens(html);
        const root = $732c9cd53da04012$var$parseHtmlFragment(preprocessed);
        const actualRoot = $732c9cd53da04012$var$isElement(root) ? $732c9cd53da04012$var$query(root, "body") || root : root;
        $732c9cd53da04012$var$runDiagnosticsTextWalk(actualRoot);
        const content = $732c9cd53da04012$var$convertChildrenToBlocks(actualRoot);
        const doc = {
            type: "doc",
            version: 1,
            content: content
        };
        return $732c9cd53da04012$var$expandMermaidBlocks(doc);
    });
}
function $732c9cd53da04012$var$htmlToAdfFromDom(root, options) {
    return $732c9cd53da04012$var$withConversionContext(options, ()=>{
        const actualRoot = $732c9cd53da04012$var$isElement(root) ? $732c9cd53da04012$var$query(root, "body") || root : root;
        $732c9cd53da04012$var$runDiagnosticsTextWalk(actualRoot);
        const content = $732c9cd53da04012$var$convertChildrenToBlocks(actualRoot);
        const doc = {
            type: "doc",
            version: 1,
            content: content
        };
        return $732c9cd53da04012$var$expandMermaidBlocks(doc);
    });
}
/**
 * @internal Used by the Node adapter to provide node-html-parser without
 * importing it in the browser/core module. Not part of the public API and not
 * re-exported from `index.ts`; external callers should use `htmlToAdf` or
 * `htmlToAdfFromDom` instead.
 */ function $732c9cd53da04012$var$htmlToAdfFromParsedRoot(root, options) {
    return $732c9cd53da04012$var$withConversionContext(options, ()=>{
        const actualRoot = $732c9cd53da04012$var$isElement(root) ? $732c9cd53da04012$var$query(root, "body") || root : root;
        $732c9cd53da04012$var$runDiagnosticsTextWalk(actualRoot);
        const content = $732c9cd53da04012$var$convertChildrenToBlocks(actualRoot);
        const doc = {
            type: "doc",
            version: 1,
            content: content
        };
        return $732c9cd53da04012$var$expandMermaidBlocks(doc);
    });
}
// Block conversion
function $732c9cd53da04012$var$convertChildrenToBlocks(parent) {
    const blocks = [];
    for (const node of $732c9cd53da04012$var$childNodes(parent)){
        if ($732c9cd53da04012$var$isTextNode(node)) {
            const text = $732c9cd53da04012$var$getText(node).trim();
            if (text) blocks.push($732c9cd53da04012$var$makeParagraph([
                $732c9cd53da04012$var$makeText(text)
            ]));
        } else if ($732c9cd53da04012$var$isElement(node)) {
            const result = $732c9cd53da04012$var$htmlElementToAdf(node);
            if (result !== null) {
                if (Array.isArray(result)) blocks.push(...result);
                else blocks.push(result);
            }
        }
    }
    return blocks;
}
const $732c9cd53da04012$var$NON_CONTENT_BLOCK_TAGS = new Set([
    "script",
    "style",
    "template",
    "head",
    "meta",
    "link",
    "base",
    "title"
]);
const $732c9cd53da04012$var$NON_CONTENT_INLINE_TAGS = new Set([
    "script",
    "style",
    "template"
]);
function $732c9cd53da04012$var$htmlElementToAdf(el) {
    const tag = $732c9cd53da04012$var$tagName(el);
    // Non-content elements are dropped by design — don't run validation against
    // them or the validator would double-report `<script>`/`<style>` as both
    // "dropped" and "unsupported".
    if ($732c9cd53da04012$var$NON_CONTENT_BLOCK_TAGS.has(tag)) {
        $732c9cd53da04012$var$warn({
            code: "dropped-non-content-element",
            message: `Dropped non-content element <${tag}>`,
            tagName: tag
        });
        return null;
    }
    $732c9cd53da04012$var$validateHtmlElementInContext(el, tag);
    const handler = $732c9cd53da04012$var$HTML_TO_ADF_HANDLERS[tag];
    if (handler) return handler(el);
    return $732c9cd53da04012$var$salvageChildren(el);
}
// Inline content conversion
function $732c9cd53da04012$var$convertInlineContent(el) {
    const content = [];
    let pendingText = "";
    const flushText = ()=>{
        if (pendingText) {
            content.push($732c9cd53da04012$var$makeText(pendingText));
            pendingText = "";
        }
    };
    for (const node of $732c9cd53da04012$var$childNodes(el)){
        if ($732c9cd53da04012$var$isTextNode(node)) pendingText += $732c9cd53da04012$var$getText(node);
        else if ($732c9cd53da04012$var$isElement(node)) {
            flushText();
            const result = $732c9cd53da04012$var$convertInlineElement(node);
            if (result !== null) {
                if (Array.isArray(result)) content.push(...result);
                else content.push(result);
            }
        }
    }
    flushText();
    return content;
}
function $732c9cd53da04012$var$convertInlineElement(el) {
    const tag = $732c9cd53da04012$var$tagName(el);
    if ($732c9cd53da04012$var$NON_CONTENT_INLINE_TAGS.has(tag)) {
        $732c9cd53da04012$var$warn({
            code: "dropped-non-content-element",
            message: `Dropped non-content inline element <${tag}>`,
            tagName: tag
        });
        return null;
    }
    $732c9cd53da04012$var$validateHtmlElementInContext(el, tag);
    const handler = $732c9cd53da04012$var$INLINE_HANDLERS[tag];
    if (handler) return handler(el);
    return $732c9cd53da04012$var$convertInlineContent(el);
}
// ---------------------------------------------------------------------------
// Conversion-time validation
//
// `validateHtmlElementInContext` and `runDiagnosticsTextWalk` only do work when
// `activeContext.onWarning` is set; the conversion path is a no-op otherwise.
// The supported element / attribute / data-type / class tables live next to
// the converter handlers so adding handler support naturally widens what the
// validator accepts. `validateHtml` is a thin wrapper that runs the converter
// with a collecting callback and returns the resulting messages.
// ---------------------------------------------------------------------------
const $732c9cd53da04012$var$SUPPORTED_HTML_TAGS = new Set([
    "a",
    "blockquote",
    "br",
    "code",
    "del",
    "details",
    "div",
    "em",
    "figcaption",
    "figure",
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6",
    "hr",
    "i",
    "iframe",
    "img",
    "input",
    "li",
    "mark",
    "ol",
    "p",
    "pre",
    "s",
    "section",
    "span",
    "strike",
    "strong",
    "sub",
    "summary",
    "sup",
    "table",
    "tbody",
    "td",
    "tfoot",
    "th",
    "thead",
    "time",
    "tr",
    "u",
    "ul"
]);
const $732c9cd53da04012$var$SUPPORTED_DATA_TYPES_BY_TAG = {
    div: new Set([
        "adf-extension",
        "block-card",
        "bodied-extension",
        "bodied-sync-block",
        "chart",
        "column",
        "embed-card",
        "extension",
        "extension-body",
        "extension-frame",
        "media",
        "media-group",
        "multi-bodied-extension",
        "panel-custom",
        "panel-error",
        "panel-info",
        "panel-note",
        "panel-success",
        "panel-warning",
        "sync-block"
    ]),
    figure: new Set([
        "media-single"
    ]),
    li: new Set([
        "decision-item",
        "task-item"
    ]),
    section: new Set([
        "layout-two-equal",
        "layout-two-left-sidebar",
        "layout-two-right-sidebar",
        "layout-three-equal",
        "layout-three-with-sidebars"
    ]),
    span: new Set([
        "emoji",
        "inline-extension",
        "media-inline",
        "mention",
        "placeholder",
        "status"
    ]),
    ul: new Set([
        "decision-list",
        "task-list"
    ])
};
const $732c9cd53da04012$var$SUPPORTED_CLASSES_BY_TAG = {
    div: new Set([
        "annotation",
        "block-card",
        "bodied-extension",
        "bodied-sync-block",
        "chart",
        "column",
        "embed-card",
        "extension",
        "extension-frame",
        "media",
        "media-group",
        "multi-bodied-extension",
        "panel-custom",
        "panel-error",
        "panel-info",
        "panel-note",
        "panel-success",
        "panel-warning",
        "sync-block"
    ]),
    figure: new Set([
        "media-single"
    ]),
    li: new Set([
        "decided",
        "decision-item",
        "task-item"
    ]),
    section: new Set([
        "layout-section",
        "layout-two-equal",
        "layout-two-left-sidebar",
        "layout-two-right-sidebar",
        "layout-three-equal",
        "layout-three-with-sidebars"
    ]),
    span: new Set([
        "annotation",
        "mention"
    ]),
    ul: new Set([
        "decision-list",
        "task-list"
    ])
};
const $732c9cd53da04012$var$GLOBAL_HTML_ATTRS = new Set([
    "data-local-id"
]);
const $732c9cd53da04012$var$SUPPORTED_ATTRS_BY_TAG = {
    a: new Set([
        "data-card-appearance",
        "href"
    ]),
    code: new Set([
        "class",
        "data-language"
    ]),
    details: new Set([
        "data-breakout",
        "data-breakout-width"
    ]),
    div: new Set([
        "class",
        "data-chart-colors",
        "data-chart-height",
        "data-chart-legend-position",
        "data-chart-orientation",
        "data-chart-show-legend",
        "data-chart-title",
        "data-chart-type",
        "data-chart-x-label",
        "data-chart-y-label",
        "data-collection",
        "data-color",
        "data-datasource",
        "data-extension-key",
        "data-extension-type",
        "data-height",
        "data-icon",
        "data-icon-id",
        "data-icon-text",
        "data-id",
        "data-layout",
        "data-media-id",
        "data-media-type",
        "data-occurrence-key",
        "data-original-height",
        "data-original-width",
        "data-parameters",
        "data-resource-id",
        "data-type",
        "data-url",
        "data-width",
        "style"
    ]),
    figcaption: new Set([
        "data-local-id"
    ]),
    figure: new Set([
        "class",
        "data-layout",
        "data-type",
        "data-width",
        "data-width-type"
    ]),
    iframe: new Set([
        "src"
    ]),
    img: new Set([
        "alt",
        "height",
        "src",
        "width"
    ]),
    input: new Set([
        "checked",
        "type"
    ]),
    li: new Set([
        "class",
        "data-state",
        "data-type"
    ]),
    ol: new Set([
        "start"
    ]),
    p: new Set([
        "style"
    ]),
    pre: new Set([
        "data-breakout",
        "data-breakout-width",
        "data-language",
        "data-unique-id"
    ]),
    section: new Set([
        "class",
        "data-breakout",
        "data-breakout-width",
        "data-column-rule-style",
        "data-type"
    ]),
    span: new Set([
        "class",
        "data-access-level",
        "data-annotation-id",
        "data-annotation-type",
        "data-color",
        "data-collection",
        "data-emoji-shortname",
        "data-extension-key",
        "data-extension-type",
        "data-local-id",
        "data-mark",
        "data-media-collection",
        "data-media-id",
        "data-name",
        "data-occurrence-key",
        "data-parameters",
        "data-shortname",
        "data-sources",
        "data-status-color",
        "data-type",
        "data-user-id",
        "data-user-type",
        "style"
    ]),
    table: new Set([
        "data-display-mode",
        "data-layout",
        "data-number-column",
        "data-width"
    ]),
    td: new Set([
        "colspan",
        "data-background",
        "data-colwidth",
        "rowspan",
        "style"
    ]),
    th: new Set([
        "colspan",
        "data-background",
        "data-colwidth",
        "rowspan",
        "style"
    ]),
    time: new Set([
        "datetime"
    ]),
    ul: new Set([
        "class",
        "data-type"
    ])
};
for (const headingTag of [
    "h1",
    "h2",
    "h3",
    "h4",
    "h5",
    "h6"
])$732c9cd53da04012$var$SUPPORTED_ATTRS_BY_TAG[headingTag] = new Set([
    "style"
]);
function $732c9cd53da04012$var$isSupportedHtmlClass(tag, className) {
    if ((tag === "code" || tag === "pre") && (className.startsWith("language-") || className.startsWith("lang-"))) return true;
    return $732c9cd53da04012$var$SUPPORTED_CLASSES_BY_TAG[tag]?.has(className) ?? false;
}
function $732c9cd53da04012$var$elementAttributes(el) {
    const attrs = el.attributes;
    if (!attrs) return [];
    const namedNodeMap = attrs;
    if (typeof namedNodeMap.length === "number" && typeof namedNodeMap.item === "function") {
        const result = [];
        for(let i = 0; i < namedNodeMap.length; i++){
            const attr = namedNodeMap.item(i);
            if (attr) result.push([
                attr.name,
                attr.value
            ]);
        }
        return result;
    }
    return Object.entries(attrs).map(([name, value])=>[
            name,
            String(value)
        ]);
}
function $732c9cd53da04012$var$htmlLocation(el) {
    const asAny = el;
    let text = asAny.outerHTML ?? asAny.toString?.() ?? `<${$732c9cd53da04012$var$tagName(el)}>`;
    text = text.split(/\s+/).filter(Boolean).join(" ");
    if (text.length > 120) text = `${text.slice(0, 117)}...`;
    return text;
}
function $732c9cd53da04012$var$shortValidationSnippet(text) {
    let snippet = text.split(/\s+/).filter(Boolean).join(" ");
    if (snippet.length > 120) snippet = `${snippet.slice(0, 117)}...`;
    return snippet;
}
/** Validate a single element. No-op when no `onWarning` callback is registered. */ function $732c9cd53da04012$var$validateHtmlElementInContext(el, tag) {
    if (!$732c9cd53da04012$var$activeContext?.onWarning && !$732c9cd53da04012$var$activeContext?.strict) return;
    if (!$732c9cd53da04012$var$SUPPORTED_HTML_TAGS.has(tag)) {
        $732c9cd53da04012$var$warn({
            code: "unsupported-element",
            message: `Unsupported HTML element <${tag}> at ${$732c9cd53da04012$var$htmlLocation(el)}`,
            tagName: tag
        });
        return;
    }
    const allowedAttrs = $732c9cd53da04012$var$SUPPORTED_ATTRS_BY_TAG[tag];
    for (const [name, value] of $732c9cd53da04012$var$elementAttributes(el)){
        const attr = name.toLowerCase();
        if (attr.includes(":")) {
            $732c9cd53da04012$var$warn({
                code: "unsupported-attribute",
                message: `Unsupported namespaced attribute '${name}' on <${tag}> at ${$732c9cd53da04012$var$htmlLocation(el)}`,
                tagName: tag
            });
            continue;
        }
        if (!$732c9cd53da04012$var$GLOBAL_HTML_ATTRS.has(attr) && !allowedAttrs?.has(attr)) {
            $732c9cd53da04012$var$warn({
                code: "unsupported-attribute",
                message: `Unsupported attribute '${name}' on <${tag}> at ${$732c9cd53da04012$var$htmlLocation(el)}`,
                tagName: tag
            });
            continue;
        }
        if (attr === "data-type") {
            const supportedValues = $732c9cd53da04012$var$SUPPORTED_DATA_TYPES_BY_TAG[tag];
            if (!supportedValues?.has(value)) $732c9cd53da04012$var$warn({
                code: "unsupported-data-type",
                message: `Unsupported data-type '${value}' on <${tag}> at ${$732c9cd53da04012$var$htmlLocation(el)}`,
                tagName: tag
            });
        } else if (attr === "class") {
            for (const className of value.split(/\s+/).filter(Boolean))if (!$732c9cd53da04012$var$isSupportedHtmlClass(tag, className)) $732c9cd53da04012$var$warn({
                code: "unsupported-class",
                message: `Unsupported class '${className}' on <${tag}> at ${$732c9cd53da04012$var$htmlLocation(el)}`,
                tagName: tag
            });
        }
    }
}
/**
 * Walk text descendants once before conversion to flag stray Confluence
 * storage-format markup that survived `preserveTextLikeAngleTokens`. Subtrees
 * rooted at `<pre>` or `<code>` are skipped so escaped storage examples in
 * documentation pages remain valid.
 */ function $732c9cd53da04012$var$runDiagnosticsTextWalk(root) {
    if (!$732c9cd53da04012$var$activeContext?.onWarning && !$732c9cd53da04012$var$activeContext?.strict) return;
    const visit = (node)=>{
        if ($732c9cd53da04012$var$isTextNode(node)) {
            $732c9cd53da04012$var$validateHtmlTextNode($732c9cd53da04012$var$getText(node));
            return;
        }
        if (!$732c9cd53da04012$var$isElement(node)) return;
        const tag = $732c9cd53da04012$var$tagName(node);
        if (tag === "pre" || tag === "code") return;
        for (const child of $732c9cd53da04012$var$childNodes(node))visit(child);
    };
    for (const child of $732c9cd53da04012$var$childNodes(root))visit(child);
}
function $732c9cd53da04012$var$validateHtmlTextNode(text) {
    const lower = text.toLowerCase();
    if (lower.includes("<ac:") || lower.includes("</ac:") || lower.includes("<ri:") || lower.includes("</ri:")) $732c9cd53da04012$var$warn({
        code: "storage-format-text",
        message: `Unsupported Confluence storage-format text: ${$732c9cd53da04012$var$shortValidationSnippet(text)}`
    });
    if (lower.includes("<![cdata[") || lower.includes("[cdata[")) $732c9cd53da04012$var$warn({
        code: "storage-format-cdata",
        message: `Unsupported CDATA macro body: ${$732c9cd53da04012$var$shortValidationSnippet(text)}`
    });
}
// Utility functions
function $732c9cd53da04012$var$makeText(text, marks) {
    const node = {
        type: "text",
        text: text
    };
    if (marks && marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$makeParagraph(content, marks) {
    const node = {
        type: "paragraph"
    };
    if (content && content.length > 0) node.content = content;
    if (marks && marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$makeMark(markType, attrs) {
    const mark = {
        type: markType
    };
    if (attrs) mark.attrs = attrs;
    return mark;
}
/** Strip leading/trailing whitespace artefacts from indented HTML. */ function $732c9cd53da04012$var$trimEdgeWhitespace(content) {
    if (content.length === 0) return;
    const first = content[0];
    if (first.type === "text" && typeof first.text === "string") {
        const trimmed = first.text.replace(/^\s+/, "");
        if (trimmed === "") content.splice(0, 1);
        else first.text = trimmed;
    }
    if (content.length === 0) return;
    const last = content[content.length - 1];
    if (last.type === "text" && typeof last.text === "string") {
        const trimmed = last.text.replace(/\s+$/, "");
        if (trimmed === "") content.splice(content.length - 1, 1);
        else last.text = trimmed;
    }
}
function $732c9cd53da04012$var$isSemanticDiv(el) {
    return !!el.getAttribute("data-type") || $732c9cd53da04012$var$getClasses(el).length > 0;
}
function $732c9cd53da04012$var$divHasOnlyInlineChildren(el) {
    for (const child of $732c9cd53da04012$var$childNodes(el)){
        if ($732c9cd53da04012$var$isTextNode(child)) continue;
        if (!$732c9cd53da04012$var$isElement(child)) continue;
        const tag = $732c9cd53da04012$var$tagName(child);
        if (tag === "div") {
            if ($732c9cd53da04012$var$isSemanticDiv(child) || !$732c9cd53da04012$var$divHasOnlyInlineChildren(child)) return false;
            continue;
        }
        if (tag === "p") return false;
        if ($732c9cd53da04012$var$convertInlineElement(child) === null) return false;
    }
    return true;
}
function $732c9cd53da04012$var$convertInlineOnlyTaskChild(node) {
    const tag = $732c9cd53da04012$var$tagName(node);
    if (tag === "p") return $732c9cd53da04012$var$convertInlineContent(node);
    if (tag === "div") {
        if ($732c9cd53da04012$var$isSemanticDiv(node) || !$732c9cd53da04012$var$divHasOnlyInlineChildren(node)) throw new Error(`Unsupported block <div> inside task item; only plain inline wrapper divs are allowed`);
        return $732c9cd53da04012$var$convertInlineContent(node);
    }
    const result = $732c9cd53da04012$var$convertInlineElement(node);
    if (result !== null) return Array.isArray(result) ? result : [
        result
    ];
    throw new Error(`Unsupported block element <${tag}> inside task item; taskItem content must be inline-only`);
}
function $732c9cd53da04012$var$extractBlockMarks(el) {
    const marks = [];
    const style = el.getAttribute("style") || "";
    // text-align
    const alignMatch = style.match(/text-align:\s*(start|center|end)/i);
    if (alignMatch && $2lsBU.ALIGNMENT_VALUES.has(alignMatch[1].toLowerCase())) marks.push($732c9cd53da04012$var$makeMark("alignment", {
        align: alignMatch[1].toLowerCase()
    }));
    // margin-left for indentation
    const marginMatch = style.match(/margin-left:\s*(\d+)px/i);
    if (marginMatch) {
        const level = Math.round(parseInt(marginMatch[1]) / 30);
        if (level > 0) marks.push($732c9cd53da04012$var$makeMark("indentation", {
            level: level
        }));
    }
    // font-size (block mark: the ADF schema uses { fontSize: "small" } as the only valid enum value)
    const fontSizeMatch = style.match(/font-size:\s*(\d+)px/i);
    if (fontSizeMatch) {
        const px = parseInt(fontSizeMatch[1]);
        // Map small font sizes to the "small" enum; anything ≤14px is considered "small"
        if (px <= 14) marks.push($732c9cd53da04012$var$makeMark("fontSize", {
            fontSize: "small"
        }));
    }
    // Breakout
    const breakoutMode = el.getAttribute("data-breakout");
    if (breakoutMode && $2lsBU.BREAKOUT_MODES.has(breakoutMode)) {
        const breakoutMark = $732c9cd53da04012$var$makeMark("breakout", {
            mode: breakoutMode
        });
        const breakoutWidth = el.getAttribute("data-breakout-width");
        if (breakoutWidth) {
            const width = parseInt(breakoutWidth, 10);
            if (!isNaN(width) && width > 0) breakoutMark.attrs.width = width;
        }
        marks.push(breakoutMark);
    }
    return marks;
}
function $732c9cd53da04012$var$hasClass(el, className) {
    const classes = (el.getAttribute("class") || "").split(/\s+/);
    return classes.includes(className);
}
function $732c9cd53da04012$var$getClasses(el) {
    return (el.getAttribute("class") || "").split(/\s+/).filter((c)=>c);
}
function $732c9cd53da04012$var$salvageChildrenAsBlock(el) {
    const result = $732c9cd53da04012$var$salvageChildren(el);
    if (!result) return $732c9cd53da04012$var$makeParagraph();
    if (Array.isArray(result)) return result.length === 1 ? result[0] : $732c9cd53da04012$var$makeParagraph(result);
    return result;
}
function $732c9cd53da04012$var$salvageChildren(el) {
    const children = $732c9cd53da04012$var$convertChildrenToBlocks(el);
    if (children.length === 0) return null;
    else if (children.length === 1) return children[0];
    else return children;
}
function $732c9cd53da04012$var$addMarkToNode(node, mark) {
    const markableTypes = [
        "text",
        "mention",
        "emoji",
        "status",
        "date",
        "inlineCard",
        "hardBreak",
        "mediaInline",
        "placeholder"
    ];
    if (markableTypes.includes(node.type)) {
        if (!node.marks) node.marks = [];
        node.marks.push(mark);
    }
}
function $732c9cd53da04012$var$htmlInlineMark(el, markType, attrs) {
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    const mark = $732c9cd53da04012$var$makeMark(markType, attrs);
    for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
    return content;
}
// Block handlers
function $732c9cd53da04012$var$htmlHeading(el) {
    const levelMatch = $732c9cd53da04012$var$tagName(el).match(/h(\d)/i);
    const level = levelMatch ? parseInt(levelMatch[1]) : 1;
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    const marks = $732c9cd53da04012$var$extractBlockMarks(el);
    const node = {
        type: "heading",
        attrs: {
            level: level
        },
        content: content
    };
    if (marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$htmlParagraph(el) {
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    const marks = $732c9cd53da04012$var$extractBlockMarks(el);
    const node = {
        type: "paragraph"
    };
    if (content.length > 0) node.content = content;
    if (marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$htmlUl(el) {
    const dataType = el.getAttribute("data-type") || "";
    const classes = $732c9cd53da04012$var$getClasses(el);
    let listType = "bulletList";
    if (dataType.includes("task") || classes.includes("task-list")) listType = "taskList";
    else if (dataType.includes("decision") || classes.includes("decision-list")) listType = "decisionList";
    const content = $732c9cd53da04012$var$childNodes(el).filter((node)=>$732c9cd53da04012$var$isElement(node) && $732c9cd53da04012$var$tagName(node) === "li").map((li)=>{
        if (listType === "taskList") return $732c9cd53da04012$var$htmlTaskItem(li);
        else if (listType === "decisionList") return $732c9cd53da04012$var$htmlDecisionItem(li);
        else return $732c9cd53da04012$var$htmlListItem(li);
    });
    const node = {
        type: listType,
        content: content
    };
    const attrs = {};
    if (listType === "taskList" || listType === "decisionList") attrs.localId = el.getAttribute("data-local-id") || $732c9cd53da04012$var$generateId();
    if (Object.keys(attrs).length > 0) node.attrs = attrs;
    return node;
}
function $732c9cd53da04012$var$htmlOl(el) {
    const order = parseInt(el.getAttribute("start") || "1");
    const content = $732c9cd53da04012$var$childNodes(el).filter((node)=>$732c9cd53da04012$var$isElement(node) && $732c9cd53da04012$var$tagName(node) === "li").map((li)=>$732c9cd53da04012$var$htmlListItem(li));
    return {
        type: "orderedList",
        attrs: {
            order: order
        },
        content: content
    };
}
function $732c9cd53da04012$var$htmlListItem(el) {
    const blocks = [];
    let pendingInline = [];
    const flushInline = ()=>{
        if (pendingInline.length > 0) {
            blocks.push($732c9cd53da04012$var$makeParagraph(pendingInline));
            pendingInline = [];
        }
    };
    for (const node of $732c9cd53da04012$var$childNodes(el)){
        if ($732c9cd53da04012$var$isTextNode(node)) {
            const text = $732c9cd53da04012$var$getText(node);
            if (text.trim()) pendingInline.push($732c9cd53da04012$var$makeText(text));
        } else if ($732c9cd53da04012$var$isElement(node)) {
            const tag = $732c9cd53da04012$var$tagName(node);
            if ([
                "p",
                "div",
                "blockquote",
                "ul",
                "ol",
                "table",
                "pre",
                "h1",
                "h2",
                "h3",
                "h4",
                "h5",
                "h6"
            ].includes(tag)) {
                flushInline();
                const result = $732c9cd53da04012$var$htmlElementToAdf(node);
                if (result !== null) {
                    if (Array.isArray(result)) blocks.push(...result);
                    else blocks.push(result);
                }
            } else {
                const result = $732c9cd53da04012$var$convertInlineElement(node);
                if (result !== null) {
                    if (Array.isArray(result)) pendingInline.push(...result);
                    else pendingInline.push(result);
                }
            }
        }
    }
    flushInline();
    return {
        type: "listItem",
        content: blocks.length > 0 ? blocks : undefined
    };
}
function $732c9cd53da04012$var$convertMixedChildrenToBlocks(el) {
    const blocks = [];
    let pendingInline = [];
    const flushInline = ()=>{
        if (pendingInline.length === 0) return;
        $732c9cd53da04012$var$trimEdgeWhitespace(pendingInline);
        if (pendingInline.length > 0) blocks.push($732c9cd53da04012$var$makeParagraph(pendingInline));
        pendingInline = [];
    };
    const pushBlockResult = (result)=>{
        if (result === null) return;
        if (Array.isArray(result)) blocks.push(...result);
        else blocks.push(result);
    };
    for (const node of $732c9cd53da04012$var$childNodes(el)){
        if ($732c9cd53da04012$var$isTextNode(node)) {
            if ($732c9cd53da04012$var$getText(node).trim()) pendingInline.push($732c9cd53da04012$var$makeText($732c9cd53da04012$var$getText(node)));
            continue;
        }
        if (!$732c9cd53da04012$var$isElement(node)) continue;
        if ($732c9cd53da04012$var$tagName(node) === "img") {
            flushInline();
            pushBlockResult($732c9cd53da04012$var$htmlElementToAdf(node));
            continue;
        }
        const inline = $732c9cd53da04012$var$convertInlineElement(node);
        if (inline !== null) {
            if (Array.isArray(inline)) pendingInline.push(...inline);
            else pendingInline.push(inline);
            continue;
        }
        flushInline();
        pushBlockResult($732c9cd53da04012$var$htmlElementToAdf(node));
    }
    flushInline();
    return blocks;
}
function $732c9cd53da04012$var$htmlTaskItem(el) {
    const localId = el.getAttribute("data-local-id") || $732c9cd53da04012$var$generateId();
    const checkbox = $732c9cd53da04012$var$query(el, 'input[type="checkbox"]');
    const state = checkbox && $732c9cd53da04012$var$hasAttribute(checkbox, "checked") ? "DONE" : "TODO";
    const inlineContent = [];
    for (const node of $732c9cd53da04012$var$childNodes(el)){
        if ($732c9cd53da04012$var$isElement(node)) {
            const tag = $732c9cd53da04012$var$tagName(node);
            if (tag === "input" && node.getAttribute("type") === "checkbox") continue;
            inlineContent.push(...$732c9cd53da04012$var$convertInlineOnlyTaskChild(node));
        } else if ($732c9cd53da04012$var$isTextNode(node)) {
            const text = $732c9cd53da04012$var$getText(node);
            if (text.trim()) inlineContent.push($732c9cd53da04012$var$makeText(text));
        }
    }
    // Strip leading/trailing whitespace artefacts from indented HTML
    $732c9cd53da04012$var$trimEdgeWhitespace(inlineContent);
    return {
        type: "taskItem",
        attrs: {
            localId: localId,
            state: state
        },
        content: inlineContent.length > 0 ? inlineContent : undefined
    };
}
function $732c9cd53da04012$var$htmlDecisionItem(el) {
    const localId = el.getAttribute("data-local-id") || $732c9cd53da04012$var$generateId();
    const state = el.getAttribute("data-state") || "UNDECIDED";
    // decisionItem content must be inline nodes only (no paragraph wrapper)
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    return {
        type: "decisionItem",
        attrs: {
            localId: localId,
            state: state
        },
        content: content.length > 0 ? content : undefined
    };
}
function $732c9cd53da04012$var$htmlTable(el) {
    const rows = [];
    const thead = el.querySelector("thead");
    const tbody = el.querySelector("tbody");
    const processRows = (rowContainer, isHeader)=>{
        if (!rowContainer) return;
        for (const trNode of $732c9cd53da04012$var$childNodes(rowContainer)){
            if (!$732c9cd53da04012$var$isElement(trNode) || $732c9cd53da04012$var$tagName(trNode) !== "tr") continue;
            const cells = [];
            for (const tdNode of $732c9cd53da04012$var$childNodes(trNode)){
                if (!$732c9cd53da04012$var$isElement(tdNode)) continue;
                const tdTag = $732c9cd53da04012$var$tagName(tdNode);
                if (tdTag !== "td" && tdTag !== "th") continue;
                const colspan = parseInt(tdNode.getAttribute("colspan") || "1");
                const rowspan = parseInt(tdNode.getAttribute("rowspan") || "1");
                const bgColor = tdNode.getAttribute("data-background") || (tdNode.getAttribute("style") || "").match(/background-color:\s*([^;]+)/i)?.[1];
                const colWidth = tdNode.getAttribute("data-colwidth");
                const cellAttrs = {};
                if (colspan > 1) cellAttrs.colspan = colspan;
                if (rowspan > 1) cellAttrs.rowspan = rowspan;
                if (bgColor) cellAttrs.background = bgColor;
                if (colWidth) cellAttrs.colwidth = colWidth.split(",").map((w)=>parseInt(w.trim()));
                const cellContent = [];
                const hasBlockChildren = $732c9cd53da04012$var$childNodes(tdNode).some((n)=>$732c9cd53da04012$var$isElement(n) && [
                        "p",
                        "div",
                        "blockquote",
                        "ul",
                        "ol",
                        "table",
                        "pre",
                        "h1",
                        "h2",
                        "h3",
                        "h4",
                        "h5",
                        "h6"
                    ].includes($732c9cd53da04012$var$tagName(n)));
                if (hasBlockChildren) cellContent.push(...$732c9cd53da04012$var$convertChildrenToBlocks(tdNode));
                else {
                    const inlineContent = $732c9cd53da04012$var$convertInlineContent(tdNode);
                    if (inlineContent.length > 0) cellContent.push($732c9cd53da04012$var$makeParagraph(inlineContent));
                }
                const cell = {
                    type: isHeader || tdTag === "th" ? "tableHeader" : "tableCell"
                };
                if (Object.keys(cellAttrs).length > 0) cell.attrs = cellAttrs;
                if (cellContent.length > 0) cell.content = cellContent;
                cells.push(cell);
            }
            if (cells.length > 0) rows.push({
                type: "tableRow",
                content: cells
            });
        }
    };
    processRows(thead, true);
    processRows(tbody, false);
    // Fallback: handle bare <tr> rows directly under <table> (no thead/tbody)
    if (rows.length === 0) {
        for (const child of $732c9cd53da04012$var$childNodes(el))if ($732c9cd53da04012$var$isElement(child) && $732c9cd53da04012$var$tagName(child) === "tr") {
            const hasHeader = !!child.querySelector("th");
            processRows({
                childNodes: [
                    child
                ]
            }, hasHeader);
        }
    }
    const tableAttrs = {
        isNumberColumnEnabled: el.getAttribute("data-number-column") === "true",
        layout: el.getAttribute("data-layout") || "default"
    };
    const displayMode = el.getAttribute("data-display-mode");
    if (displayMode) tableAttrs.displayMode = displayMode;
    const width = el.getAttribute("data-width");
    if (width) tableAttrs.width = width;
    return {
        type: "table",
        attrs: tableAttrs,
        content: rows
    };
}
function $732c9cd53da04012$var$htmlBlockquote(el) {
    const content = $732c9cd53da04012$var$convertChildrenToBlocks(el).filter((block)=>block);
    return {
        type: "blockquote",
        content: content.length > 0 ? content : undefined
    };
}
function $732c9cd53da04012$var$htmlPre(el) {
    let codeEl = $732c9cd53da04012$var$query(el, "code");
    if (!codeEl) {
        const inner = $732c9cd53da04012$var$getInnerHtml(el).trim();
        if (/^<code[\s>]/i.test(inner)) codeEl = $732c9cd53da04012$var$query($732c9cd53da04012$var$parseHtmlFragment(inner), "code");
    }
    const codeContainer = codeEl || el;
    // Code-block text comes from re-serialising the code container's innerHTML
    // and decoding entities exactly once. This preserves escaped HTML such as
    // `&lt;div&gt;` as literal `<div>` in the ADF text.
    //
    // Limitation: when the input contains unescaped raw child tags (e.g.
    // `<pre><code><table>...</table></code></pre>`), the HTML parser has
    // already normalised the tree (auto-inserting `<tbody>`, lowercasing
    // attribute names, auto-closing tags, etc.) before we get here, so the
    // re-serialised text reflects the *normalised* HTML, not what the author
    // wrote. This is inherent to round-tripping through any HTML parser.
    // Callers that need exact preservation must escape their code (`&lt;table&gt;`).
    const serializedCode = $732c9cd53da04012$var$getInnerHtml(codeContainer);
    const text = serializedCode ? $732c9cd53da04012$var$decodeHtmlEntities(serializedCode) : $732c9cd53da04012$var$getText(codeContainer);
    const classes = $732c9cd53da04012$var$getClasses(codeContainer);
    let language = "";
    for (const cls of classes){
        if (cls.startsWith("language-")) {
            language = cls.replace("language-", "");
            break;
        }
        if (cls.startsWith("lang-")) {
            language = cls.replace("lang-", "");
            break;
        }
    }
    const dataLang = codeContainer.getAttribute("data-language");
    if (dataLang) language = dataLang;
    const uniqueId = el.getAttribute("data-unique-id") || $732c9cd53da04012$var$generateId();
    const attrs = {
        uniqueId: uniqueId
    };
    if (language) attrs.language = language;
    const marks = $732c9cd53da04012$var$extractBlockMarks(el);
    const node = {
        type: "codeBlock",
        attrs: attrs,
        content: [
            {
                type: "text",
                text: text
            }
        ]
    };
    if (marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$htmlDiv(el) {
    const dataType = el.getAttribute("data-type") || "";
    const classes = $732c9cd53da04012$var$getClasses(el);
    // Panel
    if (dataType.includes("panel-")) {
        const panelType = dataType.replace("panel-", "");
        if ($2lsBU.PANEL_TYPES.has(panelType)) return $732c9cd53da04012$var$htmlPanel(el, panelType);
    }
    for (const cls of classes)if (cls.startsWith("panel-")) {
        const panelType = cls.replace("panel-", "");
        if ($2lsBU.PANEL_TYPES.has(panelType)) return $732c9cd53da04012$var$htmlPanel(el, panelType);
    }
    // Column
    if (dataType === "column" || classes.includes("column")) return $732c9cd53da04012$var$htmlLayoutColumn(el);
    // Media div
    if (dataType === "media" || classes.includes("media")) return $732c9cd53da04012$var$htmlMediaDiv(el);
    // Media group
    if (dataType === "media-group" || classes.includes("media-group")) return $732c9cd53da04012$var$htmlMediaGroup(el);
    // Block card
    if (dataType === "block-card" || classes.includes("block-card")) {
        let url = el.getAttribute("data-url") || "";
        if (!url) {
            const link = el.querySelector("a");
            url = link?.getAttribute("href") || "";
        }
        const datasource = el.getAttribute("data-datasource") || "";
        const attrs = {
            url: url
        };
        if (datasource) try {
            attrs.datasource = JSON.parse(datasource);
        } catch  {}
        return {
            type: "blockCard",
            attrs: attrs
        };
    }
    // Embed card
    if (dataType === "embed-card" || classes.includes("embed-card")) {
        const iframe = el.querySelector("iframe");
        const url = iframe?.getAttribute("src") || "";
        const layout = el.getAttribute("data-layout") || "center";
        const width = el.getAttribute("data-width");
        const originalWidth = el.getAttribute("data-original-width");
        const originalHeight = el.getAttribute("data-original-height");
        const attrs = {
            url: url,
            layout: layout
        };
        if (width) attrs.width = parseInt(width);
        if (originalWidth) attrs.originalWidth = parseInt(originalWidth);
        if (originalHeight) attrs.originalHeight = parseInt(originalHeight);
        return {
            type: "embedCard",
            attrs: attrs
        };
    }
    // Extensions
    if (dataType === "extension" || classes.includes("extension")) return $732c9cd53da04012$var$htmlExtension(el);
    if (dataType === "bodied-extension" || classes.includes("bodied-extension")) return $732c9cd53da04012$var$htmlBodiedExtension(el);
    if (dataType === "multi-bodied-extension" || classes.includes("multi-bodied-extension")) return $732c9cd53da04012$var$htmlMultiBodiedExtension(el);
    if (dataType === "extension-frame" || classes.includes("extension-frame")) return $732c9cd53da04012$var$htmlExtensionFrame(el);
    // Sync block
    if (dataType === "sync-block" || classes.includes("sync-block")) {
        const resourceId = el.getAttribute("data-resource-id") || "";
        const node = {
            type: "syncBlock",
            attrs: {
                resourceId: resourceId
            }
        };
        const marks = $732c9cd53da04012$var$extractBlockMarks(el);
        if (marks.length > 0) node.marks = marks;
        return node;
    }
    if (dataType === "bodied-sync-block" || classes.includes("bodied-sync-block")) {
        const resourceId = el.getAttribute("data-resource-id") || "";
        const content = $732c9cd53da04012$var$convertChildrenToBlocks(el);
        const node = {
            type: "bodiedSyncBlock",
            attrs: {
                resourceId: resourceId
            },
            content: content
        };
        const marks = $732c9cd53da04012$var$extractBlockMarks(el);
        if (marks.length > 0) node.marks = marks;
        return node;
    }
    // Chart
    if (dataType === "chart" || classes.includes("chart")) return $732c9cd53da04012$var$htmlChartDiv(el);
    // Fallback
    return $732c9cd53da04012$var$salvageChildren(el);
}
function $732c9cd53da04012$var$htmlPanel(el, panelType) {
    const content = $732c9cd53da04012$var$convertChildrenToBlocks(el);
    const attrs = {
        panelType: panelType
    };
    if (panelType === "custom") {
        const icon = el.getAttribute("data-icon");
        if (icon) attrs.panelIcon = icon;
        const color = el.getAttribute("data-color");
        if (color) attrs.panelColor = color;
        const iconId = el.getAttribute("data-icon-id");
        if (iconId) attrs.panelIconId = iconId;
        const iconText = el.getAttribute("data-icon-text");
        if (iconText) attrs.panelIconText = iconText;
    }
    const node = {
        type: "panel",
        attrs: attrs
    };
    if (content.length > 0) node.content = content;
    return node;
}
function $732c9cd53da04012$var$htmlLayoutColumn(el) {
    const width = el.getAttribute("data-width");
    const content = $732c9cd53da04012$var$convertChildrenToBlocks(el);
    const node = {
        type: "layoutColumn"
    };
    if (width) node.attrs = {
        width: parseInt(width)
    };
    if (content.length > 0) node.content = content;
    return node;
}
function $732c9cd53da04012$var$htmlMediaDiv(el) {
    const dataType = el.getAttribute("data-type");
    const selfId = el.getAttribute("data-id");
    // Recognize media div by data-type="media" (primary) or by having a data-id (legacy)
    if (dataType === "media" || selfId) {
        const rawType = el.getAttribute("data-media-type") || dataType || "file";
        const mediaType = rawType === "media" ? "file" : rawType;
        const id = selfId || el.getAttribute("data-media-id");
        const collection = el.getAttribute("data-collection");
        const width = el.getAttribute("data-width");
        const height = el.getAttribute("data-height");
        const occurrenceKey = el.getAttribute("data-occurrence-key");
        const mediaAttrs = {
            type: mediaType
        };
        if (id) mediaAttrs.id = id;
        if (collection) mediaAttrs.collection = collection;
        if (width) mediaAttrs.width = parseInt(width);
        if (height) mediaAttrs.height = parseInt(height);
        if (occurrenceKey) mediaAttrs.occurrenceKey = occurrenceKey;
        return {
            type: "media",
            attrs: mediaAttrs
        };
    }
    // Otherwise look for a child element with data-id or data-type="media"
    const contentEl = el.querySelector('[data-type="media"], [data-id]');
    if (contentEl) {
        const id = contentEl.getAttribute("data-id");
        const collection = contentEl.getAttribute("data-collection");
        const mediaAttrs = {
            type: "file"
        };
        if (id) mediaAttrs.id = id;
        if (collection) mediaAttrs.collection = collection;
        const content = [
            {
                type: "media",
                attrs: mediaAttrs
            }
        ];
        const layout = el.getAttribute("data-layout");
        const node = {
            type: "mediaGroup",
            content: content
        };
        if (layout) node.attrs = {
            layout: layout
        };
        return node;
    }
    return $732c9cd53da04012$var$salvageChildrenAsBlock(el);
}
function $732c9cd53da04012$var$htmlMediaGroup(el) {
    const content = [];
    for (const mediaEl of $732c9cd53da04012$var$queryAll(el, '[data-type="media"], [data-id]')){
        const id = mediaEl.getAttribute("data-id");
        const collection = mediaEl.getAttribute("data-collection");
        const occurrenceKey = mediaEl.getAttribute("data-occurrence-key");
        const mediaAttrs = {
            type: "file"
        };
        if (id) mediaAttrs.id = id;
        if (collection) mediaAttrs.collection = collection;
        if (occurrenceKey) mediaAttrs.occurrenceKey = occurrenceKey;
        content.push({
            type: "media",
            attrs: mediaAttrs
        });
    }
    if (content.length === 0) return $732c9cd53da04012$var$salvageChildrenAsBlock(el);
    return {
        type: "mediaGroup",
        content: content
    };
}
function $732c9cd53da04012$var$htmlExtension(el) {
    const extensionKey = el.getAttribute("data-extension-key") || "";
    const extensionType = el.getAttribute("data-extension-type") || "";
    const layout = el.getAttribute("data-layout") || "default";
    const parametersStr = el.getAttribute("data-parameters") || "{}";
    let parameters = {};
    try {
        parameters = JSON.parse(parametersStr);
    } catch  {
    // ignore
    }
    const attrs = {
        extensionKey: extensionKey,
        extensionType: extensionType,
        layout: layout
    };
    if (Object.keys(parameters).length > 0) attrs.parameters = parameters;
    const text = $732c9cd53da04012$var$getText(el).trim();
    if (text) attrs.text = text;
    return {
        type: "extension",
        attrs: attrs
    };
}
function $732c9cd53da04012$var$htmlBodiedExtension(el) {
    const extensionKey = el.getAttribute("data-extension-key") || "";
    const extensionType = el.getAttribute("data-extension-type") || "";
    const layout = el.getAttribute("data-layout") || "default";
    const parametersStr = el.getAttribute("data-parameters") || "{}";
    let parameters = {};
    try {
        parameters = JSON.parse(parametersStr);
    } catch  {
    // ignore
    }
    const content = $732c9cd53da04012$var$convertMixedChildrenToBlocks(el);
    const attrs = {
        extensionKey: extensionKey,
        extensionType: extensionType,
        layout: layout
    };
    if (Object.keys(parameters).length > 0) attrs.parameters = parameters;
    return {
        type: "bodiedExtension",
        attrs: attrs,
        content: content.length > 0 ? content : [
            $732c9cd53da04012$var$makeParagraph()
        ]
    };
}
function $732c9cd53da04012$var$htmlMultiBodiedExtension(el) {
    const extensionKey = el.getAttribute("data-extension-key") || "";
    const extensionType = el.getAttribute("data-extension-type") || "";
    const layout = el.getAttribute("data-layout") || "default";
    const parametersStr = el.getAttribute("data-parameters") || "{}";
    let parameters = {};
    try {
        parameters = JSON.parse(parametersStr);
    } catch  {
    // ignore
    }
    const frames = [];
    // Look for both extension-frame (standard) and extension-body (legacy) children
    for (const frameEl of $732c9cd53da04012$var$queryAll(el, '[data-type="extension-frame"], [data-type="extension-body"]')){
        const frameContent = $732c9cd53da04012$var$convertChildrenToBlocks(frameEl);
        frames.push({
            type: "extensionFrame",
            content: frameContent
        });
    }
    const attrs = {
        extensionKey: extensionKey,
        extensionType: extensionType,
        layout: layout
    };
    if (Object.keys(parameters).length > 0) attrs.parameters = parameters;
    return {
        type: "multiBodiedExtension",
        attrs: attrs,
        content: frames
    };
}
function $732c9cd53da04012$var$htmlExtensionFrame(el) {
    const attrs = {};
    const src = el.getAttribute("data-src");
    if (src) attrs.src = src;
    const content = $732c9cd53da04012$var$convertChildrenToBlocks(el);
    return {
        type: "extensionFrame",
        attrs: attrs,
        content: content
    };
}
function $732c9cd53da04012$var$htmlChartDiv(el) {
    // Recreate chart extension from data attrs and inner table
    const _chartType = el.getAttribute("data-chart-type");
    const tableEl = el.querySelector("table");
    const tableContent = tableEl ? $732c9cd53da04012$var$htmlTable(tableEl) : {
        type: "table",
        content: []
    };
    return {
        type: "extension",
        attrs: {
            extensionKey: `${$2lsBU.CHART_EXTENSION_KEY_PREFIX}chart`,
            extensionType: $2lsBU.ECOSYSTEM_EXTENSION_TYPE,
            layout: "default",
            parameters: {
                chartType: _chartType || "bar"
            }
        },
        ...tableContent ? {
            content: [
                tableContent
            ]
        } : {}
    };
}
function $732c9cd53da04012$var$htmlSection(el) {
    const classes = $732c9cd53da04012$var$getClasses(el);
    const dataType = el.getAttribute("data-type") || "";
    // Determine layout from data-type attribute or CSS class
    let layout = "default";
    if (dataType.startsWith("layout-")) layout = dataType;
    else {
        for (const cls of classes)if (cls.startsWith("layout-")) {
            layout = cls;
            break;
        }
    }
    const widths = $2lsBU.CLASS_TO_LAYOUT_WIDTHS[layout];
    const columns = [];
    let columnIndex = 0;
    for (const colNode of $732c9cd53da04012$var$childNodes(el)){
        if (!$732c9cd53da04012$var$isElement(colNode) || $732c9cd53da04012$var$tagName(colNode) !== "div") continue;
        // Check both data-type="column" and class="column"
        const colDataType = colNode.getAttribute("data-type") || "";
        const colClasses = $732c9cd53da04012$var$getClasses(colNode);
        if (colDataType !== "column" && !colClasses.includes("column")) continue;
        const content = $732c9cd53da04012$var$convertChildrenToBlocks(colNode);
        const colAttrs = {};
        if (widths && columnIndex < widths.length) colAttrs.width = widths[columnIndex];
        columns.push({
            type: "layoutColumn",
            attrs: colAttrs,
            content: content
        });
        columnIndex++;
    }
    const marks = $732c9cd53da04012$var$extractBlockMarks(el);
    const node = {
        type: "layoutSection",
        content: columns
    };
    if (marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$htmlDetails(el) {
    const summary = el.querySelector("summary");
    const title = summary ? $732c9cd53da04012$var$getText(summary) : "";
    const content = [];
    for (const node of $732c9cd53da04012$var$childNodes(el))if ($732c9cd53da04012$var$isElement(node) && $732c9cd53da04012$var$tagName(node) !== "summary") {
        const result = $732c9cd53da04012$var$htmlElementToAdf(node);
        if (result !== null) {
            if (Array.isArray(result)) content.push(...result);
            else content.push(result);
        }
    }
    const attrs = {
        title: title
    };
    const marks = $732c9cd53da04012$var$extractBlockMarks(el);
    const node = {
        type: "expand",
        attrs: attrs,
        content: content
    };
    if (marks.length > 0) node.marks = marks;
    return node;
}
function $732c9cd53da04012$var$htmlFigure(el) {
    const classes = $732c9cd53da04012$var$getClasses(el);
    const dataType = el.getAttribute("data-type") || "";
    if (dataType === "media-single" || classes.includes("media-single")) {
        const layout = el.getAttribute("data-layout") || "center";
        const width = el.getAttribute("data-width");
        const widthType = el.getAttribute("data-width-type");
        const content = [];
        for (const child of $732c9cd53da04012$var$childNodes(el)){
            if (!$732c9cd53da04012$var$isElement(child)) continue;
            const tag = $732c9cd53da04012$var$tagName(child);
            if (tag === "img") content.push($732c9cd53da04012$var$externalMediaFromImg(child));
            else if (tag === "figcaption") content.push($732c9cd53da04012$var$htmlFigcaption(child));
            else {
                const result = $732c9cd53da04012$var$htmlElementToAdf(child);
                if (result !== null) {
                    if (Array.isArray(result)) content.push(...result);
                    else content.push(result);
                }
            }
        }
        const attrs = {
            layout: layout
        };
        if (width) {
            const parsedWidth = parseInt(width, 10);
            if (!Number.isNaN(parsedWidth) && parsedWidth > 0) {
                attrs.width = parsedWidth;
                attrs.widthType = widthType || "pixel";
            }
        }
        return {
            type: "mediaSingle",
            attrs: attrs,
            content: content
        };
    }
    return $732c9cd53da04012$var$salvageChildrenAsBlock(el);
}
function $732c9cd53da04012$var$htmlFigcaption(el) {
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    return {
        type: "caption",
        content: content
    };
}
function $732c9cd53da04012$var$externalMediaFromImg(el) {
    const src = el.getAttribute("src") || "";
    const alt = el.getAttribute("alt");
    const width = el.getAttribute("width");
    const height = el.getAttribute("height");
    const attrs = {
        type: "external",
        url: src
    };
    if (alt) attrs.alt = alt;
    if (width) {
        const parsedWidth = parseInt(width, 10);
        if (!isNaN(parsedWidth)) attrs.width = parsedWidth;
    }
    if (height) {
        const parsedHeight = parseInt(height, 10);
        if (!isNaN(parsedHeight)) attrs.height = parsedHeight;
    }
    return {
        type: "media",
        attrs: attrs
    };
}
function $732c9cd53da04012$var$htmlImg(el) {
    return {
        type: "mediaSingle",
        attrs: {
            layout: "center"
        },
        content: [
            $732c9cd53da04012$var$externalMediaFromImg(el)
        ]
    };
}
function $732c9cd53da04012$var$htmlInlineImg(el) {
    return $732c9cd53da04012$var$externalMediaFromImg(el);
}
// Inline handlers
const $732c9cd53da04012$var$INLINE_HANDLERS = {
    strong: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "strong"),
    b: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "strong"),
    em: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "em"),
    i: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "em"),
    u: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "underline"),
    s: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "strike"),
    strike: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "strike"),
    del: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "strike"),
    mark: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "backgroundColor"),
    code: (el)=>{
        const text = $732c9cd53da04012$var$getText(el);
        const marks = [
            $732c9cd53da04012$var$makeMark("code")
        ];
        return [
            $732c9cd53da04012$var$makeText(text, marks)
        ];
    },
    sub: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "subsup", {
            type: "sub"
        }),
    sup: (el)=>$732c9cd53da04012$var$htmlInlineMark(el, "subsup", {
            type: "sup"
        }),
    a: (el)=>$732c9cd53da04012$var$htmlLink(el),
    span: (el)=>$732c9cd53da04012$var$htmlSpan(el),
    br: ()=>[
            {
                type: "hardBreak"
            }
        ],
    time: (el)=>$732c9cd53da04012$var$htmlTime(el),
    img: (el)=>[
            $732c9cd53da04012$var$htmlInlineImg(el)
        ],
    figcaption: (el)=>[
            $732c9cd53da04012$var$htmlFigcaption(el)
        ]
};
function $732c9cd53da04012$var$htmlLink(el) {
    const href = el.getAttribute("href") || "";
    const cardAppearance = el.getAttribute("data-card-appearance");
    if (cardAppearance) {
        // Smart link
        const url = el.getAttribute("data-url") || href;
        return [
            {
                type: "inlineCard",
                attrs: {
                    url: url
                }
            }
        ];
    }
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    const mark = $732c9cd53da04012$var$makeMark("link", {
        href: href
    });
    for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
    return content;
}
function $732c9cd53da04012$var$htmlSpan(el) {
    const dataType = el.getAttribute("data-type");
    const classes = $732c9cd53da04012$var$getClasses(el);
    // Status
    if (dataType === "status") {
        const text = el.getAttribute("data-status-text") || $732c9cd53da04012$var$getText(el);
        const color = el.getAttribute("data-color") || el.getAttribute("data-status-color") || "neutral";
        return [
            {
                type: "status",
                attrs: {
                    text: text,
                    color: color
                }
            }
        ];
    }
    // Emoji
    if (dataType === "emoji") {
        const shortName = el.getAttribute("data-shortname") || el.getAttribute("data-emoji-shortname") || "";
        const text = $732c9cd53da04012$var$getText(el);
        return [
            {
                type: "emoji",
                attrs: {
                    shortName: shortName,
                    text: text
                }
            }
        ];
    }
    // Mention (data-type or class)
    if (dataType === "mention" || classes.includes("mention")) {
        const id = el.getAttribute("data-mention-id") || el.getAttribute("data-user-id") || "";
        const text = $732c9cd53da04012$var$getText(el);
        const localId = el.getAttribute("data-local-id");
        const accessLevel = el.getAttribute("data-access-level");
        const userType = el.getAttribute("data-user-type");
        const attrs = {
            id: id,
            text: text
        };
        if (localId) attrs.localId = localId;
        if (accessLevel) attrs.accessLevel = accessLevel;
        if (userType) attrs.userType = userType;
        return [
            {
                type: "mention",
                attrs: attrs
            }
        ];
    }
    // Media inline
    if (dataType === "media-inline") {
        const id = el.getAttribute("data-media-id") || el.getAttribute("data-id");
        const collection = el.getAttribute("data-media-collection") || el.getAttribute("data-collection");
        const occurrenceKey = el.getAttribute("data-occurrence-key");
        const attrs = {
            type: "file"
        };
        if (id) attrs.id = id;
        if (collection) attrs.collection = collection;
        if (occurrenceKey) attrs.occurrenceKey = occurrenceKey;
        return [
            {
                type: "mediaInline",
                attrs: attrs
            }
        ];
    }
    // Placeholder
    if (dataType === "placeholder") {
        const text = el.getAttribute("data-placeholder-text") || $732c9cd53da04012$var$getText(el);
        return [
            {
                type: "placeholder",
                attrs: {
                    text: text
                }
            }
        ];
    }
    // Inline extension
    if (dataType === "inline-extension") {
        const extensionKey = el.getAttribute("data-extension-key") || "";
        const extensionType = el.getAttribute("data-extension-type") || "";
        const parametersStr = el.getAttribute("data-parameters") || "{}";
        let parameters = {};
        try {
            parameters = JSON.parse(parametersStr);
        } catch  {
        // ignore
        }
        const attrs = {
            extensionKey: extensionKey,
            extensionType: extensionType
        };
        if (Object.keys(parameters).length > 0) attrs.parameters = parameters;
        const text = $732c9cd53da04012$var$getText(el).trim();
        if (text) attrs.text = text;
        return [
            {
                type: "inlineExtension",
                attrs: attrs
            }
        ];
    }
    // Annotation class
    if (classes.includes("annotation")) {
        const annotationId = el.getAttribute("data-annotation-id") || "";
        const annotationType = el.getAttribute("data-annotation-type") || "inlineComment";
        const content = $732c9cd53da04012$var$convertInlineContent(el);
        const attrs = {
            annotationType: annotationType
        };
        if (annotationId) attrs.id = annotationId;
        const mark = $732c9cd53da04012$var$makeMark("annotation", attrs);
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
        return content;
    }
    for (const cls of classes)if (cls.startsWith("annotation-")) {
        const annotationType = cls.replace("annotation-", "");
        const content = $732c9cd53da04012$var$convertInlineContent(el);
        const mark = $732c9cd53da04012$var$makeMark("annotation", {
            annotationType: annotationType
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
        return content;
    }
    // Data consumer mark
    const dataMark = el.getAttribute("data-mark");
    if (dataMark === "dataConsumer") {
        const dataSourcesStr = el.getAttribute("data-sources") || "[]";
        let dataSources = [];
        try {
            dataSources = JSON.parse(dataSourcesStr);
        } catch  {
        // ignore
        }
        const content = $732c9cd53da04012$var$convertInlineContent(el);
        const mark = $732c9cd53da04012$var$makeMark("dataConsumer", {
            sources: dataSources
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
        return content;
    }
    // Fragment mark
    if (dataMark === "fragment") {
        const localId = el.getAttribute("data-local-id") || "";
        const name = el.getAttribute("data-name") || "";
        const content = $732c9cd53da04012$var$convertInlineContent(el);
        const mark = $732c9cd53da04012$var$makeMark("fragment", {
            localId: localId,
            name: name
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
        return content;
    }
    // Style-based marks
    const style = el.getAttribute("style") || "";
    const content = $732c9cd53da04012$var$convertInlineContent(el);
    const bgColorMatch = style.match(/background-color:\s*([^;]+)/i);
    if (bgColorMatch) {
        const mark = $732c9cd53da04012$var$makeMark("backgroundColor", {
            color: bgColorMatch[1].trim()
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
    }
    const colorMatch = style.match(/color:\s*([^;]+)/i);
    if (colorMatch) {
        const mark = $732c9cd53da04012$var$makeMark("textColor", {
            color: colorMatch[1].trim()
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
    }
    const fontSizeMatch = style.match(/font-size:\s*(\d+)px/i);
    if (fontSizeMatch) {
        const mark = $732c9cd53da04012$var$makeMark("fontSize", {
            size: parseInt(fontSizeMatch[1])
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
    }
    const borderMatch = style.match(/border:\s*([^;]+)/i);
    if (borderMatch) {
        const mark = $732c9cd53da04012$var$makeMark("border", {
            border: borderMatch[1].trim()
        });
        for (const node of content)$732c9cd53da04012$var$addMarkToNode(node, mark);
    }
    return content.length > 0 ? content : null;
}
function $732c9cd53da04012$var$htmlTime(el) {
    const datetime = el.getAttribute("datetime") || "";
    const ts = new Date(datetime).getTime();
    // If the datetime is invalid, fall back to plain text
    if (Number.isNaN(ts)) {
        const text = $732c9cd53da04012$var$getText(el).trim();
        return text ? [
            $732c9cd53da04012$var$makeText(text)
        ] : [];
    }
    return [
        {
            type: "date",
            attrs: {
                timestamp: String(ts)
            }
        }
    ];
}
// Handler dispatch table
const $732c9cd53da04012$var$HTML_TO_ADF_HANDLERS = {
    h1: $732c9cd53da04012$var$htmlHeading,
    h2: $732c9cd53da04012$var$htmlHeading,
    h3: $732c9cd53da04012$var$htmlHeading,
    h4: $732c9cd53da04012$var$htmlHeading,
    h5: $732c9cd53da04012$var$htmlHeading,
    h6: $732c9cd53da04012$var$htmlHeading,
    p: $732c9cd53da04012$var$htmlParagraph,
    ul: $732c9cd53da04012$var$htmlUl,
    ol: $732c9cd53da04012$var$htmlOl,
    table: $732c9cd53da04012$var$htmlTable,
    blockquote: $732c9cd53da04012$var$htmlBlockquote,
    pre: $732c9cd53da04012$var$htmlPre,
    hr: ()=>({
            type: "rule"
        }),
    div: $732c9cd53da04012$var$htmlDiv,
    section: $732c9cd53da04012$var$htmlSection,
    details: $732c9cd53da04012$var$htmlDetails,
    figure: $732c9cd53da04012$var$htmlFigure,
    figcaption: $732c9cd53da04012$var$htmlFigcaption,
    img: $732c9cd53da04012$var$htmlImg,
    iframe: (el)=>({
            type: "embedCard",
            attrs: {
                url: el.getAttribute("src") || ""
            }
        })
};
// Mermaid expansion
function $732c9cd53da04012$var$expandMermaidBlocks(doc) {
    const expandContent = (content)=>{
        const result = [];
        for (const block of content)if (block.type === "codeBlock" && block.attrs?.language === "mermaid") {
            // Extract mermaid text
            const mermaidContent = block.content?.[0];
            const mermaidText = mermaidContent?.text || "";
            // Create extension + expand pair
            result.push({
                type: "extension",
                attrs: {
                    extensionKey: $2lsBU.MERMAID_EXTENSION_KEY,
                    extensionType: "com.atlassian.ecosystem",
                    layout: "default",
                    parameters: {
                        mermaidIndex: 0
                    }
                }
            });
            result.push({
                type: "expand",
                attrs: {
                    title: "Mermaid"
                },
                content: [
                    {
                        type: "codeBlock",
                        attrs: {
                            language: "mermaid",
                            uniqueId: $732c9cd53da04012$var$generateId()
                        },
                        content: [
                            {
                                type: "text",
                                text: mermaidText
                            }
                        ]
                    }
                ]
            });
        } else {
            // Recursively expand nested content
            if (Array.isArray(block.content)) block.content = expandContent(block.content);
            result.push(block);
        }
        return result;
    };
    if (Array.isArray(doc.content)) doc.content = expandContent(doc.content);
    return doc;
}

});

parcelRegister("3Anyi", function(module, exports) {
"use strict";
/**
 * HTML input validation for the Confluence HTML format.
 *
 * Thin wrapper around `htmlToAdf` that runs the converter with a diagnostic
 * collector and returns the resulting messages. The validator stays in lockstep
 * with the converter because both share the same parser, preprocessor, element
 * traversal, and supported-element/attribute tables.
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.validateHtml = $29c700e16db4fa97$var$validateHtml;
module.exports.validateHtmlFromParsedRoot = $29c700e16db4fa97$var$validateHtmlFromParsedRoot;

var $9T4kN = parcelRequire("9T4kN");

const $29c700e16db4fa97$var$HTML_FORMAT_EXAMPLES = [
    '<div data-type="panel-info"><p>Info text</p></div>',
    '<pre><code class="language-mermaid">flowchart LR\n  A-->B</code></pre>',
    '<span data-type="status" data-color="green">Done</span>'
];
/**
 * Validate HTML before converting it to ADF.
 *
 * The converter accepts the AI-agent-friendly HTML format documented by this
 * package, not arbitrary HTML or Confluence storage-format XML. This invokes
 * the converter with a diagnostic collector so any element, attribute,
 * `data-type`, or class the converter does not natively support is reported,
 * along with stray storage-format tokens that survived unknown-tag escaping.
 *
 * Literal storage-format examples are allowed when escaped inside `<pre>` or
 * `<code>` blocks.
 */ function $29c700e16db4fa97$var$validateHtml(html, options) {
    return $29c700e16db4fa97$var$collectAndDecorate((onWarning)=>(0, $9T4kN.htmlToAdf)(html, {
            document: options?.document,
            onWarning: onWarning
        }));
}
/**
 * Validate an already-parsed HTML root. Used by the Node entry point so the
 * caller can supply a parser (e.g. `node-html-parser`) without depending on a
 * browser `Document`.
 */ function $29c700e16db4fa97$var$validateHtmlFromParsedRoot(root) {
    return $29c700e16db4fa97$var$collectAndDecorate((onWarning)=>(0, $9T4kN.htmlToAdfFromDom)(root, {
            onWarning: onWarning
        }));
}
function $29c700e16db4fa97$var$collectAndDecorate(run) {
    const messages = [];
    run((warning)=>{
        if (warning && typeof warning.message === "string") messages.push(warning.message);
    });
    // The converter emits informational diagnostics (e.g. `Dropped non-content
    // element <script>`) that are not validation failures from the caller's
    // perspective. Filter to messages that indicate the input was malformed.
    const validationMessages = messages.filter($29c700e16db4fa97$var$isValidationFailure);
    if (validationMessages.length === 0) return [];
    const examples = $29c700e16db4fa97$var$HTML_FORMAT_EXAMPLES.join("; ");
    return validationMessages.slice(0, 5).map((message)=>`${message}. Use documented Confluence HTML format patterns instead, for example: ${examples}.`);
}
function $29c700e16db4fa97$var$isValidationFailure(message) {
    return message.startsWith("Unsupported HTML element") || message.startsWith("Unsupported attribute") || message.startsWith("Unsupported namespaced attribute") || message.startsWith("Unsupported data-type") || message.startsWith("Unsupported class") || message.startsWith("Unsupported Confluence storage-format text") || message.startsWith("Unsupported CDATA macro body");
}

});

parcelRegister("2lsBU", function(module, exports) {
"use strict";
/**
 * Shared types and constants for the ADF ↔ HTML converter.
 *
 * @module @atlassian/atlassian-html-format
 */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.DATE_FORMATS = module.exports.ECOSYSTEM_EXTENSION_TYPE = module.exports.CHART_EXTENSION_KEY_PREFIX = module.exports.MERMAID_EXTENSION_KEY = module.exports.CLASS_TO_LAYOUT_WIDTHS = module.exports.LAYOUT_WIDTHS_TO_CLASS = module.exports.DECISION_STATES = module.exports.STATUS_COLORS = module.exports.BREAKOUT_MODES = module.exports.ALIGNMENT_VALUES = module.exports.PANEL_TYPES = void 0;
module.exports.PANEL_TYPES = new Set([
    "info",
    "note",
    "warning",
    "success",
    "error",
    "custom"
]);
module.exports.ALIGNMENT_VALUES = new Set([
    "start",
    "center",
    "end"
]);
module.exports.BREAKOUT_MODES = new Set([
    "wide",
    "full-width"
]);
module.exports.STATUS_COLORS = new Set([
    "neutral",
    "purple",
    "blue",
    "red",
    "yellow",
    "green"
]);
module.exports.DECISION_STATES = new Set([
    "DECIDED",
    "UNDECIDED"
]);
module.exports.LAYOUT_WIDTHS_TO_CLASS = {
    "50,50": "layout-two-equal",
    "33.33,66.66": "layout-two-left-sidebar",
    "66.66,33.33": "layout-two-right-sidebar",
    "33.33,33.33,33.33": "layout-three-equal",
    "25,50,25": "layout-three-with-sidebars"
};
module.exports.CLASS_TO_LAYOUT_WIDTHS = {
    "layout-two-equal": [
        50,
        50
    ],
    "layout-two-left-sidebar": [
        33.33,
        66.66
    ],
    "layout-two-right-sidebar": [
        66.66,
        33.33
    ],
    "layout-three-equal": [
        33.33,
        33.33,
        33.33
    ],
    "layout-three-with-sidebars": [
        25,
        50,
        25
    ]
};
module.exports.MERMAID_EXTENSION_KEY = "23392b90-4271-4239-98ca-a3e96c663cbb/63d4d207-ac2f-4273-865c-0240d37f044a/static/mermaid-diagram";
module.exports.CHART_EXTENSION_KEY_PREFIX = "ari:cloud:ecosystem::extension/346de418-cba6-4065-a053-8a4014e57b08/";
module.exports.ECOSYSTEM_EXTENSION_TYPE = "com.atlassian.ecosystem";
module.exports.DATE_FORMATS = [
    "YYYY-MM-DD",
    "YYYY/MM/DD",
    "MM-DD-YYYY",
    "DD-MM-YYYY"
];

});


//# sourceMappingURL=FullPageEditorComponent.7890c515.js.map
